(function() {
    'use strict';

    angular
        .module('ticket.service.ingresso', [ ]);
})();
(function(){
    'use strict';

    angular.module('ticket.service.ingresso')

    .factory("ticket.service.ingresso.tipovalidacaodocumento", ["common", function (common) {
      var res = {

        listvalid: function (key) {
          return this.request("listvalid", key);
        }
      }; //<-- Customize aqui seu service
        return common.service.instantiate(res, "controleingresso/tipovalidacaodocumento/");
    }]);

})();

(function(){
  'use strict';

  angular.module('ticket.service.ingresso')

    .factory("ticket.service.ingresso.tipoinformativoingresso", ["common", function (common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleingresso/tipoinformativoingresso/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.ingresso')

    .factory("ticket.service.ingresso.tabelaprecopadraoestabelecimentoingresso", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service
        return common.service.instantiate(res, "controleingresso/tabelaprecopadraoestabelecimentoingresso/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.ingresso')
    
    .factory("ticket.service.ingresso.tabelaprecopadrao", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service        
        return common.service.instantiate(res, "controleingresso/tabelaprecopadrao/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.ingresso')
    
    .factory("ticket.service.ingresso.regraingresso", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service        
        return common.service.instantiate(res, "controleingresso/regraingresso/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.ingresso')
    
    .factory("ticket.service.ingresso.estabelecimentoingresso", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service        
        return common.service.instantiate(res, "controleingresso/estabelecimentoingresso/");
    }]);

})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.site', [
        	
        ]);
})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.site')
        .controller('ticket.controller.site.home', [function(){
            var vm = this;

            
            

        }]);

    
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports', []);
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.previa',
      ["$scope", "common", "ticket.service.reports.bordero",
        function ($scope, common, borderoSvc) {
          var vm = common.controller.master(this, borderoSvc, $scope);
        }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.reports')
    .controller('ticket.controller.reports.previa.grid', ["common", "ticket.service.reports.bordero",
      function(common, borderoService) {
        var vm = common.controller.grid(this, borderoService);

        vm.Filter.Previa = true;

        // vm.search = function () {
        //   vm.searching = true;
        //   borderoService.getallprevia({
        //     Config: {
        //     Skip: 0,
        //       Top: 0
        //   },
        //   Filter: {
        //     Nome: vm.Filter.Nome,
        //     Data: vm.Filter.Data
        //   }}
        //   ).then(function (data) {
        //     vm.searching = false;
        //     vm.items = data;
        //   });
        // }
      }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.previa.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      ,'$window'
      , 'ticket.service.reports.bordero'
      , function (common, $stateParams, $sce, $state,$window, borderoSrv) {

        var vm = common.controller.basic(this, borderoSrv);
        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        // var appWindow = angular.element($window);
        // appWindow.bind('resize', function () {
        //   var element = angular.element(document.querySelector('body'));
        //   vm.height = element[0].offsetHeight;
        //   vm.style = {
        //     "width" : "100%",
        //     "height" : vm.height / 1.5
        //   }
        // });

        borderoSrv.previa($stateParams).then(function (data) {
          vm.pdfUrl = $sce.trustAsResourceUrl(data.Url);
          vm.loading = false;
        });

        vm.voltar = function () {
          $state.go('reports.previa.grid');
        }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports').controller('ticket.controller.reports.futuras-dia',
      ["$scope", "common", "ticket.service.reports.futuras",
        function ($scope, common, futurasSvc) {
          var vm = common.controller.master(this, futurasSvc, $scope);
        }]);
})();

(function () {
  'use strict';

  angular.module('ticket.controller.reports').controller('ticket.controller.reports.futuras-dia.grid', [
    "common"
    , "$state"
    , "$scope"
    , 'orderByFilter'
    , "ticket.service.reports.futuras"
    , "ticket.service.conteudo.atracao"
    , "ticket.service.reports.report"
    , function (common, $state, $scope, orderByFilter, futurasSvc, atracaoSvc, relatorioSvc) {

      var vm = common.controller.grid(this, futurasSvc, atracaoSvc, relatorioSvc);
      vm.gerar = false;
      vm.disabled = true;
      vm.Filter.DoDia = true;


      var pageSize = 20;

      var baseReportFilter = {
        "Config": {
          "Skip": 0,
          "Top": pageSize
        },
        "Filter": {
          /*        "ApelidoUsuario": null,
                    "DataInicio": null,
                    "DataFim": null,
                    "Parametros": null,
                    "IdStatusRelatorio": null, */
          "IdTipoRelatorio": 2
        }
      }

      vm.search = function (inScroll) {

        if (vm.searching) return;

        vm.searching = true;

        if (!inScroll || vm.isPost) {
          vm.isPost = false;
          vm.page = 0;
          vm.complete = false;
          vm.items = [];
        }
        relatorioSvc.getAll({
          Config: {
            Skip: vm.page,
            Top: pageSize
          },
          Filter: {
            "IdTipoRelatorio": 2
          }
        })
          .then(function (data) {
            vm.items = vm.items.concat(data);

            for (var i = 0; i < vm.items.length; i++) {
              if (vm.items[i].DataHoraTermino) {               
                vm.items[i].TempoExecucao = dateDiff(vm.items[i].DataHoraSolicitacao, vm.items[i].DataHoraTermino);
              }
            }

            if (data.length < pageSize)
              vm.complete = true;

            if (data.length > 0) {
              vm.page += 1;
            }

          })
          .finally(function () {
            vm.searching = false;
          });
      }

      //vm.Filter.Data  = moment(moment(new Date()).format('MM/DD/YYYY'),'MM/DD/YYYY').toDate();

      $scope.$watch('vm.Filter.Data ', function () {
        if (vm.Filter.Data && !vm.gerar) {
          vm.loading = true;
          // Chama a listagem do select de atracoes
          atracaoSvc.listFuturas({Data: moment( vm.Filter.Data).format()}).then(function (data) {
            data = orderByFilter(data, 'Nome');
            vm.lstAtracao = data;
            vm.loading = false;
            vm.disabled = false;
          })
        }
      }, true)

      vm.Gerar = function () {
        vm.loading = false;
        var semana = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
        var mdata = moment.parseZone(vm.Filter.Data);
        var diaSemana = semana[mdata.day()];
        if (vm.Filter.DoDia || ( !vm.Filter.DoDia && diaSemana === 'Domingo')) {
          vm.gerar = true;
          vm.Filter.Data = moment( vm.Filter.Data).format();
          futurasSvc.futurasAsync(vm.Filter)
          .then(function () {
            vm.searching = true;
            relatorioSvc.getAll(baseReportFilter).then(function (data) {
              vm.items = data;
              for (var i = 0; i < vm.items.length; i++) {
                if (vm.items[i].DataHoraTermino) {               
                  vm.items[i].TempoExecucao = dateDiff(vm.items[i].DataHoraSolicitacao, vm.items[i].DataHoraTermino);
                }
              }
            })
              .finally(function () {
                vm.searching = false;
              });
          }).finally(function () {
            vm.gerar = false;
          })
        }
        else {
          vm.utils.ShowWarning("Aviso", "Escolha um domingo!");
        }
      }

      // Ao clicar em visualizar redireciona para a pagina que mostra o pdf
      vm.exibir = function (item) {
        $state.go('reports.futuras-dia.form', { Uri: item.Url });
      }

      vm.delete = function (item) {
        vm.del(item, relatorioSvc, function () { 
          vm.items.splice(vm.items.indexOf(item), 1); 
        });
      }

      const dateDiff = function(_date1, _date2) {
        var start  = moment(_date1);
        var end = moment(_date2);

        // Calcula a diferença em milissegundos
        var diffInMs = end.diff(start);

        // Converte para horas, minutos e segundos
        var duration = moment.duration(diffInMs);
        var hours = Math.floor(duration.asHours()); // Total de horas
        var minutes = duration.minutes(); // Minutos restantes
        var seconds = duration.seconds(); // Segundos restantes

        // Retorna a diferença formatada
        return hours + "h " + minutes + "m " + seconds + "s"; // `${hours}h ${minutes}m ${seconds}s`;
      }
    }
  ])
  ;
})
();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports').controller('ticket.controller.reports.futuras-dia.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      , 'ticket.service.reports.futuras'
      , function (common, $stateParams, $sce, $state, futurasSvc) {

        var vm = common.controller.basic(this, futurasSvc);

        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        if(!$stateParams.Uri)
        {
          $state.go('reports.futuras-dia.grid');
        }

        if($stateParams.Uri) {
            vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
            vm.loading = false;
        }


        vm.voltar = function () {
          $state.go('reports.futuras-dia.grid');
        }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports').controller('ticket.controller.reports.futuras',
      ["$scope", "common", "ticket.service.reports.futuras",
        function ($scope, common, futurasSvc) {
          var vm = common.controller.master(this, futurasSvc, $scope);
        }]);
})();

(function () {
  'use strict';

  angular.module('ticket.controller.reports').controller('ticket.controller.reports.futuras.grid', [
    "common"
    ,"$state"
    ,"orderByFilter"
    ,"ticket.service.reports.futuras"
    , "ticket.service.conteudo.atracao"
    , function (common,$state, orderByFilter, futurasSvc, atracaoSvc) {

      var vm = common.controller.grid(this, futurasSvc, atracaoSvc);
      vm.gerar = false;

      vm.Filter.Data  = moment(moment(new Date()).format('MM/DD/YYYY'),'MM/DD/YYYY').toDate();
      //vm.Filter.DataFim = moment(moment(new Date()).format('MM/DD/YYYY'),'MM/DD/YYYY').toDate()

      atracaoSvc.list({}).then(function (data) {
        data = orderByFilter(data, 'Nome');
        vm.lstAtracao = data;
      })

      vm.Gerar = function () {
        vm.gerar = true;
        futurasSvc.futuras(vm.Filter).then(function (data) {
          $state.go('reports.futuras.form', {  Uri: data.Url });
        }).then(function(){
          vm.gerar = false;
        })
      }

    }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports').controller('ticket.controller.reports.futuras.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      , 'ticket.service.reports.futuras'
      , function (common, $stateParams, $sce, $state, futurasSvc) {

        var vm = common.controller.basic(this, futurasSvc);

        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        if(!$stateParams.Uri)
        {
          $state.go('reports.futuras.grid');
        }

        if($stateParams.Uri) {
            vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
            vm.loading = false;
        }


      vm.voltar = function () {
        $state.go('reports.futuras-dia.grid');
      }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.financeiro',
      ["$scope", "common", "ticket.service.reports.financeiro",
        function ($scope, common, financeiroSvc) {
          var vm = common.controller.master(this, financeiroSvc, $scope);
        }]
      )
      .controller('ticket.service.reports.financeiro',
      ["$scope", "common", 'ticket.service.reports.report',
      function ($scope, common, relatorioSvc) {
        var vm = common.controller.master(this, relatorioSvc, $scope);
      }
    ])
})();

(function () {
  'use strict';

  angular.module('ticket.controller.reports').controller('ticket.controller.reports.financeiro.grid', [
    "common"
    , "$state"
    , "orderByFilter"
    , "ticket.service.reports.financeiro"
    , "ticket.service.conteudo.atracao"
    , "ticket.service.reports.report"
    , function (common, $state, orderByFilter, financeiroSvc, atracaoSvc, relatorioSvc) {

      var vm = common.controller.grid(this, financeiroSvc, atracaoSvc, relatorioSvc);

      var pageSize = 20;

      var baseReportFilter = {
        "Config": {
          "Skip": 0,
          "Top": pageSize
        },
        "Filter": {
          /*        "ApelidoUsuario": null,
                    "DataInicio": null,
                    "DataFim": null,
                    "Parametros": null,
                    "IdStatusRelatorio": null, */
          "IdTipoRelatorio": 1
        }
      }

      vm.search = function (inScroll) {

        if (vm.searching) return;

        vm.searching = true;

        if (!inScroll || vm.isPost) {
          vm.isPost = false;
          vm.page = 0;
          vm.complete = false;
          vm.items = [];
        }
        relatorioSvc.getAll({
          Config: {
            Skip: vm.page,
            Top: pageSize
          },
          Filter: {
            "IdTipoRelatorio": 1
          }
        })
          .then(function (data) {
            vm.items = vm.items.concat(data);

            for (var i = 0; i < vm.items.length; i++) {
              if (vm.items[i].DataHoraTermino) {               
                vm.items[i].TempoExecucao = dateDiff(vm.items[i].DataHoraSolicitacao, vm.items[i].DataHoraTermino);
              }
            }

            if (data.length < pageSize)
              vm.complete = true;

            if (data.length > 0) {
              vm.page += 1;
            }

          })
          .finally(function () {
            vm.searching = false;
          });
      }

      vm.gerar = false;

      atracaoSvc.list({}).then(function (data) {
        data = orderByFilter(data, 'Nome');
        vm.lstAtracao = data;
      })

      // Enviar a requisicao para gerar o boleto
      vm.Gerar = function () {
        vm.gerar = true;
        vm.Filter.DataInicio = moment(vm.Filter.DataInicio).format();
        vm.Filter.DataFim = moment(vm.Filter.DataFim).format();

        // Envia a requisicao do relatorio financeiro e depois faz uma nova requisicao
        financeiroSvc.financeiroAsync(vm.Filter)
          .then(function () {
            vm.searching = true;
            relatorioSvc.getAll(baseReportFilter).then(function (data) {
              vm.items = data;
              for (var i = 0; i < vm.items.length; i++) {
                if (vm.items[i].DataHoraTermino) {               
                  vm.items[i].TempoExecucao = dateDiff(vm.items[i].DataHoraSolicitacao, vm.items[i].DataHoraTermino);
                }
              }
            })
              .finally(function () {
                vm.searching = false;
              });
          }).finally(function () {
            vm.gerar = false;
            vm.Filter.DataInicio = ''
            vm.Filter.DataFim = ''
          })
      }

      // Ao clicar em visualizar redireciona para a pagina que mostra o pdf
      vm.exibir = function (item) {
        $state.go('reports.financeiro.form', { Uri: item.Url });
      }

      vm.delete = function (item) {
        vm.del(item, relatorioSvc, function() { 
          vm.items.splice(vm.items.indexOf(item), 1); 
        });
      }

      const dateDiff = function(_date1, _date2) {
        var start  = moment(_date1);
        var end = moment(_date2);

        // Calcula a diferença em milissegundos
        var diffInMs = end.diff(start);

        // Converte para horas, minutos e segundos
        var duration = moment.duration(diffInMs);
        var hours = Math.floor(duration.asHours()); // Total de horas
        var minutes = duration.minutes(); // Minutos restantes
        var seconds = duration.seconds(); // Segundos restantes

        // Retorna a diferença formatada
        return hours + "h " + minutes + "m " + seconds + "s";
        // return `${hours}h ${minutes}m ${seconds}s`;
      }
    }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.financeiro.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      , 'ticket.service.reports.financeiro'
      , function (common, $stateParams, $sce, $state, financeiroSvc) {

        var vm = common.controller.basic(this, financeiroSvc);

        vm.loading = true;
        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        if(!$stateParams.Uri)
        {
          $state.go('reports.financeiro.grid');
        }

        if($stateParams.Uri) {
            vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
            vm.loading = false;
        }


        vm.voltar = function () {
          $state.go('reports.financeiro.grid');
        }
      }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.bordero',
      ["$scope", "common", "ticket.service.reports.bordero",
        function ($scope, common, borderoSvc) {
          var vm = common.controller.master(this, borderoSvc, $scope);
        }]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.reports')

    .controller('ticket.controller.reports.bordero.grid', [
      "common"
      ,'$sce'
      ,'$state'
      ,"ticket.service.reports.bordero",
      function(common, $sce, $state, borderoService) {
        var vm = common.controller.grid(this, borderoService);
        vm.exibir = function (item) {
          $state.go('reports.bordero.form', {  Uri: item.Uri });
        }
      }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .controller('ticket.controller.reports.bordero.form', [
      'common'
      , '$stateParams'
      , '$sce'
      ,'$state'
      , 'ticket.service.reports.bordero'
      , function (common, $stateParams, $sce, $state, borderoSrv) {
        var vm = common.controller.basic(this, borderoSrv);
        vm.loading = true;
        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width" : "100%",
          "height" : vm.height / 1.4
        }

        if($stateParams.Uri == null && $stateParams.IdSessao == null)
          $state.go('reports.bordero.grid');

        if($stateParams.Uri == null && $stateParams.IdSessao) {
          borderoSrv.bordero($stateParams).then(function (data) {
            vm.pdfUrl = $sce.trustAsResourceUrl(data.Url);
            vm.loading = false;
          });
        }
        else
        {
          vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
          vm.loading = false;
        }

        vm.voltar = function () {
          $state.go('reports.bordero.grid');
        }
      }])
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.planta', [
        ]);
})();

(function () {
  'use strict';
  angular.module('ticket.controller.planta')
    .controller('ticket.controller.planta.setor', setorGridController);

  setorGridController.$inject = [];

  function setorGridController() {

  }
})();

(function () {
  'use strict';
  angular.module('ticket.controller.planta')
    .controller('ticket.controller.planta.setor.grid', setorGridController);

  setorGridController.$inject = ['$scope', '$q', '$rootScope', 'common', 'ticket.service.local.setor', 'ticket.service.local.pavimento', 'ticket.service.local.layout', 'ticket.service.local.mapaassento', 'ticket.service.local.sala'];

  function setorGridController($scope, $q, $rootScope, common, setorSrv, pavimentoSrv, layoutSrv, mapaAssentoSrv, salaSrv) {


    var vm = common.controller.grid(this, setorSrv);

    vm.search = function() {

      vm.searching = true;
      //Common
      vm.layouts = [];
      vm.salas = [];


      vm.dados = {};
      vm.dados.salas = [];

      var layouts = [];
      var salas = [];

      setorSrv.getAll({
        Config: {
          Skip: 0,
          Top: 0
        },
        Filter: vm.Filter
      })
        .then(function(data) {

          $rootScope.$emit('queried', data);
          vm.setores = data;




          vm.setores.forEach(function(item, index) {
            //Obtem os ids pais existêntes em setores
            if (salas.indexOf(item.IdSala) === -1)
              salas.push(item.IdSala);

            if (layouts.indexOf(item.IdLayout) === -1)
              layouts.push(item.IdLayout);

          });

          salas.forEach(function(IdSala, index) {
            salaSrv.get({
              Id: IdSala
            })
              .then(function(sala) {

                sala.layouts = [];

                layouts.forEach(function(IdLayout, index) {
                  layoutSrv.get({
                    Id: IdLayout
                  })
                    .then(function(layout) {
                      if (layout.IdSala == IdSala)
                        sala.layouts.push(layout);
                    });
                });

                vm.dados.salas.push(sala);
              });
          });
        })
        .finally(function() {
          vm.searching = false;
        });
    };

    //TODO: Criar diretiva
    //Tabela
    $scope.tableRowExpanded = true;
    $scope.tableRowIndexCurrExpanded = "";
    $scope.showTransactions = true;
    $scope.tableRowIndexPrevExpanded = "";
    $scope.idExpanded = "";
    $scope.dataCollapse = [true, true, true, true, true, true];

    $scope.selectTableRow = function(index, Id) {
      if ($scope.tableRowExpanded === false && $scope.tableRowIndexCurrExpanded === "" && $scope.idExpanded === "") {
        $scope.tableRowIndexPrevExpanded = "";
        $scope.tableRowExpanded = true;
        $scope.tableRowIndexCurrExpanded = index;
        $scope.idExpanded = Id;
        $scope.dataCollapse[index] = false;
      } else if ($scope.tableRowExpanded === true) {
        if ($scope.tableRowIndexCurrExpanded === index && $scope.idExpanded === Id) {
          $scope.tableRowExpanded = true;
          $scope.tableRowIndexCurrExpanded = "";
          $scope.idExpanded = "";
          $scope.dataCollapse[index] = true;
        } else {
          $scope.tableRowIndexPrevExpanded = $scope.tableRowIndexCurrExpanded;
          $scope.tableRowIndexCurrExpanded = index;
          $scope.idExpanded = Id;
          $scope.dataCollapse[$scope.tableRowIndexPrevExpanded] = true;
          $scope.dataCollapse[$scope.tableRowIndexCurrExpanded] = false;
        }
      }
    };

    vm.delete = function(itm) {
      setorSrv.del(itm).then(function() {
        vm.utils.ShowSuccess("Exclusão de registro", "Operação realizada com sucesso!");
        vm.setores.splice(vm.setores.indexOf(itm), 1);
      })
        .finally(function() {
          vm.loading = false;
        });
    }
  }
})();

(function() {
  'use strict';

  angular.module('ticket.controller.planta')

  .controller('ticket.controller.planta.setor.form', setorFormController);

  setorFormController.$inject =['appSettings', '$scope', 'common', '$state', 'ticket.service.local.setor', 'ticket.service.local.pavimento', 'ticket.service.local.layout', 'ticket.service.local.mapaassento'];

  function setorFormController(appSettings, $scope, common, $state, setorSrv, pavimentoSrv, layoutSrv, mapaAssentoSrv) {
    var vm = common.controller.form(this, setorSrv);
    var isEditing = false;
    vm.ZonaDisable = true;

    vm.userSettings = appSettings.getUserStore();
    vm.loaded = function() {

      var lugarLivre = vm.item.LugarMarcado;

      vm.item.LugarMarcado = true;

      if (vm.item.Id !== undefined || vm.item.Id !== null)
        isEditing = true;

      if (isEditing) {
        $state.$current.data = {
          displayName: 'EDIÇÃO'
        }

        vm.item.LugarMarcado = lugarLivre;
      } else {
        vm.item.LugarMarcado = true;
      }

      $scope.$watch('vm.item.LugarMarcado', function() {
        if (vm.item.LugarMarcado)
          vm.item.QtdLugaresSetorLivre = null;
        else
          vm.item.IdMapa = null;
      });
    };

    $scope.$watch("vm.item.IdLayout",function () {

      if(vm.item.IdLayout)
      {
        pavimentoSrv.list({IdLayout :vm.item.IdLayout }).then(function(data) {
          vm.zonalist = data;
          vm.ZonaDisable = false;
        });
      }

    }, true);

    vm.LugarLivre = function() {}
    vm.cancel = function() {
      $state.go('planta.setor.grid');
    };

    //Salva e volta para o grid
    vm.save = function() {

      vm.loading = true;

      if (vm.item.Id == null) {
        setorSrv.post(vm.item).then(function(item) {
          vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
          $state.go('planta.setor.grid');
        })
          .finally(function() {
            vm.loading = false;
          });
      } else {

        setorSrv.put(vm.item).then(function(item) {
          vm.utils.ShowSuccess("Alteração de registro", "Operação realizada com sucesso!");
          $state.go('planta.setor.grid');
        })
          .finally(function() {
            vm.loading = false;
          });
      }
    }

    layoutSrv.list({
      Todos: true
    }).then(function(data) {
      vm.layoutList = data;
    });
    // pavimentoSrv.list().then(function(data) {
    //   vm.zonalist = data;
    // });

    mapaAssentoSrv.list({}).then(function(data) {
      vm.mapaAssentoList = data;
    });

  }

})();

(function () {
  'use strict';

  angular.module('ticket.controller.planta')


    .controller('ticket.controller.planta.sala.popupdocumento', salaPopupdocumentoController);


  salaPopupdocumentoController.$inject = [
    "common",
    "$scope",
    "$uibModalInstance",
    "table",
    "$rootScope",
    "ticket.service.local.sala", 'ticket.service.local.tipodocumentosala'];

  function salaPopupdocumentoController (common, $scope, $uibModalInstance, table, $rootScope, salaSvc, tipodocumentoSalaSrv) {

    var vm = this;
    vm.loaded = loaded;
    vm = common.controller.grid(vm, salaSvc);
    vm.search();

    vm.TableAdd = table;

    vm.Confirm = function (obj, lst) {

      var lsTitem = lst.filter(function (itm) {
        return itm.Id == obj.Id;
      });
      obj.Nome = lsTitem[0].Nome;

      $uibModalInstance.close(obj);
    };

    vm.Cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    function loaded() {
      tipodocumentoSalaSrv.list({}).then(function (tipodocumento) {
        vm.tipodocumentoSala = tipodocumento.filter(function (itm) {
          return table.filter(function (itmTable) {
              return itm.Id == itmTable.Id;
            }).length == 0
        })
      });
    }

  }


})();

(function () {
  'use strict';

  angular.module('ticket.controller.planta')

    .controller('ticket.controller.planta.sala', salaMasterController);
  salaMasterController.$inject = [
    '$scope',
    'common',
    '$uibModal',
    '$state',
    'ticket.service.local.sala'];
  function salaMasterController ($scope, common, $uibModal, $state, salaSrv) {
    var vm = common.controller.master(this, salaSrv, $scope);

  }
})();

(function () {
  'use strict';

  angular.module('ticket.controller.planta')


    .controller('ticket.controller.planta.sala.grid', salaGridController);

  salaGridController.$inject = ['common', 'ticket.service.local.sala', 'ticket.service.local.documentosala'];

  function salaGridController (common, salaSrv, documentoSalaSrv) {

    var vm = common.controller.grid(this, salaSrv);

    vm.del = function (itm) {
      vm.utils.Confirm("Exclusão de registro", "Deseja excluir esse registro?").then(function () {
        salaSrv.del(itm).then(function (salaDeletada) {
          vm.items.splice(vm.items.indexOf(itm), 1);
          documentoSalaSrv.getAll({
            Config: {Skip: 0, Top: 0},
            Filter: {SalaIdSala: itm.Id}
          }).then(function (data) {
            data.forEach(function (item, index) {
              documentoSalaSrv.del({Id: item.Id}).then(function () {

              });
            });
          });

          vm.utils.ShowSuccess("Exclusão de registro.", "Esse registro foi excluído com sucesso!");
        });
      });
    };

  }


})();

(function () {
  'use strict';

  angular.module('ticket.controller.planta')

   .controller('ticket.controller.planta.sala.form', salaFormController);


   salaFormController.$inject = ['$q', 'common', '$uibModal', '$state', 'ticket.service.local.sala', 'ticket.service.local.documentosala', 'ticket.service.local.tipodocumentosala'];

    function salaFormController ($q, common, $uibModal, $state, salaSrv, documentoSalaSrv, tipoDocumentoSalaSrv) {

      var vm = common.controller.form(this, salaSrv);
      var isEditing = false;

      vm.loaded = function () {
        if (vm.item.Id !== undefined || vm.item.Id !== null)
          isEditing = true;

        if (isEditing) {
          $state.$current.data = {displayName: 'EDIÇÃO'}
          documentoSalaSrv.getAll({
            Config: {Skip: 0, Top: 0},
            Filter: {IdSala: vm.item.Id}
          }).then(function (data) {
            data.forEach(function (item, index) {
              tipoDocumentoSalaSrv.get({Id: item.Id}).then(function (tipo) {
                item.Nome = tipo.Nome;
              });
              vm.Table.push(item);
            });
          });
        } else {
          //DO NOTHING
        }
      };

      vm.myfilter = function (v) {
        return v.deleted == null;
      };

      vm.Table = [];

      vm.openPopUp = function () {
        $uibModal.open({
          animation: false,
          templateUrl: 'view/planta/sala/template/popup.html',
          controller: 'ticket.controller.planta.sala.popupdocumento',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            table: function () {
              return vm.Table
            }
          }
        }).result.then(function (item) {
          vm.Table.push({
            Id: item.Id,
            Nome: item.Nome,
            Valor: item.Valor,
            Vencimento: item.Vencimento
          });
        });
      };

      vm.ExcluirItem = function (item) {

        if (vm.Table.length === 0) return;
        vm.Table.splice(vm.Table.indexOf(item), 1);
      };

      vm.cancel = function () {
        $state.go('planta.sala.grid');
      };
      //Salva e volta para o grid

      vm.save = function () {

        vm.loading = true;

        if (vm.item.Id == null) {
          salaSrv.post({Sala: vm.item, Documentos: vm.Table}).then(function () {
            vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
            $state.go('planta.sala.grid');
          })
            .finally(function () {
              vm.loading = false;
            });
        }
        else {
          salaSrv.put({Sala: vm.item, Documentos: vm.Table}).then(function () {
            vm.utils.ShowSuccess("Alteração de registro", "Operação realizada com sucesso!");
            $state.go('planta.sala.grid');
          })
            .finally(function () {
              vm.loading = false;
            });
        }
      }
    }


})();

(function() {
  'use strict';

  angular.module('ticket.controller.planta')

  .controller('ticket.controller.planta.pavimento', pavimentoMasterController);

  pavimentoMasterController.$inject = [
    '$scope',
    'common',
    '$uibModal',
    '$state',
    'ticket.service.local.pavimento'];

  function pavimentoMasterController($scope, common, $uibModal, $state, pavimentoSrv) {
    var vm = common.controller.master(this, pavimentoSrv, $scope);

  }
})();

(function() {
  'use strict';

  angular.module('ticket.controller.planta')

  .controller('ticket.controller.planta.pavimento.grid', pavimentoGridControllerfunction);

  pavimentoGridControllerfunction.$inject = ['$scope', '$rootScope', 'common', 'ticket.service.local.pavimento', 'ticket.service.local.layout', 'ticket.service.local.sala'];

  function pavimentoGridControllerfunction($scope, $rootScope, common, pavimentoSrv, layoutSrv, salaSrv) {

    var vm = common.controller.grid(this, pavimentoSrv);

    vm.search = function() {

      vm.searching = true;
      //Common
      vm.layouts = [];
      vm.salas = [];


      vm.dados = {};
      vm.dados.salas = [];

      var layouts = [];
      var salas = [];

      pavimentoSrv.getAll({
        Config: {
          Skip: 0,
          Top: 0
        },
        Filter: vm.Filter
      })
        .then(function(data) {

          $rootScope.$emit('queried', data);
          vm.pavimentos = data;
          // vm.pavimentos.forEach(function(item, index) {
          //   //Obtem os ids pais existêntes em setores
          //   if (salas.indexOf(item.IdSala) === -1)
          //     salas.push(item.IdSala);
          //
          //   if (layouts.indexOf(item.IdLayout) === -1)
          //     layouts.push(item.IdLayout);
          //
          // });
          // salas.forEach(function(IdSala, index) {
          //   salaSrv.get({
          //     Id: IdSala
          //   })
          //     .then(function(sala) {
          //
          //       sala.layouts = [];
          //
          //       layouts.forEach(function(IdLayout, index) {
          //         layoutSrv.get({
          //           Id: IdLayout
          //         })
          //           .then(function(layout) {
          //             if (layout.IdSala == IdSala)
          //               sala.layouts.push(layout);
          //           });
          //       });
          //
          //       vm.dados.salas.push(sala);
          //     });
          // });
        })
        .finally(function() {
          vm.searching = false;
        });
    };

    //TODO: Criar diretiva
    //Tabela
    $scope.tableRowExpanded = false;
    $scope.tableRowIndexCurrExpanded = "";
    $scope.showTransactions = true;
    $scope.tableRowIndexPrevExpanded = "";
    $scope.idExpanded = "";
    $scope.dataCollapse = [true, true, true, true, true, true];

    $scope.selectTableRow = function(index, Id) {
      if ($scope.tableRowExpanded === false && $scope.tableRowIndexCurrExpanded === "" && $scope.idExpanded === "") {
        $scope.tableRowIndexPrevExpanded = "";
        $scope.tableRowExpanded = true;
        $scope.tableRowIndexCurrExpanded = index;
        $scope.idExpanded = Id;
        $scope.dataCollapse[index] = false;
      } else if ($scope.tableRowExpanded === true) {
        if ($scope.tableRowIndexCurrExpanded === index && $scope.idExpanded === Id) {
          $scope.tableRowExpanded = false;
          $scope.tableRowIndexCurrExpanded = "";
          $scope.idExpanded = "";
          $scope.dataCollapse[index] = true;
        } else {
          $scope.tableRowIndexPrevExpanded = $scope.tableRowIndexCurrExpanded;
          $scope.tableRowIndexCurrExpanded = index;
          $scope.idExpanded = Id;
          $scope.dataCollapse[$scope.tableRowIndexPrevExpanded] = true;
          $scope.dataCollapse[$scope.tableRowIndexCurrExpanded] = false;
        }
      }
    };

    vm.delete = function(itm) {
      pavimentoSrv.del(itm).then(function() {
        vm.utils.ShowSuccess("Exclusão de registro", "Operação realizada com sucesso!");
        vm.pavimentos.splice(vm.pavimentos.indexOf(itm), 1);
      })
        .finally(function() {
          vm.loading = false;
        });
    }

  }
})();

(function() {
  'use strict';

  angular.module('ticket.controller.planta')

  .controller('ticket.controller.planta.pavimento.form', pavimentoFormController);

  pavimentoFormController.$inject = ['appSettings', 'common', '$state', 'ticket.service.local.pavimento', 'ticket.service.local.layout'];

  function pavimentoFormController(appSettings, common, $state, pavimentoSrv, layoutSrv) {

    var vm = common.controller.form(this, pavimentoSrv);
    var isEditing = false;
    vm.userSettings = appSettings.getUserStore();

    vm.loaded = function() {
      if (vm.item.Id !== undefined || vm.item.Id !== null)
        isEditing = true;


      if (isEditing) {
        $state.$current.data = {
          displayName: 'EDIÇÃO'
        }
      } else {
        //DO NOTHING
      }
    };
    vm.openGrid = function() {
      $state.go('planta.pavimento.grid');
    };

    //Salva e volta para o grid
    vm.save = function() {

      vm.loading = true;

      if (vm.item.Id == null) {
        pavimentoSrv.post(vm.item).then(function(item) {
          vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
          $state.go('planta.pavimento.grid');
        })
          .finally(function() {
            vm.loading = false;
          });
      } else {
        pavimentoSrv.put(vm.item).then(function(item) {
          vm.utils.ShowSuccess("Alteração de registro", "Operação realizada com sucesso!");
          $state.go('planta.pavimento.grid');
        })
          .finally(function() {
            vm.loading = false;
          });
      }
    }


    layoutSrv.list({
      Todos: true
    }).then(function(data) {
      vm.layoutList = data;
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.planta')
    .controller('ticket.controller.planta.bloqueio-permanente', [function () {
      var vm = this;
    }])

    .controller('ticket.controller.planta.bloqueio-permanente.grid', ['$scope', 'common', '$state', 'ticket.service.local.assentobloqueio', function ($scope, common, $state, assentobloqueioSrv) {
      var vm = common.controller.grid(this, assentobloqueioSrv);

      vm.add = function () {
        $state.go('planta.bloqueio-permanente.form');
      }
    }])

    .controller('ticket.controller.planta.bloqueio-permanente.form', [
      'common',
      '$scope',
      '$state',
      '$stateParams',
      'toaster',
      '$document',
      'appSettings',
      'ticket.service.local.assentobloqueio',
      'ticket.service.local.tipoassentobloqueio',
      'ticket.service.local.assento',
      'ticket.service.local.setor',
      'ticket.service.local.sala',
      'ticket.service.local.layout',
      function (common, $scope, $state, $stateParams, toaster, $document, appSettings, assentoBloqueioSrv, tipoAssentoBloqueioSrv, assentoSrv, setorSrv, salaSvc, layoutSvc) {
        var vm = common.controller.form(this, assentoBloqueioSrv);
        vm.loadingSvg = false;
        vm.listSetor = [];
        vm.listTiposBloqueio = [];
        vm.assentoList = [];
        vm.assentosBloqueados = [];
        vm.zoomHabilitado = false;

        vm.enableScroll = enableScroll;
        vm.disableScroll = disableScroll;

        var us = appSettings.getUserStore();
        var idEstabelecimento = us.id_estabelecimento

        vm.PossuiLayout = us.possui_layout;
        vm.PossuiSetor = us.possui_setor;

        //console.log('vm.PossuiLayout', vm.PossuiLayout);
        ///console.log('vm.PossuiSetor', vm.PossuiSetor);

        salaSvc.list({IdEstabelecimento: idEstabelecimento}).then(function (salas) {
          vm.listSalas = salas;
        });

        $scope.$watch('vm.item.IdSala', function () {
          // Resets the layout and their dependant datas when reselected
          vm.item.IdLayout = '';

          if (vm.item.IdSala) {
            layoutSvc.list({IdSala: vm.item.IdSala}).then(function (layouts) {
              vm.listLayouts = layouts;

              if (vm.PossuiLayout == 'False') {
                vm.item.IdLayout = layouts[0].Id;
              }
            });
          }
        });

        $scope.$watch('vm.item.IdLayout', function () {
          // Resets the sector and their dependant datas when reselected
          vm.item.IdSetor = '';
          if (vm.item.IdLayout) {

            setorSrv.list({IdLayout: vm.item.IdLayout}).then(function (result) {
              var setorLugarMarcado = result.filter(function (itm) {
                return itm.LugarMarcado == true;
              });

              if (vm.PossuiSetor == 'False') {
                //console.log('setorLugarMarcado[0]',setorLugarMarcado[0]);
                vm.item.IdSetor = setorLugarMarcado[0].Id
              }
                vm.listSetor = setorLugarMarcado;
            });
          }
        });


        if ($stateParams.IdAssento && $stateParams.IdSetor && $stateParams.DataInicio) {
          assentoBloqueioSrv.get($stateParams).then(function (data) {
            vm.item = data;
            vm.item.HoraInicio = moment(data.DataInicio, 'HH:mm').format('HH:mm');
            vm.item.HoraFim = moment(data.DataFim, 'HH:mm').format('HH:mm');
          });
        }

        if (!vm.item)
          vm.item = {};

        vm.item.Assentos = [];
        vm.minDate = new Date();


        tipoAssentoBloqueioSrv.list({})
          .then(function (data) {
            vm.listTiposBloqueio = data;
          });

        $scope.$watch('vm.item.IdSetor', function (idSetor, old) {

          // Resets if the chosen option is blank
          if(!idSetor) {
            vm.exibeBtn = false;
            vm.mapaSvg = '';
            vm.assentosBloqueados = [];
            return;
          }

          if (idSetor != old) {
            vm.assentosBloqueados = [];
          }

          if (!idSetor) return;
          else
            vm.loadingSvg = true;

          setorSrv.getSvg({
            Id: idSetor
          }).then(function (mapsvg) {
            vm.loadingSvg = false;
            vm.exibeBtn = true;
            vm.mapaSvg = mapsvg;
          });
        });


        /*var currSVG = null;
        vm.svgloaded = function (svg) {
          currSVG = svg;
          loadSVG(svg);
        };*/

        vm.svgloaded = function (svg) {
          //console.log("entrou");
          vm.svg = svg;
          window.we = {
            SetorLoaded: function () {

              assentoBloqueioSrv.list({
                IdSetor: vm.item.IdSetor
              }).then(function (assentos) {
                //console.log(assentos);
                var status = null;

                for (var i = 0; i < assentos.length; i++)
                  selecionar(status, (assentos[i].Bloqueado) ? 'S' : 'N', assentos[i].IdAssento, !assentos[i].Bloqueado, false, ((assentos[i].Bloqueado) ? "#FF0000" : "#0085A4"));
              });
            },
            seatClick: function (IdSessaoAssento, IdAssento, lblAssento) {

              var status = null;
              var idSessao = IdSessaoAssento == 'N' ? 'S' : 'N';

              var index = vm.assentosBloqueados.map(function (e) {
                return e.IdAssento;
              }).indexOf(IdAssento);

              if (index === -1) {
                vm.assentosBloqueados.push({
                  IdAssento: IdAssento,
                  DataInicio: (IdSessaoAssento == 'S') ? null : new Date()
                });
              } else {
                vm.assentosBloqueados.splice(index, 1, {
                  IdAssento: IdAssento,
                  DataInicio: (IdSessaoAssento == 'S') ? null : new Date()
                });
              }
              selecionar(status, idSessao, IdAssento, true, false, ((idSessao == 'S') ? "#FF0000" : "#0085A4"));
            }

          };

          svg[0].dispatchEvent( new Event('load'));

          // svg[0].onload({
          //   target: svg[0]
          // });

          //disableScroll();
        };

        function disableScroll() {
          vm.zoomHabilitado = true;

         var svgContent = document.getElementById('svgcontent');
          svgContent.style.pointerEvents = 'auto';

          document.body.onmousewheel = function () {
            return false;
          };
        };


        function enableScroll() {
          vm.zoomHabilitado = false;

         //console.log('enableScroll');
          var svgContent = document.getElementById('svgcontent');
          svgContent.style.pointerEvents = 'none';

          document.body.onmousewheel = function () {
            return true;
          };
        };

        vm.save = function () {
          vm.item.Assentos = vm.assentosBloqueados.filter(function (obj) {
            return obj.DataInicio !== null;
          });

          if(vm.item.Assentos.length > 0) {

            assentoBloqueioSrv.post(vm.item).then(function () {
              toaster.pop('success', "Bloqueio realizado com sucesso!", "Operação realizada com sucesso!");
              $state.go('^.grid');
            });
          }else {
            toaster.pop('warning', "Selecione pelo menos um assento!", "Nenhum assento selecionado!");
          }
        };
      }
    ]);
})();

(function() {
  'use strict';

  angular.module('ticket.controller.planta')

  .controller('ticket.controller.planta.layout', layoutMasterController);

  layoutMasterController.$inject = [
    '$scope',
    'common',
    '$uibModal',
    '$state',
    'ticket.service.local.layout'];
  function layoutMasterController($scope, common, layoutSrv) {
    var vm = common.controller.master(this, layoutSrv, $scope);

  }

})();

(function() {
  'use strict';

  angular.module('ticket.controller.planta')

  .controller('ticket.controller.planta.layout.grid', layoutGridController);

  layoutGridController.$inject = ['$rootScope', 'common', 'ticket.service.local.sala', 'ticket.service.local.layout'];

  function layoutGridController($rootScope, common, salaSrv, layoutSrv) {

    var vm = common.controller.grid(this, layoutSrv);


    vm.search = function() {

      vm.searching = true;


      vm.salas = [];
      vm.dados = {};
      vm.dados.salas = [];

      var salas = [];

      layoutSrv.getAll({
        Config: {
          Skip: 0,
          Top: 0
        },
        Filter: vm.Filter
      })
        .then(function(data) {
          $rootScope.$emit('queried', data);
          vm.layouts = data;

          //vm.items = data;

          // vm.layouts.forEach(function(item) {
          //   //Obtem os ids pais existêntes em setores
          //   if (salas.indexOf(item.IdSala) === -1)
          //     salas.push(item.IdSala);
          //
          // });
          // salas.forEach(function(IdSala) {
          //   salaSrv.get({
          //     Id: IdSala
          //   })
          //     .then(function(sala) {
          //       vm.dados.salas.push(sala);
          //       addDataCollapse();
          //     });
          // });

        })
        .finally(function() {
          vm.searching = false;
        });
    };

    vm.delete = function(itm) {
      layoutSrv.del(itm).then(function() {
        vm.utils.ShowSuccess("Exclusão de registro", "Operação realizada com sucesso!");
        vm.layouts.splice(vm.layouts.indexOf(itm), 1);
      })
        .finally(function() {
          vm.loading = false;
        });
    }


    //TODO: Criar diretiva
    //Tabela
    vm.dataCollapse = [];


    function addDataCollapse (){
      if(vm.dados.salas){
        for(var i = 0; i < vm.dados.salas.length; i++){
          vm.dataCollapse.push(true);
        }
      }
    }

    vm.selectTableRow = function(index){
      if(vm.dataCollapse[index]){
        vm.dataCollapse[index] = false;
      }else{

        vm.dataCollapse[index] = true;
      }
    };

  }


})();

(function() {
  'use strict';

  angular.module('ticket.controller.planta')
  .controller('ticket.controller.planta.layout.form', layoutFormController);

  layoutFormController.$inject = ['common', '$state', 'ticket.service.local.layout', 'ticket.service.local.sala'];
  function layoutFormController(common, $state, layoutSrv, salaSrv) {

    var vm = common.controller.form(this, layoutSrv);
    var isEditing = false;
    vm.loaded = function() {
      if (vm.item.Id !== undefined || vm.item.Id !== null)
        isEditing = true;


      if (isEditing) {
        $state.$current.data = {
          displayName: 'EDIÇÃO'
        }
      } else {
        //DO NOTHING
      }
    };
    vm.cancel = function() {
      $state.go('planta.layout.grid');
    };

    salaSrv.list({}).then(function(listaSala) {
      vm.salaList = listaSala;
    });

    //Salva e volta para o grid
    vm.save = function() {
      vm.loading = true;
      if (vm.item.Id == null) {
        layoutSrv.post(vm.item).then(function() {
          vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
          $state.go('planta.layout.grid');
        })
          .finally(function() {
            vm.loading = false;
          });
      } else {
        layoutSrv.put(vm.item).then(function() {
          vm.utils.ShowSuccess("Alteração de registro", "Operação realizada com sucesso!");
          $state.go('planta.layout.grid');
        })
          .finally(function() {
            vm.loading = false;
          });
      }
    }




  }

})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.fluxocaixa', [

        ]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')
    .controller('ticket.controller.fluxocaixa.fechamentocaixa',
      ["$scope", "common","ticket.service.fluxocaixa.bilheteriacaixa",
        function ($scope, common, bilheteriacaixaSvc) {
          var vm = common.controller.master(this,bilheteriacaixaSvc, $scope);
        }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')

    .controller('ticket.controller.fluxocaixa.fechamentocaixa.grid',
      [
        "common",
        '$state',
        'toaster',
        '$uibModal',
        "ticket.service.fluxocaixa.bilheteriacaixa",
        "ticket.service.reports.fechamentocaixa"
        , function (common, $state, toaster, $uibModal, bilheteriacaixaSvc, fechamentocaixaSvc) {

        var vm = common.controller.grid(this, bilheteriacaixaSvc);
        var _search = vm.search;

        vm.search = function(inScroll){
          if(vm.Filter.DataPeriodoInicio)
            vm.Filter.DataPeriodoInicio = moment( vm.Filter.DataPeriodoInicio).format();
          if(vm.Filter.DataPeriodoFim)
            vm.Filter.DataPeriodoFim = moment( vm.Filter.DataPeriodoFim).format();
          
          _search(inScroll);
        }


        vm.Filter.DataPeriodoInicio =  moment().subtract(7, 'days').format();
        
        vm.fecharCaixa = function (item) {

          item.loading = true;
          var IdCaixa = item.IdBilheteriaCaixa;
          item.searching = true;

          $uibModal.open({
            animation: true,
            templateUrl: 'view/fluxo-caixa/fechamentocaixa/popup/fechamentocaixa.popup.html',
            controller: 'ticket.controller.fluxocaixa.popfechamentocaixa',
            controllerAs: 'vm',
            size: 'lg',
            resolve: { caixa: function(){
                return item;
              } 
            }
          }).result.then(function (motivo) {

            fechamentocaixaSvc.fecharCaixa({IdCaixa: IdCaixa, MotivoGerente: motivo}).then(
              function (data) {

                toaster.pop("success", "Fechamento de Caixa", "Caixa fechado com sucesso!");
                $state.go('fluxocaixa.fechamentocaixa.form-relatorio', {  Uri: data.Url });

                vm.Data = data;
                item.StatusCaixa = "Fechado";
                item.DataHoraFechamento = new Date();
                item.searching = false;
              }
              ,
              function () {
                toaster.pop("error", "Fechamento de Caixa", "Erro ao fechar o caixa!");
              }
            ).finally(function () {
              item.searching = false;
            });
          }, function () {
            item.searching = false;
          });
        }

        vm.resumoFechamento = function (itm) {

          var idCaixa = itm.IdBilheteriaCaixa;

          itm.searching = true;

          fechamentocaixaSvc.fecharCaixa({IdCaixa: idCaixa, Resumo: true}).then(
            function (data) {
              itm.searching = false;
              $state.go('fluxocaixa.fechamentocaixa.form-relatorio', {Uri: data.Url});
            });
        }

      }]);

})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')
    .controller('ticket.controller.fluxocaixa.fechamentocaixa.form-relatorio', [
      'common'
      , '$stateParams'
      , '$sce'
      , '$state'
      , '$window'
      , 'ticket.service.reports.bordero'
      , function (common, $stateParams, $sce, $state, $window, borderoSrv) {

        var vm = common.controller.basic(this, borderoSrv);
        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width": "100%",
          "height": vm.height / 1.4
        }


        if ($stateParams.Uri == "" || $stateParams.Uri == null) {

          $state.go('fluxocaixa.fechamentocaixa.form');
        }
        else {
          vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
          vm.loading = false;
        }


        vm.voltar = function () {
          $state.go('fluxocaixa.fechamentocaixa.grid');
        }
      }])
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')
    .controller('ticket.controller.fluxocaixa.fechamentocaixa.card',
      [
        "common"
        , "$scope"
        , "$state"
        , "$uibModal"
        , "$log"
        , "toaster"
        , "ticket.service.fluxocaixa.bilheteriacaixa"
        , "ticket.service.reports.fechamentocaixa"
        , function (common, $scope, $state, $uibModal, $log, toaster, bilheteriacaixaSvc, fechamentocaixaSvc) {

        var vm = common.controller.grid(this, bilheteriacaixaSvc);

        vm.search();

        //Ao entrar na tela, exibe os cxs, abertos e fechados.
        // bilheteriacaixaSvc.list({IdEstabelecimento: null}).then(function (data) {
        //   vm.items = data;
        // });

        // bilheteriacaixaSvc.getAll({
        //   Config: {Skip: 0, Top: 0},
        //   Filter: {IdEstabelecimento: null}
        // }).then(function (data) {
        //   vm.items = data;
        // });
        //
        // vm.Scroll = function () {
        //   console.log('o');
        // }


        vm.fecharCaixa = function (item) {

          item.loading = true;
          vm.loading = true;
          var IdCaixa = item.IdBilheteriaCaixa;

          $uibModal.open({
            animation: true,
            templateUrl: 'view/fluxo-caixa/fechamentocaixa/popup/fechamentocaixa.popup.html',
            controller: 'ticket.controller.fluxocaixa.popfechamentocaixa',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {}
          }).result.then(function (motivo) {

            fechamentocaixaSvc.fecharCaixa({IdCaixa: IdCaixa, MotivoGerente: motivo}).then(
              function (data) {

                toaster.pop("success", "Fechamento de Caixa", "Caixa fechado com sucesso!");
                $state.go('fluxocaixa.fechamentocaixa.form-relatorio', {  Uri: data.Url });

                vm.Data = data;
                item.StatusCaixa = "Fechado";
                item.DataHoraFechamento = new Date();
                item.loading = false;
              }
              ,
              function () {
                toaster.pop("error", "Fechamento de Caixa", "Erro ao fechar o caixa!");
              }
            ).finally(function () {
              vm.loading = false;
              item.loading = false;
            });
          }, function () {
            item.loading = false;
            vm.loading = false;
          });
        }

        vm.openGrid = function () {
          $state.go('fluxocaixa.fechamentocaixa.grid');
        }

      }])

    .controller("ticket.controller.fluxocaixa.popfechamentocaixa", [
      "common",
      "$scope",
      "$uibModalInstance",
      'caixa',
      function (common, $scope, $uibModalInstance, caixa) {

        var vm = common.controller.basic(this);
        vm.caixa = caixa;


        vm.Confirm = function (motivo) {
          $uibModalInstance.close(motivo);
        };

        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };

      }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')
    .controller('ticket.controller.fluxocaixa.estabelecimentofechamentodia',
      ["$scope", "common","ticket.service.fluxocaixa.estabelecimentofechamentodia",
        function ($scope, common, estabelecimentofechamentodiaSvc) {
          var vm = common.controller.master(this, estabelecimentofechamentodiaSvc, $scope);
        }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')

    .controller('ticket.controller.fluxocaixa.estabelecimentofechamentodia.grid',
      [
        "common",
        "$state",
        "ticket.service.fluxocaixa.estabelecimentofechamentodia",
        "ticket.service.reports.fechamentodia",
        function (common, $state, estabelecimentofechamentodiaSvc, fechamentodiaSvc) {

          var vm = common.controller.grid(this, estabelecimentofechamentodiaSvc);

          var _search = vm.search;

	        vm.search = function(inScroll){
	          if(vm.Filter.DataPeriodoInicio)
	            vm.Filter.DataPeriodoInicio = moment( vm.Filter.DataPeriodoInicio).format();
	          if(vm.Filter.DataPeriodoFim)
	            vm.Filter.DataPeriodoFim = moment( vm.Filter.DataPeriodoFim).format();

	          _search(inScroll);
	        }
	        vm.Filter.DataPeriodoInicio = moment().subtract(7, 'days').format();

          vm.resumoFechamentoDia = function (itm) {

            var id = itm.IdEstabelecimentoFechamentoDia;

            itm.searching = true;

            fechamentodiaSvc.fechamentodiaresumo({IdEstabelecimentoFechamentoDia: id}).then(
              function (data) {
                itm.searching = false;
                $state.go('fluxocaixa.estabelecimentofechamentodia.form-relatorio', {Uri: data.Url});
              });
          }

    }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')
    .controller('ticket.controller.fluxocaixa.estabelecimentofechamentodia.form-relatorio', [
      'common'
      , '$stateParams'
      , '$sce'
      , '$state'
      , '$window'
      , 'ticket.service.reports.bordero'
      , function (common, $stateParams, $sce, $state, $window, borderoSrv) {

        var vm = common.controller.basic(this, borderoSrv);
        vm.loading = true;

        var element = angular.element(document.querySelector('body'));
        vm.height = element[0].offsetHeight;
        vm.style = {
          "width": "100%",
          "height": vm.height / 1.4
        }


        if ($stateParams.Uri == "" || $stateParams.Uri == null) {

          $state.go('fluxocaixa.estabelecimentofechamentodia.form');
        }
        else {
          vm.pdfUrl = $sce.trustAsResourceUrl($stateParams.Uri);
          vm.loading = false;
        }


        vm.voltar = function () {
          $state.go('fluxocaixa.estabelecimentofechamentodia.grid');
        }
      }])
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')
    .controller('ticket.controller.fluxocaixa.estabelecimentofechamentodia.form', ["common", "$state", "GuidEmpty", "ticket.service.fluxocaixa.estabelecimentoestacao"
      , "ticket.service.fluxocaixa.estabelecimentofechamentodia"
      , function (common, $state, GuidEmpty, estabelecimentoestacaoSvc, estabelecimentofechamentodiaSvc) {

        var vm = common.controller.basic(this);
        vm.loading = false;
        vm.loadingCaixa = false;
        vm.hasCaixaAberto = true;
        vm.caixas = [];
        vm.borderos = [];

        vm.hasBorderoAberto = true;
        vm.diaSelected = false;

        //DIAS ABERTOS( A SER FECHADOS)
        estabelecimentofechamentodiaSvc.diasabertos({}).then(function (data) {
          vm.diasAbertos = data;
          var hoje = moment(new Date()).format('YYYY-MM-DD');
           vm.diasAbertos.forEach(function (itm) {
             if(moment(itm.DataContabil).format('YYYY-MM-DD') == hoje)
              itm.flagHoje = true;
          });
        });

        vm.SelecionaDia = function (dia) {
          vm.closed = false;
          vm.loadingCaixa = true;
          vm.loadingBordero = true;
          vm.diaSelected = true;

          //DESMARCA TODOS ANTES DE SELECONAR O ESCOLHIDO
          vm.diasAbertos.filter(function (itm) {
            if (itm.selecionado)
              itm.selecionado = false;
          });

          
          dia.selecionado = true;

          //LISTA OS CAIXAS
          estabelecimentoestacaoSvc.listestacaofechamentodia({DataContabil: dia.DataContabil}).then(function (data) {
            vm.hasMenor = false;

            if (vm.diasAbertos.filter(function (itm) {
                return itm.DataContabil < dia.DataContabil;
              }).length > 0) {
              vm.hasMenor = true;
            }

            vm.caixas = data.filter(function (itm) {
              return itm.IdBilheteriaCaixa != GuidEmpty;
            });

            vm.hasCaixaAberto = (data.filter(function (itm) {
              return itm.IdBilheteriaCaixa != GuidEmpty && itm.DataHoraFechamento == null
            }).length > 0);
            vm.loadingCaixa = false;
          })

          estabelecimentofechamentodiaSvc.borderos({DataContabil: dia.DataContabil}).then(function (data) {
            vm.borderos = data;
            vm.hasBorderoAberto = (data.filter(function (itm) {
              return itm.StatusBordero == 'Aberto'
            }).length > 0);
            vm.loadingBordero = false;
          })
        }

        vm.FecharDia = function () {
          vm.loading = true;

          var dia = vm.diasAbertos.find(function (itm) {
            return itm.selecionado === true;
          });

          dia.loading = true;
          vm.loading = true;

          if (dia) {
            //FECHAMENTO
            estabelecimentofechamentodiaSvc.fecharDia({DataContabil: dia.DataContabil}).then(
              function (data) {
                vm.loading = false;
                vm.utils.ShowSuccess("Fechamento do dia", "Dia fechado com sucesso!");
                vm.openGrid();
              }
            ).finally(function () {
              vm.loading = false;
              dia.loading = false;
            })
          }
        }

        vm.openGrid = function () {
          $state.go('fluxocaixa.estabelecimentofechamentodia.grid');
        }

      }]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.estabelecimento', [
        	
        ]);
})();
(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.usuario',
      ["$scope", "common", "ticket.service.controleacesso.usuario",
        function ($scope, common, usuarioSvc) {
          var vm = common.controller.master(this, usuarioSvc, $scope);
        }])
    .controller('ticket.controller.estabelecimento.usuario.grid',
      ["$scope", "common", "toaster", "ticket.service.controleacesso.usuario",
        function ($scope, common, toaster, usuarioSvc) {
          var vm = common.controller.grid(this, usuarioSvc);

          vm.reenviarEmail = reenviarEmail;

          vm.getPk = function (itm) {
            return {Id: itm.IdAtracao};
          }

          function reenviarEmail(itm) {
            usuarioSvc.reenviarEmail({Email: itm.Login, Reenvio: true}).then(
              function (data) {
                toaster.pop("success", "Reenvio de e-mail", "E-mail reenviado com sucesso!");
              })
          }
        }])
    .controller('ticket.controller.estabelecimento.usuario.form',
      ["$q", "common","orderByFilter", "ticket.service.controleacesso.usuario", "ticket.service.controleacesso.perfil",
        function ($q, common,orderByFilter, usuarioSvc, perfilSvc) {
          var vm = common.controller.form(this, usuarioSvc);
          vm.exibirEstabelecimentos = exibirEstabelecimentos;
          vm.checkLogin = checkLogin;
          vm.lstPerfil = [];

          perfilSvc.list({}).then(function (lst) {
            lst = orderByFilter(lst, 'Nome');
            vm.lstPerfil = lst;
          });

          function checkLogin(v) {

            var deferred = $q.defer();
            var rex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (rex.test(v))
              deferred.resolve(true);
            else
              deferred.reject(false);
            return deferred.promise;
          }

          function exibirEstabelecimentos(itm) {
            var result = [];
            if (itm)
              result = vm.lstPerfil.filter(function (v) {
                return v.IdPerfil == itm.IdPerfil;
              });

            return (result.length > 0 ) ? result[0].Estabelecimentos : "Selecione um perfil para definir acesso a um estabelecimento.";
          }


        }]);
})();

(function() {
    'use strict';

    angular
    .module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.usuario.profile',
     ["ticket.service.controleacesso.usuario", "common","$state", "appSettings", "$rootScope",
     function(usuarioSvc, common, $state,  appSettings, $rootScope){
        var vm = common.controller.basic(this);
        var user = appSettings.getUserStore();
        /*
        "common", "ticket.service.controleacesso.usuario" "appSettings"
        */
        vm.cancel  = cancel;
        vm.save = save;
        vm.item = {};


        usuarioSvc.getProfile().then(function (v) {

          vm.item = v;
          vm.item.Perfil = user.perfil;
      });


        function cancel() {
            $state.go('site.home');
        }

        function save() {
         usuarioSvc.put(vm.item).then(function(v){
            vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
            $state.go('site.home');
        })
         .finally(function(){ vm.loading = false;
         });
     }



 }]);

})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.tipo-bloqueio', [function () {
      var vm = this;
    }])

    .controller('ticket.controller.estabelecimento.tipo-bloqueio.grid', ['$scope', 'common', '$state', 'ticket.service.local.tipoassentobloqueio', function ($scope, common, $state, tipoassentobloqueioSrv) {
      var vm = common.controller.grid(this, tipoassentobloqueioSrv);

    }])

    .controller('ticket.controller.estabelecimento.tipo-bloqueio.form', ['$scope', 'common', 'ticket.service.local.tipoassentobloqueio', function ($scope, common, tipoassentobloqueioSrv) {
      var vm = common.controller.form(this, tipoassentobloqueioSrv);

      vm.loaded = loaded;
      vm.CorSel = '#0000FF';

      $scope.$watch('vm.CorSel', function () {
        // vm.color = vm.CorSel;
        if (!vm.item)
          return;
        vm.item.Cor = vm.CorSel.replace('#', '');
      })

      vm.colors = [
        '#0000FF',
        '#A020F0',
        '#4B0082',
        '#32CD32',
        '#6B8E23',
        '#008000',
        '#FF69B4',
        '#FF1493',
        '#FF0000',
        '#B22222',
        '#5C3317',
        '#A68064',
      ];

      vm.options = {
        size: 30,
        roundCorners: true
      };

      function loaded() {
        if (!vm.item)
          return;
        vm.CorSel = '#' + vm.item.Cor;


      }


    }])
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')

    .controller('ticket.controller.estabelecimento.ingresso', [
      "$scope",
      "common",
      "$uibModal",
      "$state",
      "ticket.service.ingresso.estabelecimentoingresso",
      function (
        $scope,
        common,
        $uibModal,
        $state,
        estabelecimentoingressoSvc) {
        var vm = common.controller.master(this, estabelecimentoingressoSvc, $scope);
      }])
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')

    .controller('ticket.controller.estabelecimento.ingresso.grid', ["common", "ticket.service.ingresso.estabelecimentoingresso", function (common, estabelecimentoingressoSvc) {
      var vm = this;
      common.controller.grid(vm, estabelecimentoingressoSvc);
    }])
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')

    // .controller('ticket.controller.estabelecimento.ingresso', [
    //   "$scope",
    //   "common",
    //   "$uibModal",
    //   "$state",
    //   "ticket.service.ingresso.estabelecimentoingresso",
    //   function (
    //     $scope,
    //     common,
    //     $uibModal,
    //     $state,
    //     estabelecimentoingressoSvc) {
    //   var vm = common.controller.master(this, estabelecimentoingressoSvc, $scope);
    // }])

    .controller('ticket.controller.estabelecimento.ingresso.form', [
      "common",
      "$uibModal",
      "$state",
      "$interval",
      "ticket.service.ingresso.estabelecimentoingresso",
      "ticket.service.ingresso.tipovalidacaodocumento",
      "ticket.service.ingresso.regraingresso",
      "ticket.service.ingresso.tipoinformativoingresso",
      function (common,
                $uibModal,
                $state,
                $interval,
                estabelecimentoIngressoSvc,
                tipovalidacaodocumentoSvc,
                regraIngressoSvc,
                tipoinformativoingressoSvc) {

        var vm = this;
        vm.msgRegraIngresso = null;
        vm.descDisabled = false;
        vm.Meia = 7;
        vm.Cortesia = 5;
        vm.Inteira = 1;
        vm.PrecoFixo = 8;

        tipoinformativoingressoSvc.list({}).then(function (data) {
          vm.lstTipoInformativo = data;
        })


        // vm.lstTipoInformativo = [];
        // vm.lstTipoInformativo.push({Id :  1 ,Nome : 'Nenhum'});
        // vm.lstTipoInformativo.push({Id :  2 ,Nome : 'MouserOver'});
        // vm.lstTipoInformativo.push({Id :  3 ,Nome : 'AoClicar'});
        // vm.lstTipoInformativo.push({Id :  4 ,Nome : 'AoClicarExigeAceite'});


        vm.loaded = function () {

          //A mascara está dividindo o valor por 100. Reajustando para o valor correto antes de enviar.
          //vm.item.ValorRegra = vm.item.ValorRegra / 100;

          vm.searchValidaIngresso = true;

          regraIngressoSvc.getOne({IdRegraIngresso: vm.item.IdRegraIngresso}).then(function (data) {
            vm.RegraSelecionada = data[0];

            tipovalidacaodocumentoSvc.listvalid({IdRegraIngresso: vm.item.IdRegraIngresso}).then(function (data) {
              vm.tipovalidacaodocumento = data;
            }).finally(function () {
              vm.searchValidaIngresso = false;
            });

          });
        }

        vm = common.controller.form(vm, estabelecimentoIngressoSvc);
        //vm.item.VendeBilheteria = true;

        if(vm.item)
        {
          vm.item.VendeBilheteria = true;
          vm.item.VendeRemoto = false;
        }

        vm.save = function (regraSelecionada) {
          vm.loading = true;


          var valorRegra = vm.item.ValorRegra * 100;

          // console.log('regraSelecionada.IdRegraIngresso',regraSelecionada.IdRegraIngresso);
          // return false;

          if (regraSelecionada.TipoDesconto == "P") {

            if (valorRegra == 50 && regraSelecionada.IdRegraIngresso != vm.Meia) {
              vm.msgRegraIngresso = "O desconto de 50% só pode ser aplicado para a Regra do tipo MEIA.";
              vm.loading = false;
              return false;
            }
            else if (regraSelecionada.IdRegraIngresso == vm.Meia && valorRegra != 50) {
              vm.msgRegraIngresso = "Para a regra do tipo MEIA é obrigatório que o desconto seja de 50%";
              vm.loading = false;
              return false;
            }
            else if (valorRegra == 100 && regraSelecionada.IdRegraIngresso != vm.Cortesia) {
              vm.msgRegraIngresso = "O desconto de 100% só pode ser aplicado para a Regra do tipo CORTESIA.";
              vm.loading = false;
              return false;
            }
            else if (regraSelecionada.IdRegraIngresso == vm.Cortesia && valorRegra != 100) {
              vm.msgRegraIngresso = "Para a regra do tipo CORTESIA é obrigatório que o desconto seja de 100%";
              vm.loading = false;
              return false;
            }
            else if (valorRegra > 100) {
              vm.msgRegraIngresso = "O desconto máximo permitido é de 100%.";
              vm.loading = false;
              return false;
            }
            else if (valorRegra == 0) {
              vm.msgRegraIngresso = "Informe um desconto.";
              vm.loading = false;
              return false;
            }
            else {
              vm.msgRegraIngresso = null;
            }
          }
          else {
            //var valorRegra = vm.item.ValorRegra;

            if (regraSelecionada.IdRegraIngresso == vm.PrecoFixo && valorRegra == 0) {
              vm.msgRegraIngresso = "Informe o valor do Ingresso";
              vm.loading = false;
              return false;
            }

            if (regraSelecionada.IdRegraIngresso == vm.Inteira && valorRegra > 0) {
              vm.msgRegraIngresso = "Para a regra do tipo INTERIA não é permitido desconto.";
              vm.loading = false;
              return false;
            }
          }


          //A mascara está dividindo o valor por 100. Reajustando para o valor correto antes de enviar.
          //if(regraSelecionada.TipoDesconto == "P")
          //vm.item.ValorRegra =   vm.item.ValorRegra * 100;

          if (vm.item.Id == null) {
            estabelecimentoIngressoSvc.post(vm.item).then(function () {
              vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
              $state.go('estabelecimento.ingresso.grid');
            })
              .finally(function () {
                vm.loading = false;
              });
          }
          else {
            estabelecimentoIngressoSvc.put(vm.item).then(function () {
              vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
              $state.go('estabelecimento.ingresso.grid');
            })
              .finally(function () {
                vm.loading = false;
              });
          }
        };

        vm.OpenGrid = function () {
          $state.go("estabelecimento.ingresso.grid");
        };

        vm.open = function (regra) {

          $uibModal.open({
            animation: true,
            templateUrl: 'view/estabelecimento/ingresso/template/regra.tmpl.html',
            controller: 'ticket.controller.estabelecimento.ingresso.regra',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              regra: function () {
                return regra;
              }
            }
          }).result.then(function (item) {

            if (item.IdRegraIngresso == vm.Inteira) {
              vm.descDisabled = true;
              vm.item.ValorRegra = 0;
            }
            else if (item.IdRegraIngresso == vm.Meia) {
              vm.descDisabled = true;
              vm.item.ValorRegra = 0.5;
            }
            else if (item.IdRegraIngresso == vm.Cortesia) {
              vm.descDisabled = true;
              vm.item.ValorRegra = 1;
            }
            else {

              vm.descDisabled = false;
              vm.item.ValorRegra = null;
            }

            vm.searchValidaIngresso = true;
            vm.item.IdRegraIngresso = item.IdRegraIngresso;
            vm.RegraSelecionada = item;

            tipovalidacaodocumentoSvc.listvalid({IdRegraIngresso: item.IdRegraIngresso}).then(function (data) {
              vm.tipovalidacaodocumento = data;
            }).finally(function () {
              vm.searchValidaIngresso = false;
            });

          });
        }
      }])
    .controller("ticket.controller.estabelecimento.ingresso.regra", [
      "common",
      "$scope",
      "$uibModalInstance",
      "regra",
      "ticket.service.ingresso.regraingresso",
      "ticket.service.ingresso.tipovalidacaodocumento",
      function (common, $scope, $uibModalInstance, regra, regraIngressoSvc, tipovalidacaodocumentoSvc) {
        var vm2 = this;
        common.controller.grid(vm2, regraIngressoSvc);

        if (regra != undefined) {
          vm2.search();
        }
        vm2.loaded = loaded;

        vm2.Confirm = function (item, index) {
          var itm = angular.copy(item);
          itm.Index = index;


          $uibModalInstance.close(itm);

          // tipovalidacaodocumentoSvc.listvalid({IdRegraIngresso: itm.IdRegraIngresso}).then(function (data) {
          //   vm.tipovalidacaodocumento = data;
          //
          // }).finally(function () {
          //   $uibModalInstance.close(itm);
          // });

          vm2 = null;
        };

        vm2.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };

        function loaded() {


          if (regra != undefined) {
            vm2.items.forEach(function (itm, index) {
              if (itm.IdRegraIngresso == regra.IdRegraIngresso) {
                vm2.selected = index;
              }
            })
          }
        }

      }]);
})();

(function () {
  'use strict';

  //GETTER
  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.formapagamentotaxa.form', [
      'common',
      '$state',
      'orderByFilter',
      '$stateParams',
      'ticket.service.formapagamento.taxa',
      'ticket.service.formapagamento',
      'ticket.service.formapagamento.estabelecimento',
      function (common, $state, orderByFilter, $stateParams, formaPagamentoEstabelecimentoTaxaService, formaPagamentoService, formaPagamentoEstabelecimentoService) {

        var vm = common.controller.form(this, formaPagamentoEstabelecimentoTaxaService);

        //Carrega a lista de formas de pagamentos, antes de carregar o state


        formaPagamentoEstabelecimentoService.list({IdEstabelecimento: null}).then(function (data) {
          data = orderByFilter(data, 'NomeFormaPagamento');
          vm.formaPagamentoList =  data;
        });

        vm.minDate = new Date();

        isEditing();


        vm.save = function (itm) {
          if(vm.item.IdEstabelecimento)
          formaPagamentoEstabelecimentoTaxaService.put(vm.item).then(function () {
            vm.utils.ShowSuccess("Alteração de registro", "Operação realizada com sucesso!");

            $state.go('estabelecimento.formapagamentotaxa.grid');
          })
          else
            formaPagamentoEstabelecimentoTaxaService.post(vm.item).then(function () {
              vm.utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
              $state.go('estabelecimento.formapagamentotaxa.grid');
            })
        }

        function isEditing() {
          if ($stateParams.IdEstabelecimento && $stateParams.IdFormaPagamento && $stateParams.DataInicio) {
            formaPagamentoEstabelecimentoTaxaService.get($stateParams).then(function (data) {
              vm.item = data;
              return vm.item
            });
          }
        }
      }]);


})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.formapagamentotaxa',
      ['$scope', 'common', 'ticket.service.formapagamento.taxa',
        function ($scope,common, formaPagamentoEstabelecimentoTaxaService) {
        var vm = common.controller.master(this, formaPagamentoEstabelecimentoTaxaService,$scope);
      }]);


})();

(function() {
  'use strict';

  //GETTER
  angular.module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.formapagamentotaxa.grid', ['common', 'ticket.service.formapagamento.taxa', function(common, formaPagamentoEstabelecimentoTaxaService) {
      var vm = common.controller.grid(this, formaPagamentoEstabelecimentoTaxaService);
    }]);



})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.estacao', [function() {
      var vm = this;
    }])

  .controller('ticket.controller.estabelecimento.estacao.grid', ['$scope', 'common', '$state', 'ticket.service.controleestabelecimento.estabelecimentoEstacao', function($scope, common, $state, estacaoSvc) {
    var vm = common.controller.grid(this, estacaoSvc);

/*    if(vm.items.length <= 20)
      vm.complete = true;*/

  }])

  .controller('ticket.controller.estabelecimento.estacao.form', ['$rootScope', '$state','common', 'ticket.service.controleestabelecimento.estabelecimentoEstacao', function($rootScope, $state, common, estacaoSvc) {
    var vm = common.controller.form(this, estacaoSvc);

    vm.lstTiposImpressao =
      [
        { value : 'U' , Nome : 'USB'},
        { value : 'T' , Nome : 'Térmica(Contingência)'},
        { value : 'P' , Nome : 'Paralela'},
        { value : 'S' , Nome : 'Serial'}
    ]

    vm.lstTiposImpressora = 
      [
        { value : 'Argox OS-214 plus series PPLA' , Nome : 'Argox OS-214 plus series PPLA'},
        { value : 'Argox OS-2140 PPLA' , Nome : 'Argox OS-2140 PPLA'}
    ]


    vm.save = function() {

              vm.loading = true;
              if (pk.IdEstabelecimentoEstacao == null || pk.IdEstabelecimentoEstacao == "") {
                estacaoSvc.grant(vm.item)
                  .then(function(v) {
                    vm.utils.ShowSuccess("Registro de estação", "Operação realizada com sucesso!");
                    $rootScope.$emit('saved', v);
                    $state.go('^.grid');
                  })
                  .finally(function() {
                    vm.loading = false;
                  });
              } else {
                estacaoSvc.put(vm.item)
                  .then(function(v) {
                    vm.utils.ShowSuccess("Alteração de registro", "Operação realizada com sucesso!");
                    $rootScope.$emit('saved', pk);
                    $state.go('^.grid');
                  })
                  .finally(function() {
                    vm.loading = false;
                  });
              }
            }

  }])
})();

(function () {
    'use strict';

    angular
        .module('ticket.controller.estabelecimento')

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura', ["$scope", "common", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura",
            function ($scope, common, structSvc) {
                var vm = common.controller.master(this, structSvc, $scope);
            }])

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura.form', ["common", "toaster", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura",
            function (common, toaster, structSvc) {
                var vm = common.controller.basic(this, structSvc);

              structSvc.get({ pk: null }).then(function (data) {
                    vm.item = data;
                });

                vm.Salvar = function () {
                  vm.loading = true;
                    
                    structSvc.put(vm.item).then(
                            function (data) { toaster.pop('success', 'Sucesso!', 'Configuração realizada com sucesso!'); vm.loading = false;},
                            function () { vm.loading = false; }
                    );
                }
            }]);
})();

(function () {
    'use strict';

    angular
        .module('ticket.controller.estabelecimento')

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracao', ["$scope", "common", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
            function ($scope, common, estabelecimentoconfiguracaoSvc) {
                var vm = common.controller.master(this, estabelecimentoconfiguracaoSvc, $scope);
            }])

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracao.grid', ["common", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
            function (common, estabelecimentoconfiguracaoSvc) {
                var vm = common.controller.grid(this, estabelecimentoconfiguracaoSvc);
            }])

        .controller('ticket.controller.estabelecimento.estabelecimentoconfiguracao.form', ["common", "toaster", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
            function (common, toaster, estabelecimentoConfiguracaoInformacaoSvc) {
                var vm = common.controller.basic(this, estabelecimentoConfiguracaoInformacaoSvc);

              estabelecimentoConfiguracaoInformacaoSvc.get({ pk: null }).then(function (data) {
                    vm.item = data;
                });

                vm.Salvar = function () {
                  vm.loading = true;
                    if (vm.item.Id != null) {

                      estabelecimentoConfiguracaoInformacaoSvc.put(vm.item).then(
                            function (data) {

                                toaster.pop('success', 'Sucesso!', 'Configuração realizada com sucesso!');
                            },
                            function () {
                              vm.loading = false;
                            }
                      ).finally(function () {
                        vm.loading = false;
                      });
                    }
                    else {
                      estabelecimentoConfiguracaoInformacaoSvc.post(vm.item).then(
                        function (data) {
                            vm.item = data;
                            toaster.pop('success', 'Sucesso!', 'Configuração realizada com sucesso!');
                        },
                        function () {
                          vm.loading = false;
                        }
                  ).finally(function () {
                        vm.loading = false;
                      });
                    }
                }
            }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.dadosbancarios.grid', ['$scope', 'common', 'ticket.service.controleestabelecimento.dadosbancarios', dadosBancariosGridController]);
  function dadosBancariosGridController($scope, common, dadosBancarios) {
   var vm = common.controller.grid(this, dadosBancarios);
  }
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')
    .controller('ticket.controller.estabelecimento.dadosbancarios.form', ['$rootScope', '$state', 'common',  'ticket.service.controleestabelecimento.dadosbancarios', 'ticket.service.controleestabelecimento.empresa', 'ticket.service.controleestabelecimento.banco', dadosbancariosController]);

  function dadosbancariosController($rootScope, $state, common, dadosBancarios, empresaSrv, bancoSrv) {
    var vm = common.controller.form(this, dadosBancarios);

    listEmpresas();
    listBancos();


    function listEmpresas() {
      empresaSrv.list({}).then(function(empresas) {
        vm.empresaList = empresas;
        // if(angular.isUndefined(vm.empresaList))
        //   listEmpresas();
      });
    }

    function listBancos() {
      bancoSrv.list({}).then(function(bancos) {
        vm.bancoList = bancos;
        // if(angular.isUndefined(vm.bancoList))
        //   listBancos();
      });
    }
  }
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.conteudo', [
        	
        ]);
})();
(function () {
  'use strict';

  angular
    .module('ticket.controller.conteudo')

    .controller('ticket.controller.conteudo.tabelaprecopadrao', ["$scope", "common", "ticket.service.ingresso.tabelaprecopadrao", function ($scope, common, tabelaPrecoSvc) {
      var vm = common.controller.master(this, tabelaPrecoSvc, $scope);
    }])

    .controller('ticket.controller.conteudo.tabelaprecopadrao.grid', ["common", "ticket.service.ingresso.tabelaprecopadrao", function (common, tabelaPrecoSvc) {
      var vm = common.controller.grid(this, tabelaPrecoSvc);
    }])

    .controller('ticket.controller.conteudo.tabelaprecopadrao.form', [
      "common", "$uibModal", "$state", "$scope", "toaster", "ticket.service.ingresso.tabelaprecopadrao", "ticket.service.ingresso.tabelaprecopadraoestabelecimentoingresso",
      function (common, $uibModal, $state, $scope, toaster, tabelaPrecoSvc, tabelaPrecoPadraoEstabelecimentoIngressoSvc) {

        var vm = this;
        vm.loaded = loaded;

        vm = common.controller.form(vm, tabelaPrecoSvc);

        if (vm.item != null) {
          vm.item.Status = vm.item.Status == undefined ? false : vm.item.Status
        }

        vm.myfilter = function (v) {
          return v.deleted == null;
        };

        vm.Table = [];

        vm.open = function () {
          $uibModal.open({
            animation: false,
            templateUrl: 'view/conteudo/tabelaprecopadrao/template/ingresso.tmpl.html',
            controller: 'ticket.controller.conteudo.tabelaprecopadrao.popupingresso',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              table: function () {
                return vm.Table
              }
            }
          }).result.then(function (ingressos) {

            if (ingressos.length > 0) {
              ingressos.forEach(function (item, index) {

                var valor = 0;

                //Se a RegraIngresso for "8", o valor a ser pego é o da própria regra. Pois é para valor fixo.
                if (item.IdRegraIngresso == 8)
                  valor = item.ValorRegra;
                else
                  valor = parseFloat(item.TipoDesconto == 'F' ? vm.item.ValorBase !== undefined ? vm.item.ValorBase - item.ValorRegra : 0 : vm.item.ValorBase !== undefined ? vm.item.ValorBase - ((vm.item.ValorBase * item.ValorRegra)) : 0);

                vm.Table.push({
                  Nome: item.Nome,
                  TipoDesconto: item.TipoDesconto,
                  IdEstabelecimentoIngresso: item.Id,
                  //IdTabelaPrecoPadrao: item.IdTabelaPrecoPadrao,
                  ValorRegra: item.ValorRegra,
                  Valor: valor,
                  RegraIngresso: item.IdRegraIngresso
                });
              })
            }
          });
        }

        vm.ExcluirItem = function (item) {
          item.deleted = true;
        }

        $scope.$watch('vm.item.ValorBase', function () {

          for (var i = 0; i < vm.Table.length; i++) {
            var valor = 0;
            //Se a RegraIngresso for "8", o valor a ser pego é o da própria regra. Pois é para valor fixo.
            if (vm.Table[i].IdRegraIngresso == 8)
              valor = vm.Table[i].ValorRegra;
            else
              valor = parseFloat(vm.Table[i].TipoDesconto == 'F' ? vm.item.ValorBase !== undefined ? vm.item.ValorBase - vm.Table[i].ValorRegra : 0 : vm.item.ValorBase !== undefined ? vm.item.ValorBase - ((vm.item.ValorBase * vm.Table[i].ValorRegra)) : 0);

            console.log('valor', valor);

            vm.Table[i].Valor = valor;
          }
        });

        vm.Save = function () {
          vm.loading = true;
          var FormTabelaPreco = {
            TabelaPrecoPadrao: {},
            TabelaPrecoPadraoEstabelecimentoIngresso: []

          }

          FormTabelaPreco.TabelaPrecoPadrao = vm.item;

          for (var i = 0; i < vm.Table.length; i++) {
            FormTabelaPreco.TabelaPrecoPadraoEstabelecimentoIngresso.push({
              IdEstabelecimentoIngresso: vm.Table[i].IdEstabelecimentoIngresso,
              deleted: vm.Table[i].deleted
            })
          }

          if (FormTabelaPreco.TabelaPrecoPadrao.Id === undefined) {
            //INCLUS�O
            tabelaPrecoSvc.post(FormTabelaPreco).then(
              function (succ) {
                toaster.pop('success', 'Sucesso!', 'Tabela de preço cadastrada com sucesso!');
                $state.go('conteudo.tabelaprecopadrao.grid');
                vm.searching = false;
              },
              function (err) {
                vm.loading = false;
              }
            ).finally(function () {
              vm.loading = false;
            });
          } else {
            //EDI��O
            tabelaPrecoSvc.put(FormTabelaPreco).then(
              function (succ) {
                toaster.pop('success', 'Sucesso!', 'Tabela de preço atualizada com sucesso!');
                $state.go('conteudo.tabelaprecopadrao.grid');
                vm.searching = false;
              },
              function (err) {
                vm.loading = false;
              }
            ).finally(function () {
              vm.loading = false;
            });
          }
        }

        vm.OpenGrid = function () {
          $state.go('conteudo.tabelaprecopadrao.grid');
        }

        function loaded() {
          if (vm.item != null) {
            vm.item.Status = vm.item.Status == 2 ? true : false
          }

          if (vm.item.Id != null)
            tabelaPrecoPadraoEstabelecimentoIngressoSvc.list({
              IdTabelaPrecoPadrao: vm.item.Id
            }).then(

              function (data) {
                vm.Table = data;
              },
              function () {
              })
        }


      }
    ])

    .controller("ticket.controller.conteudo.tabelaprecopadrao.popupingresso", [
      "common",
      "$scope",
      "$uibModalInstance",
      "table",
      "$rootScope",
      "ticket.service.ingresso.estabelecimentoingresso",
      function (common, $scope, $uibModalInstance, table, $rootScope, ingressoSvc) {
        var vm = common.controller.grid(this, ingressoSvc);

        vm.TabelaIngressos = vm.items;
        vm.loaded = loaded;

        vm.selected = function (items, itm) {
          if (itm.selected)
            itm.selected = false;
          else
            itm.selected = true;

          var count = items.filter(function (itm) {
            return itm.selected == true > 0
          }).length;

          if (count > 0)
            vm.btnPopupIngresso = true;
          else
            vm.btnPopupIngresso = false;

        }

        vm.myfilter = function (v) {
          return v.selected == true;
        };

        vm.Confirm = function (lst) {
          $uibModalInstance.close(lst);
        };

        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };

        function loaded() {
          if (table.length != null)
            vm.TabelaIngressos = vm.items.filter(function (itm) {
              return table.filter(function (itmTable) {
                  return (itmTable.IdEstabelecimentoIngresso == itm.Id) && itmTable.deleted != true;
                }).length == 0;
            });
        }

      }
    ]);

})
();

(function() {
  'use strict';

  angular.module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.programacao.resumoprogramacao',[
      '$state',
      '$scope',
      'common',
      'dateFilter',
      '$filter',
      '$stateParams',
      '$uibModal',
      '$timeout',
      'toaster',
      'ticket.service.programacao.sessao',
      'ticket.service.controleestabelecimento.estabelecimento',
      'ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura',
      "ticket.service.cliente.producao",
      function(
        $state,
        $scope,
        common,
        dateFilter,
        $filter,
        $stateParams,
        $uibModal,
        $timeout,
        toaster,
        sessaoSvc,
        estabelecimentoSvc,
        estabelecimentoConfiguracaoEstruturaSvc,
        producaoSvc) {

        var vm = common.controller.basic(this);

        vm.Sessao = {
          ListaSessaoTipoSessaoEmpresa : [],
          IdTipoLote:null
        }

        vm.oneAtATime = false;
        vm.accordionArray = [];
        vm.ok = true;

        if(!$stateParams.IdSessao){
          back();
        }

        vm.Sessao.Id = $stateParams.IdSessao;
        vm.IdSessao = vm.Sessao.Id;

         if($stateParams && $stateParams.filter) {
           console.log('$stateParams', $stateParams);
           vm.Filter = $stateParams.filter;
         }

        estabelecimentoConfiguracaoEstruturaSvc.get({}).then(function (data) {
          if (data) {
            if (!data.PossuiLote)
              vm.Sessao.IdTipoLote = 1; //Se não possui lote, o mesmo sempre será do tipo Data;

            vm.PossuiLote = data.PossuiLote;
          }
        });

        if (vm.IdSessao) {
          sessaoSvc.get({
            Id: vm.IdSessao
          }).then(function (sessao) {

            if (sessao != null) {

              vm.Sessao.Id = vm.IdSessao;
              vm.Sessao.IdTipoAtracao = sessao.IdTipoAtracao;
              vm.Sessao.IdAtracao = sessao.IdAtracao;
              vm.Sessao.IdSala = sessao.IdSala;
              vm.Sessao.IdLayout = sessao.IdLayout;
              vm.Sessao.VendeRemoto = sessao.VendeRemoto;
              vm.Sessao.ExistiuVenda = sessao.ExistiuVenda;
              vm.Sessao.ModelCancelaReservaMinutoAntes = sessao.ModelCancelaReservaMinutoAntes;
              vm.Sessao.ModelDataEncerraVendaAposSessao = sessao.ModelDataEncerraVendaAposSessao;
              vm.Sessao.ModelDataEncerraVendaRemotoAntesSessao = sessao.ModelDataEncerraVendaRemotoAntesSessao;
              vm.Sessao.IdTipoLote = sessao.IdTipoLote;
              vm.Sessao.IdTipoAudio = sessao.IdTipoAudio;
              vm.Sessao.IdLegendaIdioma = sessao.IdLegendaIdioma;
              vm.Sessao.IdEstabelecimento = sessao.IdEstabelecimento;
              vm.Sessao.IdProducao = sessao.IdProducao;
            }
          }).finally(function (sessao) {
            if(vm.Sessao.IdProducao)
              producaoSvc.get({
                IdProducao: vm.Sessao.IdProducao
              }).then(function (data) {
                vm.Producao.push(data);
              });
          });
        }

        sessaoSvc.resumoProgramacao({Id:  $stateParams.IdSessao}).then(function(data) {
          data.HoraAbertura = moment(data.HoraAbertura, "HH:mm").format('HH:mm');
          vm.item = data;
          vm.item.DiaSemana = moment(data.DataHoraInicio).format('dddd').substring(0,3).toUpperCase();
          //vm.Ordena(vm.item.ListaTipoIngresso);

          vm.lotes = [];
          vm.setores = [];
          var copia = false;

          for (var k = 0; k < data.ListIngresso[0].ListaSetores.length; k++) {

            var st = data.ListIngresso[0].ListaSetores[k];

            vm.setores.push({
              IdLayout: null,
              IdMapa: null,
              InformacaoAcesso: null,
              MsgIngresso: null,
              NomeZona: st.NomeZona,
              QuantidadeLugares: st.QtdLugaresMaxima,
              Nome: st.NomeSetor,
              Id: st.IdSetor,
              LugarMarcado: st.LugarMarcado,
              ValorBase: st.ValorBase
            });
          }

          for (var i = 0; i < data.ListIngresso.length; i++) {
            var lote = data.ListIngresso[i];
            var NewLote = {
              IndexLote: lote.Lote != undefined ? lote.Lote : (vm.lotes.length + 1) - vm.QtdLoteDeleted,
              IdLote: copia ? null : lote.IdLote,
              setores: [],
              spinDelLot: false,
              QtdIngresso: lote.Quantidadeingresso,
              DataEncerramentoLote: new Date(lote.DataEncerramentoLote),
              HoraEncerramentoLote: lote.HoraEncerramentoLote,
              ExistiuVenda: copia ? false : lote.ExistiuVenda,
              LoteEncerrado: copia ? false : lote.LoteEncerrado,
              active: i == 0 ? true : false,
              IdSessaoLote: copia ? null : lote.IdSessaoLote,
              Lote : lote.Lote
            };

            for (var j = 0; j < lote.ListaSetores.length; j++) {
              var setor = lote.ListaSetores[j];

              var valorBase = 0;
              if (setor.ListaIngressos.length > 0)
                valorBase = setor.ListaIngressos[0].ValorBase;

              var setorNew = {
                IdSetor: setor.IdSetor,
                Nome: setor.NomeSetor,
                NomeZona: setor.NomeZona,
                QuantidadeLugares: setor.QtdLugaresMaxima,
                tipoIngresso: [],
                ValorBase: valorBase,
                LugarMarcado: setor.LugarMarcado,
                tabelaPreco: {},
                IdSessaoSetor: copia ? null : setor.IdSessaoSetor
              }

              for (var l = 0; l < setor.ListaIngressos.length; l++) {
                var ingresso = setor.ListaIngressos[l];

                var ingressoNew = {
                  IdSessaoSetorLotePrecoIngresso: copia ? null : ingresso.IdSessaoSetorLotePrecoIngresso,
                  IdTipoingresso: ingresso.IdEstabelecimentoIngresso,
                  Nome: ingresso.NomeIngresso,
                  Valor: ingresso.ValorIngresso,
                  IdSetor: ingresso.IdSetor,
                  TipoDesconto: ingresso.TipoDesconto,
                  ValorRegra: ingresso.ValorRegra,
                  IdEstabelecimentoIngresso: ingresso.IdEstabelecimentoIngresso,
                  deleted: null,
                  StatusRegistro: null,
                  excluido: false,
                  ValorBase: setor.ValorBase,
                  IdRegraIngresso: ingresso.IdRegraIngresso, //NEW ELTON
                  DefineValorNaSessao: ingresso.DefineValorNaSessao,
                  VendeBilheteria: ingresso.VendeBilheteria, //INGRESSO
                  VendeRemoto : ingresso.VendeRemoto, //INGRESSO
                  ExibeQtd : ingresso.ExibeQtd,
                  QuantidadeIngressos : ingresso.QuantidadeMaximaIngressos > 0 ? ingresso.QuantidadeMaximaIngressos : null,
                  OrdemIngresso : ingresso.OrdemIngresso
                }
                setorNew.tipoIngresso.push(ingressoNew);
              }
              NewLote.setores.push(setorNew);
            }
            vm.lotes.push(NewLote);
          }

          vm.accordionArray[0] = true;
          ValidaIngressoSetor();
        });

        vm.addTipoIngresso = function (lote, setor, $event, index) {

          $event.preventDefault();
          $event.stopPropagation();

          vm.accordionArray[index] = true;

          $uibModal.open({
            animation: false,
            templateUrl: 'view/conteudo/programacao/resumoProgramacao/popup/ingresso.resumo.popup.html',
            controller: 'ticket.controller.conteudo.programacao.resumo.popingresso',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              setor: function () {
                return setor
              }
            }
          }).result.then(function (items) {

            var valor = 0;

            if (items.length > 0) {

              for (var i = 0; i < items.length; i++) {
                //Se a RegraIngresso for "8", o valor a ser pego é o da própria regra. Pois é para valor fixo.
                if (items[i].IdRegraIngresso == 8) {
                  valor = items[i].ValorRegra;
                } else {

                  valor = parseFloat(items[i].TipoDesconto == 'F' ? setor.ValorBase !== null ? setor.ValorBase - items[i].ValorRegra : 0 : setor.ValorBase !== null ? setor.ValorBase - ((setor.ValorBase * items[i].ValorRegra)) : 0);
                }
                setor.tipoIngresso.push({
                  IdSessaoSetorLotePrecoIngresso: null,
                  IdTipoingresso: items[i].IdEstabelecimentoIngresso,
                  Nome: items[i].Nome,
                  Valor: valor > 0 ? valor : 0,
                  IdSetor: setor.IdSetor,
                  TipoDesconto: items[i].TipoDesconto,
                  ValorRegra: items[i].TipoDesconto == "F" ? items[i].ValorRegra : items[i].ValorRegra,
                  IdEstabelecimentoIngresso: items[i].Id,
                  deleted: null,
                  excluido: false,
                  IdRegraIngresso: items[i].IdRegraIngresso,
                  DefineValorNaSessao : items[i].DefineValorNaSessao,
                  VendeBilheteria: items[i].VendeBilheteria, //INGRESSO
                  VendeRemoto : items[i].VendeRemoto //INGRESSO
                });
              }
            }
            ValidaIngressoSetor();
          });


        }

        vm.save = function () {

          ValidaIngressoSetor();

          if(!vm.HasIngresso)
            toaster.pop('warnig', 'Aviso!', 'Algum dos setores está sem ingresso!');

          vm.loading = true;

          var ListaSessaoLote = [];
          var sessaoLote = {};
          var ListaSessaoSetor = [];
          var sessaoSetor = {};
          var ListaSessaoSetorLotePrecoIngresso = [];
          var sessaoSetorLotePrecoIngresso = {};
          var ListSessao = [];

          vm.Sessao.IdProducao = vm.Producao.length > 0 ? vm.Producao[0].IdProducao : null;

          ListSessao.push(vm.Sessao);

          if (vm.lotes.length > 0) {
            for (var i = 0; i < vm.lotes.length; i++) {

              if (vm.lotes[i].setores.length > 0) {

                for (var j = 0; j < vm.lotes[i].setores.length; j++) {

                  if (vm.lotes[i].setores[j].tipoIngresso.length > 0) {

                    for (var l = 0; l < vm.lotes[i].setores[j].tipoIngresso.length; l++) {
                      var p = vm.lotes[i].setores[j].tipoIngresso[l];

                      //if(!p.excluido) {
                      var valorBase = vm.lotes[i].setores[j].ValorBase;
                      sessaoSetorLotePrecoIngresso = {
                        Id: p.IdSessaoSetorLotePrecoIngresso,
                        IdSessaoSetor: null,
                        IdSessaoLote: null,
                        IdEstabelecimentoIngresso: p.IdEstabelecimentoIngresso,
                        ValorIngresso: p.Valor,
                        excluido: p.excluido,
                        ValorBase: valorBase,
                        IdRegraIngresso: p.IdRegraIngresso,
                        QuantidadeIngressos: p.QuantidadeIngressos,
                        IdSessaoIngresso : p.IdSessaoIngresso
                      }
                      //}

                      if (ListaSessaoSetorLotePrecoIngresso !== null || ListaSessaoSetorLotePrecoIngresso !== undefined)
                        ListaSessaoSetorLotePrecoIngresso.push(sessaoSetorLotePrecoIngresso);
                      sessaoSetorLotePrecoIngresso = null;
                    }
                  }

                  var s = vm.lotes[i].setores[j];
                  sessaoSetor = {
                    Id: s.IdSessaoSetor,
                    IdSessao: vm.IdSessao,
                    IdSetor: s.IdSetor,
                    QtdLugaresMaxima: s.QuantidadeLugares,
                    LugarMarcado: s.LugarMarcado,
                    ListaSessaoSetorLotePrecoIngresso: ListaSessaoSetorLotePrecoIngresso
                  }
                  ListaSessaoSetorLotePrecoIngresso = [];
                  ListaSessaoSetor.push(sessaoSetor);
                  sessaoSetor = [];
                }
              }

              var l = vm.lotes[i];

              sessaoLote = {
                Id: l.IdSessaoLote,
                IdSessaoLote: null,
                IdSessao: vm.IdSessao,
                DataHoraEncerramento: l.DataEncerramentoLote,
                HoraEncerramentoLote: l.HoraEncerramentoLote,
                QuantidadeIngressos: vm.PossuiLote ? l.QtdIngresso : vm.QtdIngressoSetores,
                ListaSessaoSetor: ListaSessaoSetor,
                deleted: l.deleted,
                Ordem: l.IndexLote
              }
              ListaSessaoSetor = [];
              ListaSessaoLote.push(sessaoLote);
              sessaoLote = null;
            }
          }

          sessaoSvc.alteraringresso({
            ListaSessaoLote: ListaSessaoLote,
            ListaSessao: ListSessao
          }).then(function () {
            vm.loading = false;
            vm.ok = false;
            toaster.pop('success', 'Sucesso!', 'Programação Alterada com sucesso!');

            $timeout(function () {
              back();
            },3000)

          },function () {
            vm.loading = false;
            vm.ok = true;
          });
        }

        vm.incluirQuantidade = function (itm) {
          itm.ExibeQtd = true;
        }

        vm.excluirQuantidade = function(itm){
          itm.ExibeQtd = false;
          itm.QuantidadeIngressos = null;
        }

        vm.delIngresso = function (item, setor) {

          if (item.IdSessaoSetorLotePrecoIngresso == null) {
            item.deleted = true;
          } else {
            item.excluido = true;
            item.deleted = true;
          }

          if (setor.tipoIngresso.length > 0) {

            var ingresso = setor.tipoIngresso = setor.tipoIngresso.filter(function (itm) {

              return itm.deleted == null || (itm.deleted == true && itm.excluido == true);
            });

            if (ingresso.length == 0)
              setor.tabelaPreco = {};
          }
          ValidaIngressoSetor();
        }

        function ValidaIngressoSetor() {

          for (var i = 0; i < vm.lotes.length; i++) {
            var lote = vm.lotes[i];

            if (lote.setores.length > 0) {

              vm.HasIngresso = true;

              for (var j = 0; j < lote.setores.length; j++) {
                var setor = lote.setores[j];


                if(setor.tipoIngresso.filter(function (t) {return t.deleted == undefined;}).length == 0)
                {
                  vm.HasIngresso = false;
                  return false;
                }

                setor.IngNeg = false;

                setor.tipoIngresso.forEach(function (itm) {
                  if (itm.Valor <= 0 && itm.IdRegraIngresso != 5) {
                    vm.HasIngresso = false;
                    setor.IngNeg = true;
                  }
                })
              }
            }
          }
        }

        //Producao
        vm.Producao = [];

        vm.querySearchProducao = function (filter) {
          var nome = filter.toLowerCase();
          return producaoSvc.list({Nome: nome});
        };
        //Fim Producao

        vm.back = function () {
          back();
        };

        function back() {
          $state.go('conteudo.programacao.grid', {Filter : $stateParams.Filter});
        }
      }])

    .controller("ticket.controller.conteudo.programacao.resumo.popingresso", [
      "common",
      "$scope",
      "$uibModalInstance",
      "setor",
      "$rootScope",
      "ticket.service.ingresso.estabelecimentoingresso",
      function (common, $scope, $uibModalInstance, setor, $rootScope, ingressoSvc) {
        var vm = common.controller.grid(this, ingressoSvc);
        vm.page = 0;
        vm.items = [];
        vm.searching = false;
        vm.complete = false;
        vm.sh = false;
        var pageSize = 20;
        vm.LimteAlcancado = false;
        vm.click = false;
        vm.ingressosSelecionados = [];

        var gridIngressos = angular.copy(setor);

        //Só faço o count com os Ingresso que não foram deletados, pois os ingressos que foram deletadas permanecem no objeto com o "deleted = true".
        var countGrid = gridIngressos.tipoIngresso.filter(function (itm) {
          return itm.deleted == null;
        }).length;

        if (countGrid == 30) {
          vm.LimteAlcancado = true;
        }
        else{
          vm.search = function (inScroll) {

            vm.click = true;

            vm.sh = true;
            if (vm.searching) return;
            vm.searching = true;

            if (!inScroll) {
              vm.page = 0;
              vm.complete = false;
              vm.items = [];
            }

            vm.Filter.Keys = [];
            setor.tipoIngresso.forEach(function (t) {
              vm.Filter.Keys.push({Id: t.IdEstabelecimentoIngresso});
            })

            ingressoSvc.getAll({
              Config: {
                Skip: vm.page,
                Top: pageSize
              },
              Filter: vm.Filter
            })
              .then(function (data) {
                vm.items = vm.items.concat(data);

                vm.items.filter(function (itm) {
                  vm.ingressosSelecionados.filter(function (itmTable) {
                    if(itmTable.Id == itm.Id && itmTable.deleted != true)
                    {
                      itm.selected = true;
                    }
                  })});

                if (data.length < pageSize)
                  vm.complete = true;

                if (data.length > 0) {

                  vm.page += 1;
                }
                else {
                  vm.NotResult = true;
                }

              }).finally(function () {
              vm.searching = false;
            });
          };
        }

        vm.Tabelaingressos = vm.items;

        vm.selected = function (items, itm) {

          var index = vm.ingressosSelecionados.map(function (e) {
            return e.Id;
          }).indexOf(itm.Id);

          if (index === -1) {
            vm.ingressosSelecionados.push(itm);
          }
          else {
            vm.ingressosSelecionados.splice(vm.ingressosSelecionados.indexOf(itm), 1);
          }

          if (itm.selected)
            itm.selected = false;
          else
            itm.selected = true;

          if (vm.ingressosSelecionados.length > 0)
            vm.btnPopupIngresso = true;
          else
            vm.btnPopupIngresso = false;


          if((vm.ingressosSelecionados.length + countGrid) <= 30)
            vm.LimteAlcancado = false;

        }
        // vm.myfilter = function (v) {
        //   return v.selected == true;
        // };

        vm.Confirm = function (lst) {
          var countLst = lst.length;
          if ((countGrid + countLst) > 30) {
            vm.LimteAlcancado = true;
            return false;
          }
          else {
            vm.LimteAlcancado = false;
          }

          $uibModalInstance.close(lst);
        };
        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }
    ]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.conteudo')
        .controller('ticket.controller.conteudo.programacao', 
            ["$scope", "common", "ticket.service.programacao.sessao", 
            function ($scope, common, programacaoSvc) {
            var vm = common.controller.master(this, programacaoSvc, $scope);
        }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.conteudo')


    .controller('ticket.controller.conteudo.programacao.grid', [
      "common",
      "$scope",
      "toaster",
      '$state',
      'orderByFilter',
      '$filter',
      '$stateParams',
      "ticket.service.programacao.sessao",
      "ticket.service.reports.bordero",
      'ticket.service.conteudo.atracao',
      "$uibModal",

      function (common, $scope, toaster, $state, orderByFilter, $filter, $stateParams, programacaoSvc, borderoSvc, atracaoSvc, $uibModal) {

        var vm = common.controller.grid(this, programacaoSvc);
        vm.loadBordero = false;


        vm.changeNaoLiberada = function () {
          if (vm.Filter.VendaLiberada) {
            vm.Filter.Todos = false;
          }
          else {
            vm.Filter.Todos = null;
          }
        };

        atracaoSvc.listAtracaoProgramacao({}).then(function (listData) {
          vm.atracoes = listData;
        });

        vm.add = add;

        if($stateParams.Filter) {
          vm.Filter.DataPeriodoInicio  = $stateParams.Filter.DataPeriodoInicio;
          vm.Filter.DataPeriodoFim  = $stateParams.Filter.DataPeriodoFim;
        }
        else
          vm.Filter.DataPeriodoInicio = new Date();


        vm.selectAll = function () {
          vm.items.map(function (itm) {
            if (!itm.PossuiBordero && itm.Status != 2)
              return itm.Selected = vm.SelectAll;
          });
        };

        vm.editarProgramacao = editarProgramacao;

        //NOVA : FLAG - VendaLiberada
        vm.SuspenderVenda = function () {
          vm.searching = true;

          vm.itemsSelected = [];
          vm.itemsSelected = $filter('filter')(vm.items, {'Selected': 'true'});


          if (vm.itemsSelected.length == 0) {
            vm.searching = false;
            toaster.pop('warning', 'Atenção!', 'Nenhuma sessão selecionada!');
            return
          }

          var Sessoes = [];

          console.log('vm.itemsSelected', vm.itemsSelected);

          for (var i = 0; i < vm.itemsSelected.length; i++) {
            Sessoes.push({
              Id: vm.itemsSelected[i].Id,
              VendeRemoto: false,
              VendaBilheteria: false,
              ExistiuVenda: true,
              RemoveBloqueio: false
            });
          }


          programacaoSvc.hasbloqueio(Sessoes).then(function (data) {
            console.log('hasbloqueio', data);

            if(data) {
              $uibModal.open({
                animation: false,
                templateUrl: "view/common/confirm-cancel.html",
                controller: function ($uibModalInstance, itm) {
                  var vm = this;
                  vm.itm = itm;
                  vm.no = function () {
                    $uibModalInstance.close(2);
                    vm.limpaBloqueio = 'NAO'
                  }
                  vm.yes = function () {
                    $uibModalInstance.close(1);
                    vm.limpaBloqueio = 'SIM'
                  }
                  vm.cancel = function () {
                    $uibModalInstance.close(3);
                    return false;
                    vm.limpaBloqueio = 'CANCELAR'
                  }
                },
                controllerAs: 'vm',
                size: 'sm',
                resolve: {
                  itm: function () {
                    return {
                      tit: 'Confirmação!',
                      msg: 'Deseja excluir os bloqueios caso não haja vendas?'
                    };
                  }
                }
              }).result.then(function (item) {

                if (item === 1) {
                  Sessoes.forEach(function (itm) {
                    itm.RemoveBloqueio = true
                  })
                }
                else if (item === 2) {
                  Sessoes.forEach(function (itm) {
                    itm.RemoveBloqueio = false
                  })
                }
                else {
                  vm.searching = false;
                  return;
                }
                programacaoSvc.put(Sessoes).then(
                  function () {
                    vm.searching = false;
                    toaster.pop('success', 'Sucesso!', 'Vendas suspensas com sucesso!');
                    vm.search();
                    vm.SelectAll = false;
                  },
                  function () {
                  });

              });
            }
            else{
              programacaoSvc.put(Sessoes).then(
                function () {
                  vm.searching = false;
                  toaster.pop('success', 'Sucesso!', 'Vendas suspensas com sucesso!');
                  vm.search();
                  vm.SelectAll = false;
                },
                function () {
                });
            }
          })




        };

        //NOVA : FLAGS - VendeRemoto VendeBilheteria ExistiuVenda VendaLiberada
        vm.LiberarOnlineBilheteria = function (el) {

          vm.searching = true;

          vm.itemsSelected = [];
          vm.itemsSelected = $filter('filter')(vm.items, {'Selected': 'true'});

          if (vm.itemsSelected.length == 0) {
            vm.searching = false;
            toaster.pop('warning', 'Atenção!', 'Nenhuma sessão selecionada!');
            return
          }

          var Sessoes = [];

          for (var i = 0; i < vm.itemsSelected.length; i++) {
            Sessoes.push({
              Id: vm.itemsSelected[i].Id,
              VendeRemoto: true,
              VendaBilheteria: true,
              ExistiuVenda: true
            });
          }

          programacaoSvc.put(Sessoes).then(
            function () {
              vm.searching = false;
              toaster.pop('success', 'Sucesso!', 'Vendas liberadas com sucesso!');
              vm.search();
              vm.SelectAll = false;
            },
            function () {
            });
        };


        //NOVA : FLAGS - VendeBilheteria ExistiuVenda VendaLiberada
        vm.LiberarBilheteria = function () {
          vm.searching = true;

          vm.itemsSelected = [];
          vm.itemsSelected = $filter('filter')(vm.items, {'Selected': 'true'});

          if (vm.itemsSelected.length == 0) {
            vm.searching = false;
            toaster.pop('warning', 'Atenção!', 'Nenhuma sessão selecionada!');
            return
          }

          var Sessoes = [];

          for (var i = 0; i < vm.itemsSelected.length; i++) {
            Sessoes.push({
              Id: vm.itemsSelected[i].Id,
              VendaBilheteria: true,
              ExistiuVenda: true,
              VendeRemoto: false
            });
          }

          programacaoSvc.put(Sessoes).then(
            function () {
              vm.searching = false;
              toaster.pop('success', 'Sucesso!', 'Vendas bilheteria liberadas com sucesso!');
              vm.search();
              vm.SelectAll = false;
            },
            function () {
            });
        };

        vm.LiberarOnline = function () {
          vm.searching = true;

          vm.itemsSelected = [];
          vm.itemsSelected = $filter('filter')(vm.items, {'Selected': 'true'});

          if (vm.itemsSelected.length == 0) {
            vm.searching = false;
            toaster.pop('warning', 'Atenção!', 'Nenhuma sessão selecionada!');
            return
          }

          var Sessoes = [];

          for (var i = 0; i < vm.itemsSelected.length; i++) {
            Sessoes.push({
              Id: vm.itemsSelected[i].Id,
              VendaBilheteria: false,
              ExistiuVenda: true,
              VendeRemoto: true
            });
          }

          programacaoSvc.put(Sessoes).then(
            function () {
              vm.searching = false;
              toaster.pop('success', 'Sucesso!', 'Vendas bilheteria liberadas com sucesso!');
              vm.search();
              vm.SelectAll = false;
            },
            function () {
            });
        };


        vm.GerarBordero = function (sessao) {
          $scope.Atracao = sessao.NomeAtracao;
          $scope.DataHoraInicio = sessao.DataHoraInicio;

          $uibModal.open({
            animation: true,
            template: '' +
            '<div class="modal-header">' +
            '<h3 class="modal-title">Borderô</h3>' +
            '</div>' +
            '<div class="modal-body">' +
            '<p><strong>Deseja gerar o borderô para a sessao abaixo ?</strong></p>' +
            '<p>Atração : {{Atracao}}</p>' +
            "<p>Sessão : {{DataHoraInicio | date : 'dd/MM'}} ÀS {{DataHoraInicio | date : 'HH:mm'}}</p>" +
            '</div>' +
            '<div class="modal-footer">' +
            '<button class="btn btn-outline btn-link pull-right" type="button" ng-click="vm.Cancel();">Não</button>' +
            '<button class="btn btn-w-m btn-success pull-right" type="button" ng-click="vm.Confirm();">Sim</button>' +
            '</div>',
            controller: function ($uibModalInstance) {
              var vm = this;
              vm.Confirm = function (itm) {
                $uibModalInstance.close(itm);
              };
              vm.Cancel = function () {
                $uibModalInstance.dismiss('cancel');
              };
            },
            controllerAs: 'vm',
            size: 'md',
            scope: $scope,
            resolve: {}
          }).result.then(function () {
            vm.loadBordero = true;
            sessao.searching = true;
            borderoSvc.bordero({IdSessao: sessao.Id}).then(function (data) {
              toaster.pop('success', 'Sucesso!', 'Bordero gerado com sucesso!');
              vm.loadBordero = false;
              sessao.searching = false;
              sessao.PossuiBordero = true;
            }, function () {
              sessao.PossuiBordero = false;
            });
          });
        }

        function add() {
          $state.go('conteudo.programacao.form.identificacao')
        }

        function editarProgramacao(itm) {
          $state.go('conteudo.programacao.form.identificacao', {Id: itm.Id});
        }

        vm.resumoProgramacao = function (itm) {
          $state.go('conteudo.programacao.resumoprogramacao', {IdSessao: itm.Id, Filter : vm.Filter});
        }
      }
    ]);
})();

/// <reference path="../../../../view/conteudo/programacao/template/ingresso.tmpl.html" />
/// <reference path="../../../../view/conteudo/programacao/template/ingresso.tmpl.html" />
(function () {
  'use strict';

  angular
    .module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.programacao.form', [
      "orderByFilter",
      "$ocLazyLoad",
      "common",
      "$q",
      "$timeout",
      "$scope",
      "$uibModal",
      "$state",
      "$stateParams",
      "appSettings",
      "dateFilter",
      "toaster",
      "ticket.service.programacao.sessao",
      "ticket.service.conteudo.atracao",
      "ticket.service.controleestabelecimento.estabelecimentoTipoAtracao",
      "ticket.service.local.layout",
      "ticket.service.local.sala",
      "ticket.service.local.setor",
      'ticket.service.ingresso.tabelaprecopadraoestabelecimentoingresso',
      'ticket.service.programacao.tiposessaoempresa',
      'ticket.service.programacao.legendaidioma',
      'ticket.service.conteudo.artista',
      'ticket.service.programacao.sessaotiposessaoempresa',
      'ticket.service.programacao.sessaoparticipanteconvidado',
      'ticket.service.programacao.tipoentregaestabelecimento',
      "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
      "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura",
      "ticket.service.conteudo.tipoatracao",
      "ticket.service.cliente.producao",
      function (orderByFilter,
                $ocLazyLoad,
                common,
                $q,
                $timeout,
                $scope,
                $uibModal,
                $state,
                $stateParams,
                appSettings,
                dateFilter,
                toaster,
                sessaoSvc,
                atracaoSvc,
                tipoAtracaoSvc,
                layoutSvc,
                salaSvc,
                setorSvc,
                tabelaprecopadraoestabelecimentoingressoSvc,
                tipoSessaoEmpresaSvc,
                legendaIdiomaSvc,
                artistaSvc,
                sessaotiposessaoempresaSvc,
                sessaoparticipanteconvidadoSvc,
                tipoEntregaEstabelecimentoSvc,
                estabelecimentoConfiguracaoInformacaoSvc,
                estabelecimentoConfiguracaoEstruturaSvc,
                tipoatracaoSvc,
                producaoSvc) {

        var vm = common.controller.basic(this);

        vm.QtdLoteDeleted = 0;
        vm.lotes = [];
        vm.tabelaDataHorario = [];
        var user = appSettings.getUserStore();
        vm.Today = moment().add('day');
        vm.CopiaSessao = false;
        vm.HasSessao = false;
        vm.SearchSessao = false;
        vm.clickIdentificacao = true;
        vm.PossuiLote = false;
        vm.HasTipoEntrega = true;
        vm.DataHora = function () {
          vm.clickDataHora = true;
        }
        vm.minDate = new Date();
        vm.ValorIngresso = function () {
          vm.clickValorIngresso = true;
        }
        vm.Detalhes = function () {
          vm.clickDetalhes = true;
        }
        vm.Incluido = [];

        vm.Sessao = {
          Id: null,
          IdEstabelecimento: null,
          IdAtracao: null,
          IdSala: null,
          IdLayout: null,
          DataHoraInicio: null,
          IdTipoLote: 1,
          IdTipoAudio: 1,
          IdLegendaIdioma: null,
          ListaSessaoTipoSessaoEmpresa: [],
          ListaSessaoParticipanteConvidado: [],
          ListaSessaoTipoEntregaEstabelecimento: [],
          ExistiuVenda: false,
          ModelEncerraVendaAutomatica:null,
          VendeRemoto:null,
          VendaBilheteria:null
        };

        vm.calcIngressos = calcIngressos;
        vm.dadosIncompletos = dadosIncompletos;

        if ($stateParams.Id == null) {
          estabelecimentoConfiguracaoInformacaoSvc.get({}).then(function (data) {
            if (data) {
              // vm.Sessao.ModelDataEncerraVendaAposSessao = data.EncerramentoVendaMinutoAntesRemoto;
              // vm.Sessao.ModelCancelaReservaMinutoAntes = data.CancelaReservaMinutoAntes;
              // vm.Sessao.ModelDataEncerraVendaRemotoAntesSessao = data.EncerramentoVendaMinutoAposInicioSessao;

              vm.Sessao.ModelDataEncerraVendaAposSessao = data.EncerramentoVendaMinutoAposInicioSessao;
              vm.Sessao.ModelCancelaReservaMinutoAntes = data.CancelaReservaMinutoAntes;
              vm.Sessao.ModelDataEncerraVendaRemotoAntesSessao = data.EncerramentoVendaMinutoAntesRemoto;
            }
          });

          vm.Sessao.ModelEncerraVendaAutomatica = true;
//          vm.Sessao.VendeRemoto = true;
          $state.go('conteudo.programacao.form.identificacao');
        }

        // tipoatracaoSvc.list().then(function(data){
        //   console.log('tipoAtracao', data);
        //   vm.tipoatracao = data;
        // })

        estabelecimentoConfiguracaoEstruturaSvc.get({}).then(function (data) {
          if (data) {
            if (!data.PossuiLote)
              vm.Sessao.IdTipoLote = 1; //Se não possui lote, o mesmo sempre será do tipo Data;

            vm.PossuiLote = data.PossuiLote;
          }
        });

        vm.MontaSessao = function (idSessao, copia) {

          vm.lotes = [];
          vm.setores = [];

          vm.IdSessao = idSessao;

          sessaoSvc.listSessao({
            Id: idSessao
          }).then(function (sessaoLotes) {
            if (!sessaoLotes || sessaoLotes.length === 0) return;

            for (var k = 0; k < sessaoLotes[0].ListaSetores.length; k++) {

              var st = sessaoLotes[0].ListaSetores[k];

              vm.setores.push({
                IdLayout: null,
                IdMapa: null,
                InformacaoAcesso: null,
                MsgIngresso: null,
                NomeZona: st.NomeZona,
                QuantidadeLugares: st.QtdLugaresMaxima,
                Nome: st.NomeSetor,
                Id: st.IdSetor,
                LugarMarcado: st.LugarMarcado,
                ValorBase: st.ValorBase
              });
            }

            for (var i = 0; i < sessaoLotes.length; i++) {
              var lote = sessaoLotes[i];
              var NewLote = {
                IndexLote: lote.Lote != undefined ? lote.Lote : (vm.lotes.length + 1) - vm.QtdLoteDeleted,
                IdLote: copia ? null : lote.IdLote,
                setores: [],
                spinDelLot: false,
                QtdIngresso: lote.Quantidadeingresso,
                DataEncerramentoLote: new Date(lote.DataEncerramentoLote),
                HoraEncerramentoLote: lote.HoraEncerramentoLote,
                ExistiuVenda: copia ? false : lote.ExistiuVenda,
                LoteEncerrado: copia ? false : lote.LoteEncerrado,
                active: i == 0 ? true : false,
                IdSessaoLote: copia ? null : lote.IdSessaoLote,
                Lote : lote.Lote
              };

              for (var j = 0; j < lote.ListaSetores.length; j++) {
                var setor = lote.ListaSetores[j];

                var valorBase = 0;
                if (setor.ListaIngressos.length > 0)
                  valorBase = setor.ListaIngressos[0].ValorBase;

                var setorNew = {
                  IdSetor: setor.IdSetor,
                  Nome: setor.NomeSetor,
                  NomeZona: setor.NomeZona,
                  QuantidadeLugares: setor.QtdLugaresMaxima,
                  tipoIngresso: [],
                  ValorBase: valorBase,
                  LugarMarcado: setor.LugarMarcado,
                  tabelaPreco: {},
                  IdSessaoSetor: copia ? null : setor.IdSessaoSetor
                }

                for (var l = 0; l < setor.ListaIngressos.length; l++) {
                  var ingresso = setor.ListaIngressos[l];

                  var ingressoNew = {
                    IdSessaoSetorLotePrecoIngresso: copia ? null : ingresso.IdSessaoSetorLotePrecoIngresso,
                    IdTipoingresso: ingresso.IdEstabelecimentoIngresso,
                    Nome: ingresso.NomeIngresso,
                    Valor: ingresso.ValorIngresso,
                    IdSetor: ingresso.IdSetor,
                    TipoDesconto: ingresso.TipoDesconto,
                    ValorRegra: ingresso.ValorRegra,
                    IdEstabelecimentoIngresso: ingresso.IdEstabelecimentoIngresso,
                    deleted: null,
                    StatusRegistro: null,
                    excluido: false,
                    ValorBase: setor.ValorBase,
                    IdRegraIngresso: ingresso.IdRegraIngresso, //NEW ELTON
                    DefineValorNaSessao: ingresso.DefineValorNaSessao,
                    VendeBilheteria: ingresso.VendeBilheteria, //INGRESSO
                    VendeRemoto : ingresso.VendeRemoto, //INGRESSO
                    ExibeQtd : ingresso.ExibeQtd,
                    QuantidadeIngressos : ingresso.QuantidadeMaximaIngressos > 0 ? ingresso.QuantidadeMaximaIngressos : null,
                    OrdemIngresso : ingresso.OrdemIngresso
                  }
                  setorNew.tipoIngresso.push(ingressoNew);
                }
                NewLote.setores.push(setorNew);
              }
              vm.lotes.push(NewLote);
            }

            calcIngressos();

          }).finally(function () {

            if (vm.setores.length > 0) {
              vm.QtdIngressoSetores = vm.setores.map(function (itm) {
                return itm.QuantidadeLugares;
              }).reduce(function (total, value) {
                return total + value;
              });
            }
          });

          if (idSessao) {
            $scope.exibeTipoAtracao = true;
            sessaoSvc.get({
              Id: idSessao
            }).then(function (sessao) {

              if (sessao != null) {

                vm.item.IdTipoAtracao = sessao.IdTipoAtracao;

                vm.Sessao.IdAtracao = sessao.IdAtracao;
                vm.Sessao.IdSala = sessao.IdSala;
                vm.Sessao.IdLayout = sessao.IdLayout;
                vm.Sessao.VendeRemoto = sessao.VendeRemoto; //GET OK
                vm.Sessao.VendaBilheteria = sessao.VendaBilheteria; //GET OK

                vm.Sessao.ExistiuVenda = copia ? false : sessao.ExistiuVenda;
                vm.Sessao.ModelCancelaReservaMinutoAntes = sessao.ModelCancelaReservaMinutoAntes;
                vm.Sessao.ModelDataEncerraVendaAposSessao = sessao.ModelDataEncerraVendaAposSessao;
                vm.Sessao.ModelDataEncerraVendaRemotoAntesSessao = sessao.ModelDataEncerraVendaRemotoAntesSessao;

                vm.Sessao.IdTipoLote = sessao.IdTipoLote;
                vm.Sessao.IdTipoAudio = sessao.IdTipoAudio;
                vm.Sessao.IdLegendaIdioma = sessao.IdLegendaIdioma;
                vm.Sessao.IdProducao = sessao.IdProducao;

                if (sessao.ModelDataEncerraVendaRemotoAntesSessao == null) {
                  vm.Sessao.ModelEncerraVendaAutomatica = true;
                }

                vm.possuiLayout = "False";
                vm.selectedItem = [{
                  IdAtracao: sessao.IdAtracao,
                  IdTipoAtracao: sessao.IdTipoAtracao,
                  Nome: sessao.NomeAtracao
                }];
                vm.selectedItemSala = [{
                  Id: sessao.IdSala,
                  Nome: sessao.NomeSala
                }];
                vm.ValidaAtracao = true;
                vm.ValidaSala = true;

                setTimeout(function () {
                  $scope.$apply(function () {
                    vm.possuiLayout = user.possui_layout;
                    vm.ValidaLayout = true;
                    vm.selectedItemLayout = [{
                      Id: sessao.IdLayout,
                      IdSala: sessao.IdSala,
                      Nome: sessao.NomeLayout
                    }];

                    layoutSvc.list({
                      IdSala: sessao.IdSala
                    }).then(function (data) {
                      vm.arrLayout = data;
                    });

                  });
                }, 1000);

                var dataHora = dateFilter(sessao.DataHoraInicio, 'HH:mm');

                if (!copia) {
                  vm.tabelaDataHorario.push({
                    Id: vm.tabelaDataHorario.length + 1,
                    IdSessao: copia ? null : sessao.Id,
                    DataSessao: copia ? null : sessao.DataHoraInicio,
                    HoraSessao: copia ? null : dataHora,
                    EventoDiaInteiro: sessao.DuracaoDiaInteiro,
                    AberturaPortao: sessao.HoraAbertura != null ? moment(sessao.HoraAbertura, "HH:mm").format('HH:mm') : "", //.replace(":", "") : "",
                    ExistiuVenda: copia == true ? false : sessao.ExistiuVenda
                  });
                } else {
                  vm.tabelaDataHorario = [];
                }
              }
            }).finally(function (sessao) {
              vm.HasIngresso = true;
              if(vm.Sessao.IdProducao)
                producaoSvc.get({
                  IdProducao: vm.Sessao.IdProducao
                }).then(function (data) {
                  vm.Producao.push(data);
                });
            });
          }

          sessaotiposessaoempresaSvc.list({
            IdSessao: idSessao
          }).then(function (data) {
            data.forEach(function (itmData, index) {
              vm.TipoSessoEmpresa.forEach(function (itmTela, index) {

                if (itmData.IdTipoSessao == itmTela.IdTipoSessao) {
                  itmTela.selected = true;
                }
              });
            });

          }).finally(function (data) {
          });

          sessaoparticipanteconvidadoSvc.list({
            IdSessao: idSessao,
            IdTipoArtista: 4
          }).then(function (data) {
            vm.ArtistaConvidado = data;
          });

          sessaoparticipanteconvidadoSvc.list({
            IdSessao: idSessao,
            IdTipoArtista: 3
          }).then(function (data) {
            vm.MusicoConvidado = data;
          });


        }
        //FIM GET DOS DADOS PARA EDIÇÃO

        //COPIAR UMA SESSAO
        vm.copiarSessao = function (itm) {
          $uibModal.open({
            animation: true,
            templateUrl: 'view/conteudo/programacao/popup/programacoes.popup.html',
            controller: 'ticket.controller.conteudo.programacao.popprogramacoes',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {}
          }).result.then(function (sessao) {
            vm.CopiaSessao = true;
            vm.MontaSessao(sessao.Id, true);
          });
        }
        //FIM COPIAR UMA SESSAO

        //1 . IDENTIFICACAO =================================================================================================================================
        vm.item = {
          IdTipoAtracao: null
        };

        vm.ValidaAtracao = false;
        vm.ValidaSala = false;
        vm.ValidaLayout = false;
        vm.arrLayout = [];
        vm.IdTipoAtracao = null;

        tipoAtracaoSvc.listCached().then(function (v) {
          v = orderByFilter(v, '-Principal');
          if (v.length === 1) {
            vm.item.IdTipoAtracao = parseInt(v[0].IdTipoAtracao);
          }

          vm.ListaTipoAtracao = v;
        });

        vm.possuiLayout = user.possui_layout;

        vm.selectedItem = [];
        vm.searchAtracao = function (query) {
          var nome = query.toLowerCase();
          return atracaoSvc.list({
            Nome: nome,
            //TipoAtracao: vm.item.IdTipoAtracao
          });
        };

        vm.incluirQuantidade = function (itm) {
          itm.ExibeQtd = true;
        }

        vm.excluirQuantidade = function(itm){
          itm.ExibeQtd = false;
          itm.QuantidadeIngressos = null;
        }

        vm.selectedItemChange = function selectedItemChange(item) {

          var _item = angular.copy(item);

          var IdAtracao = _item.item.IdAtracao;

          if (item !== undefined) {
            vm.ValidaAtracao = true;
            vm.Sessao.IdAtracao = IdAtracao;
          } else
            vm.ValidaAtracao = false;

          vm.item.IdTipoAtracao = _item.item.IdTipoAtracao;

          $scope.exibeTipoAtracao = true;


          // $scope.NomeTipoAtracaoSelected = vm.ListaTipoAtracao.find(function (itm) {
          //   return itm.IdTipoAtracao == _item.item.IdTipoAtracao
          // }).NomeTipoAtracao;

          //console.log('vm.NomeTipoAtracaoSelected', $scope.NomeTipoAtracaoSelected)
        }

        vm.deleteAtracao = function removed(itm) {
          vm.ValidaAtracao = false;
          vm.Sessao.IdAtracao = null;
          vm.item.IdTipoAtracao = null;
          $scope.exibeTipoAtracao = false;
        }

        vm.deleteSala = function removed(itm) {
          vm.ValidaSala = false;
          vm.Sessao.IdSala = null;

          vm.Sessao.IdLayout = null;
          vm.ValidaLayout = false;
          vm.selectedItemLayout = [];
        }

        vm.deleteLayout = function removed(itm) {
          vm.Sessao.IdLayout = null;
          vm.ValidaLayout = false;
        }

        vm.ChangeTipoAtracao = function () {
          vm.selectedItem = [];
          vm.ValidaAtracao = false;
        }

        vm.selectedItemSala = [];
        vm.querySearchSala = function (query) {
          var nome = query.toLowerCase();

          return salaSvc.list({
            Nome: nome
          });
        };

        //Chamado quando escolho uma sala, busca os layouts para a sala escolhida.
        vm.selectedItemChangeSala = function selectedItemChangeSala(item) {

          var _item = angular.copy(item);
          var IdSala = _item.item.IdSala;
          vm.arrLayout = [];
          vm.selectedItemLayout = [];

          if (item !== undefined) {
            vm.ValidaSala = true;
            vm.Sessao.IdSala = IdSala;

            layoutSvc.list({
              IdSala: IdSala
            }).then(function (data) {
              vm.arrLayout = data;
            }).finally(function () {

              //Se não possuo layout, por default tenho um layout (obrigatório), logo, pego o primeiro item.
              if (vm.possuiLayout == "False") {
                if (vm.arrLayout.length > 0) {
                  vm.Sessao.IdLayout = vm.arrLayout[0].Id;
                  vm.ValidaLayout = true;

                  var idLayout = vm.arrLayout[0].Id;

                  //Após escolher o layout, busca-se os setores referente ao mesmo
                  //if ($stateParams.Id == null) {
                    setorSvc.list({
                      IdLayout: idLayout
                    }).then(
                      function (setores) {
                        vm.setores = [];

                        if (user.possui_setor == "False") {
                          vm.setores[0] = setores[0];
                          vm.accordionArray[0] = true;
                        } else {
                          vm.setores = setores;
                          vm.accordionArray[0] = true;
                        }
//                        if ($stateParams.Id == null && !vm.CopiaSessao) {
                        if (!vm.CopiaSessao) {
                          vm.HasIngresso = false;
                          vm.addLote(true, true);
                        }

                        if (vm.setores.length > 0) {

                          vm.QtdIngressoSetores = vm.setores.map(function (itm) {
                            return itm.QuantidadeLugares;
                          }).reduce(function (total, value) {
                            return total + value;
                          });
                        }

                      }).finally(function (setores) {

                    });
                 // }
                }
              }
            });
          } else {
            vm.ValidaSala = false;
            vm.selectedItemLayout = null;
            vm.searchTextLayout = "";
          }
        }

        vm.querySearchLayout = function querySearchLayout(query) {
          var defer = $q.defer();
          defer.resolve(vm.arrLayout.filter(function (itm) {
            return itm.Nome.toLowerCase().indexOf(query.toLowerCase()) >= 0
          }));
          return defer.promise;
        }

        vm.selectedItemChangeLayout = function selectedItemChangeLayout(item) {
          var _item = angular.copy(item);
          var IdLayout = _item.item.Id;

          if (item !== undefined) {

            vm.ValidaLayout = true;
            vm.Sessao.IdLayout = IdLayout;

            //Após escolher o layout, busca-se os setores referente ao mesmo
            setorSvc.list({
              IdLayout: IdLayout
            }).then(
              function (setores) {

                vm.setores = [];
                if (setores.length > 0) {
                  vm.QtdIngressoSetores = setores.map(function (itm) {
                    return itm.QuantidadeLugares;
                  }).reduce(function (total, value) {
                    return total + value;
                  });
                  vm.lugaresRestantes = vm.QtdIngressoSetores;
                }

                //Para garantir sempre o primeiro setor, pos não tendo setor configurado, existirá apenas um como default.
                if (user.possui_setor == "False") {
                  if (setores.length > 0) {
                    vm.setores[0] = setores[0]
                  }
                } else {
                  vm.setores = setores;
                }
                if ($stateParams.Id == null) {
                  vm.addLote(true, true);
                }

                vm.accordionArray[0] = true;
              }).finally(function (setores) {

            });
          } else {
            vm.ValidaLayout = false;
          }
        }
        //FIM 1. IDENTIFICACAO

        //2. DATA E HORARIO ==========================================================================================================================


        vm.addDataHora = function () {
          NewDataHoraOrUpdate();
        }
        vm.editarDataHora = function (dataHora) {
          if (dataHora.EventoDiaInteiro)
            dataHora.HoraSessao = null;

          NewDataHoraOrUpdate(dataHora);
        }

        function NewDataHoraOrUpdate(dataHora) {

          if (dataHora) {
            var hora = moment(dataHora.AberturaPortao, "HH:mm").format('HH:mm');
            dataHora.AberturaPortao = hora;
          }

          $uibModal.open({
            animation: false,
            templateUrl: 'view/conteudo/programacao/popup/datahora.popup.html',
            controller: 'ticket.controller.conteudo.programacao.popdatahora',
            controllerAs: 'vm',
//            size: 'md',
            windowClass: 'myDialog',
            resolve: {
              dataHora: function () {
                return dataHora
              },
              IdSala:function(){
                return vm.Sessao.IdSala;
              }
            }
          }).result.then(function (itm) {


            if (itm != null) {

              if (itm.Id === undefined) {
                var horaSessao = itm.HoraSessao;
                vm.tabelaDataHorario.push({
                  Id: vm.tabelaDataHorario.length + 1,
                  IdSessao: null,
                  DataSessao: itm.DataSessao,
                  HoraSessao: itm.EventoDiaInteiro == true ? "23:59" : horaSessao,
                  EventoDiaInteiro: itm.EventoDiaInteiro,
                  AberturaPortao: itm.AberturaPortao
                });
              } else {
                // var horaSessao = itm.EventoDiaInteiro == true ? "23:59" : itm.HoraSessao;
                // vm.tabelaDataHorario[vm.tabelaDataHorario.indexOf(itm)].HoraSessao = horaSessao;
                // vm.tabelaDataHorario[vm.tabelaDataHorario.indexOf(itm)].AberturaPortao = itm.AberturaPortao;
              }
            }
          });
        }

        vm.copiarDataHora = function (itm) {
          $uibModal.open({
            animation: true,
            templateUrl: 'view/conteudo/programacao/popup/calendario.popup.html',
            controller: 'ticket.controller.conteudo.programacao.popcalendario',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              sessao: function () {
                return itm;
              },
              SessaoIncluidas: function () {
                return vm.Incluido;
              },
              tabelaDataHorario: function () {
                return vm.tabelaDataHorario;
              },
              IdSala:function(){
                return vm.Sessao.IdSala;
              }
            }
          }).result.then(function (datas) {
            if (datas != null) {
              for (var i = 0; i < datas.length; i++) {
                vm.tabelaDataHorario.push({
                  Id: vm.tabelaDataHorario.length + 1,
                  IdSessao: null,
                  DataSessao: datas[i]._d,
                  HoraSessao: itm.HoraSessao,
                  EventoDiaInteiro: itm.EventoDiaInteiro,
                  AberturaPortao: itm.AberturaPortao
                });
              }

            }
          });
        }
        vm.excluirDataHora = function (itm) {
          vm.tabelaDataHorario.splice(vm.tabelaDataHorario.indexOf(itm), 1)
        }
        //FIM 2. DATA E HORA

        // 3. VALORES DE INGRESSO ==========================================================================================================================

        vm.setores = [];
        vm.loteselecionado = 0;
        vm.oneAtATime = true;
        vm.accordionArray = [];
        var tipoFinalizacaoLote = [];
        tipoFinalizacaoLote.push({
          IdTipoFinalizacao: 1,
          Nome: 'Quantidade'
        });
        tipoFinalizacaoLote.push({
          IdTipoFinalizacao: 2,
          Nome: 'Data/Hora'
        });
        vm.btnPopupIngresso = false;
        vm.TipoLotes = tipoFinalizacaoLote;

        vm.myfilter = function (v) {
          return v.deleted == null || (v.deleted == null && v.excluido == true);
        };

        vm.addLote = function (updatePos, primeiroLote) {
          if (vm.lotes.length == 0 && !primeiroLote) {
            $state.go('conteudo.programacao.form.identificacao');
          } else {
            if (primeiroLote) {
              vm.lotes = [];
            }

            var lote = {
              IndexLote: ((vm.lotes.length) + 1) - (vm.QtdLoteDeleted),
              IdLote: null,
              setores: [],
              spinDelLot: false,
              QtdIngresso: null,
              active: false,
              deleted: false,
              IdSessaoLote: null
            };

            //Ao adicionar um novo lote, todos os setores são inseridos no novo lote
            for (var i = 0; i < vm.setores.length; i++) {
              var s = vm.setores[i];
              lote.setores.push({
                IdSetor: s.Id,
                Nome: s.Nome,
                NomeZona: s.NomeZona,
                QuantidadeLugares: s.QuantidadeLugares,
                tipoIngresso: [],
                ValorBase: null,
                LugarMarcado: s.LugarMarcado,
                tabelaPreco: {},
                IdRegraIngresso: s.IdRegraIngresso
              });
            }
            vm.lotes.push(lote);

            //Usado para marcar o ultimo lote inclu[ido
            if (updatePos) {
              $timeout(function () {
                vm.lotes[vm.lotes.length - 1].active = true
              }, 0);
            }
          }

          ValidaIngressoSetor();
        }

        //Ao mudar o valor base de cálculo de um setor, os valores dos ingressos são recalculados automaticamente.
        vm.ChangeValueIngresso = function (setor) {

          var valor = 0;
          if (setor.tipoIngresso.length > 0) {
            for (var i = 0; i < setor.tipoIngresso.length; i++) {

              //Se a RegraIngresso for "8", o valor a ser pego é o da própria regra. Pois é para valor fixo.
              if (setor.tipoIngresso[i].IdRegraIngresso == 8) {
                valor = setor.tipoIngresso[i].ValorRegra;
              } else {
                valor = parseFloat(setor.tipoIngresso[i].TipoDesconto == 'F' ? setor.ValorBase !== null ? setor.ValorBase - setor.tipoIngresso[i].ValorRegra : 0 : setor.ValorBase !== null ? setor.ValorBase - ((setor.ValorBase * setor.tipoIngresso[i].ValorRegra)) : 0);
              }
              setor.tipoIngresso[i].Valor = valor > 0 ? valor : 0;
            }
          }

          ValidaIngressoSetor();
        }

        // vm.changeQtdMaxIng = function(itm){
        //   ValidaIngressoSetor();
        // }

        $scope.$watch('vm.lotes',function () {
          if(vm.validate) {
            ValidaIngressoSetor();
          }
        }, true)

        vm.delLote = function (lote, index) {
          vm.utils.Confirm("Excluir Lote", "Deseja excluir o lote " + (index + 1) + " ?").then(function () {
            lote.spinDelLote = true;

            vm.QtdLoteDeleted = vm.QtdLoteDeleted + 1;

            $timeout(function () {

              if (lote.IdSessaoLote == null) {
                vm.lotes.splice(vm.lotes.indexOf(lote), 1);
                ValidaIngressoSetor();
              } else {
                lote.deleted = true;
                ValidaIngressoSetor();
              }

              lote.spinDelLote = false;

              var idx = 0;
              vm.lotes.forEach(function (item) {
                if (!item.deleted)
                  item.IndexLote = ++idx;
              })
              vm.lotes[vm.lotes.length - 1].active = true;
              calcIngressos();
            }, 1000);
            ValidaIngressoSetor();

          });

        }

        vm.filterLote = function () {

        }

        vm.delIngresso = function (item, setor) {

          if (item.IdSessaoSetorLotePrecoIngresso == null) {
            item.deleted = true;
          } else {
            item.excluido = true;
            item.deleted = true;
          }

          if (setor.tipoIngresso.length > 0) {

            var ingresso = setor.tipoIngresso = setor.tipoIngresso.filter(function (itm) {

              return itm.deleted == null || (itm.deleted == true && itm.excluido == true);
            });

            if (ingresso.length == 0)
              setor.tabelaPreco = {};
          }
          ValidaIngressoSetor();
        }

        //Adiciona ingressos ao setor
        vm.addTipoIngresso = function (lote, setor, $event, index) {

          //vm.ValidaLote();

          $event.preventDefault();
          $event.stopPropagation();

          vm.accordionArray[index] = true;

          $uibModal.open({
            animation: false,
            templateUrl: 'view/conteudo/programacao/popup/ingresso.popup.html',
            controller: 'ticket.controller.conteudo.programacao.popingresso',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              setor: function () {
                return setor
              }
            }
          }).result.then(function (items) {

            var valor = 0;

            if (items.length > 0) {

              for (var i = 0; i < items.length; i++) {
                //Se a RegraIngresso for "8", o valor a ser pego é o da própria regra. Pois é para valor fixo.
                if (items[i].IdRegraIngresso == 8) {
                  valor = items[i].ValorRegra;
                } else {

                  valor = parseFloat(items[i].TipoDesconto == 'F' ? setor.ValorBase !== null ? setor.ValorBase - items[i].ValorRegra : 0 : setor.ValorBase !== null ? setor.ValorBase - ((setor.ValorBase * items[i].ValorRegra)) : 0);
                }
                setor.tipoIngresso.push({
                  IdSessaoSetorLotePrecoIngresso: null,
                  IdTipoingresso: items[i].IdEstabelecimentoIngresso,
                  Nome: items[i].Nome,
                  Valor: valor > 0 ? valor : 0,
                  IdSetor: setor.IdSetor,
                  TipoDesconto: items[i].TipoDesconto,
                  ValorRegra: items[i].TipoDesconto == "F" ? items[i].ValorRegra : items[i].ValorRegra,
                  IdEstabelecimentoIngresso: items[i].Id,
                  deleted: null,
                  excluido: false,
                  IdRegraIngresso: items[i].IdRegraIngresso,
                  DefineValorNaSessao : items[i].DefineValorNaSessao,
                  VendeBilheteria: items[i].VendeBilheteria, //INGRESSO
                  VendeRemoto : items[i].VendeRemoto //INGRESSO
                });
              }
            }
            ValidaIngressoSetor();
          });


        }

        //Adiciona uma tabela de preços a um setor.
        vm.addTabelaPreco = function (lote, setor, $event, index) {

          //vm.ValidaLote();

          $event.preventDefault();
          $event.stopPropagation();

          vm.accordionArray[index] = true;

          $uibModal.open({
            animation: false,
            templateUrl: 'view/conteudo/programacao/popup/tabelapreco.popup.html',
            controller: 'ticket.controller.conteudo.programacao.poptabelapreco',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              setor: function () {
                return setor
              }
            }
          }).result.then(function (item) {

            setor.searching = true;
            incluirIngresso(item);

            function incluirIngresso(item) {
              if (item != null) {

                setor.tipoIngresso = [];
                setor.tabelaPreco = item;
                tabelaprecopadraoestabelecimentoingressoSvc.list({
                  IdTabelaPrecoPadrao: item.Id
                }).then(
                  function (ingressos) {
                    if (ingressos.length > 0) {
                      for (var i = 0; i < ingressos.length; i++) {
                        setor.tipoIngresso.push({
                          IdSessaoSetorLotePrecoIngresso: null,
                          IdTipoingresso: ingressos[i].IdEstabelecimentoIngresso,
                          Nome: ingressos[i].Nome,
                          Valor: ingressos[i].Valor,
                          IdSetor: setor.IdSetor,
                          TipoDesconto: ingressos[i].TipoDesconto,
                          ValorRegra: ingressos[i].ValorRegra,
                          IdEstabelecimentoIngresso: ingressos[i].IdEstabelecimentoIngresso,
                          deleted: null,
                          excluido: false,
                          IdRegraIngresso: ingressos[i].IdRegraIngresso,
                          DefineValorNaSessao: ingressos[i].DefineValorNaSessao,
                          VendeBilheteria: ingressos[i].VendeBilheteria, //INGRESSO
                          VendeRemoto : ingressos[i].VendeRemoto //INGRESSO
                        });
                      }
                      setor.ValorBase = item.ValorBase;
                    }
                  }).finally(function () {
                  setor.searching = false;
                  ValidaIngressoSetor();
                });
              }
            }
          });
        }

        // FIM 3. VALORES DE INGRESS

        // 4. DETALHES ==========================================================================================================================
        vm.TipoSessoEmpresa = [];
        vm.LegendaIdioma = [];
        vm.TipoEntrega = [];

        //Busca os tipos de sessões de uma Empresa, ex.: 3D, Extreme Digital
        tipoSessaoEmpresaSvc.list({
          IdEmpresa: null
        }).then(
          function (data) {
            vm.TipoSessoEmpresa = data;

            // GET DOS DADOS PARA EDIÇÃO
            if ($stateParams.Id != null) {
              vm.setores = [];
              vm.MontaSessao($stateParams.Id, false);

              //Busca os Tipos de Entregas
              tipoEntregaEstabelecimentoSvc.list({
                IdSessao: $stateParams.Id
              }).then(
                function (data) {
                  if (data != null) {

                    data.forEach(function (item, index) {
                      vm.TipoEntrega.push({
                        IdEstabelecimento: item.IdEstabelecimento,
                        Nome: item.Nome,
                        IdTipoEntrega: item.IdTipoEntrega,
                        selected: (item.IdSessao != null)
                      })
                    })
                  }
                }
              );
            } else {

              //Busca os Tipos de Entregas
              tipoEntregaEstabelecimentoSvc.list({
                IdSessao: null
              }).then(
                function (data) {
                  if (data != null) {

                    data.forEach(function (item, index) {
                      vm.TipoEntrega.push({
                        IdEstabelecimento: item.IdEstabelecimento,
                        Nome: item.Nome,
                        IdTipoEntrega: item.IdTipoEntrega,
                        selected: true //Se estou incluindo uma nova programação trago todos os checks marcados.
                      })
                    })
                  }
                }
              );
            }
          }
        );

        legendaIdiomaSvc.list({}).then(function (data) {
          vm.LegendaIdioma = data;
        })

        //Artistas Convidados
        vm.ArtistaConvidado = [];

        vm.querySearchArtista = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({
            NomeArtistico: nome,
            IdTipoArtista: 4
          });
        };
        //Fim Artistas Convidados

        //Musico Convidados
        vm.MusicoConvidado = [];

        vm.querySearchMusico = function (filter) {

          var nome = filter.toLowerCase();
          return artistaSvc.list({
            NomeArtistico: nome,
            IdTipoArtista: 3
          });
        };
        //Fim Musico Convidados


        //Producao
        vm.Producao = [];
        vm.querySearchProducao = function (filter) {
          var nome = filter.toLowerCase();
          return producaoSvc.list({Nome: nome});
        };
        //Fim Producao

        vm.ClearDataEncerraVenda = function () {
          vm.Sessao.ModelDataEncerraVendaRemotoAntesSessao = null;
        }
        //FIM 4. DETALHES

        // SAVE ==========================================================================================================================
        vm.Save = function () {
          if (vm.Sessao.VendeRemoto && vm.TipoEntrega.filter(function (itm) {
              return itm.selected == true;
            }).length == 0) {
            vm.HasTipoEntrega = false;
            return false;
          } else {
            vm.HasTipoEntrega = true;
          }


          vm.validate = validateDados();
          if (vm.validate) {
            vm.dadosIncompletos();
            return;
          }

          vm.loading = true;
          // Tabela Sessao
          if (vm.tabelaDataHorario != null) {

            var d = new Date();
            var t = d.getTimezoneOffset();

            var sessoes = [];
            for (var i = 0; i < vm.tabelaDataHorario.length; i++) {
              var s = vm.tabelaDataHorario[i];

              var sessao = {};
              var data = null;
              var hora = null;

              sessao = angular.copy(vm.Sessao);
              sessao.HoraSessao = s.HoraSessao;
              sessao.DataHoraInicio = moment(moment(s.DataSessao).format('YYYY-MM-DD')).format();

              sessao.IdProducao = vm.Producao.length > 0 ? vm.Producao[0].IdProducao : null;

              if (s.AberturaPortao !== undefined) {
                if (s.AberturaPortao !== "") {
                  sessao.HoraAbertura = s.AberturaPortao; //.substring(0, 2) + ':' + s.AberturaPortao.substring(2);
                }
              }

              sessao.Id = s.IdSessao;

              sessao.IdTipoAtracao = vm.item.IdTipoAtracao;

              sessao.DuracaoDiaInteiro = s.EventoDiaInteiro;
              var d = new Date();
              var t = d.getTimezoneOffset();
              sessao.TimeZone = t * -1;

              if (vm.Sessao.IdTipoAudio == 3)
                sessao.IdLegendaIdioma = vm.Sessao.IdLegendaIdioma;
              else
                sessao.IdLegendaIdioma = null;

              if(vm.TipoSessoEmpresa.length > 1) {
                for (var j = 0; j < vm.TipoSessoEmpresa.length; j++) {
                  var tipoSessao = vm.TipoSessoEmpresa[j];

                  if (tipoSessao.selected) {
                    sessao.ListaSessaoTipoSessaoEmpresa.push({
                      IdTipoSessao: tipoSessao.IdTipoSessao,
                      PrioridadeConveniencia: tipoSessao.PrioridadeConveniencia
                    });
                  }
                }
              }
              else{

                sessao.ListaSessaoTipoSessaoEmpresa.push(
                  {
                    IdTipoSessao: vm.TipoSessoEmpresa[0].IdTipoSessao,
                    PrioridadeConveniencia: vm.TipoSessoEmpresa[0].PrioridadeConveniencia
                }
                );
              }


              for (var l = 0; l < vm.ArtistaConvidado.length; l++) {
                var artista = vm.ArtistaConvidado[l];
                sessao.ListaSessaoParticipanteConvidado.push({
                  IdArtista: artista.IdArtista,
                  IdTipoArtista: artista.IdTipoArtista ? artista.IdTipoArtista : 4,
                  Nome: artista.Nome
                })
              }

              for (var l = 0; l < vm.MusicoConvidado.length; l++) {
                var musico = vm.MusicoConvidado[l];
                sessao.ListaSessaoParticipanteConvidado.push({
                  IdArtista: musico.IdArtista,
                  IdTipoArtista: musico.IdTipoArtista ? musico.IdTipoArtista : 3,
                  Nome: musico.Nome
                })
              }

              vm.TipoEntrega.forEach(function (item) {

                if (item.selected) {
                  sessao.ListaSessaoTipoEntregaEstabelecimento.push({
                    IdTipoEntrega: item.IdTipoEntrega,
                    IdEstabelecimento: item.IdEstabelecimento
                  });
                }

              });

              sessoes.push(sessao);
            }
          }

          var ListaSessaoLote = [];
          var sessaoLote = {};
          var ListaSessaoSetor = [];
          var sessaoSetor = {};
          var ListaSessaoSetorLotePrecoIngresso = [];
          var sessaoSetorLotePrecoIngresso = {};

          if (vm.lotes.length > 0) {
            for (var i = 0; i < vm.lotes.length; i++) {

              if (vm.lotes[i].setores.length > 0) {

                for (var j = 0; j < vm.lotes[i].setores.length; j++) {

                  if (vm.lotes[i].setores[j].tipoIngresso.length > 0) {

                    for (var l = 0; l < vm.lotes[i].setores[j].tipoIngresso.length; l++) {
                      var p = vm.lotes[i].setores[j].tipoIngresso[l];
                      var valorBase = vm.lotes[i].setores[j].ValorBase;
                      if(!p.excluido)
                      {
                        sessaoSetorLotePrecoIngresso = {
                          Id: p.IdSessaoSetorLotePrecoIngresso,
                          IdSessaoSetor: null,
                          IdSessaoLote: null,
                          IdEstabelecimentoIngresso: p.IdEstabelecimentoIngresso,
                          ValorIngresso: p.Valor,
                          excluido: p.excluido,
                          ValorBase: valorBase,
                          IdRegraIngresso: p.IdRegraIngresso,
                          QuantidadeIngressos: p.QuantidadeIngressos
                        }
                        if (ListaSessaoSetorLotePrecoIngresso !== null || ListaSessaoSetorLotePrecoIngresso !== undefined)
                          ListaSessaoSetorLotePrecoIngresso.push(sessaoSetorLotePrecoIngresso);
                        sessaoSetorLotePrecoIngresso = null;
                    }
                    }
                  }

                  var s = vm.lotes[i].setores[j];
                  sessaoSetor = {
                    Id: s.IdSessaoSetor,
                    IdSessao: null,
                    IdSetor: s.IdSetor,
                    QtdLugaresMaxima: s.QuantidadeLugares,
                    LugarMarcado: s.LugarMarcado,
                    ListaSessaoSetorLotePrecoIngresso: ListaSessaoSetorLotePrecoIngresso
                  }
                  ListaSessaoSetorLotePrecoIngresso = [];
                  ListaSessaoSetor.push(sessaoSetor);
                  sessaoSetor = [];
                }
              }

              var l = vm.lotes[i];

              sessaoLote = {
                Id: l.IdSessaoLote,
                IdSessaoLote: null,
                IdSessao: null,
                DataHoraEncerramento: l.DataEncerramentoLote,
                HoraEncerramentoLote: l.HoraEncerramentoLote,
                QuantidadeIngressos: vm.PossuiLote ? l.QtdIngresso : vm.QtdIngressoSetores,
                ListaSessaoSetor: ListaSessaoSetor,
                deleted: l.deleted,
                Ordem: l.IndexLote,
                PossuiLote : vm.PossuiLote
              }
              ListaSessaoSetor = [];
              ListaSessaoLote.push(sessaoLote);
              sessaoLote = null;
            }
          }

          sessaoSvc.post({
            ListaSessaoLote: ListaSessaoLote,
            ListaSessao: sessoes
          }).then(function () {

            var msg = ($stateParams.Id != null ) ? 'Alteração de registro' : 'Inclusão de registro';

            //vm.utils.ShowSuccess(msg, "Operação realizada com sucesso!");
            toaster.pop('success', msg, "Operação realizada com sucesso!");
            $state.go('conteudo.programacao.grid');
          }).finally(function () {
            vm.loading = false;
          });
        }
        // FIM SAVE

        vm.HasIngresso = null;

        //METODO ValidaIngressoSetor
        function ValidaIngressoSetor() {


          for (var i = 0; i < vm.lotes.length; i++) {
            var lote = vm.lotes[i];

            if (lote.setores.length > 0) {

              vm.HasIngresso = true;

              for (var j = 0; j < lote.setores.length; j++) {
                var setor = lote.setores[j];

                var ingresso = setor.tipoIngresso.filter(function (itm) {
                    return itm.excluido == false || itm.excluido == undefined ;
                  }).length



                if (ingresso == 0) {
                  vm.HasIngresso = false;
                  return false;
                }

                setor.IngNeg = false;
                setor.tipoIngresso.forEach(function (itm) {
                  if (itm.Valor <= 0 && itm.IdRegraIngresso != 5) {
                    vm.HasIngresso = false;
                    setor.IngNeg = true;
                  }
                  // if(itm.Valor <=0)
                  // {
                  //   vm.HasIngresso = false;
                  //   vm.IngressoNegativo = true;
                  //   break;
                  // }
                })

                // if (setor.tipoIngresso.length == 0) {
                //   vm.HasIngresso = false;
                //   break;
                // } else {
                //
                //   setor.tipoIngresso.forEach(function (itm) {
                //
                //     if(itm.Valor <= 0) {
                //       vm.HasIngresso = false;
                //     }
                //     // if(itm.Valor <=0)
                //     // {
                //     //   vm.HasIngresso = false;
                //     //   vm.IngressoNegativo = true;
                //     //   break;
                //     // }
                //   })
                //   vm.HasIngresso = true;
                // }


              }
            }
          }
        }


        function validateDados() {
          ValidaIngressoSetor();
          return vm.tabelaDataHorario.length === 0 || !vm.HasIngresso;
        }


        if (vm.lotes.length > 0) {
          for (var i = 0; i < vm.lotes.length; i++) {
            var lote = vm.lotes[i];

            if (vm.SetorSemIngresso)
              break;

            if (lote.setores.length > 0) {
              for (var j = 0; j < lote.setores.length; j++) {
                var setor = lote.setores[j];

                if (setor.tipoIngresso.length == 0) {

                  vm.SetorSemIngresso = true;
                  break;
                }
              }
            }
          }
        }

        vm.Cancelar = function () {
          $state.go('conteudo.programacao.grid');
        }


        vm.ValidaLote = function (itm) {

          if (itm != null || itm != undefined) {

            vm.LotesInvalido = null;

            var lt = vm.lotes.filter(function (itm) {
              return itm.deleted != true;
            })

            vm.TotalLotes = lt.map(function (itm) {
              return itm.QtdIngresso
            }).reduce(function (total, value) {
              return total + value
            });


            var lotes = [];
            var tipoLote = vm.Sessao.IdTipoLote;

            if (vm.lotes.length > 1) {
              lotes = orderByFilter(vm.lotes, 'IndexLote');

              var qtdIngresso = 0;
              var data = new Date;

              //vm.LotesInvalido = false;
              lotes.forEach(function (item, idx) {
                if (tipoLote == 2) {
                  //   if (qtdIngresso > item.QtdIngresso) {
                  //     vm.LotesInvalido = 'A quantidade de ingressos para os lotes devem ser cumulativos.';
                  //     return false;
                  //   }
                  //   else {
                  //     qtdIngresso = item.QtdIngresso;
                  //     vm.LotesInvalido = null;
                  //   }
                  // }
                  // else {

                  if (data > item.DataEncerramentoLote) {
                    vm.LotesInvalido = 'As datas para os próximos lotes não podem ser menores que as datas dos lotes anteriores.';
                    return false;
                  } else {
                    vm.LotesInvalido = null;
                    data = item.DataEncerramentoLote;
                  }
                }
              })
            }

            if (vm.LotesInvalido != null)
              return false;

            if (vm.TotalLotes > vm.QtdIngressoSetores) {
              vm.QtdIngressosLotesMaior = true;
            } else {
              vm.QtdIngressosLotesMaior = false;
            }

          }

          vm.dateOptions = {
            minDate: new Date()
          };
        }


        vm.accordionArray[0] = true;


        /***
         * Faz a redução da quantidade de ingressos disponiveis, baseado nos setores
         * @param n Novo valor
         * @param o Valor antigo
         */
        function calcIngressos(n, o) {

          var lotes = vm.lotes;
          var setores = vm.setores;
          var qtdIngLote = 0;

          if (setores.length > 0) {
            vm.QtdIngressoSetores = setores.map(function (itm) {
              return itm.QuantidadeLugares;
            }).reduce(function (total, value) {
              return total + value;
            });
          }

          lotes = lotes.filter(function (itm) {
            return itm.deleted != true;
          })

          if (lotes.length > 0) {
            qtdIngLote = lotes.map(function (itm) {
              return itm.QtdIngresso;
            }).reduce(function (total, value) {
              return total + value;
            });
          }
          var calc = 0;

          if (!isNaN(parseInt(qtdIngLote)))
            calc = (parseInt(vm.QtdIngressoSetores) - parseInt(qtdIngLote));

          vm.lugaresRestantes = calc <= 0 ? 0 : calc;


          // if (vm.lugaresRestantes === 0) {
          //   return;
          // }
          //
          // var adding = 0;
          // var reduction = 0;
          //
          // if (n < o) {
          //   adding = (o - n);
          //   vm.lugaresRestantes = vm.lugaresRestantes + adding;
          // }
          // else if (n)
          // {
          //   reduction = n > o ? (n - o) : n;
          //   vm.lugaresRestantes = vm.lugaresRestantes - reduction;
          // }
          // else if ((QtdIngressoSetores - vm.lugaresRestantes) > o)
          // {
          //   vm.lugaresRestantes = vm.lugaresRestantes + Number(o);
          // }
          // else {
          //   vm.lugaresRestantes = QtdIngressoSetores;
          // }
        }

        function dadosIncompletos() {
          $uibModal.open({
            animation: true,
            templateUrl: 'view/conteudo/programacao/popup/dadosincompletos.popup.html',
            controller: 'ticket.controller.conteudo.programacao.dadosincompletos',
            controllerAs: 'vm',
            size: 'md',
            resolve: {}
          }).result.then(function () {
            // vm.CopiaSessao = true;
            // vm.MontaSessao(sessao.Id, true);
          });
        }


      }
    ])

    .controller("ticket.controller.conteudo.programacao.popingresso", [
      "common",
      "$scope",
      "$uibModalInstance",
      "setor",
      "$rootScope",
      "ticket.service.ingresso.estabelecimentoingresso",
      function (common, $scope, $uibModalInstance, setor, $rootScope, ingressoSvc) {
        var vm = common.controller.grid(this, ingressoSvc);
        vm.LimteAlcancado = false;
        vm.loaded = loaded;

        var gridIngressos = angular.copy(setor);

        //Só faço o count com os Ingresso que não foram deletados, pois os ingressos que foram deletadas permanecem no objeto com o "deleted = true".
        var countGrid = gridIngressos.tipoIngresso.filter(function (itm) {
          return itm.deleted == null;
        }).length;

        if (countGrid == 30)
          vm.LimteAlcancado = true;

        vm.search();

        vm.Tabelaingressos = vm.items;

        vm.selected = function (items, itm) {



          if (itm.selected)
            itm.selected = false;
          else
            itm.selected = true;

          var count = items.filter(function (itm) {
            return itm.selected == true > 0
          }).length;

          if (count > 0)
            vm.btnPopupIngresso = true;
          else
            vm.btnPopupIngresso = false;

        }
        vm.myfilter = function (v) {
          return v.selected == true;
        };

        vm.Confirm = function () {

          var lst = vm.Tabelaingressos.filter(function(itm){
            return itm.selected == true
          })

          var countLst = lst.length;

          if ((countGrid + countLst) > 30) {
            vm.LimteAlcancado = true;
            return false;
          }
          else {
            vm.LimteAlcancado = false;
          }

          $uibModalInstance.close(lst);
        };
        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };

        function loaded() {
          vm.Tabelaingressos = vm.items.filter(function (itm) {
            return setor.tipoIngresso.filter(function (itmTable) {
                return (itmTable.IdEstabelecimentoIngresso == itm.Id) && itmTable.deleted != true;
              }).length == 0;
          });
        }
      }
    ])

    .controller("ticket.controller.conteudo.programacao.poptabelapreco", [
      "common",
      "$scope",
      "$uibModalInstance",
      "setor",
      "ticket.service.ingresso.tabelaprecopadrao",
      function (common, $scope, $uibModalInstance, setor, tabelaPrecoSvc) {
        var vm = common.controller.grid(this, tabelaPrecoSvc);

        vm.TabelaPrecos = vm.items;
        vm.loaded = loaded;
        vm.setor = setor;
        vm.Confirm = function (item) {
          $uibModalInstance.close(item);
        };

        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };

        function loaded() {
          if (setor.tabelaPreco != null) {
            vm.TabelaPrecos = vm.items.filter(function (itm) {
              return itm.Id != setor.tabelaPreco.Id;
            });
          }
        }
      }
    ])

    .controller("ticket.controller.conteudo.programacao.popdatahora", [
      "common",
      "$scope",
      "$uibModalInstance",
      "$rootScope",
      "dataHora",
      "IdSala",
      "ticket.service.programacao.sessao",
      "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
      function (common, $scope, $uibModalInstance, $rootScope, dataHora, IdSala, sessaoSvc, estabelecimentoConfiguracaoInformacaoSvc) {
        var vm = this;
        vm.DataInvalida = false;
        vm.minDate = new Date();
        var today = moment().add('day')
        vm.Today = today;
        today = today - 1;
        var minuto = 0;
        vm.SearchConfiguracao = true;
        vm.primeiroAcesso = true;

        vm.WatchHoraSessao = $scope.$watch('vm.DataHora.HoraSessao', function () {
          montaHoraAbertura();
        });

        estabelecimentoConfiguracaoInformacaoSvc.get({
          pk: null
        }).then(function (data) {
          minuto = data.HoraAberturaMinutoAntes;
          if (!vm.DataHora.HoraAberturaMinutoAntes) {
            vm.DataHora.HoraAberturaMinutoAntes = data.HoraAberturaMinutoAntes;
          }
          vm.Abertura = data.HoraAberturaMinutoAntes;
          vm.SearchConfiguracao = false;
        });

        function montaHoraAbertura() {
          var hora = vm.DataHora.HoraSessao;
          if (minuto > 0 && hora != undefined) {
            var mom = moment(hora, "HH:mm");
            var hora = mom.subtract(minuto, 'minutes');
            var horaSub = hora.format('HH:mm')
            vm.DataHora.AberturaPortao = horaSub;
          }
        }

        vm.DataHora = dataHora;

        if (dataHora)
          vm.HoraAberturaOld = dataHora.AberturaPortao;

        if (dataHora === undefined)
          vm.DataHora = {
            EventoDiaInteiro: false
          };

        vm.Confirm = function (itm) {

          //Método usado para anular o watch();
          vm.WatchHoraSessao();

          vm.SearchSessao = true;

          if (itm != null) {
            var sess = moment(itm.HoraSessao, 'HH:mm');
            var aber = moment(itm.AberturaPortao, 'HH:mm');

            if (aber > sess) {
              vm.HoraAberturaMaior = true;
              vm.SearchSessao = false;
              return false;
            }
            else {
              vm.HoraAberturaMaior = false;
            }

            if (itm.DataSessao < today._d) {
              vm.DataInvalida = true;
            } else {

              if (itm.EventoDiaInteiro)
                itm.HoraSessao = '23:59';

              var horaSessao = itm.HoraSessao;
              sessaoSvc.getAll({
                Config: {
                  Skip: 0,
                  Top: 0
                },
                Filter: {
                  'DataHoraInicio': moment(itm.DataSessao).format(),
                  'HoraSessao': horaSessao,
                  'IdSala':IdSala
                }
              }).then(function (sessao) {
                if (sessao.length > 0) {
                  if (itm.IdSessao != sessao[0].Id) {
                    vm.HasSessao = true;
                  }
                } else {
                  vm.HasSessao = false;
                }

                if (!vm.HasSessao) {
                  itm.edicao = true;
                  $uibModalInstance.close(itm);
                }
              }).finally(function () {
                vm.SearchSessao = false;
              });
            }
          }
        };
        vm.Cancel = function (itm) {
          itm.AberturaPortao = vm.HoraAberturaOld;
          $uibModalInstance.dismiss('cancel');
        };
      }
    ])

    .controller("ticket.controller.conteudo.programacao.popcalendario", [
      "common",
      "$scope",
      "$uibModalInstance",
      "$rootScope",
      "sessao",
      "SessaoIncluidas",
      "tabelaDataHorario",
      "IdSala",
      "dateFilter",
      "ticket.service.programacao.sessao",
      function (common, $scope, $uibModalInstance, $rootScope, sessao, SessaoIncluidas, tabelaDataHorario, IdSala , dateFilter, sessaoSvc) {
        var vm = this;
        vm.today = moment();
        vm.DatasExistentes = [];
        vm.CopiarSessao = true;
        vm.highlightDays = [];

        tabelaDataHorario.forEach(function (sessao, index) {
          vm.highlightDays.push({
            date: moment(sessao.DataSessao).hours(sessao.HoraSessao.slice(0, 2)).minutes(sessao.HoraSessao.slice(-2))._d,
            css: 'selected',
            selectable: false,
            title: 'Sessão já adicionada. Caso queira uma sessão para o mesmo dia, clicar em "INCLUIR DATA"'
          })
        })

        vm.Confirm = function (itm) {
          vm.CopiarSessao = true;
          var ctn = 0;

          itm.forEach(function (item, index) {
            sessaoSvc.getAll({
              Config: {
                Skip: 0,
                Top: 0
              },
              Filter: {
                'DataHoraInicio': item.format(),
                'HoraSessao': sessao.HoraSessao,
                'IdSala':IdSala
              }
            }).then(function (sessao) {

              if (sessao.length > 0) {
                vm.CopiarSessao = false;
                var data = dateFilter(sessao[0].DataHoraInicio, "dd/MM/yyyy HH:mm");

                var existeServ = vm.DatasExistentes.filter(function (itm) {
                  return itm == data;
                });

                if (existeServ.length == 0) {
                  vm.DatasExistentes.push(data);
                }
              }
              ctn = ctn + 1;
              if (vm.CopiarSessao && (itm.length == ctn)) {
                $uibModalInstance.close(itm);
              }


            }).finally(function () {
            }); // if(vm.CopiarSessao)
            // {
            //   $uibModalInstance.close(itm);
            // }
          });


        };

        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }
    ])

    .controller("ticket.controller.conteudo.programacao.popprogramacoes", [
      "common",
      "$scope",
      "$uibModalInstance",
      "$stateParams",
      "ticket.service.programacao.sessao",
      function (common, $scope, $uibModalInstance, $stateParams, programacaoSvc) {

        var vm = common.controller.grid(this, programacaoSvc);
        //vm.search();

        vm.Confirm = function (item) {

          //   $stateParams.filter = {
          //     Id : item.Id
          // }
          $uibModalInstance.close(item);
        };

        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };

      }
    ])
    .controller("ticket.controller.conteudo.programacao.dadosincompletos", [
      "common",
      "$scope",
      '$state',
      "$uibModalInstance",
      function (common, $scope, $state, $uibModalInstance) {
        var vm = this;
        vm.goBack = goBack;

        function goBack() {
          //$state.go('conteudo.programacao.form.identificacao');
          $state.go('conteudo.programacao.form.valores-ingresso');
          vm.Cancel();
        }

        vm.Cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }
    ]);


})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.conteudo')
        .controller('ticket.controller.conteudo.genero', ["$scope", "common", "ticket.service.conteudo.genero", function ($scope, common, generoSvc) {
            var vm = common.controller.master(this, generoSvc, $scope);
        }])

        .controller('ticket.controller.conteudo.genero.grid', ["common", "ticket.service.conteudo.genero", function(common, generoSvc){
            var vm = common.controller.grid(this, generoSvc);
        }])

        .controller('ticket.controller.conteudo.genero.form', ["common", "ticket.service.conteudo.genero", function(common, generoSvc){
            var vm = common.controller.form(this, generoSvc);
        }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.conteudo')

    .controller('ticket.controller.conteudo.wizard', [
      'common', '$scope', '$q', '$timeout', 'Upload', '$uibModal', '$stateParams', '$state', 'orderByFilter', '$filter', 'toaster',
      'ticket.service.conteudo.atracao',
      'ticket.service.conteudo.inadequacao',
      'ticket.service.conteudo.genero',
      'ticket.service.conteudo.artista',
      'ticket.service.conteudo.classificacao',
      'ticket.service.conteudo.banda',
      'ticket.service.conteudo.atracaoversao',
      'ticket.service.conteudo.atracaoinadequacao',
      'ticket.service.conteudo.atracaogenero',
      'ticket.service.conteudo.atracaoparticipante',
      'ticket.service.conteudo.atracaoarquivo',
      'ticket.service.conteudo.atracaobanda',
      function (common, $scope, $q, $timeout, Upload, $uibModal, $stateParams, $state, orderByFilter, $filter,toaster, atracaoSvc, inadequacaoSvc, generoSvc, artistaSvc, classificacaoSvc, bandaSvc, atracaoVersaoSvc, atracaoInadequacaoSvc, atracaoGeneroSvc, atracaoParticipanteSvc, atracaoArquivoSvc, atracaobandaSvc) {
        var vm = common.controller.grid(this, atracaoSvc);

        vm.spinFotoDestaque = false;
        vm.spinFotoCapa = false;
        vm.spinFotoGaleria = false;
        vm.ValidaGenero = false;
        vm.PodeEditar = false;
        vm.participantesload = null;

        var objFotoGaleria = {}

        var FichaTecnica = {
          PaisOrigem: 'Brasil',
          IdiomaOriginal : 'Português'
        };
        var Sinopse = {};

        if ($stateParams.filter == null) {
          return $state.go('conteudo.atracao.grid'); //PROTEÇÃO CONTRA REFRESH: SE FILTER NÃO FOI INFORMADO, RETORNA PRO GRID.
        }

        if (!$stateParams.filter.IdAtracao) {
          vm.PodeEditar = true;
        }

        if ($stateParams.filter != null) {
          vm.TipoVisao = $stateParams.filter.IdTipoAtracao;
          FichaTecnica.Nome = $stateParams.filter.NomeAtracao
        }

        // GET DOS DADOS PARA EDIÇÃO
        if ($stateParams.filter != null && $stateParams.filter.IdAtracao != null) {

          var IdAtracao = $stateParams.filter.IdAtracao;
          var IdTipoAtracao = $stateParams.filter.IdTipoAtracao;
          var NumeroVersao = $stateParams.filter.NumeroVersao;



          vm.itensCount = 0;
          vm.loadInadequacoes = true;
          vm.loadGeneros = true;

          // atracaoSvc.get({IdAtracao: IdAtracao}).then(function (atracao) {
          //
          // });

          atracaoVersaoSvc.get({IdAtracao: IdAtracao, NumeroVersao: NumeroVersao}).then(function (p) {
            FichaTecnica.Nome = p.NomeHistorico;
            FichaTecnica.NomeOriginal = p.NomeOriginal;
            FichaTecnica.UrlOficial = p.UrlOficial;
            FichaTecnica.PaisOrigem = p.PaisOrigem;
            FichaTecnica.IdiomaOriginal = p.IdiomaOriginal;
            FichaTecnica.AnoLancamento = p.AnoLancamento;
            FichaTecnica.DataEstreia = p.DataEstreia;
            FichaTecnica.Duracao = p.Duracao;
            FichaTecnica.IdClassificacao = p.IdClassificacao;
            FichaTecnica.PodeEditar = p.PodeEditar;
            Sinopse.Texto = p.Sinopse;

            vm.PodeEditar = p.PodeEditar;
          });

          atracaoArquivoSvc.listarquivos({IdAtracao: IdAtracao}).then(function (data) {

            var fotoDestaque = data.filter(function (itm) {
              return itm.IdTipoArquivo == 2;
            });
            vm.Atracao.Midia.FotoDestaque = fotoDestaque[0];

            var fotoCapa = data.filter(function (itm) {
              return itm.IdTipoArquivo == 1;
            });
            vm.Atracao.Midia.FotoCapa = fotoCapa[0];

            var fotoGaleria = data.filter(function (itm) {
              return ((itm.IdTipoArquivo == 5) || (itm.IdTipoArquivo == 3));
            });

            var lstGaleria = [];
           lstGaleria = arrGaleria(fotoGaleria);

            if (lstGaleria.length > 0) {
              lstGaleria.forEach(function (itm) {
                vm.Atracao.Midia.FotoGaleria.push(itm);
              })
            }

            // for (var i = 0; i < fotoGaleria.length; i++) {
            //
            //   console.log('fotoGaleria', fotoGaleria);
            //
            //   vm.FotoGaleria = fotoGaleria;
            //   objFotoGaleria = angular.copy(objFotoGaleria);
            //
            //   objFotoGaleria.Id = guid();
            //
            //   var galeria = fotoGaleria[i];
            //
            //   if (galeria.IdTipoArquivo == 5)
            //     objFotoGaleria.Thumb = galeria;
            //   if (galeria.IdTipoArquivo == 3)
            //     objFotoGaleria.Normal = galeria;
            //
            //   // var Imagem = {
            //   //   Id: fotoGaleria[i].Id,
            //   //   Uri: fotoGaleria[i].Uri,
            //   //   Arquivo: fotoGaleria[i].Arquivo,
            //   //   IdTipoArquivo: fotoGaleria[i].IdTipoArquivo
            //   // }
            //
            //   vm.Atracao.Midia.FotoGaleria.push(objFotoGaleria);
            // }


            var video = data.filter(function (itm) {
              return itm.IdTipoArquivo == 4;
            });
            vm.Atracao.Midia.Video = video[0];
          });


          vm.Filter.IdAtracao = IdAtracao;
          vm.Filter.NumeroVersao = NumeroVersao;

          atracaoInadequacaoSvc.list(vm.Filter).then(function (data) {
              vm.Inadequacoes = orderByFilter(data, 'Nome');
            }
          ).finally(function () {
            vm.loadInadequacoes = false;
          });

          atracaoGeneroSvc.list(vm.Filter).then(function (data) {
              data.forEach(function (itm, index) {

                if (itm.Principal)
                  vm.GeneroPrincipal = itm.Id;
              })

              vm.Generos = orderByFilter(data, 'Nome');
            }
          ).finally(function () {
            vm.loadGeneros = false;
          });

          //AUTOR
          var p1 = atracaoParticipanteSvc.list({IdTipoArtista: 1,IdAtracao: IdAtracao,NumeroVersao: NumeroVersao});

          //Diretor
          var p2 = atracaoParticipanteSvc.list({IdTipoArtista: 2,IdAtracao: IdAtracao,NumeroVersao: NumeroVersao});

          //Elenco
          var p3 = atracaoParticipanteSvc.list({IdTipoArtista: 4,IdAtracao: IdAtracao,NumeroVersao: NumeroVersao});

          //Produtor
          var p4 = atracaoParticipanteSvc.list({IdTipoArtista: 6,IdAtracao: IdAtracao,NumeroVersao: NumeroVersao});

          //Diretor Musical - Tipo 7
          var p5 = atracaoParticipanteSvc.list({IdTipoArtista: 5,IdAtracao: IdAtracao,NumeroVersao: NumeroVersao});

          //Elenco Musical - TIPOATRACAO => TEATRO
          if (IdTipoAtracao == 2) {
            var p6 = atracaoParticipanteSvc.list({IdTipoArtista: 3, IdAtracao: IdAtracao, NumeroVersao: NumeroVersao});
          }
          //Musico   - TIPOATRACAO => EVENTO E SHOW
          if (IdTipoAtracao == 1 || IdTipoAtracao == 3) {
            var p7 = atracaoParticipanteSvc.list({IdTipoArtista: 3, IdAtracao: IdAtracao, NumeroVersao: NumeroVersao});
          }

          //Banda
          var p8 = atracaobandaSvc.list({IdAtracao: IdAtracao,NumeroVersao: NumeroVersao});

          $q.all([p1, p2, p3, p4, p5, p6, p7, p8]).then(function (values) {
            vm.Autoria = orderByFilter(values[0], 'Nome');
            vm.Direcao = orderByFilter(values[1], 'Nome');
            vm.Elenco = orderByFilter(values[2], 'Nome');
            vm.Producao = orderByFilter(values[3], 'Nome');
            vm.DirecaoMusical = orderByFilter(values[4], 'Nome');
            if (IdTipoAtracao == 2) {
              vm.ElencoMusical = orderByFilter(values[5], 'Nome');
            }
            if (IdTipoAtracao == 1 || IdTipoAtracao == 3) {
              vm.Musico = orderByFilter(values[6], 'Nome');
            }
            vm.Banda = orderByFilter(values[7], 'Nome');

            complete();
          });

          function complete () {
            vm.participantesload = false;
          }

          vm.result = false;
          var Atracao = {
            IdAtracao: IdAtracao,
            FilaFraude: true,
            IdTipoAtracao: IdTipoAtracao,
            Ativo: true,
            User: ''
          }
        }
        // FIM GET DOS DADOS PARA EDIÇÃO

        if ($stateParams.filter != null) {
          vm.result = false;
          var Atracao = {
            IdAtracao: $stateParams.filter.IdAtracao,
            FilaFraude: true,
            IdTipoAtracao: $stateParams.filter.IdTipoAtracao,
            Ativo: true,
            User: ''
          }
        }

        vm.Atracao = {
          Atracao: Atracao,
          AtracaoEstabelecimento: {Ativo: true, NomeImpressao: ''},
          FichaTecnica: FichaTecnica,
          Participantes: {},
          Banda: [],
          Sinopse: Sinopse,
          Midia: {FotoDestaque: null, FotoCapa: null, FotoGaleria: [], Video: null,}
        }

        $scope.$watch('vm.Generos',function () {

          if(vm.Generos.length > 0)
            vm.ValidaGenero = true;
          else
            vm.ValidaGenero = false;

          if(vm.Generos.length == 1)
          {
            vm.Generos[0].Principal = true;
            vm.GeneroPrincipal = vm.Generos[0].Id;
          }

        },true);

        //INICIO DO SALVAMENTO
        vm.Save = function () {
          vm.loading = true;
          vm.Atracao.FichaTecnica.Inadequacoes = [];
          vm.Atracao.FichaTecnica.Generos = [];
          vm.Atracao.Participantes = [];
          vm.Atracao.Midia.AtracaoArquivo = [];

          for (var i = 0; i < vm.Inadequacoes.length; i++) {
            vm.Atracao.FichaTecnica.Inadequacoes.push({Id: vm.Inadequacoes[i].Id});
          }

          for (var i = 0; i < vm.Generos.length; i++) {
            var principal = false;

            if (vm.Generos[i].Id == vm.GeneroPrincipal)
              principal = true;

            vm.Atracao.FichaTecnica.Generos.push({
              Id: vm.Generos[i].Id,
              Principal: principal
            });
          }

          //PARTICIPANTES
          for (var i = 0; i < vm.Direcao.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Direcao[i].IdArtista,
              IdTipoArtista: vm.Direcao[i].IdTipoArtista || 2,
              Nome: vm.Direcao[i].Nome
            });
          }

          for (var i = 0; i < vm.Autoria.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Autoria[i].IdArtista,
              IdTipoArtista: vm.Autoria[i].IdTipoArtista || 1,
              Nome: vm.Autoria[i].Nome,
            });
          }

          for (var i = 0; i < vm.Elenco.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Elenco[i].IdArtista,
              IdTipoArtista: vm.Elenco[i].IdTipoArtista || 4,
              Nome: vm.Elenco[i].Nome
            });
          }

          for (var i = 0; i < vm.Producao.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Producao[i].IdArtista,
              IdTipoArtista: vm.Producao[i].IdTipoArtista || 6,
              Nome: vm.Producao[i].Nome
            });
          }

          for (var i = 0; i < vm.DirecaoMusical.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.DirecaoMusical[i].IdArtista,
              IdTipoArtista: vm.DirecaoMusical[i].IdTipoArtista || 5,
              Nome: vm.DirecaoMusical[i].Nome
            });
          }

          for (var i = 0; i < vm.ElencoMusical.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.ElencoMusical[i].IdArtista,
              IdTipoArtista: vm.ElencoMusical[i].IdTipoArtista || 3,
              Nome: vm.ElencoMusical[i].Nome
            });
          }

          for (var i = 0; i < vm.Musico.length; i++) {
            vm.Atracao.Participantes.push({
              IdArtista: vm.Musico[i].IdArtista,
              IdTipoArtista: vm.Musico[i].IdTipoArtista || 3,
              Nome: vm.Musico[i].Nome
            });
          }
          //FIM PARTICIPANTES

          //BANDA
          if (vm.Banda != null && vm.Banda.length > 0) {
            for (var i = 0; i < vm.Banda.length; i++) {
              vm.Atracao.Banda.push({
                IdBanda: vm.Banda[i].IdBanda,
                Nome: vm.Banda[i].Nome
              });
            }
          }
          //FIM BANDA

          if (vm.Atracao.Midia.FotoDestaque != null) {
            vm.Atracao.Midia.FotoDestaque.Id = guid();
          vm.Atracao.Midia.AtracaoArquivo.push(vm.Atracao.Midia.FotoDestaque);
        }

          if (vm.Atracao.Midia.FotoCapa != null) {
            vm.Atracao.Midia.FotoCapa.Id = guid();
            vm.Atracao.Midia.AtracaoArquivo.push(vm.Atracao.Midia.FotoCapa);
          }

          if (vm.Atracao.Midia.Video != null) {
            vm.Atracao.Midia.Video.Id = guid();
            vm.Atracao.Midia.AtracaoArquivo.push(vm.Atracao.Midia.Video);
          }


          for (var i = 0; i < vm.Atracao.Midia.FotoGaleria.length; i++) {

            var galeria = vm.Atracao.Midia.FotoGaleria[i];

            var newGuid = guid();

            var normal = galeria.Normal;
            vm.Atracao.Midia.AtracaoArquivo.push({
              Id: newGuid,
              IdAtracao: normal.IdAtracao,
              NumeroVersao: normal.NumeroVersao,
              IdTipoArquivo: normal.IdTipoArquivo,
              Uri: normal.Uri,
              Arquivo: normal.Arquivo,
              Base64: normal.Base64,
              IdAtracaoArquivoOriginal: normal.IdAtracaoArquivoOriginal
            });

            var thumb = galeria.Thumb;
            vm.Atracao.Midia.AtracaoArquivo.push({
              Id: guid(),
              IdAtracao: thumb.IdAtracao,
              NumeroVersao: thumb.NumeroVersao,
              IdTipoArquivo: thumb.IdTipoArquivo,
              Uri: thumb.Uri,
              Arquivo: thumb.Arquivo,
              Base64: thumb.Base64,
              IdAtracaoArquivoOriginal: newGuid
            });
          }

          // function MontaObjetoGaleria(obj,newGuid) {
          //   console.log('obj', obj);
          //
          //   var atracaoArquivo = {
          //     Id: obj.Id,
          //     IdAtracao: obj.IdAtracao,
          //     NumeroVersao: obj.NumeroVersao,
          //     IdTipoArquivo: obj.IdTipoArquivo,
          //     Uri: obj.Uri,
          //     Arquivo: obj.Arquivo,
          //     Base64: obj.Base64,
          //     IdAtracaoArquivoOriginal: obj.IdAtracaoArquivoOriginal
          //   }
          //   console.log('atracaoArquivo', atracaoArquivo);
          //   return atracaoArquivo;
          // }

          atracaoSvc.save(vm.Atracao).then(function (v) {
            var pk = v.Atracao.IdAtracao;

            vm.utils.Confirm('ATRAÇÃO CADASTRADA COM SUCESSO!', 'Deseja preencher as informações exclusivas do estabelecimento?').then(function () {
                $state.go('conteudo.atracao.informacoesexclusivas', {Id: pk});
              },
              function () {
                $state.go('conteudo.atracao.grid');
              });
          }).finally(function () {
            vm.loading = false;
          });
        };
        //FIM DO SALVAMENTO

        //BUSCANDO OS DADOS PARA CRIAÇÂO DE UMA NOVA ATRAÇÃO, EX.: PREENCHER COMBO, AUTOCOMPLETE E ETC
        classificacaoSvc.list({}).then(function (data) {
          vm.classificacoes = orderByFilter(data, 'Nome');
        });

        vm.Inadequacoes = [];
        vm.Generos = [];
        //PARTICIPANTES
        vm.Autoria = [];
        vm.Direcao = [];
        vm.Elenco = [];
        vm.Producao = [];
        vm.DirecaoMusical = [];
        vm.ElencoMusical = [];
        vm.Musico = [];
        vm.Banda = [];

        //INADEQUAÇÕES
        vm.inadequacoesSearch = function (filter) {
          var nome = filter.toLowerCase();
          return inadequacaoSvc.list({Nome: nome});
        }
        //GENEROS
        vm.generosSearch = function (filter) {
          var nome = filter.toLowerCase();
            return generoSvc.list({Nome: nome, IdTipoAtracao : $stateParams.filter.IdTipoAtracao})
          //return generoSvc.list({Nome: nome})
        };


        //BANDA
        vm.searchBanda = function (filter) {
          var nome = filter.toLowerCase();

          return bandaSvc.list({Nome: nome});
          //vm.BandaArray = data;
        };


        //AUTOR - Tipo 1
        vm.autoriaSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 1})
        };

        //DIRETOR 2
        vm.direcaoSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 2})
        };

        //Musico - Tipo 3
        vm.musicoSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 3})
        };

        //Elenco Musical(Musicos) - Tipo 3
        vm.elencoMusicalSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 3})
        };

        //Elenco - Tipo 4
        vm.elencoSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 4})
        };

        //Produtor - Tipo 6
        vm.producaoSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 6})
        };

        //Diretor Musical - Tipo 7
        vm.direcaoMusicalSearch = function (filter) {
          var nome = filter.toLowerCase();
          return artistaSvc.list({NomeArtistico: nome, IdTipoArtista: 5})
        };


        //========================== WIZARD MIDIA ============================

        function getImageDimensions(v) {
          return new Promise (function (resolved, rejected) {
            var i = new Image()
            i.onload = function(){
              resolved({w: i.width, h: i.height})
            };
            i.src = v
          })
        }


        ////========================== FOTO DESTAQUE ============================
        vm.uploadDestaque = function ($files) {
          UploadFotoDestaque($files);
        }

        $scope.$watch('vm.FileDestaque', function () {
          if (vm.FileDestaque != null) {
            vm.spinFotoDestaque = true;
            vm.stt_des = 'uploading'
            UploadFotoDestaque(vm.FileDestaque);
          }
        });

        function UploadFotoDestaque(files) {
          if (files.length > 0) {
            upload(files).then(function (v) {

              var imgs = [];
              imgs.push({w: 740, h: 380});

              var configIgm = {
                tpImg: 'retangular',
                imgs: imgs,
                ratio: 1.95
              }

                getImageDimensions(v).then(function (i) {

                if(i.w >= 740 && i.h >= 380) {

                  vm.DialogCrop(v, configIgm).then(function (images) {
                    vm.Atracao.Midia.FotoDestaque = {Uri: '../img/foto-destaque-loading.gif'};

                    if (images !== undefined) {

                      var atracaoArquivo = {
                        Base64: images[0].dataURI,
                        IdTipoArquivo: 2
                      };

                      atracaoSvc.uploadImagem(atracaoArquivo).then(function (data) {

                        vm.Atracao.Midia.FotoDestaque = data;
                        vm.Atracao.Midia.FotoDestaque.IdTipoArquivo = 2;

                      });
                    }
                  });
                }
                else{
                  $scope.$apply(function () {
                    toaster.pop('warning', 'Aviso!', 'Imagem de Destaque deve possuir um formaro mínimo de 740x380.');
                    vm.spinFotoDestaque = false;
                    return false;
                  })
                }
              });



            }).finally(function () {
              vm.spinFotoDestaque = false;
            });
          }
        }

        vm.DeleteFotoDestaque = function (imagem, ev) {
          vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
            vm.Atracao.Midia.FotoDestaque = null;
            var arrImagem = [];
            arrImagem.push(imagem);
            // atracaoSvc.deleteImagem(arrImagem).then(function (data) {
            //   if (data.statusText == "OK") {
            //     vm.Atracao.Midia.FotoDestaque = null;
            //   }
            // });
          });
        };

        ////========================== FOTO CAPA============================
        $scope.$watch('vm.FileCapa', function () {
          if (vm.FileCapa != null) {
            vm.spinFotoCapa = true;
            UploadFotoCapa(vm.FileCapa);
          }
        });

        vm.uploadCapa = function ($files) {
          UploadFotoCapa($files);
        };

        function UploadFotoCapa(files) {
          if (files.length > 0) {
            upload(files).then(function (v) {

              var imgs = [];
              imgs.push({w: 370, h: 550});

              var configIgm = {
                tpImg: 'square',
                imgs: imgs,
                ratio: 0.67
              }

              getImageDimensions(v).then(function (i) {

                if(i.w >= 370 && i.h >= 550) {

                  vm.DialogCrop(v, configIgm).then(function (images) {

                    vm.Atracao.Midia.FotoCapa = {Uri: '../img/foto-capa-loading.gif'};

                    if (images !== undefined) {

                      var atracaoArquivo = {
                        Base64: images[0].dataURI,
                        IdTipoArquivo: 1
                      };

                      atracaoSvc.uploadImagem(atracaoArquivo).then(function (data) {
                        vm.Atracao.Midia.FotoCapa = data;
                        vm.Atracao.Midia.FotoCapa.IdTipoArquivo = 1;
                      }).finally(function () {
                        vm.spinFotoCapa = false;
                      });
                    }

                  });
                }
                else{
                  $scope.$apply(function () {

                    toaster.pop('warning', 'Aviso!', 'Imagem de Capa deve possuir um formaro mínimo de 370x550.');
                    vm.spinFotoCapa = false;
                    return false;
                  });
                }
              });

            });
          }
        }

        vm.DeleteFotoCapa = function (imagem, ev) {
          vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
            vm.Atracao.Midia.FotoCapa = null;
            var arrImagem = [];
            arrImagem.push(imagem);
            // atracaoSvc.deleteImagem(arrImagem).then(function (data) {
            //   if (data.statusText == "OK") {
            //     vm.Atracao.Midia.FotoCapa = null;
            //   }
            // });
          });
        };


        ////========================== FOTO GALERIA============================
        function guid() {
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
              .toString(16)
              .substring(1);
          }

          return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
        }

        $scope.$watch('vm.FileGaleria', function () {
          if (vm.FileGaleria != null) {
            vm.spinFotoGaleria = true;
            UploadFotoGaleria(vm.FileGaleria);
          }
        });

        function UploadFotoGaleria(files, index) {

          if (files.length > 0) {
            var imgs = [];
            imgs.push({w: 352, h: 235, IdTipoArquivo: 5});
            imgs.push({w: 960, h: 640, IdTipoArquivo: 3});

            var configIgm = {
              tpImg: 'square',
              imgs: imgs,
              ratio: 1.5
            }

            upload(files).then(function (v) {

            getImageDimensions(v).then(function (i) {
              if(i.w >= 960 && i.h >= 640) {
                 vm.DialogCrop(v, configIgm).then(function (images) {

                    var imgGaleria = [];

                    if (images !== undefined) {

                      objFotoGaleria = angular.copy(objFotoGaleria);

                      objFotoGaleria.Thumb = {
                        Uri :'../img/foto-galeria-loading.gif'
                      };

                      var idAtracaoArquivo = guid();
                      objFotoGaleria.Id = guid();//'Id' + Math.floor((1 + Math.random()) * 0x10000).toString(16);

                      images.forEach(function (itm, idx) {

                        var idTipoArquivo = 3;

                        if (itm.w == 352)
                          idTipoArquivo = 5;

                        var atracaoArquivo = {
                          Base64: itm.dataURI,
                          IdTipoArquivo: idTipoArquivo
                        };

                        atracaoSvc.uploadImagem(atracaoArquivo).then(function (data) {

                          if (itm.w == 352) {
                            objFotoGaleria.Thumb = data;
                            objFotoGaleria.Thumb.Id = guid();
                            objFotoGaleria.Thumb.IdAtracaoArquivoOriginal = idAtracaoArquivo;
                          }
                          else {
                            objFotoGaleria.Normal = data;
                            objFotoGaleria.Normal.Id = idAtracaoArquivo;
                            objFotoGaleria.Normal.IdAtracaoArquivoOriginal = null;
                          }

                        }).finally(function () {
                          vm.spinFotoCapa = false;
                        });

                      })

                      if(index === undefined)
                        vm.Atracao.Midia.FotoGaleria.push(objFotoGaleria);
                      else
                        vm.Atracao.Midia.FotoGaleria[index] = objFotoGaleria;

                    }
                  });
                }
                else
                  {
                      $scope.$apply(function () {
                        toaster.pop('warning', 'Aviso!', 'Imagem de Galeria deve possuir um formaro mínimo de 960x640.');
                        vm.spinFotoGaleria = false;
                        return false;
                      });
                   }

                }).finally(function () {
                  vm.spinFotoGaleria = false;
                });


            });


          }
        }

        function reqImage(resp, ls) {
          var req = {
            loading: true,
            Imagem: resp.data.Imagem,
            img: '',
            IdAtracao: "",
            NumeroVersao: "",
            IdTipoArquivo: ls.IdTipoArquivo,
            Uri: "",
            Arquivo: "",
            Base64: '',

            // prom: atracaoSvc.uploadImagem(ls).then(function (data) {
            //     req.Imagem = data.data.Imagem;
            //   },
            //   function (err) {
            //     req.error = true;
            //   }
            // ).finally(function () {
            //   req.loading = false;
            // })
          }
          return req;
        }

        vm.DeleteFotoGaleria = function (idx, itm, ev) {

          vm.utils.Confirm('EXCLUIR', 'Confirma a exclusão da imagem?').then(function () {
            vm.Atracao.Midia.FotoGaleria.splice(idx, 1);

            //var arrArquivo = [];
            //arrArquivo.push(itm.Normal);
            //arrArquivo.push(itm.Thumb);

            // atracaoSvc.deleteImagem(arrArquivo).then(function (data) {
            // });
            //atracaoSvc.deleteImagem(itm.Thumb).then(function (data) {});
          });
        };

        vm.updateGaleria = function ($files, $index) {
          UploadFotoGaleria($files, $index);
        };


        ////========================== UPLOAD VIDEO============================
        $scope.$watch('vm.FileVideo', function () {
          if (vm.FileVideo != null) {
            atracaoSvc.uploadVideo({file: vm.FileVideo}).then(function (data) {
                vm.result = true;
                vm.Atracao.Midia.Video = data.Video;
                vm.Atracao.Midia.Video.IdTipoArquivo = 4;
                vm.Atracao.Midia.Video.Uri = data.Video.Uri;
              },
              function (resp) {
              },
              function (evt) {
                vm.videoProgress = Math.round(evt.loaded / evt.total * 100);
              }
            ).finally(function () {
              vm.videoProgress = null;
            });

          }
        });

        //DELETE
        vm.DeleteVideo = function (video) {
          vm.Atracao.Midia.Video = null;

          var arrVideo = [];
          arrVideo.push(video);
          // atracaoSvc.deleteImagem(arrVideo).then(function (data) {
          //   if (data.Status == "OK") {
          //     vm.Atracao.Midia.Video = null;
          //   }
          // });
        }

        //UPLOAD
        vm.UpdateVideo = function ($files) {

          if ($files != null) {
            atracaoSvc.uploadVideo({file: $files}).then(function (data) {
                vm.result = true;
                vm.Atracao.Midia.Video = data.data.Video;
                vm.Atracao.Midia.Video.IdTipoArquivo = 4;
                vm.Atracao.Midia.Video.Uri = data.data.Video.Uri;
              },
              function (resp) {
              },
              function (evt) {
                vm.videoProgress = Math.round(evt.loaded / evt.total * 100);
              }
            ).finally(function () {
              vm.videoProgress = null;
            });

          }
        }


        ////========================== METODOS GENERICOS============================
        function upload($files) {

          if ($files.length > 0) {

            var def = $q.defer();
            var file = $files[0];
            var result = [];
            var reader = new FileReader();
            reader.onerror = reader.onabort = function () {
              def.reject('Falha ao ler o arquivo')
            }
            reader.onload = function (evt) {
              $scope.$apply(function () {
                if (result.indexOf(evt.target.result) === -1) {
                  result.push(evt.target.result);
                }

                if ($files.length == 0)
                  def.resolve(result);
                else
                  reader.readAsDataURL($files.splice(0, 1)[0]);
              });
            };
            reader.readAsDataURL($files.splice(0, 1)[0]);
            return def.promise;
          }
        };

        vm.DialogCrop = function (image, configIgm) {
          return $uibModal.open({
            animation: true,
            modalFade: false,
            templateUrl: 'view/conteudo/atracao/template/crop_tmpl.html',
            controller: 'app.controller.conteudo.atracao.wizard_crop',
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
              image: function () {
                vm.loadingCrop = true;
                return image;
              },
              configIgm: function () {
                return configIgm;
              }
            }
          })
            .result.then(function (imgResult) {
                vm.loadingCrop = true;
                return imgResult;
              },
              function (e) {
              });
        };

        //========================== FIM WIZARD MIDIA ============================

        vm.Cancelar = function () {
          $state.go('conteudo.atracao.grid');
        }

        function arrGaleria(fotoGaleria) {
          var mapFotoGaleria = [];
          if (fotoGaleria.length > 0) {

            fotoGaleria.forEach(function (itm, idx, arr) {
              itm.Thumb = arr.find(function (a) {
                return a.IdAtracaoArquivoOriginal == itm.IdAtracaoArquivo
              });

            });
            fotoGaleria = fotoGaleria.filter(function (a) {
              return a.IdAtracaoArquivoOriginal == '00000000-0000-0000-0000-000000000000' || a.IdAtracaoArquivoOriginal === null;
            });

            mapFotoGaleria = fotoGaleria.map(function (itm) {
                var guidId = guid();
                return objFotoGaleria = {
                  Id: guid(),
                  Thumb: {
                    Id: itm.Thumb.Id,
                    IdAtracao: itm.Thumb.IdAtracao,
                    NumeroVersao: itm.Thumb.NumeroVersao,
                    IdTipoArquivo: itm.Thumb.IdTipoArquivo,
                    Uri: itm.Thumb.Uri,
                    Arquivo: itm.Thumb.Arquivo,
                    Base64: itm.Thumb.Base64,
                    IdAtracaoArquivoOriginal: itm.Thumb.IdAtracaoArquivoOriginal
                  },
                  Normal: {
                    Id: itm.Id,
                    IdAtracao: itm.IdAtracao,
                    NumeroVersao: itm.NumeroVersao,
                    IdTipoArquivo: itm.IdTipoArquivo,
                    Uri: itm.Uri,
                    Arquivo: itm.Arquivo,
                    Base64: itm.Base64,
                    IdAtracaoArquivoOriginal: itm.IdAtracaoArquivoOriginal
                  }
                }
              }
            );
          }

          return mapFotoGaleria;
        }
      }
    ])

    .controller("app.controller.conteudo.atracao.wizard_crop", ["$scope", "$uibModalInstance", "image", "configIgm", function ($scope, $uibModalInstance, image, configIgm) {
      var vm = this;


      var configIgm = configIgm;
      var arrImagem = configIgm.imgs;

      var tpImg = 'square';
      var w = 200;
      var h = 200;
      var ratio = null;

      var resultImageSize = [];

      if (configIgm !== undefined) {

        if (configIgm.tpImg != undefined && configIgm.tpImg === 'retangular')
          tpImg = 'rectangle';

        if (arrImagem.length > 0) {
          arrImagem.forEach(function (img, i) {
            if (img.w !== undefined && img.h !== undefined) {
              resultImageSize.push({w: img.w, h: img.h});
            }
          })
        }
        else {
          resultImageSize.push({w: w, h: h});
        }

        if (configIgm.ratio !== undefined) {
          ratio = configIgm.ratio;
        }
      }


      vm.size = 'large';
      vm.tipoImagem = 'rectangle';
      vm.imageDataURI = image[0];
      vm.resImageDataURI = '';
      vm.resultImageFormat = 'image/jpg';
      vm.resultImageQuality = 1;
      vm.resultImageSize = resultImageSize;
      vm.ratio = ratio;
      //vm.selMinSize = 100;
      //vm.resImgSize = 200;

      vm.Confirm = function () {
        vm.loadingCrop = true;
          $uibModalInstance.close(vm.resArrImagens);
      };

      vm.Cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
    }]);

})
();


(function () {
    'use strict';

    angular
        .module('ticket.controller.conteudo')

        .controller('ticket.controller.conteudo.pre_cadastro', [
            'common',
            '$state',
            'orderByFilter',
            'toaster',
            'ticket.service.conteudo.atracao',
            'ticket.service.controleestabelecimento.estabelecimentoTipoAtracao',
            'ticket.service.conteudo.atracaoestabelecimento',
            function (common, $state, orderByFilter,toaster, atracaoSvc, tipoSvc, atracaoEstabelecimentoSvc) {

                var vm = common.controller.grid(this, atracaoSvc);

                vm.NovaAtracao = novaAtracao;
                vm.customToggle = customToggle;

                tipoSvc.list({}).then(function (v) {

                    v = orderByFilter(v, '-Principal');

                    vm.Filter.TipoAtracao = v[0].IdTipoAtracao;
                    vm.Filter.Todos = 1;
                    vm.Filter.Status = 3;

                  vm.TipoAtracao = v[0];

                    if (v.length > 0) {
                        vm.tiposAtracao = v;

                        // vm.ObterTitulo = function () {
                        //
                        //     return vm.tiposAtracao.filter(
                        //       function (v) { return v.IdTipoAtracao == vm.Filter.TipoAtracao; })[0].IdTipoAtracao
                        // }
                    }
                    // else {
                    //
                    //     vm.ObterTitulo = function () { return v[0].IdTipoAtracao == 1 ? 'SHOW' : v[0].IdTipoAtracao == 2 ? 'SHOW' : ''; }
                    // }
                });

              vm.NomeCriacao = function (itm) {
                vm.TipoAtracao = vm.tiposAtracao.find(function (tipo) {
                    return tipo.IdTipoAtracao == itm;
                })
              }

              vm.associarDesassociar = function (itm) {
                atracaoEstabelecimentoSvc.associar({Id: itm.IdAtracao,NomeImpressao: itm.NomeAtracao}).then(function () {
                  toaster.pop('success', 'Associação', "Associação realizada com sucesso!");
                  itm.Associada = true;
                  itm.Status = 1;
                });
              }

                function customToggle(itm) {
                    var key = { Id: itm.IdAtracao };

                    var text = itm.Status === 1 ? 'Deseja inativar essa atração?' : 'Deseja ativar essa atração?';
                    var textTitle = itm.Status === 1 ? 'Inativar Atração' : 'Ativar atração.';

                    vm.utils.Confirm(textTitle, text).then(function () {

                        atracaoEstabelecimentoSvc.toggle(key).then(function (v) {
                            itm.Status = v;
                        });
                    });
                }

                function novaAtracao() {
                    $state.go('conteudo.atracao.wizard.ficha_tecnica', { filter: { IdTipoAtracao: vm.Filter.TipoAtracao, NomeAtracao : vm.Filter.Nome } });
                }
            }])
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.conteudo')
    .controller('ticket.controller.conteudo.atracao', ["$scope", "common", "ticket.service.conteudo.atracao", "ticket.service.conteudo.atracaoestabelecimento", function($scope, common, atracaoSvc) {
      var vm = common.controller.master(this, atracaoSvc, $scope);


    }])
    .controller('ticket.controller.conteudo.atracao.grid', ["$scope", "common", "$rootScope", "ticket.service.conteudo.atracao", "ticket.service.conteudo.atracaoestabelecimento", "$state",
      function($scope, common, $rootScope, atracaoSvc, atracaoEstabelecimentoSvc, $state) {

        var vm = common.controller.grid(this, atracaoSvc);

        vm.CountAtracao = 0;
        vm.page = 0;
        vm.items = [];
        vm.searching = false;
        vm.complete = false;
        vm.sh = false;
        vm.NotResult = false;
        var pageSize = 20;

        var atracao = atracaoSvc.list({
          IdEstabelecimento: '',
          HasCount: true
        }).then(function(atr) {
          if (atr != null){}
            vm.CountAtracao = atr.length;

        });

        vm.search = function(inScroll) {

          vm.sh = true;
          if (vm.searching) return;
          vm.searching = true;

          if (!inScroll) {
            vm.page = 0;
            vm.complete = false;
            vm.items = [];
          }

            atracaoSvc.getAll({
                Config: {
                  Skip: vm.page,
                  Top: pageSize
                },
                Filter: vm.Filter
              })
              .then(function(data) {
                vm.items = vm.items.concat(data);

                if (data.length < pageSize)
                  vm.complete = true;

                if (data.length > 0) {
                  vm.NotResult = false;
                  vm.page += 1;
                }
                else
                {
                  vm.NotResult = true;
                }

              }).finally(function() {
                vm.searching = false;
              });
        };

        vm.editarInformacoesExclusivas = editarInformacoesExclusivas;
        vm.editarAtracao = editarAtracao;
        vm.customToggle = customToggle;
        vm.desassociar = desassociar;

        // Obter Ativos
        vm.Filter.Status = 1;
        vm.atracaoEstabelecimentoSvc = atracaoEstabelecimentoSvc;

        vm.novaAtracao = function() {
          $state.go('conteudo.atracao.pre_cadastro')
        }

        /* funções */
        function desassociar(itm) {
          vm.utils.Confirm("Desassociar Atração", "Deseja desassociar esta atração?").then(function() {

            var key = {
              Id: itm.IdAtracao
            };
            vm.loadPopup = true;
            vm.atracaoEstabelecimentoSvc.del(key).then(function(data) {
              vm.items.splice(vm.items.indexOf(itm), 1);
              vm.utils.ShowSuccess("Desassociar Atração", "Atração desassociada com sucesso!");
            }).finally(function() {
              delete vm.loadPopup;
            });
          });
        }


        function editarAtracao(itm) {
          //$state.go('conteudo.atracao.wizard.ficha_tecnica', { filter: { Id: itm.Id, NumeroVersao: itm.NumeroVersao, IdTipoAtracao: itm.IdTipoAtracao } });
          $state.go('conteudo.atracao.wizard.ficha_tecnica', {
            filter: {
              NumeroVersao: itm.NumeroVersao,
              IdTipoAtracao: itm.IdTipoAtracao,
              IdAtracao: itm.IdAtracao
            }
          });
        }

        function editarInformacoesExclusivas(itm) {
          $state.go('conteudo.atracao.informacoesexclusivas', {
            Id: itm.IdAtracao
          });
        }

        function customToggle(itm) {

          vm.utils.Confirm("Desabilitar Atração", "Deseja desabilitar esta atração?").then(function() {
            var key = {
              Id: itm.IdAtracao
            };

            vm.atracaoEstabelecimentoSvc.toggle(key).then(function (v) {
              itm.Status = v;
            });

          });
        }
      }
    ])

  .controller('ticket.controller.conteudo.atracao.form', ["common", "ticket.service.conteudo.atracao",
      function(common, atracaoSvc) {

        var vm = common.controller.form(this, atracaoSvc);

      }
    ])
    .controller('ticket.controller.conteudo.atracao.informacoesexclusivas', ["$state", '$stateParams', "common", "ticket.service.conteudo.atracaoestabelecimento", "ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao",
      function($state, $stateParams, common, atracaoestabelecimentoSvc, estabelecimentoConfiguracaoInformacaoSvc) {

        var vm = common.controller.form(this, atracaoestabelecimentoSvc);



        if($stateParams.Id === null && $stateParams.IdAtracao === ""){
          estabelecimentoConfiguracaoInformacaoSvc.get({ pk: null }).then(function (data) {
            vm.item.NotasCompra = data.NotasCompra;
            vm.item.NotasImpressao = data.NotasImpressao;
          });
        }

      }
    ]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication', [
        	
        ]);
})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.authentication.signup.controller', ["$scope", "$state", "$mdToast", "$http", "$filter", "triSettings", function($scope, $state, $mdToast, $http, $filter, triSettings){
            var vm = this;
            vm.triSettings = triSettings;
            vm.signupClick = signupClick;
            vm.user = {
                name: '',
                email: '',
                password: '',
                confirm: ''
            };



            ////////////////

            function signupClick() {
                $mdToast.show(
                    $mdToast.simple()
                    .content($filter('triTranslate')('Confirmation sent'))
                    .position('bottom right')
                    .action($filter('triTranslate')('Login'))
                    .highlightAction(true)
                    .hideDelay(0)
                ).then(function() {
                    $state.go('authentication.login');
                });
            }
        }]);
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.authentication')
    .controller('ticket.controller.authentication.login', ["$state", "ticketSettings", "$scope", "common", "ticket.service.controleacesso.login",
      function($state, ticketSettings, $scope, common, loginSvc) {
        var vm = common.controller.instantiate(this);

        //SE ENTROU NESSE CONTROLLER, ENTÃO PERDE AS CREDENCIAIS.
        loginSvc.Logout(true);


        function loginClick() {
          vm.loading = true;
          loginSvc.Logon(vm.user)
            .then(function(v) {
                (v.estabelecimento == null) ? $state.go('auth.establishment'): $state.go('site.home');
              },
              function(e) {
                var msg = "Usuário/Senha incorretos. Verifique as informações e tente novamente.";

                if (e.status == -1) {
                  msg = "Falha ao acessar o serviço. Verifique sua conexão com a internet."
                } else if (e.data && e.data.error == "no_establishment") {
                  msg = e.data.error_description;
                }

                vm.utils.ShowError("Identificação no sistema", msg);

              })
            .finally(function(e) {
              vm.loading = false;
            });
        }

        vm.loginClick = loginClick;
        vm.socialLogins = [{
          icon: 'fa fa-twitter',
          color: '#5bc0de',
          url: '#'
        }, {
          icon: 'fa fa-facebook',
          color: '#337ab7',
          url: '#'
        }, {
          icon: 'fa fa-google-plus',
          color: '#e05d6f',
          url: '#'
        }, {
          icon: 'fa fa-linkedin',
          color: '#337ab7',
          url: '#'
        }];
        vm.ticketSettings = ticketSettings;
        // create blank user variable for login form
        vm.user = {
          email: '',
          password: ''
        };





      }
    ]);


})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.lock', LockController);

    /* @ngInject */
    function LockController($state, triSettings) {
        var vm = this;
        vm.loginClick = loginClick;
        vm.user = {
            name: 'Morris Onions',
            email: 'info@oxygenna.com',
            password: ''
        };
        vm.triSettings = triSettings;

        ////////////////

        // controller to handle login check
        function loginClick() {
            // user logged in ok so goto the dashboard
            $state.go('triangular.dashboard-general');
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.resetpassword', ["$q", "$state", "$stateParams", "common", "ticket.service.controleacesso.usuario", "ticket.service.controleacesso.login",  "ticketSettings", function($q, $state, $stateParams, common, usuarioSvc, loginSvc, ticketSettings){
            var vm = common.controller.basic(this) ;

            vm.user = {Password : '', Token: $stateParams.token};
            vm.pageTitle = $state.current.data.pageTitle;

            vm.loading = true;
            vm.err = false;
            vm.showFields = false;

            usuarioSvc.resetPasswordValidate($stateParams.token).then(
                function(res){                     
                    vm.showFields = true;
                },
                function(err){
                    vm.err = true;
                    var d = {Message: 'Ocorreu um erro ao acessar o serviço'}
                    var m = err.data || d;
                    vm.errMsg = m.Message || d.Message;
                }
            ).finally(function(){
                vm.loading = false;
            });
            
            vm.ComparaSenha = function(value){
              var def = $q.defer();
              
                if (value == vm.user.Password ) 
                {def.resolve(true);} 
                else 
                {def.reject(false);}

              return def.promise;
            };

            vm.Change = function(){ 
                vm.loading = true;
                usuarioSvc.resetPasswordConfirm( vm.user ).then(
                        function(res){  
                            vm.utils.ShowSuccess("Alteração de senha", "Sua senha foi alterada com sucesso.")
                            
                            loginSvc.Logon( { email: res.Login , password: vm.user.Password } ).then(function(v){ 
                                    ( v.estabelecimento == null ) ?  $state.go('auth.establishment') : $state.go('site.home');
                                }
                            );
                        },
                        function(e){  }
                    ).finally(function(){
                        vm.loading = false;
                    }); 
            }


        }]);

    
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.forgot', ["$state", "ticketSettings", "common", "ticket.service.controleacesso.captcha", "ticket.service.controleacesso.usuario", function ($state, ticketSettings, common, captchaSvc, usuarioSvc) {
            var vm = common.controller.instantiate(this);

            vm.ticketSettings = ticketSettings;
            vm.user = { Email: '' };

            vm.loadingCaptcha = true;
            vm.loadingError   = false;

            //busca um novo hash e renderiza o captcha que está associado.
            vm.reload = function(){
                vm.loadingError = false;

                return captchaSvc.get()
                    .then
                    (
                        function(v){ vm.user.Hash = v.Chave; },
                        function(err){ vm.ImgCaptcha = null; vm.loadingError = true; }
                    )
                    .finally
                    (
                        function(){ vm.loadingCaptcha = false; }
                    );
            }

            //renderiza o captcha
            vm.renderCaptcha = function(){
                vm.loadingCaptcha = true;
                vm.loadingError = false;

                captchaSvc.render({Chave: vm.user.Hash})
                .then(
                    function(v){vm.ImgCaptcha = v;},
                    function(err){vm.reload();}
                )
                .finally(
                    function(){vm.loadingCaptcha = false;}
                );
            };

            vm.reseting = false;

            //Dispara o reinicio da senha
            vm.resetClick = function(){
                vm.reseting = true;
                usuarioSvc.resetPasswordV2(vm.user).then(
                    function(){
                        vm.utils.ShowSuccess("Recuperação de senha", "Enviamos as instruções para o seu e-mail.")
                        $state.go('auth.login')
                    },
                    function(err){
                        vm.reload();
                    }
                ).finally(function(){
                    vm.reseting = false;
                });
            }


            vm.reload().then(function(){ vm.renderCaptcha(); });

        }]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .controller('ticket.controller.authentication.establishment', 
            ["$state", "ticketSettings", "common", "ticket.controleacesso.service.perfilestabelecimento", "ticket.service.controleacesso.login", 
            function($state, ticketSettings, common, estabelecimentoSvc, loginSvc){
                var vm = common.controller.instantiate(this);
                vm.estabelecimentos = [];
                vm.loading = true;

                estabelecimentoSvc.list({ }).then(
                    function(v)
                    {
                        vm.loading = false;
                        if( v.length == 0)
                            {$state.go('auth.login');}
                        else
                            {vm.estabelecimentos = v;}


                    },
                    function(e){
                        vm.loading = false;
                        vm.utils.ShowError("Seleção de estabelecimentos", 'Nenhum estabelecimento identificado. Refaça seu login.');
                        $state.go('auth.login');
                    }
                );


                vm.selecionar = function(itm){
                    loginSvc.RefreshToken(itm.IdEstabelecimento).then(
                        function(v){
                            vm.utils.ShowSuccess("Seleção de estabelecimentos", 'Estabelecimento selecionado: ' + v.estabelecimento)
                            $state.go('site.home');

                         },
                        function(err){
                            vm.utils.ShowError("Seleção de estabelecimentos", 'Ocorreu um erro na troca de estabelecimento.');
                            $state.go('auth.login');
                        }
                    );
                }


        }]);


})();

(function() {
    'use strict';

    angular
        .module('ticket.service.cliente', [ ]);
})();

(function () {
    'use strict';

    var mod = angular.module('ticket.service.cliente');

    mod.factory("ticket.service.cliente.producao", ["common", "$q", "$timeout", function (common, $q, $timeout) {
        var res = {};

        return common.service.instantiate(res, "cliente/producao/");

    }]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.translate', [
            'pascalprecht.translate',
            'LocalStorageModule'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.translate')
        .filter('ticketTranslate', appTranslateFilter);

    /* @ngInject */
    function appTranslateFilter($injector, $filter) {
        return function(input) {
            // if angular translate installed this will return true
            // so we can translate
            if($injector.has('translateFilter')) {
                return $filter('translate')(input);
            }
            else {
                // no translation active so just return the same input
                return input;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('ticket.translate')
        .config(translateConfig);

    /* @ngInject */
    function translateConfig($translateProvider, $translatePartialLoaderProvider, appSettingsProvider) {
        var appLanguages = [
        {
            name: 'English',
            key: 'en'
        },
        {
            name: 'Portuguese',
            key: 'pt'
        }];

        /**
         *  each module loads its own translation file - making it easier to create translations
         *  also translations are not loaded when they aren't needed
         *  each module will have a i18n folder that will contain its translations
         */
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });

        $translatePartialLoaderProvider.addPart('app');

        // make sure all values used in translate are sanitized for security
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // cache translation files to save load on server
        $translateProvider.useLoaderCache(true);

        
        var angularTranslateLanguageKeys = [];
        for (var language in appLanguages) {
            angularTranslateLanguageKeys.push(appLanguages[language].key);

            appSettingsProvider.addLanguage({
                name: appLanguages[language].name,
                key: appLanguages[language].key
            });
        }

        /**
         *  try to detect the users language by checking the following
         *      navigator.language
         *      navigator.browserLanguage
         *      navigator.systemLanguage
         *      navigator.userLanguage
         */
        $translateProvider
        .registerAvailableLanguageKeys(angularTranslateLanguageKeys, {
            'en_US': 'en',
            'en_UK': 'en',
            'pt_BR': 'pt',
            'pt_PT': 'pt'
        })
        .use('pt');

        // store the users language preference in a cookie
        $translateProvider.useLocalStorage();
    }
})();

(function() {
    'use strict';

    angular
        .module('ticket.service.venda', [ ]);
})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.venda');

	mod.factory("ticket.service.venda.vendabilheteria", ["common", function(common){
    var res = {

      cancelarVendaBilheteria: function (filter) {
        return this.request("cancelarVendaBilheteria", filter.filter);
      }
    };
		return common.service.instantiate(res, "venda/vendabilheteria/");
	}]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.service.reports', [ ]);
})();

(function() {
  'use strict'
  angular.module('ticket.service.reports')
  .factory('ticket.service.reports.report', ['common', function(common) {
    var res = {
      getAll: function(filter) {
        return this.request("getall/", filter);
      }
    }
    return common.service.instantiate(res, 'relatorio/relatorio/')
  }])
})();

(function(){
  'use strict';

  angular.module('ticket.service.reports')

    .factory("ticket.service.reports.futuras", ["common", function(common){
      var res = {
        futuras: function(filter){
          return this.request("futuras/", filter);
        },

        futurasAsync: function(filter) {
          return this.request("futurasasync/", filter);
        },

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "relatorio/futuras/");
    }]);



})();

(function(){
  'use strict';

  angular.module('ticket.service.reports')

    .factory("ticket.service.reports.financeiro", ["common", function(common){
      var res = {
        financeiro: function(filter){
          return this.request("financeiro/", filter);
        },

        financeiroAsync: function(filter) {
          return this.request("financeiroasync/", filter);
        },
      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "relatorio/financeiro/");
    }]);
})();

/**
 * Created by elton.araujo on 09/05/2017.
 */
(function(){
  'use strict';

  angular.module('ticket.service.reports')

    .factory("ticket.service.reports.fechamentodia", ["common", function(common){
      var res = {
        fechamentodiaresumo: function(filter){
          return this.request("fechamentodiaresumo/", filter);
        },

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "relatorio/fechamentodia/");
    }]);

})();

(function(){
  'use strict';

  angular.module('ticket.service.reports')

    .factory("ticket.service.reports.fechamentocaixa", ["common", function(common){
      var res = {
        fecharCaixa: function(filter){
          return this.request("fecharCaixa/", filter);
        },

      }; //<-- Customize aqui seu service

      return common.service.instantiate(res, "relatorio/fechamentocaixa/");
    }]);

})();

(function () {
  'use strict';

  angular.module('ticket.service.reports')
    .factory("ticket.service.reports.bordero", borderoFactory);

  borderoFactory.$inject = ['common'];
  function borderoFactory(common) {
    var res = {
      previa: function(idSessao){
        return this.request("previa/", idSessao);
      },
      bordero: function(idSessao){
        return this.request("bordero/", idSessao);
      },
      getallprevia: function(filter){
        return this.request("getallprevia", filter);
      }
    };
    return common.service.instantiate(res, "reports/bordero/");
  }
})();

(function() {
    'use strict';

    angular
        .module('ticket.service.programacao', [ ]);
})();
(function(){
    'use strict';

    angular.module('ticket.service.programacao')
    
    .factory("ticket.service.programacao.tiposessaoempresa", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/tiposessaoempresa/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.tipoentregaestabelecimento", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/tipoentregaestabelecimento/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessaotiposessaoempresa", ["common","$http","appSettings", function(common,$http,appSettings){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/sessaotiposessaoempresa/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessaotipoentregaestabelecimento", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/sessaotipoentregaestabelecimento/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessaoparticipanteconvidado", ["common","$http","appSettings", function(common,$http,appSettings){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/sessaoparticipanteconvidado/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessaolegendaidioma", ["common","$http","appSettings", function(common,$http,appSettings){
        var res = {

          listSessao: function (key) {
            return this.request("listSessao", key);
          }
        }; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/sessaolegendaidioma/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.programacao')

    .factory("ticket.service.programacao.sessao", ["common","$http","appSettings", function(common,$http,appSettings){
        var res = {

          listSessao: function (key) {
            return this.request("listSessao", key);
          },

          resumoProgramacao: function (filter) {
            return this.request("resumoprogramacao", filter);
          },
          alteraringresso : function (frm) {
            return this.request("alteraringresso", frm);
          },
          hasbloqueio: function (keys) {
            return this.request("hasbloqueio", keys);
          },
        }; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/sessao/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.programacao')
    
    .factory("ticket.service.programacao.legendaidioma", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "programacao/legendaidioma/");
    }]);

})();
(function() {
    'use strict';

    angular
        .module('ticket.service.local', [ ]);
})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.tipoobjetomapa", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/tipoobjetomapa/");
    }]);

})();
(function () {
  'use strict';

    angular.module('ticket.service.local')
      .factory('ticket.service.local.tipodocumentosala', ['common', function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/tipodocumentosala/");
      }]);
})();

(function() {
  'use strict';

  angular.module('ticket.service.local')
    .factory('ticket.service.local.tipoassentobloqueio', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service

      return common.service.instantiate(res, "local/tipoassentobloqueio/");
    }]);
})();

(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.tipoassento", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/tipoassento/");
    }]);

})();
(function() {
  'use strict';

  angular.module('ticket.service.local')

  .factory("ticket.service.local.setor", ["common", function(common) {
    var res = {
      getSvg: function(filter) {
        return this.request('svg', filter);
      }
    }; //<-- Customize aqui seu service

    return common.service.instantiate(res, "local/setor/");
  }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.sala", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/sala/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')

    .factory("ticket.service.local.pavimento", ["common", function(common){
        var res = { }; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/zona/");
    }]);

})();

(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.objetomapa", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/objetomapa/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.mapaassento", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/mapaassento/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.local')
    
    .factory("ticket.service.local.layout", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/layout/");
    }]);

})();
(function () {
  'use strict';

    angular.module('ticket.service.local')
      .factory('ticket.service.local.documentosala', ['common', function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "local/documentosala/");
      }]);
})();

(function() {
  'use strict';

  angular.module('ticket.service.local')

  .factory("ticket.service.local.assentobloqueio", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "local/assentobloqueio/");
  }]);

})();
(function() {
  'use strict';

  angular.module('ticket.service.local')

  .factory("ticket.service.local.assento", ["common", function(common) {
    var res = {}; //<-- Customize aqui seu service

    return common.service.instantiate(res, "local/assento/");
  }]);

})();
(function() {
    'use strict';

    angular
        .module('ticket.service.formapagamento', [ ]);
})();

(function () {
  'use strict';


  angular.module('ticket.service.formapagamento')
    .factory('ticket.service.formapagamento.taxa', formaPagamentoTaxaFactory);

  formaPagamentoTaxaFactory.$inject = ['common'];
  function formaPagamentoTaxaFactory(common) {
    var service = {
      //PASS FUNCTIONS TO SERVICE
    };
    return common.service.instantiate(service, 'formapagamento/formapagamentoestabelecimentotaxa/');


    //DECLARE FUNCTIONS HERE


  }
})();

(function () {
  'use strict';


  angular.module('ticket.service.formapagamento')
    .factory('ticket.service.formapagamento.estabelecimento', formaPagamentoTaxaFactory);

  formaPagamentoTaxaFactory.$inject = ['common'];
  function formaPagamentoTaxaFactory(common) {
    var service = {
      //PASS FUNCTIONS TO SERVICE
    };
    return common.service.instantiate(service, 'formapagamento/formapagamentoestabelecimento/');


    //DECLARE FUNCTIONS HERE


  }
})();

(function () {
  'use strict';

  angular.module('ticket.service.formapagamento')
    .factory('ticket.service.formapagamento', formaPagamentoTaxaFactory);

  formaPagamentoTaxaFactory.$inject = ['common'];
  function formaPagamentoTaxaFactory(common) {
    var service = {
      //PASS FUNCTIONS TO SERVICE
    };
    return common.service.instantiate(service, 'formapagamento/formapagamento/');


    //DECLARE FUNCTIONS HERE


  }
})();

(function() {
    'use strict';

    angular
        .module('ticket.service.fluxocaixa', [ ]);
})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.fluxocaixa');

	mod.factory("ticket.service.fluxocaixa.estabelecimentofechamentodia", ["common", function(common){
		var res = {
			fecharDia: function (mdl) {
				return this.request("fecharDia", mdl);
			},
      borderosabertos: function(filter){
			  return this.request('borderosabertos',filter);
      },
      diasabertos: function(){
        return this.request('diasabertos',{});
      },
      borderos: function(filter){
        return this.request('borderos',filter);
      },
		};
		return common.service.instantiate(res, "fluxocaixa/estabelecimentofechamentodia/");
	}]);

})();

(function(){
  'use strict';

  var mod = angular.module('ticket.service.fluxocaixa');

  mod.factory("ticket.service.fluxocaixa.estabelecimentoestacao", ["common", function(common){
    var res = {
      listestacaofechamentodia : function (filter) {
        return this.request("listestacaofechamentodia", filter);
      }

    };
    return common.service.instantiate(res, "fluxocaixa/estabelecimentoestacao/");
  }]);

})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.fluxocaixa');

	mod.factory("ticket.service.fluxocaixa.bilheteriacaixa", ["common", function(common){
    var res = {

      fecharCaixa: function (key) {
        return this.request("fecharCaixa", key);
      }
    };
		return common.service.instantiate(res, "fluxocaixa/bilheteriacaixa/");
	}]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.service.controleestabelecimento', [ ]);
})();
(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleestabelecimento');

	mod.factory("ticket.service.controleestabelecimento.estabelecimentoconfiguracaoestrutura", ["common", function (common) {
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleestabelecimento/estabelecimentoconfiguracaoestrutura/");
	}]);

})();

(function () {
    'use strict';

    var mod = angular.module('ticket.service.controleestabelecimento');

    mod.factory("ticket.service.controleestabelecimento.estabelecimentoTipoAtracao", ["common", function (common) {
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "controleestabelecimento/estabelecimentotipoatracao/");
    }]);

})();
(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleestabelecimento');
	
	mod.factory("ticket.service.controleestabelecimento.estabelecimentoEstacao", ["common", function(common){
		var res = {
	      grant: function(uk){
	      	return this.request("grant", uk);
	      }
		}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleestabelecimento/estabelecimentoEstacao/");
	}]);

})();
(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleestabelecimento');

	mod.factory("ticket.service.controleestabelecimento.estabelecimentoconfiguracaoinformacao", ["common", function (common) {
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleestabelecimento/estabelecimentoconfiguracaoinformacao/");
	}]);

})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleestabelecimento');
	
	mod.factory("ticket.service.controleestabelecimento.estabelecimento", ["common", function(common){
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleestabelecimento/estabelecimento/");
	}]);

})();
(function() {
  'use strict';

  angular
    .module('ticket.service.controleestabelecimento')
    .factory('ticket.service.controleestabelecimento.empresa', ['common', function(common) {
      var res = {}; //<-- Customize aqui seu service
      return common.service.instantiate(res, "controleestabelecimento/empresa/");
    }])
})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleestabelecimento');

	mod.factory("ticket.service.controleestabelecimento.dadosbancarios", ["common", function(common){
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleestabelecimento/dadosbancarios/");
	}]);

})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleestabelecimento');

	mod.factory("ticket.service.controleestabelecimento.banco", ["common", function(common){
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleestabelecimento/banco/");
	}]);

})();

(function() {
    'use strict';

    angular
        .module('ticket.service.controleatracao', [ ]);
})();
(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleatracao');

	mod.factory('ticket.service.controleatracao.autoria', ["common", "$q", "$timeout", function (common, $q, $timeout) {

		var res = {  list: function(filter){
        	return $q(function (resolve, reject) {
                $timeout(function () {
                    resolve([
		                    	{Id:1, Nome: "Manoel Carlos"}, 
		                    	{Id:2, Nome: "Dilma Russef"},
		                    	{Id:3, Nome: "Manoel Juramento"}, 
		                    	{Id:4, Nome: "Eduardo Cunho"},
		                    	{Id:5, Nome: "Bolsonaro"},
		                    	{Id:6, Nome: "Jandira Fegali"}		                 
                    	]);
                    
                }, 0, true)
            });
        },

        	
        }; //<-- Customize aqui seu service

        return common.service.instantiate(res, "conteudo/autoria/");

        return res;  
		
	}]);
})();
(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleatracao');
	//mod.factory("ticket.conteudo.atracao.service", ["API_CONFIG", "$http", "helperService", function(API_CONFIG, $http, helper){
	mod.factory("ticket.conteudo.atracao.service", ["common", function(common){
		var res = {}; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleconteudo/atracao/");
	}]);

})();
(function() {
    'use strict';

    angular
        .module('ticket.service.controleacesso', [ ]);
})();
(function(){
'use strict';

    angular.module("ticket.service.controleacesso")
    .factory("ticket.service.controleacesso.usuario", ["common", "appSettings", function( common, appSettings ){
        var res = {
          getProfile: function () { return this.request("getprofile"); },
        	//resetPassword: function(mdl){  return this.request("resetpassword", mdl); },
          resetPasswordV2: function(mdl){  return this.request("resetpassword2", Object.assign({}, mdl, { IdSistema: appSettings.appKey})); },
        	resetPasswordValidate: function(token){ return this.request("resetpasswordvalidate", {Token: token}); },
        	resetPasswordConfirm: function(mdl){ return  this.request("resetpasswordconfirm", mdl); },
        	checkRegisteredLogin:function (mdl) {  return  this.request("checkregisteredlogin", mdl, {supressError: true}); },
          reenviarEmail: function(mdl){  return this.request("resetpasswordAdmin", mdl); },


        };

        return common.service.instantiate(res, "controleacesso/usuario/");
    }]);
})();

(function(){
'use strict';

	angular.module("ticket.service.controleacesso")
	.factory("ticket.authentication.signup.service", ["$http", "$mdToast", "API_CONFIG", function($http, $mdToast, API_CONFIG ){

		return {};

	}]);

	

})();
(function () {
  'use strict';

  angular.module('ticket.service.controleacesso')
    .factory("ticket.controleacesso.service.perfilestabelecimento", 
    	['common', function(common){
    		var res = {};
    		return common.service.instantiate(res, "controleacesso/perfilestabelecimento/", res);
    }]);
})();

(function(){
	'use strict';

	var mod = angular.module('ticket.service.controleacesso');

	mod.factory("ticket.service.controleacesso.perfil", ["common", function(common){
		var res = {
		  IsInRole: function(IdTela){
		    return this.request('isinrole', {IdFuncionalidade: IdTela});
      }
    }; //<-- Customize aqui seu service

		return common.service.instantiate(res, "controleacesso/perfil/");
	}]);

})();

(function(){

	angular.module("ticket.service.controleacesso")
	.factory("ticket.service.controleacesso.login", ["$http", "appSettings", "$rootScope", "$q", function($http, appSettings, $rootScope, $q ){

        var authData = null;



	    var svc = {
            CheckProfile: function (arr) {
                if (authData == null)
                    return false;
                else
                    return arr.indexOf(authData.profile) >= 0;
            },
            Logon: function (mdl) {
                var data = "grant_type=password&username=" + encodeURIComponent(mdl.email) + "&password=" + encodeURIComponent(mdl.password);
                var cfg = {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': 'Basic ' + btoa(appSettings.appId + ':' + appSettings.appKey) },
                    xhrFields: { withCredentials: true }
                };
              var d = svc.Restore();
              if(d)
               var idEstabelecimento = d.id_estabelecimento;
                return $http.post( appSettings.auth,data, cfg)
                    .then(function (v) {
                        authData = v.data;
                        appSettings.setUserStore(authData);
                        $rootScope.$broadcast("app.logon", authData);
                        return authData;
                    },
                        function (e) {
                            svc.Logout(true);
                            return $q.reject(e);
                        }).finally(function(){
                        //   if(idEstabelecimento)
                        //     svc.RefreshToken(idEstabelecimento);
                        });
            },
            Logout: function (silence) {
                appSettings.clearUserStore();
                $rootScope.$broadcast("app.logoff");
            },
            RefreshToken: function (IdEstabelecimento) {
                IdEstabelecimento = IdEstabelecimento || '';
                var d = svc.Restore();

                if (d == null || d.access_token == null)
                    return $q.reject("Não autenticado");
                else
                {
                    if (d.quantidade_estabelecimento) {
                        var qty_establishment = d.quantidade_estabelecimento
                    }

                    appSettings.clearUserStore();
                    $rootScope.$broadcast("app.logoff");

                    return $http({
                        method: 'POST',
                        url: appSettings.auth,
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 'Authorization':  'Basic ' + btoa(appSettings.appId + ':' + appSettings.appKey) },
                        data: $.param({
                            grant_type: 'refresh_token',
                            refresh_token: d.refresh_token,
                            estab_id: IdEstabelecimento
                        })
                    }).then(
                        function (v) {
                            if (v.status == 200) {
                                authData = v.data;
                                if (qty_establishment) {
                                    authData.quantidade_estabelecimento = qty_establishment;
                                }
                                appSettings.setUserStore(authData);
                                $rootScope.$broadcast("app.logon", authData);
                                return authData;
                            }
                        },
                        function(err){
                            //svc.Logout(true);
                            return $q.reject("Falha na autenticação automática");
                        });
                }
            },
            Restore: function () {

                if (!authData)
                    authData = appSettings.getUserStore();

                if (authData == null || authData.access_token == null)
                    return null;
                else
                    return authData;
            }
        };


        return svc;


	}]);



})();

(function(){

	angular.module("ticket.service.controleacesso")
	.factory("ticket.service.controleacesso.captcha", ["common", function( common ){
		

			var res = {
					get : function(key){ return this.request(  "get", key);  },
					render: function(key){return this.request( "render", key);  }
			   }

			return common.service.basic(res, "controleacesso/captcha/");

		}

	]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.service.conteudo', [ ]);
})();
(function () {
    "use stric";

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.tipoatracao", ["common", function (common) {
        var res = {};//<-- Customize aqui seu service

        return common.service.instantiate(res, "controleconteudo/tipoAtracao/");

    }])
})();

(function () {
    'use strict';

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.inadequacao", ["common", "$q", "$timeout", function (common, $q, $timeout) {
        var res = {};

        return common.service.instantiate(res, "controleconteudo/inadequacao/");

    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.conteudo')
    
    .factory("ticket.service.conteudo.genero", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "controleconteudo/genero/");
    }]);

})();
(function(){
    'use strict';

    angular.module('ticket.service.conteudo')
    
    .factory("ticket.service.conteudo.classificacao", ["common", function(common){
        var res = {}; //<-- Customize aqui seu service

        return common.service.instantiate(res, "controleconteudo/classificacao/");
    }]);

})();
(function () {
    'use strict';

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.banda", ["common", "$q", "$timeout", function (common, $q, $timeout) {
        var res = {};

        return common.service.instantiate(res, "controleconteudo/banda/");

    }]);

})();
(function () {
    'use strict';

    angular.module('ticket.service.conteudo')

    .factory("ticket.service.conteudo.atracaoversao", [
        "common",
        "Upload",
        "ticket.service.controleacesso.login",
        "appSettings",
        "$http",
        "$q",
    function (common, Upload, loginSvc, appSettings, $http, $q) {

        var res = {}; //<-- Customize aqui seu service

        //return res;

        return common.service.instantiate(res, "controleconteudo/atracaoversao/");
    }]);

})();
(function(){
	'use strict';

	var mod = angular.module('ticket.service.conteudo');
	
	mod.factory("ticket.service.conteudo.atracaoestabelecimento", ["common", function(common){
		var res = {

      associar: function (form) {
        return this.request("associar", form);
      }

    };
		return common.service.instantiate(res, "controleconteudo/atracaoestabelecimento/");
	}]);

})();

(function () {
    'use strict';

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.atracaoparticipante", ["common", "$q", "$timeout", function (common, $q, $timeout) {
        var res = {};

        return common.service.instantiate(res, "controleconteudo/atracaoparticipante/");

    }]);

})();
(function () {
    'use strict';

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.atracaoinadequacao", ["common", "$q", "$timeout", function (common, $q, $timeout) {
        var res = {};

        return common.service.instantiate(res, "controleconteudo/atracaoinadequacao/");

    }]);

})();
(function () {
    'use strict';

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.atracaogenero", ["common", "$q", "$timeout", function (common, $q, $timeout) {
        var res = {};

        return common.service.instantiate(res, "controleconteudo/atracaogenero/");

    }]);

})();
(function () {
    'use strict';

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.atracaobanda", ["common", "$q", "$timeout", function (common, $q, $timeout) {
        var res = {};

        return common.service.instantiate(res, "controleconteudo/atracaobanda/");

    }]);

})();

(function () {
    'use strict';

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.atracaoarquivo", ["common", "$q", "$timeout", function (common, $q, $timeout) {
        var res = {

          listarquivos: function (filter) {
            return this.request("listarquivos", filter);
          }
        };

        return common.service.instantiate(res, "controleconteudo/atracaoarquivo/");

    }]);

})();

(function () {
    'use strict';

    angular.module('ticket.service.conteudo')

    .factory("ticket.service.conteudo.atracao", [
        "common",
        "Upload",
        "ticket.service.controleacesso.login",
        "appSettings",
        "$http",
        "$q",
    function (common, Upload, loginSvc, appSettings, $http, $q) {

        var res = {

          listFuturas: function (filter) {
            return this.request("listFuturas", filter);
          },

            uploadVideo: function (itm) {

                var fd = new FormData();

                fd.append("file", itm.file[0]);

                var def = $q.defer();

                this.request("UploadVideo", fd,{
                        transformRequest: angular.identity,
                        headers: { 'Content-Type': undefined },
                        uploadEventHandlers: { progress: function (e) { def.notify(e); } }
                    }).then(
                        function (resp) { def.resolve(resp); },
                        function (err) { def.reject(err); }
                    );

                return def.promise;
            },

            uploadImagem: function (imageBase64) {
                return this.request("UploadImage", imageBase64);
            },

            deleteImagem: function (imagem) {
                return this.request("DeleteImage", imagem);
            },

            save: function (NovaAtracao) {

                var Atracao = {
                    Nome:NovaAtracao.FichaTecnica.Nome,
                    IdAtracao: NovaAtracao.Atracao.IdAtracao,
                    FilaFraude: true,
                    IdTipoAtracao: NovaAtracao.Atracao.IdTipoAtracao,
                    ModeradoSite: NovaAtracao.Atracao.ModeradoSite,
                    Ativo: true,
                    User: ''
                }

                var AtracaoEstabelecimento = {};

                var Generos = NovaAtracao.FichaTecnica.Generos;
                var Inadequacoes = NovaAtracao.FichaTecnica.Inadequacoes;
                var Participantes = NovaAtracao.Participantes;
                var Banda = NovaAtracao.Banda;

                var AtracaoVersao = {
                    NomeHistorico: NovaAtracao.FichaTecnica.Nome,
                    NomeOriginal: NovaAtracao.FichaTecnica.NomeOriginal,
                    IdClassificacao: NovaAtracao.FichaTecnica.IdClassificacao,
                    Sinopse: NovaAtracao.Sinopse.Texto,
                    Duracao: NovaAtracao.FichaTecnica.Duracao,
                    PaisOrigem: NovaAtracao.FichaTecnica.PaisOrigem,
                    IdiomaOriginal: NovaAtracao.FichaTecnica.IdiomaOriginal,
                    UrlOficial: NovaAtracao.FichaTecnica.UrlOficial,
                    AnoLancamento: NovaAtracao.FichaTecnica.AnoLancamento,
                    DataEstreia: NovaAtracao.FichaTecnica.DataEstreia,
                    PodeEditar: NovaAtracao.FichaTecnica.PodeEditar,
                    Uri: "Uri",
                    Status: "",
                    User: ""
                }

                var AtracaoArquivo = NovaAtracao.Midia.AtracaoArquivo;

                return this.request("post", {
                    Atracao:
                        Atracao,
                    Generos: Generos,
                    Inadequacoes: Inadequacoes,
                    Participantes: Participantes,
                    Bandas:Banda,
                    AtracaoVersao: AtracaoVersao,
                    AtracaoEstabelecimento: AtracaoEstabelecimento,
                    AtracaoArquivo: AtracaoArquivo
                }
                );
            },


          listAtracaoProgramacao: function(filter) {
            return this.request("listatracaoprogramacao", filter);
          }

        }; //<-- Customize aqui seu service

        //return res;

        return common.service.instantiate(res, "controleconteudo/atracao/");
    }]);

})();

(function () {
    "use stric";

    var mod = angular.module('ticket.service.conteudo');

    mod.factory("ticket.service.conteudo.artista", ["common", function (common) {
        var res = {};//<-- Customize aqui seu service

        return common.service.instantiate(res, "controleconteudo/artistatipoartista/");

    }])
})();
(function() {
    'use strict';

    angular
        .module('ticket.controller.site')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, menuProvider) {

        $stateProvider

         $stateProvider
        .state('site', {
            abstract: true,
            url: '/site',
            templateUrl: "view/site/_content.html"
        })
        .state('site.home', {
            url: '/home',
            data: { displayName: 'Home' },
            templateUrl: 'view/site/home/index.html',
            controller:  'ticket.controller.site.home',
            controllerAs: 'vm'
        })
        .state('ticket.user-home', {
            templateUrl: 'view/site/home/index.html',
            controller: function($state){ $state.go('site.home') },
            controllerAs: 'vm'
        })


        // menuProvider.left.add(
        //     {
        //         name: 'Site',
        //         icon: 'fa fa-home',
        //         type: 'link',
        //         priority: 1.0,
        //         state: 'ticket.user-home',/*,
        //         data: { permissions: { only: ['site.user-home'] } }*/
        //         childs:[
        //             {
        //                 name: 'Home',
        //                 icon: 'fa fa-home',
        //                 type: 'link',
        //                 priority: 1.0,
        //                 state: 'ticket.user-home'/*,
        //                 data: { permissions: { only: ['site.user-home'] } }*/
        //             }
        //         ]
        //     }
        // );

        menuProvider.left.add({
            type: 'divider',
            priority: 1.1
        });
    }
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.reports')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {
    $stateProvider
      .state('reports', {
        abstract: true,
        url: '/reports',
        templateUrl: "view/site/_content.html"
      })
      .state('reports.previa', {
        data: {
          displayName: 'Borderô Provisório'
        },
        abstract: true,
        parent: 'reports',
        url: '/previa',
        templateUrl: 'view/reports/previa/index.html',
        controller: 'ticket.controller.reports.previa',
        controllerAs: 'vm'
      })
      .state('reports.previa.grid', {
        templateUrl: 'view/reports/previa/grid.html',
        url: '/:filter',
        parent: 'reports.previa',
        data: {
          _id: '5874B0F8-CB82-44CD-B3D6-D106C7485643',
          displayName: 'Borderô Provisório'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.reports.previa.grid',
        controllerAs: 'vm'
      })
      .state('reports.previa.form', {
        templateUrl: 'view/reports/previa/form.html',
        url: '/form/:IdSessao',
        parent: 'reports.previa',
        data: {
          displayName: 'Borderô Provisório'
        },
        params: {
          IdSessao: null
        },
        controller: 'ticket.controller.reports.previa.form',
        controllerAs: 'vm'
      })


      .state('reports.bordero', {
        data: {
          displayName: 'Borderô'
        },
        abstract: true,
        parent: 'reports',
        url: '/bordero',
        templateUrl: 'view/reports/bordero/index.html',
        controller: 'ticket.controller.reports.bordero',
        controllerAs: 'vm'
      })
      .state('reports.bordero.grid', {
        templateUrl: 'view/reports/bordero/grid.html',
        url: '/:filter',
        parent: 'reports.bordero',
        data: {
          _id: '16F36DB9-EF6E-4188-A0EE-460E6BB60F7F',
          displayName: 'Borderô Definitivo'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.reports.bordero.grid',
        controllerAs: 'vm'
      })
      .state('reports.bordero.form', {
        templateUrl: 'view/reports/bordero/form.html',
        url: '/form/:IdSessao',
        parent: 'reports.bordero',
        data: {
          displayName: 'Borderô Definitivo'
        },
        params: {
          IdSessao: null,
          Uri:null
        },
        controller: 'ticket.controller.reports.bordero.form',
        controllerAs: 'vm'
      })
      .state('reports.financeiro', {
        data: {
          displayName: 'Financeiro'
        },
        abstract: true,
        parent: 'reports',
        url: '/financeiro',
        templateUrl: 'view/reports/financeiro/index.html',
        controller: 'ticket.controller.reports.financeiro',
        controllerAs: 'vm'
      })
      .state('reports.financeiro.grid', {
        templateUrl: 'view/reports/financeiro/grid.html',
        url: '/:filter',
        parent: 'reports.financeiro',
        data: {
          _id: '2C425FAF-3D50-44BE-B599-E5EA94418D25',
          displayName: 'Financeiro'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.reports.financeiro.grid',
        controllerAs: 'vm'
      })
      .state('reports.financeiro.form', {
        templateUrl: 'view/reports/financeiro/form.html',
        url: '/form/',
        parent: 'reports.financeiro',
        data: {
          displayName: 'Financeiro'
        },
        params: {
          IdSessao: null,
          Uri:null
        },
        controller: 'ticket.controller.reports.financeiro.form',
        controllerAs: 'vm'
      })

      .state('reports.futuras', {
        data: {
          displayName: 'Futuras'
        },
        abstract: true,
        parent: 'reports',
        url: '/futuras',
        templateUrl: 'view/reports/futuras/index.html',
        controller: 'ticket.controller.reports.futuras',
        controllerAs: 'vm'
      })
      // .state('reports.futuras.grid', {
      //   templateUrl: 'view/reports/futuras/grid.html',
      //   url: '/:filter',
      //   parent: 'reports.futuras',
      //   data: {
      //     displayName: 'Futuras'
      //   },
      //   params: {
      //     items: null,
      //     filter: null
      //   },
      //   controller: 'ticket.controller.reports.futuras.grid',
      //   controllerAs: 'vm'
      // })
      .state('reports.futuras.form', {
        templateUrl: 'view/reports/futuras/form.html',
        url: '/form/',
        parent: 'reports.futuras',
        data: {
          displayName: 'Futuras'
        },
        params: {
          IdSessao: null,
          Uri:null
        },
        controller: 'ticket.controller.reports.futuras.form',
        controllerAs: 'vm'
      })

      .state('reports.futuras-dia', {
        data: {
          displayName: 'Futuras'
        },
        abstract: true,
        parent: 'reports',
        url: '/futuras-dia',
        templateUrl: 'view/reports/futuras-dia/index.html',
        controller: 'ticket.controller.reports.futuras-dia',
        controllerAs: 'vm'
      })
      .state('reports.futuras-dia.grid', {
        templateUrl: 'view/reports/futuras-dia/grid.html',
        url: '/:filter',
        parent: 'reports.futuras-dia',
        data: {
          _id: 'EE3CB4F3-4A10-4596-88E9-6231954E3FCF',
          displayName: 'Futuras'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.reports.futuras-dia.grid',
        controllerAs: 'vm'
      })
      .state('reports.futuras-dia.form', {
        templateUrl: 'view/reports/futuras-dia/form.html',
        url: '/form/',
        parent: 'reports.futuras-dia',
        data: {
          displayName: 'Futuras'
        },
        params: {
          IdSessao: null,
          Uri:null
        },
        controller: 'ticket.controller.reports.futuras-dia.form',
        controllerAs: 'vm'
      })
    ;

    menuProvider.left.add({
      name: 'Relatórios',
      icon: 'fa fa-clipboard',
      type: 'group',
      state: 'reports',
      priority: 1.0,
      childs: [
        {
          name: 'Borderô Provisório',
          state: 'reports.previa.grid'
        },
        {
          name: 'Borderô Definitivo',
          state: 'reports.bordero.grid'
        },
        {
          name: 'Financeiro',
          state: 'reports.financeiro.grid'
        },
        // {
        //   name: 'Futuras por Período',
        //   state: 'reports.futuras.grid'
        // },
        {
          name: 'Futuras',
          state: 'reports.futuras-dia.grid'
        }
      ]
    });
    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.planta')
    .config(moduleConfig);

  moduleConfig.$inject = ['$stateProvider', 'menuProvider', 'appSettingsProvider'];

  function moduleConfig($stateProvider, menuProvider) {
    $stateProvider
      .state('planta', {
        abstract: true,
        url: '/planta',
        templateUrl: "view/site/_content.html"

      })

      // Pavimento
      .state('planta.pavimento', {
        data: {
          displayName: 'Zona'
        },
        abstract: true,
        parent: 'planta',
        url: '/zona',
        templateUrl: 'view/planta/pavimento/index.html',
        controller: 'ticket.controller.planta.pavimento',
        controllerAs: 'vm'
      })
      .state('planta.pavimento.grid', {
        templateUrl: 'view/planta/pavimento/grid.html',
        url: '/:filter',
        parent: 'planta.pavimento',
        data: {
          displayName: 'Zona'
        },
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.planta.pavimento.grid',
        controllerAs: 'vm'
      })
      .state('planta.pavimento.form', {
        data: {
          displayName: 'Zona'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'planta.pavimento',
        templateUrl: 'view/planta/pavimento/form.html',
        controller: 'ticket.controller.planta.pavimento.form',
        controllerAs: 'vm'
      })
      //Fim Pavimento


      //Sala
      .state('planta.sala', {
        data: {
          displayName: 'Sala'
        },
        abstract: true,
        parent: 'planta',
        url: '/sala',
        templateUrl: 'view/planta/sala/index.html',
        controller: 'ticket.controller.planta.sala',
        controllerAs: 'vm'
      })
      .state('planta.sala.grid', {
        templateUrl: 'view/planta/sala/grid.html',
        url: '/:filter',
        parent: 'planta.sala',
        data: {
          _id: '68C4E24D-F738-44BD-B946-986108D63EFE',
          displayName: 'Sala'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.planta.sala.grid',
        controllerAs: 'vm'
      })
      .state('planta.sala.form', {
        data: {
          displayName: 'Sala'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'planta.sala',
        templateUrl: 'view/planta/sala/form.html',
        controller: 'ticket.controller.planta.sala.form',
        controllerAs: 'vm'
      })
      //Fim Sala

      //Setor
      .state('planta.setor', {
        data: {
          displayName: 'Setor'
        },
        abstract: true,
        parent: 'planta',
        url: '/setor',
        templateUrl: 'view/planta/setor/index.html',
        controller: 'ticket.controller.planta.setor',
        controllerAs: 'vm'
      })
      .state('planta.setor.grid', {
        templateUrl: 'view/planta/setor/grid.html',
        url: '/:filter',
        parent: 'planta.setor',
        data: {
          _id: '262576B4-8A5B-4258-A388-3321090A7548',
          displayName: 'Setor'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.planta.setor.grid',
        controllerAs: 'vm'
      })
      .state('planta.setor.form', {
        data: {
          displayName: 'Setor'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'planta.setor',
        templateUrl: 'view/planta/setor/form.html',
        controller: 'ticket.controller.planta.setor.form',
        controllerAs: 'vm'
      })
      //Fim Setor

      //Layout
      .state('planta.layout', {
        data: {
          displayName: 'Layout'
        },
        abstract: true,
        parent: 'planta',
        url: '/layout',
        templateUrl: 'view/planta/layout/index.html',
        controller: 'ticket.controller.planta.layout',
        controllerAs: 'vm'
      })
      .state('planta.layout.grid', {
        templateUrl: 'view/planta/layout/grid.html',
        url: '/:filter',
        parent: 'planta.layout',
        data: {
          displayName: 'Layout'
        },
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.planta.layout.grid',
        controllerAs: 'vm'
      })
      .state('planta.layout.form', {
        data: {
          displayName: 'Layout'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'planta.layout',
        templateUrl: 'view/planta/layout/form.html',
        controller: 'ticket.controller.planta.layout.form',
        controllerAs: 'vm'
      })

      .state('planta.bloqueio-permanente', {
        data: {
          displayName: 'Bloqueio Permanente de Assentos'
        },
        abstract: true,
        parent: 'planta',
        url: '/bloqueio-permanente',
        templateUrl: 'view/planta/bloqueio-permanente/index.html',
        controller: 'ticket.controller.planta.bloqueio-permanente',
        controllerAs: 'vm'
      })
      .state('planta.bloqueio-permanente.grid', {
        templateUrl: 'view/planta/bloqueio-permanente/grid.html',
        url: '/:filter',
        parent: 'planta.bloqueio-permanente',
        data: {
          _id: '558CB922-D986-48A6-8730-FBE92D64AA37',
          displayName: 'Bloqueio Permanente de Assentos'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.planta.bloqueio-permanente.grid',
        controllerAs: 'vm'
      })
      .state('planta.bloqueio-permanente.form', {
        data: {
          displayName: 'Bloqueio Permanente de Assentos'
        },
        url: '/form/:IdAssento/:IdSetor/:DataInicio',
        params: {
          IdAssento: null,
          IdSetor: null,
          DataInicio: null
        },
        parent: 'planta.bloqueio-permanente',
        templateUrl: 'view/planta/bloqueio-permanente/form.html',
        controller: 'ticket.controller.planta.bloqueio-permanente.form',
        controllerAs: 'vm'
      });


    menuProvider.left.add({
      name: 'Planta',
      icon: 'fa fa-map',
      type: 'group',
      state: 'planta',
      priority: 1.0,
      childs: [{
        name: 'Sala',
        icon: 'fa fa-cube',
        type: 'link',
        priority: 1.0,
        state: 'planta.sala.grid'
      }, {
        name: 'Layout',
        type: 'link',
        priority: 1.0,
        state: 'planta.layout.grid'
      }, {
        name: 'Zona',
        icon: 'fa fa-road',
        type: 'link',
        priority: 1.0,
        state: 'planta.pavimento.grid'
      }, {
        name: 'Setor',
        icon: 'fa fa-th',
        type: 'link',
        priority: 1.0,
        state: 'planta.setor.grid'
      },
        {
          name: 'Bloqueio Permanente de Assentos',
          icon: 'fa fa-user',
          type: 'link',
          priority: 1.0,
          state: 'planta.bloqueio-permanente.grid'
        }
      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('ticket.controller.fluxocaixa')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {


    $stateProvider
      .state('fluxocaixa', {
        abstract: true,
        url: '/fluxocaixa',
        templateUrl: "view/site/_content.html"
      })

    .state('fluxocaixa.estabelecimentofechamentodia', {
      data: {
        displayName: 'Fechamento do Dia'
      },
      abstract: true,
      parent: 'fluxocaixa',
      url: '/estabelecimentofechamentodia',
      templateUrl: 'view/fluxo-caixa/estabelecimentofechamentodia/index.html',
      controller: 'ticket.controller.fluxocaixa.estabelecimentofechamentodia',
      controllerAs: 'vm'
    })

    .state('fluxocaixa.estabelecimentofechamentodia.grid', {
      templateUrl: 'view/fluxo-caixa/estabelecimentofechamentodia/grid.html',
      url: '/:filter',
      parent: 'fluxocaixa.estabelecimentofechamentodia',
      data: {
        _id: 'D08F7B52-FD30-49D4-80C7-F6A24B95472B',
        displayName: 'Fechamento do Dia'
      },
      // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
      //   return rolesProvider.IsInRole($rootScope.toState.data._id);
      // }],
      params: {
        items: null,
        filter: null
      },
      controller: 'ticket.controller.fluxocaixa.estabelecimentofechamentodia.grid',
      controllerAs: 'vm'
    })


    .state('fluxocaixa.estabelecimentofechamentodia.form', {
      data: {
        displayName: 'Fechamento do Dia'
      },
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'fluxocaixa.estabelecimentofechamentodia',
      templateUrl: 'view/fluxo-caixa/estabelecimentofechamentodia/form.html',
      controller: 'ticket.controller.fluxocaixa.estabelecimentofechamentodia.form',
      controllerAs: 'vm'
    })

      .state('fluxocaixa.estabelecimentofechamentodia.form-relatorio', {
        data: {
          displayName: 'Resumo'
        },
        url: '/form-relatorio/',
        params: {
          Uri: null
        },
        parent: 'fluxocaixa.estabelecimentofechamentodia',
        templateUrl: 'view/fluxo-caixa/estabelecimentofechamentodia/form-relatorio.html',
        controller: 'ticket.controller.fluxocaixa.estabelecimentofechamentodia.form-relatorio',
        controllerAs: 'vm'
      })




    .state('fluxocaixa.fechamentocaixa', {
      data: {
        displayName: 'Fechamento de Caixa'
      },
      abstract: true,
      parent: 'fluxocaixa',
      url: '/fechamentocaixa',
      templateUrl: 'view/fluxo-caixa/fechamentocaixa/index.html',
      controller: 'ticket.controller.fluxocaixa.fechamentocaixa',
      controllerAs: 'vm'
    })

    .state('fluxocaixa.fechamentocaixa.grid', {
      templateUrl: 'view/fluxo-caixa/fechamentocaixa/grid.html',
      url: '/:filter',
      parent: 'fluxocaixa.fechamentocaixa',
      data: {
        _id: '7DA43666-344C-43F7-BA26-CAD711F12C86',
        displayName: 'Fechamento de Caixa'
      },
      // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
      //   return rolesProvider.IsInRole($rootScope.toState.data._id);
      // }],
      params: {
        items: null,
        filter: null,
        Uri: null
      },
      controller: 'ticket.controller.fluxocaixa.fechamentocaixa.grid',
      controllerAs: 'vm'
    })


    .state('fluxocaixa.fechamentocaixa.form', {
      data: {
        displayName: 'Fechamento do Caixa'
      },
      url: '/form/:Id',
      params: {
        Id: null
      },
      parent: 'fluxocaixa.fechamentocaixa',
      templateUrl: 'view/fluxo-caixa/fechamentocaixa/form.html',
      controller: 'ticket.controller.fluxocaixa.fechamentocaixa.card',
      controllerAs: 'vm'
    })
      .state('fluxocaixa.fechamentocaixa.form-relatorio', {
        data: {
          displayName: 'Resumo'
        },
        url: '/form-relatorio/',
        params: {
          Uri: null
        },
        parent: 'fluxocaixa.fechamentocaixa',
        templateUrl: 'view/fluxo-caixa/fechamentocaixa/form-relatorio.html',
        controller: 'ticket.controller.fluxocaixa.fechamentocaixa.form-relatorio',
        controllerAs: 'vm'
      })

    menuProvider.left.add({
      name: 'Bilheteria',
      icon: 'fa fa-film',
      type: 'group',
      state: 'fluxocaixa',
      priority: 1.0,
      childs: [{
          name: 'Fechamento do Dia',
          icon: 'fa fa-user',
          type: 'link',
          priority: 1.0,
          state: 'fluxocaixa.estabelecimentofechamentodia.grid'
        }, {
          name: 'Fechamento de Caixa',
          icon: 'fa fa-user',
          type: 'link',
          priority: 1.0,
          state: 'fluxocaixa.fechamentocaixa.grid'
        }

      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.estabelecimento')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider
      .state('estabelecimento', {
        abstract: true,
        url: '/estabelecimento',
        templateUrl: "view/site/_content.html"
      })

      .state('estabelecimento.estabelecimentoconfiguracao', {
        data: {
          displayName: 'Estabelecimento'
        },
        abstract: true,
        parent: 'estabelecimento',
        url: '/configuracao',
        templateUrl: 'view/estabelecimento/estabelecimentoconfiguracao/index.html',
        controller: 'ticket.controller.estabelecimento.estabelecimentoconfiguracao',
        controllerAs: 'vm'
      })
      //.state('ingresso.ingresso.grid', {
      //  templateUrl: 'view/ingresso/ingresso/grid.html',
      //  url: '/:filter',
      //  parent: 'ingresso.ingresso',
      //  data: { displayName: 'Pesquisa' },
      //  params: {
      //      items: null,
      //      filter: null
      //  },
      //  controller: 'ticket.controller.ingresso.ingresso.grid',
      //  controllerAs: 'vm'
      //})


      .state('estabelecimento.estabelecimentoconfiguracao.form', {
        data: {
          _id: '546308F6-6CC6-4693-B24B-48A5CF9F5389',
          displayName: 'Estabelecimento'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'estabelecimento.estabelecimentoconfiguracao',
        templateUrl: 'view/estabelecimento/estabelecimentoconfiguracao/form.html',
        controller: 'ticket.controller.estabelecimento.estabelecimentoconfiguracao.form',
        controllerAs: 'vm'
      })


      //------------------
      /*
       .state('estabelecimento.estrutura', {
       data: {
       displayName: 'Estrutura'
       },
       abstract: true,
       parent: 'estabelecimento',
       url: '/estrutura',
       templateUrl: 'view/estabelecimento/estrutura/index.html',
       controller: 'ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura',
       controllerAs: 'vm'
       })

       .state('estabelecimento.estrutura.form', {
       data: {
       displayName: 'Estrutura'
       },
       url: '/form/:Id',
       params: {
       Id: null
       },
       parent: 'estabelecimento.estrutura',
       templateUrl: 'view/estabelecimento/estrutura/form.html',
       controller: 'ticket.controller.estabelecimento.estabelecimentoconfiguracaoestrutura.form',
       controllerAs: 'vm'
       })
       */

      //------------------


      .state('estabelecimento.estacao', {
        data: {
          displayName: 'Estação'
        },
        abstract: true,
        parent: 'estabelecimento',
        url: '/estacao',
        templateUrl: 'view/estabelecimento/estacao/index.html',
        controller: 'ticket.controller.estabelecimento.estacao',
        controllerAs: 'vm'
      })

      .state('estabelecimento.estacao.grid', {
        data: {
          _id: '6682CC4A-1D09-493F-9E41-91477166C81D',
          displayName: 'Estação'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        url: '/:filter',
        params: {
          items: null,
          filter: null
        },
        parent: 'estabelecimento.estacao',
        templateUrl: 'view/estabelecimento/estacao/grid.html',
        controller: 'ticket.controller.estabelecimento.estacao.grid',
        controllerAs: 'vm'
      })
      .state('estabelecimento.estacao.form', {
        data: {displayName: 'Estação'},
        url: '/form/:IdEstabelecimentoEstacao',
        parent: 'estabelecimento.estacao',
        templateUrl: 'view/estabelecimento/estacao/form.html',
        controller: 'ticket.controller.estabelecimento.estacao.form',
        controllerAs: 'vm'
      })

       .state('estabelecimento.dadosbancarios', {
       data: {
       displayName: 'Estação'
       },
       abstract: true,
       parent: 'estabelecimento',
       url: '/dadosbancarios',
       templateUrl: 'view/estabelecimento/dadosbancarios/index.html',
       controllerAs: 'vm'
       })
       .state('estabelecimento.dadosbancarios.grid', {
       data: {displayName: 'Dados bancários'},
       url: '/:filter',
       params: {
       items: null,
       filter: null
       },
       parent: 'estabelecimento.dadosbancarios',
       templateUrl: 'view/estabelecimento/dadosbancarios/grid.html',
       controller: 'ticket.controller.estabelecimento.dadosbancarios.grid',
       controllerAs: 'vm'
       })
       .state('estabelecimento.dadosbancarios.form', {
       data: {displayName: 'Dados bancários'},
       url: '/form/:IdEmpresaDadosBancarios',
       params: {
       IdEmpresaDadosBancarios: null
       },
       parent: 'estabelecimento.dadosbancarios',
       templateUrl: 'view/estabelecimento/dadosbancarios/form.html',
       controller: 'ticket.controller.estabelecimento.dadosbancarios.form',
       controllerAs: 'vm'
       })


      .state('estabelecimento.formapagamentotaxa', {
        data: {
          displayName: 'Forma Pagamento e Taxa'
        },
        abstract: true,
        parent: 'estabelecimento',
        url: '/formapagamento',
        templateUrl: 'view/estabelecimento/formapagamentotaxa/index.html',
        //controller: 'ticket.controller.estabelecimento.formapagamentotaxa',
        controllerAs: 'vm'
      })

      .state('estabelecimento.formapagamentotaxa.grid', {
        templateUrl: 'view/estabelecimento/formapagamentotaxa/grid.html',
        url: '/:filter',
        parent: 'estabelecimento.formapagamentotaxa',
        data: {
          _id: 'A47AA232-52EF-4B1E-AA33-66E60E9816E0',
          displayName: 'Forma de pagamento e Taxa'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.estabelecimento.formapagamentotaxa.grid',
        controllerAs: 'vm'
      })

      .state('estabelecimento.formapagamentotaxa.form', {
        templateUrl: 'view/estabelecimento/formapagamentotaxa/form.html',
        parent: 'estabelecimento.formapagamentotaxa',
        data: {
          displayName: 'Forma de pagamento e Taxa'
        },
        url: '/form/:IdFormaPagamento/:IdEstabelecimento/:DataInicio',
        params: {
          IdFormaPagamento: null,
          IdEstabelecimento: null,
          DataInicio: null
        },
        controller: 'ticket.controller.estabelecimento.formapagamentotaxa.form',
        controllerAs: 'vm'
      })

      .state('estabelecimento.usuario', {
        data: {
          displayName: 'Usuário'
        },
        abstract: true,
        parent: 'estabelecimento',
        url: '/usuario',
        templateUrl: 'view/estabelecimento/usuario/index.html',
        //controller: 'ticket.controller.acesso.usuario',
        controllerAs: 'vm'
      })
      .state('estabelecimento.usuario.grid', {
        templateUrl: 'view/estabelecimento/usuario/grid.html',
        url: '/:filter',
        parent: 'estabelecimento.usuario',
        data: {
          _id: 'FCA2F683-FE8A-4E94-96C0-69CA7915058F',
          displayName: 'Usuários'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.estabelecimento.usuario.grid',
        controllerAs: 'vm'
      })
      .state('estabelecimento.usuario.form', {
        data: {
          displayName: 'Usuário'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'estabelecimento.usuario',
        templateUrl: 'view/estabelecimento/usuario/form.html',
        controller: 'ticket.controller.estabelecimento.usuario.form',
        controllerAs: 'vm'
      })
      .state('estabelecimento.usuario.profile', {
        data: {
          displayName: 'Profile'
        },
        url: '/profile',
        parent: "estabelecimento",
        templateUrl: 'view/estabelecimento/usuario/profile.html',
        controller: 'ticket.controller.estabelecimento.usuario.profile',
        controllerAs: 'vm'
      })

      .state('estabelecimento.ingresso', {
        data: {
          displayName: 'Ingresso'
        },
        abstract: true,
        parent: 'estabelecimento',
        url: '/ingresso',
        templateUrl: 'view/estabelecimento/ingresso/index.html',
        controller: 'ticket.controller.estabelecimento.ingresso',
        controllerAs: 'vm'
      })
      .state('estabelecimento.ingresso.grid', {
        templateUrl: 'view/estabelecimento/ingresso/grid.html',
        url: '/:filter',
        parent: 'estabelecimento.ingresso',
        data: {
          _id: 'E96012B0-AF0C-4089-A727-6417DC9B4990',
          displayName: 'Ingressos'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.estabelecimento.ingresso.grid',
        controllerAs: 'vm'
      })
      .state('estabelecimento.ingresso.form', {
        data: {
          displayName: 'Ingresso'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'estabelecimento.ingresso',
        templateUrl: 'view/estabelecimento/ingresso/form.html',
        controller: 'ticket.controller.estabelecimento.ingresso.form',
        controllerAs: 'vm'
      })

      .state('estabelecimento.tipo-bloqueio', {
        data: {
          displayName: 'Bloqueio de Assentos'
        },
        abstract: true,
        parent: 'estabelecimento',
        url: '/tipo-bloqueio',
        templateUrl: 'view/estabelecimento/tipo-bloqueio/index.html',
        controller: 'ticket.controller.estabelecimento.tipo-bloqueio',
        controllerAs: 'vm'
      })
      .state('estabelecimento.tipo-bloqueio.grid', {
        templateUrl: 'view/estabelecimento/tipo-bloqueio/grid.html',
        url: '/:filter',
        parent: 'estabelecimento.tipo-bloqueio',
        data: {
          _id: 'B1A3970E-A6FA-4E99-B58D-CBAC400F8B8A',
          displayName: 'Bloqueio de Assentos'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.estabelecimento.tipo-bloqueio.grid',
        controllerAs: 'vm'
      })
      .state('estabelecimento.tipo-bloqueio.form', {
        data: {
          displayName: 'Bloqueio de Assentos'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'estabelecimento.tipo-bloqueio',
        templateUrl: 'view/estabelecimento/tipo-bloqueio/form.html',
        controller: 'ticket.controller.estabelecimento.tipo-bloqueio.form',
        controllerAs: 'vm'
      }) ;


    menuProvider.left.add({
      name: 'Configuração',
      icon: 'fa fa-cog',
      type: 'group',
      state: 'estabelecimento',
      priority: 1.0,
      childs: [{
        name: 'Estabelecimento',
        icon: 'fa fa-user',
        type: 'link',
        priority: 1.0,
        state: 'estabelecimento.estabelecimentoconfiguracao.form'
      },
        {
          name: 'Forma de pagamento e Taxa',
          icon: 'fa fa-user',
          type: 'link',
          priority: 1.0,
          state: 'estabelecimento.formapagamentotaxa.grid'
        },
        {
          name: 'Usuários',
          icon: 'fa fa-user',
          type: 'link',
          priority: 1.0,
          state: 'estabelecimento.usuario.grid'
        },
        {
          name: 'PDVs',
          icon: 'fa fa-desktop',
          type: 'link',
          priority: 3.0,
          state: 'estabelecimento.estacao.grid'
        },
        {
          name: 'Ingresso',
          icon: 'fa fa-user',
          type: 'link',
          priority: 1.0,
          state: 'estabelecimento.ingresso.grid'
        },
        {
          name: 'Tipo de Bloqueio de Assento',
          icon: 'fa fa-user',
          type: 'link',
          priority: 1.0,
          state: 'estabelecimento.tipo-bloqueio.grid'
        }
        /*      {
         name: 'Estrutura',
         icon: 'fa fa-user',
         type: 'link',
         priority: 2.0,
         state: 'estabelecimento.estrutura.form'
         },
         */
         // ,{
         // name: 'Dados bancários',
         // icon: 'fa fa-desktop',
         // type: 'link',
         // priority: 3.0,
         // state: 'estabelecimento.dadosbancarios.grid'
         // },


      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller.conteudo')
    .config(moduleConfig);

  /* @ngInject */
  function moduleConfig($stateProvider, menuProvider) {

    $stateProvider
      .state('conteudo', {
        abstract: true,
        url: '/conteudo',
        data: {
          displayName: 'Conteúdo'
        },
        templateUrl: "view/site/_content.html"
      })
      .state('conteudo.artista', {
        url: '/artista',
        data: {
          displayName: 'Artista'
        },
        templateUrl: 'view/site/home/index.html',
        controller: 'ticket.controller.site.home',
        controllerAs: 'vm'
      })

      .state('conteudo.atracao', {
        data: {
          displayName: 'Atração'
        },
        parent: 'conteudo',
        url: '/atracao',
        templateUrl: 'view/conteudo/atracao/index.html',
        controller: "ticket.controller.conteudo.atracao",
        controllerAs: 'vm'
      })
      .state('conteudo.atracao.grid', {
        templateUrl: 'view/conteudo/atracao/grid.html',
        url: '/:filter',
        parent: 'conteudo.atracao',
        data: {
          _id: '9513B36D-77C2-4482-AE2A-9C2901666D4A',
          displayName: 'Atrações'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.conteudo.atracao.grid',
        controllerAs: 'vm'
      })
      .state('conteudo.atracao.informacoesexclusivas', {
        url: '/info/:IdAtracao',
        params: {
          Id: null
        },
        parent: 'conteudo.atracao',
        data: {
          displayName: 'INFORMAÇÕES EXCLUSIVAS'
        },
        templateUrl: 'view/conteudo/atracao/informacoesexclusivas.html',
        controller: 'ticket.controller.conteudo.atracao.informacoesexclusivas',
        controllerAs: 'vm'
      })
      .state('conteudo.atracao.pre_cadastro', {
        url: '/pre_cadastro/:filter',
        params: {
          items: null,
          filter: null
        },
        data: {
          displayName: 'Pré cadastro'
        },
        templateUrl: 'view/conteudo/atracao/pre_cadastro.html',
        controller: 'ticket.controller.conteudo.pre_cadastro',
        controllerAs: 'vm'
      })
      .state('conteudo.atracao.wizard', {
        url: "/wizard",
        templateUrl: "view/conteudo/atracao/form_wizard.html",
        controller: 'ticket.controller.conteudo.wizard',
        controllerAs: 'vm',
        params: {
          filter: null //{ IdTipoAtracao: null, Id: null, NumeroVersao: null } -- proteção contra refresh: filter com valor default null
        },
        abstract: true,
        parent: 'conteudo.atracao',
        data: {
          displayName: 'Atração'
        },
        resolve: {
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([{
              files: ['/css/plugins/steps/jquery.steps.css']
            }]);
          }]
        }

      })
      .state('conteudo.atracao.wizard.ficha_tecnica', {
        url: '/ficha_tecnica',
        templateUrl: 'view/conteudo/atracao/template/ficha_tecnica_tmpl.html',
        parent: 'conteudo.atracao.wizard',
        data: {
          displayName: 'Atração'
        }
      })
      .state('conteudo.atracao.wizard.participantes', {
        url: '/participantes',
        templateUrl: 'view/conteudo/atracao/template/participantes_tmpl.html',
        //controller: 'ticket.controller.conteudo.wizard.participante',
        //controllerAs: 'vm',
        parent: 'conteudo.atracao.wizard',
        data: {
          displayName: 'Atração'
        }
      })
      .state('conteudo.atracao.wizard.sinopse', {
        url: '/sinopse',
        templateUrl: 'view/conteudo/atracao/template/sinopse_tmpl.html',
        //controller: 'ticket.controller.conteudo.wizard.sinopse',
        //controllerAs: 'vm',
        parent: 'conteudo.atracao.wizard',
        data: {
          displayName: 'Atração'
        }
      })
      .state('conteudo.atracao.wizard.midia', {
        url: '/midia',
        templateUrl: 'view/conteudo/atracao/template/midia_tmpl.html',
        //controller: 'ticket.controller.conteudo.wizard.midia',
        //controllerAs: 'vm',
        parent: 'conteudo.atracao.wizard',
        data: {
          displayName: 'Atração'
        }
      })

      .state('conteudo.genero', {
        data: {
          displayName: 'Gênero'
        },
        abstract: true,
        parent: 'conteudo',
        url: '/genero',
        templateUrl: 'view/conteudo/genero/index.html',
        controller: 'ticket.controller.conteudo.genero',
        controllerAs: 'vm'
      })
      .state('conteudo.genero.grid', {
        templateUrl: 'view/conteudo/genero/grid.html',
        url: '/:filter',
        parent: 'conteudo.genero',
        data: {
          displayName: 'Pesquisa'
        },
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.conteudo.genero.grid',
        controllerAs: 'vm'
      })
      .state('conteudo.genero.form', {
        data: {
          displayName: 'EDIÇÃO'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'conteudo.genero',
        templateUrl: 'view/conteudo/genero/form.html',
        controller: 'ticket.controller.conteudo.genero.form',
        controllerAs: 'vm'
      })

      .state('conteudo.programacao', {
        data: {
          displayName: 'Programação'
        },
        abstract: true,
        parent: 'conteudo',
        url: '/programacao',
        templateUrl: 'view/conteudo/programacao/index.html',
        controller: 'ticket.controller.conteudo.programacao',
        controllerAs: 'vm'
      })
      .state('conteudo.programacao.grid', {
        templateUrl: 'view/conteudo/programacao/grid.html',
        url: '/:filter',
        parent: 'conteudo.programacao',
        data: {
          _id: 'C2D19267-4CAF-48D1-BAEF-9B97D691939A',
          displayName: 'Programação'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          Filter: null
        },
        controller: 'ticket.controller.conteudo.programacao.grid',
        controllerAs: 'vm'
      })
      .state('conteudo.programacao.form', {
        url: "/form",
        templateUrl: "view/conteudo/programacao/form.html",
        controller: 'ticket.controller.conteudo.programacao.form',
        controllerAs: 'vm',
        params: {Id: null},
        parent: 'conteudo.programacao',
        data: {
          displayName: 'Programação'
        },
        resolve: {
          loadPlugin: ['$ocLazyLoad', function ($ocLazyLoad) {
            return $ocLazyLoad.load([{
              files: ['/css/plugins/steps/jquery.steps.css']
            }]);
          }]
        }
      })
      .state('conteudo.programacao.form.identificacao', {
        url: '/identificacao/:Id',
        templateUrl: 'view/conteudo/programacao/template/identificacao.tmpl.html',
        parent: 'conteudo.programacao.form',

        data: {
          displayName: 'Programação'
        }
      })
      .state('conteudo.programacao.form.data-horario', {
        url: '/data-horario',
        templateUrl: 'view/conteudo/programacao/template/data-horario.tmpl.html',
        parent: 'conteudo.programacao.form',
        data: {
          displayName: 'Programação'
        }
      })
      .state('conteudo.programacao.form.valores-ingresso', {
        url: '/valores-ingresso',
        templateUrl: 'view/conteudo/programacao/template/valores-ingresso.tmpl.html',
        parent: 'conteudo.programacao.form',
        data: {
          displayName: 'Programação'
        }
      })
      .state('conteudo.programacao.form.detalhes', {
        url: '/detalhes',
        templateUrl: 'view/conteudo/programacao/template/detalhes.tmpl.html',
        parent: 'conteudo.programacao.form',
        data: {
          displayName: 'Programação'
        }
      })

      //NOVO - TABELA DE PREÇO
      .state('conteudo.tabelaprecopadrao', {
        data: {
          displayName: 'Tabela de Preço Padrão'
        },
        abstract: true,
        parent: 'conteudo',
        url: '/tabelapreco',
        templateUrl: 'view/conteudo/tabelaprecopadrao/index.html',
        controller: 'ticket.controller.conteudo.tabelaprecopadrao',
        controllerAs: 'vm'
      })
      .state('conteudo.tabelaprecopadrao.grid', {
        templateUrl: 'view/conteudo/tabelaprecopadrao/grid.html',
        url: '/:filter',
        parent: 'conteudo.tabelaprecopadrao',
        data: {
          _id: 'F0FF0DDF-2250-4939-89BD-15BB916C3456',
          displayName: 'Tabela de Preço'
        },
        // resolve: ['$rootScope', 'rolesProvider', function($rootScope, rolesProvider){
        //   return rolesProvider.IsInRole($rootScope.toState.data._id);
        // }],
        params: {
          items: null,
          filter: null
        },
        controller: 'ticket.controller.conteudo.tabelaprecopadrao.grid',
        controllerAs: 'vm'
      })
      .state('conteudo.tabelaprecopadrao.form', {
        data: {
          displayName: 'Tabela de Preço'
        },
        url: '/form/:Id',
        params: {
          Id: null
        },
        parent: 'conteudo.tabelaprecopadrao',
        templateUrl: 'view/conteudo/tabelaprecopadrao/form.html',
        controller: 'ticket.controller.conteudo.tabelaprecopadrao.form',
        controllerAs: 'vm'
      })


      .state('conteudo.programacao.resumoprogramacao', {
        data: {
          displayName: 'Resumo da Programação'
        },
        url: '/resumoProgramacao/:IdSessao',
        params: {
          IdSessao: null,
          Filter : null
        },
        parent: 'conteudo.programacao',
        templateUrl: 'view/conteudo/programacao/resumoProgramacao/resumo.html',
        controller: 'ticket.controller.conteudo.programacao.resumoprogramacao',
        controllerAs: 'vm'
      })

    menuProvider.left.add({
      name: 'Conteúdo',
      state: 'conteudo',
      icon: 'fa fa-film',
      type: 'group',
      priority: 1.0,
      childs: [
        // {
        //   name: 'Artista',
        //   icon: 'fa fa-user',
        //   type: 'link',
        //   priority: 1.0,
        //   state: 'conteudo.artista'
        // },
        {
          name: 'Tabela de Preço',
          icon: 'fa fa-user',
          type: 'link',
          priority: 1.0,
          state: 'conteudo.tabelaprecopadrao.grid'
        },
        {
          name: 'Atração',
          icon: 'fa fa-film',
          type: 'link',
          priority: 2.0,
          state: 'conteudo.atracao.grid'
        },
        {
          name: 'Programação',
          icon: 'fa fa-object-group',
          type: 'link',
          priority: 4.0,
          state: 'conteudo.programacao.grid'
        }
      ]
    });

    menuProvider.left.add({
      type: 'divider',
      priority: 1.1
    });
  }
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .run(["$rootScope", "$state", "ticket.service.controleacesso.login", function($rootScope, $state, loginSvc){
    
            // create roles for app
            //RoleStore
            //.defineRole('GESTÃO', ['site.user-home', 'conteudo.atracao', 'conteudo.atracao.nova', 'conteudo.atracao.nova-wizard'], checkRole);
            

            ///////////////////////

            // default redirect if access is denied
            function accessDenied() {
                $state.go('401');
            }

            // function that calls user service to check if permission is allowed
            function checkRole(permission, transitionProperties) {
                return loginSvc.hasPermission(permission, transitionProperties);
            }

            // watches

            // redirect all denied permissions to 401
            var deniedHandle = $rootScope.$on('$stateChangePermissionDenied', accessDenied);

            // remove watch on destroy
            $rootScope.$on('$destroy', function() {
                deniedHandle();
            });
        }]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.controller.authentication')
        .config(moduleConfig);

    /* @ngInject */
    function moduleConfig($stateProvider, menuProvider) {

        $stateProvider
        .state('auth', {
            abstract: true,
            templateUrl: "view/authentication/_content.html"
        })
        .state('auth.login', {
            url: '/login',
            templateUrl: 'view/authentication/login/login.html',
            controller:  'ticket.controller.authentication.login',
            controllerAs: 'vm',
            data: { pageTitle: 'Login', specialClass: 'gray-bg' }
        })        
        .state('auth.forgot', {
            url: '/forgot',
            templateUrl: 'view/authentication/forgot/forgot.html',
            controller: 'ticket.controller.authentication.forgot',
            controllerAs: 'vm'
        })
        .state('auth.resetpassword', {
            url: '/resetpassword/:token',
            templateUrl: 'view/authentication/forgot/reset.html',
            controller: 'ticket.controller.authentication.resetpassword',
            controllerAs: 'vm',
            data: { pageTitle: 'Recuperação de senha' }
        })
        .state('auth.lock', {
            url: '/lock',
            templateUrl: 'app/authentication/lock/lock.tmpl.html',
            controller: 'ticket.controller.authentication.lock',
            controllerAs: 'vm'
        })
        .state('auth.establishment', {
            url: '/establishment',
            templateUrl: 'view/authentication/establishment/index.html',
            controller: 'ticket.controller.authentication.establishment',
            controllerAs: 'vm'
        })
        .state('auth.setpassword', {
            url: '/setpassword/:token',
            templateUrl: 'view/authentication/forgot/reset.html',
            controller: 'ticket.controller.authentication.resetpassword',
            controllerAs: 'vm',
            data: { pageTitle: 'Definir senha',  }
        });

        

    }
})();

(function() {
  'use strict';

  angular
    .module("ticket", ['app', 'app.directive', 'ticket.translate', 'ticket.service', 'ticket.controller', 'ticket.filter'])
})();
(function() {
    'use strict';

    angular
        .module('ticket')
        .provider('ticketSettings', settingsProvider);

    /* @ngInject */
    function settingsProvider() {
        // Provider
        var settings = {
            name: 'Divertix',
            logo: 'fa fa-ticket',
            copyright: '',
            version: ''
        };

        this.setLogo = setLogo;
        this.setName = setName;
        this.setCopyright = setCopyright;
        this.setVersion = setVersion;


        function setLogo(logo) {
            settings.logo = logo;
        }

        function setName(name) {
            settings.name = name;
        }

        function setCopyright(copy) {
            settings.copyright = copy;
        }

        function setVersion(version) {
            settings.version = version;
        }

        // Service
        this.$get = function() {
            return {
                name: settings.name,
                copyright: settings.copyright,
                logo: settings.logo,
                version: settings.version,
                defaultSkin: settings.defaultSkin
            };
        };
    }
})();

(function() {
  'use strict';

  angular
    .module('ticket.service', [
      'ticket.service.controleacesso',
      'ticket.service.controleatracao',
      'ticket.service.controleestabelecimento',
      'ticket.service.conteudo',
      'ticket.service.local',
      'ticket.service.ingresso',
      'ticket.service.programacao',
      'ticket.service.fluxocaixa',
      'ticket.service.venda',
      'ticket.service.formapagamento',
      'ticket.service.reports',
      'ticket.service.cliente'
    ]);
})();

(function() {
  'use strict';
  angular
    .module('inspinia', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toaster', 'ui.mask', 'ngFileUpload', 'oc.lazyLoad', 'ticket', 'ui.utils.masks', 'multipleDatePicker', 'tableSort', 'infinite-scroll', 'ngImgCrop','ngjsColorPicker','textAngular','ta-maxlength'])


  //Override module dependecy config
  .value('THROTTLE_MILLISECONDS', 2000);
})();

'use strict';
angular.module('inspinia')
  .controller('MainController',['appSettings', function (appSettings) {

    var vm = this;
    
    vm.versao = appSettings.versao;
    vm.userName = 'Example user';
    vm.helloText = 'Welcome in INSPINIA Gulp SeedProject';
    vm.descriptionText = 'It is an application skeleton for a typical AngularJS web app. You can use it to quickly bootstrap your angular webapp projects.';

  }]);

'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
  var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "AM",
        "PM"
      ],
      "DAY": [
        "domingo",
        "segunda-feira",
        "ter\u00e7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\u00e1bado"
      ],
      "ERANAMES": [
        "antes de Cristo",
        "depois de Cristo"
      ],
      "ERAS": [
        "a.C.",
        "d.C."
      ],
      "FIRSTDAYOFWEEK": 6,
      "MONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "SHORTDAY": [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\u00e1b"
      ],
      "SHORTMONTH": [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
      ],
      "STANDALONEMONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, d 'de' MMMM 'de' y",
      "longDate": "d 'de' MMMM 'de' y",
      "medium": "d 'de' MMM 'de' y HH:mm:ss",
      "mediumDate": "d 'de' MMM 'de' y",
      "mediumTime": "HH:mm:ss",
      "short": "dd/MM/yy HH:mm",
      "shortDate": "dd/MM/yy",
      "shortTime": "HH:mm"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "R$",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": ".",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-\u00a4",
          "negSuf": "",
          "posPre": "\u00a4",
          "posSuf": ""
        }
      ]
    },
    "id": "pt-br",
    "localeID": "pt_BR",
    "pluralCat": function(n, opt_precision) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
  });
}]);

(function() {
    'use strict';

    angular
        .module('ticket.filter', [
          'ticket.filter'
    ]);
})();

(function() {
    'use strict';

    angular
        .module('ticket.filter')
        .filter('time', timeFilter);

    /* @ngInject */
    function timeFilter($filter) {
      return function(input)
      {
        if(input == null){ return ""; }

        var _date = $filter('date')(new Date(input), 'HH:mm');

        return _date;

      };
    }
})();

(function() {
    'use strict';

    angular
        .module('ticket.filter')
        .filter('momentParseZone', momentParseZone)



    /* @ngInject */
    function momentParseZone() {
      return function(input)
      {
        if(input == null){ return ""; }

        var _date = moment.parseZone(input).format('HH:mm')

        return _date;

      };
    }

})();

(function() {
  'use strict';

  angular
      .module('ticket.filter')
      .filter('momentCompleteDate', momentCompleteDate);


  /* @ngInject */
  function momentCompleteDate() {
    return function(input)
    {
      if(input == null){ return ""; }
      var _date = moment.utc(input).local().format('DD/MM/YYYY HH:mm')

      return _date;

    };
  }

})();

(function() {
    'use strict';

    angular
        angular.module("app.directive", []);
})();
(function () {
  angular.module('app.directive')
    .directive('readMore', function () {
      return {
        restrict: 'A',
        transclude: true,
        replace: true,
        template: '<p></p>',
        scope: {
          moreText: '@',
          lessText: '@',
          words: '@',
          ellipsis: '@',
          char: '@',
          limit: '@',
          content: '@'
        },
        link: function (scope, elem, attr, ctrl, transclude) {
          var moreText = angular.isUndefined(scope.moreText) ? ' <a class="read-more">Ver mais</a>' : ' <a class="read-more">' + scope.moreText + '</a>',
            lessText = angular.isUndefined(scope.lessText) ? ' <a class="read-less">Ocultar</a>' : ' <a class="read-less">' + scope.lessText + '</a>',
            ellipsis = angular.isUndefined(scope.ellipsis) ? '' : scope.ellipsis,
            limit = angular.isUndefined(scope.limit) ? 80 : scope.limit;

          attr.$observe('content', function (str) {
            readmore(str);
          });

          transclude(scope.$parent, function (clone, scope) {
            readmore(clone.text().trim());
          });

          function readmore(text) {

            var text = text,
              orig = text,
              regex = /\s+/gi,
              charCount = text.length,
              wordCount = text.trim().replace(regex, ' ').split(' ').length,
              countBy = 'char',
              count = charCount,
              foundWords = [],
              markup = text,
              more = '';

            if (!angular.isUndefined(attr.words)) {
              countBy = 'words';
              count = wordCount;
            }

            if (countBy === 'words') { // Count words

              foundWords = text.split(/\s+/);

              if (foundWords.length > limit) {
                text = foundWords.slice(0, limit).join(' ') + ellipsis;
                more = foundWords.slice(limit, count).join(' ');
                markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
              }

            } else { // Count characters

              if (count > limit) {
                text = orig.slice(0, limit) + ellipsis;
                more = orig.slice(limit, count);
                markup = text + moreText + '<span class="more-text">' + more + lessText + '</span>';
              }

            }

            elem.append(markup);

            elem.find('.read-more').show();
            elem.find('.more-text').hide().removeClass('show');
            
            elem.find('.read-more').on('click', function () {
              $(this).hide();
              elem.find('.more-text').addClass('show').slideDown();
            });
            elem.find('.read-less').on('click', function () {
              elem.find('.read-more').show();
              elem.find('.more-text').hide().removeClass('show');
            });

          }
        }
      };
    });
})();
(function() {

  //TIPOS DE INPUTS

  /*

  1 - select
   options -  Array (Utilizado para fazer o bind)
   valueField - Usado quando o identificar for diferente de "Id"
   textField -  Usado quando o texto for diferente de "Nome"

  2 - number
   number|{int} - Total de casas decimais. (Default = "0")
   maxlength={int} - Quantidade máxima de caracteres que o usuário poderá digitar.



    */

  angular.module("app.directive")
    .directive('ngField', ['$compile', function($compile) {

      function getTemplate(scope, elm) {
        var engines = {
          date: 'uib-datepicker-popup="dd/MM/yyyy" ',
          cpf: ' ng-cpf ',
          cnpj: ' ng-cnpj ',
          cep: 'ng-cep',
          text: ''
        };
        var masks = {
          cpf: '999.999.999-99',
          cnpj: '99.999.999/9999-99',
          cep: '99.999-999'
        };
        var patterns = {
          //email: '/^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z0-9.]{2,}$/'
          //email:'/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/'
          //email:'/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/'
        };

        var required = (scope.required) ? ' ng-required="true" ' : '';

        var pattern = (patterns[scope.type]) ? ' ng-pattern="' + patterns[scope.type] + '" ' : "";

        var $frm = elm.closest('form');
        scope.form = ($frm.length == 0 || $frm.attr("name") == "" || $frm.attr("name") == null) ? 'frm' : $frm.attr("name");
        scope.name = scope.name || "txt_" + elm.index();

        var flagPopup = scope.name + '_popup';

        scope.valueField = scope.valueField || 'Id';
        scope.textField = scope.textField || 'Nome';
        var diretiveDisabled = scope.ngDisabled != null ? 'ng-disabled="ngDisabled"' : '';

        var maxlength = scope.maxlength != null ? ' maxlength="{{maxlength}}"' : '';
        var minlength = scope.minlength != null ? ' minlength="{{minlength}}"' : '';

        scope.ngDisabled = scope.ngDisabled || false;

        var rows = scope.rows != null ? 'rows= {{rows}}' : 'rows=4';

        var htmlTooltip = scope.tooltip != null ? '<span class="input-group-addon btn btn-primary" style="border-color:#ccc; background-color:white!important" popover-placement="auto top"  uib-popover="{{tooltip}}" popover-trigger="mouseenter"><i class="fa fa-question-circle" style="color:black" aria-hidden="true"></i></span>' : '';

        var res = '';

        if ($frm.length == 0) {
          res += '    <span class="help-block">Elemento de formulário não encontrado.</span>';
        } else {
          res =
            '<ng-form name={{form}}>' +
            ' <div class="form-group form-group-sm ">' +
            '    <h4 class="text-bold text-left">{{label}}</h4>' +
            '    <div ng-class="{\'has-success\':(' + scope.form + '.' + scope.name + '.$valid && !' + scope.form + '.' + scope.name + '.$pending && !loading), \'has-error\':(!' + scope.form + '.' + scope.name + '.$valid && !' + scope.form + '.' + scope.name + '.$pending && !loading) }">';

          if (scope.type == 'select') {
            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '      <select ' + diretiveDisabled + ' class="form-control" aria-label="{{label}}" ' + maxlength + ' ng-model="model" name="' + scope.name + '" ' + required + '  validate-async="validateAsync" ng-field-validator >' +
              '<option></option>' +
              '        <option ng-repeat="o in options" value="{{o.' + scope.valueField + '}}">{{o.' + scope.textField + '}}</option>' +
              '      </select>' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'date') {
            scope.dateOptions = {
              minDate: scope.minDate,
              'class': 'datepicker'
            };

            scope.ngOptinos = {
              /*timezone: 'UTC'*/
            }
            res += '<div class="input-group">' +
              '<input ' + diretiveDisabled + ' type="text" class="form-control" aria-label="{{label}}" ng-model-options="ngOptinos" ng-model="model" name="' + scope.name + '" ' + required + ' uib-datepicker-popup="dd/MM/yyyy" show-button-bar="false" datepicker-options="dateOptions" is-open="' + flagPopup + '" />' +
              '<span class="input-group-btn">' +
              '<button type="button" class="btn btn-sm btn-primary" ng-click="' + flagPopup + '=true;">' +
              '<i class="glyphicon glyphicon-calendar"></i>' +
              '</button>' +
              '</span>' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'time') {

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" ui-time-mask="short" class="form-control" aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'phone') {

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" ui-br-phone-number class="form-control" aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          } else if (scope.type == 'password') {
            res += '      <input ' + diretiveDisabled + ' type="password" class="form-control" aria-label="{{label}}" ' + maxlength + ' ng-model="model" name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />';
          } else if (scope.type == 'textarea') {
            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<textarea ' + rows + ' ' + diretiveDisabled + 'name="' + scope.name + '" class="form-control" ng-model="model"' + maxlength + required + ' style="resize:none"></textarea>' +
              htmlTooltip +
              '</div>';
          }

          else {
            var format = "";

            if (scope.type != null) {
              var arr = scope.type.split('|');

              if (arr[0] == "number") {
                format = (arr.length == 1) ? "ui-hide-group-sep ui-number-mask='0'" : "ui-hide-group-sep ui-number-mask='" + arr[1] + "'"
              } else if (arr[0] == "cpf")
                format = "ui-br-cpf-mask";
              else if (arr[0] == "percentual")
                format = (arr.length == 1) ? "ui-percentage-mask" : "ui-percentage-mask='" + arr[1] + "'"
              else if (arr[0] == "money")
                format = (arr.length == 1) ? "ui-money-mask" : "ui-money-mask='" + arr[1] + "'"
            }

            res += (scope.tooltip != null ? '<div class="input-group">' : '<div class="form-group">') +
              '<input ' + diretiveDisabled + ' type="text" class="form-control" '+ minlength + ' aria-label="{{label}}" ' + maxlength + ' ' + format + ' ng-model="model"  name="' + scope.name + '" ' + required + pattern + '  validate-async="validateAsync" ng-field-validator  />' +
              htmlTooltip +
              '</div>';
          }

          if (scope.validateSubmit === undefined) {

            res += '    </div>' +
              '    <span class="help-block" ng-show="' + scope.form + '.' + scope.name + '.$error.required">Preenchimento obrigatório</span>' +
              '    <span class="help-block" ng-show="' + scope.name + '.$error.pattern">Formato inválido</span>' +
              '    <span class="help-block" ng-show="' + scope.name + '.$error.custom">{{validateAsyncError}}</span>' +
              ' </div> ' +
              '</ng-form>';
          } else {
            res += '    </div>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.form + '.' + scope.name + '.$error.required">Preenchimento obrigatório</span>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.name + '.$error.pattern">Formato inválido</span>' +
              '    <span class="help-block" ng-show="validateSubmit  && ' + scope.name + '.$error.custom">{{validateAsyncError}}</span>' +
              ' </div> ' +
              '</ng-form>';
          }


        }

        return res;
      }

      return {
        restrict: 'E',
        //label - título do campo, form: nome do form que o campo pertence, name: nome usado pelo js, model: model :), type: email, cpf, data, etc., required : obrigatoriedade, mask: máscara de formatação (type costuma ter sua formatação implicita), validate: função que recebe o valor e evento do campo e retorna bool que será aplicado na validação, validateAsync: retorna um promise onde function(modelValue, viewValue) {return $http.post(url)}
        scope: {
          label: '@label',
          name: '@name',
          model: '=?',
          ngDisabled: "=?",
          maxlength: "=",
          minlength: "=",
          tooltip: "@tooltip",
          rows: '=',
          type: '@type',
          required: '@',
          mask: '@mask',
          validate: '=?',
          validateAsync: '=?',
          validateAsyncError: '@',
          loading: '=',
          pattern: '@',
          size: '@',
          options: '=',
          valueField: '@',
          textField: '@',
          options: '=',
          valueField: '@',
          textField: '@',
          maskPercentual: '@',
          minDate: '=',
          validateSubmit: '=?'
        },
        link: function(scope, elm, attrs) {

          var htm = getTemplate(scope, elm);
          elm.html(htm).show();
          $compile(elm.contents())(scope);


          scope.$watch('model', function() {
            if (scope.type == 'date' && typeof(scope.model) === "string")

              scope.model = new Date(scope.model);
            else if (scope.type == 'select' && typeof(scope.model) != "string" && scope.model !== undefined && scope.model != null)
              scope.model = scope.model.toString();
          });
        }
      };
    }])

  .directive('ngFieldValidator', ['$compile', function($compile) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        validate: '&',
        validateAsync: '=?'
      },
      link: function(scope, elm, attrs, ngModel) {
        if (ngModel && scope.validateAsync)
          ngModel.$asyncValidators.custom = scope.validateAsync;
      }
    };
  }]);

})();

(function () {
angular.module("app.directive")
  .directive('ngEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter);
          });
          event.preventDefault();
        }
      });
    };
  });
})
();

(function() {
  angular.module("app.directive")
    .directive('ngSvg', [function() {
      return {
        restrict: 'E',
        scope: {
          content: '=',
          loaded: '&',
          'class': '@',
          width: '@',
          height: '@',
          mouseover: '&'
        },
        link: function(scope, elm, attrs) {

          var chgSize = function($svg) {
            if (scope.width && scope.width != '')
              $svg.attr('width', scope.width);

            if (scope.height && scope.height != '')
              $svg.attr('height', scope.height);
          }


          scope.$watch("content", function() {
            elm.html('');
            if (scope.content) {
              elm.html(scope.content);
              elm.attr('ng-mouseover', scope.mouseover);
              if (scope.loaded())
                scope.loaded()(elm.find('svg'));

            }

          });
          scope.$watch("width", function() {
            chgSize(elm.find('svg'));
          });
          scope.$watch("height", function() {
            chgSize(elm.find('svg'));
          });
        }
      };

    }])
    .directive('svgLoading', [function() {
      return {
        restrict: 'E',
        template: '<svg width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="uil-ring svg-purple-color"><rect x="0" y="0" width="100" height="100" fill="none" class="bk"></rect><circle cx="50" cy="50" r="40" stroke-dasharray="163.36281798666926 87.9645943005142" stroke="#d25353" fill="none" stroke-width="20"><animateTransform attributeName="transform" type="rotate" values="0 50 50;180 50 50;360 50 50;" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite" begin="0s"></animateTransform></circle></svg>'
      };
    }]);

})();
(function () {

    angular.module("app.directive")
.directive('icheck', function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, element, $attrs, ngModel) {
            return $timeout(function () {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function (newValue) {
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-orange',
                    radioClass: 'iradio_square-orange'

                }).on('ifChanged', function (event) {
                    if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                        $scope.$apply(function () {
                            return ngModel.$setViewValue(event.target.checked);
                        });
                    }
                    if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                        return $scope.$apply(function () {
                            return ngModel.$setViewValue(value);
                        });
                    }
                });
            });
        }
    };
});
})();
(function () {

  angular.module("app.directive")
    .directive('chips', function () {
      return {
        restrict: 'E',
        scope: {
          tags: '=',
          selecionado: '=',
          autocomplete: '=autocomplete',
          placeholder: '@',
          valueField: '@',
          textField: '@',
          iconField: '@',
          max: '@', //Quantidade de itens que poderão ser adicionado ao chip
          disabled: '=', // Se 'true' desabilita o chip
          hasImage: '=', //Se definido como 'false', o chips não terá imagem, default 'true'
          allowNewItem: '=', // Se definido como 'false', o chip não permitirá a inclusão de novo item, default 'true'.
          selectedItemChange: '=?',
          items: '=?',
          removed:'=?',
          hasCheck: '=',
          enterNew: '='
        },
        template: '<div class="tags">' +
        '<div ng-repeat="t in tags" class="tag">' +
        '<img src="{{t[iconField]}}" fallback-src="../img/user_32x32.png" ng-if="t[iconField] != undefined" ng-hide="{{hasImage}}">&nbsp;' +
        '<img src="../img/user_32x32.png" ng-if="t[iconField] == undefined" ng-show="{{hasImage == false ? false : true}}"></img>' +
        '<span style="line-height: 30px;margin-left: 5px;">{{t[textField]}} </span> <b  class="badge badge-danger" ng-if="t[valueField]==null">Novo</b>&nbsp;&nbsp' +
        '<a class="close" ng-click="remove($index, t)" ng-hide="{{disabled}}">' +
        '<i class="fa fa-times-circle fa-5x" style="margin-top: 5px" aria-hidden="true"></i></a>' +
        '<input ng-if="hasCheck" icheck name="{{optName}}" type="radio" ng-model="$parent.$parent.selecionado" ng-value="t[valueField]" />'+
        '</div>' +
        '</div>' +
        '<div class="input-form">' +
        '<input type="text" id="txtBusca" class="form-control" placeholder="{{placeholder}}" ng-disabled="disabled" ng-model="newValue" /> '+
        '<div class="text-danger" ng-if="limiteAlcancado"><strong>O limite foi alcançado.</strong></div>' +
        '<h4 class="text-primary" ng-if="enterNew"><small>Pressione a tecla "ENTER" para incluir um novo registro.</small></h4>',
        // '<div class="progress progress-striped active" style="height: 4px;margin-top: -5px;">' +
        // '<div style="width:{{progress}}%" class="progress-bar progress-bar-success">' +
        // '</div>' +
        // '</div>',

        // '<span class="input-group-btn"><a class="btn btn-default" ng-click="add()">Add</a></span></div>',
        link: function ($scope, $element, attrs) {
          $scope.optName    =  "opt_" + Math.floor((1 + Math.random()) * 0x10000).toString(16)
          $scope.valueField = $scope.valueField || 'Id';
          $scope.textField = $scope.textField || 'Nome';
          $scope.iconField = $scope.iconField || '';

          if($scope.hasImage === undefined || $scope.hasImage === null){
            attrs.$set('hasImage', true);
            //$scope.hasImage = true;
          }

          var max = $scope.max;
          var input = angular.element($element).find('#txtBusca');

          $scope.autocompleteFocus = function (event, ui) {

            //input.val(ui.item[$scope.textField]);

            return false;
          };

          $scope.autocompleteSelect = function (event, ui) {
            $scope.newValue = ui.item[$scope.textField];

            if ($scope.selectedItemChange != undefined)
              $scope.selectedItemChange(ui);

            $scope.$apply(function () {
              $scope.add(ui.item)
            });

            return false;
          };

          $scope.progress = 0;

          $($element).find('#txtBusca').autocomplete({
            minLength: 0,

            source: function (req, resp) {

              $scope.items(req.term).then(function (data) {
                return resp(data);
              }).finally(function () {
                $scope.progress = 0;
              });
            },

            focus: (function (_this) {

              return function (event, ui) {

                return $scope.autocompleteFocus(event, ui);
              };
            })(this),

            select: (function (_this) {
              return function (event, ui) {

                return $scope.autocompleteSelect(event, ui);
              };
            })(this)

          }).autocomplete("instance")._renderItem = function (ul, item) {
//            maxShowItems: 5;

            // if($scope.hasImage === undefined || $scope.hasImage === null){
            //   $scope.hasImage = true;
            // }

            var $li = $('<li>');
            $li.attr("data-id", item[$scope.valueField])
            var $div = $('<div>');
            var $img = $('<img>');
            var $a = $('<a>');

            if($scope.hasImage === undefined || $scope.hasImage === true){
              if (item[$scope.iconField] != undefined) {
                $img.attr({
                  src: item[$scope.iconField],
                  alt: item[$scope.textField],
                  'fallback-src' : '../img/user_32x32.png'
                });
                $a.append($img);
              }
              else {
                $a.append('<img src="../img/user_32x32.png"> </img>');
              }
            }

            $a.append(item[$scope.textField]);
            $div.append($a);
            $li.append($div);
            ul.addClass("chips");

            $img.error(function() {
//              $(this).attr("src", "https://www.google.com/images/srpr/logo3w.png");
              $(this).attr("src", "../img/user_32x32.png");
            })

            return $li.appendTo(ul);
          }

          $scope.add = function (itm) {

            if ($scope.tags.length == max && max > 1) {
              $scope.limiteAlcancado = true;
              input.attr('disabled', true);
              $scope.newValue = "";
              input.val('');
            }

            if ($scope.allowNewItem != false || $scope.allowNewItem == undefined || itm[$scope.valueField] != undefined) {
              //if ($scope.tags.length < max || max == undefined) {
                if ($scope.tags.filter(function (item) {
                    if (itm[$scope.valueField] == !undefined)
                      return item[$scope.valueField] == itm[$scope.valueField]
                    else
                      return item[$scope.textField] == itm[$scope.textField]
                  }).length == 0) {

                  if(itm.Nome != undefined && itm.Nome != "") {
                    itm.Selecionado = null;
                    if(max == 1) {
                      $scope.tags = [];
                      $scope.tags.push(itm);
                    }
                    else
                    $scope.tags.push(itm);
                  }
                }
                $scope.newValue = "";
                input.val('');
                input.blur();
                $('#txtBusca').autocomplete('close');
              //}
              //else {
                // if (itm != undefined) {
                //   $scope.tags = [];
                //   $scope.tags.push(itm);
                //   $scope.newValue = "";
                // }
             // }

            }
            if ($scope.tags.length == max && max > 1) {
              input.attr('disabled', true);
            }

            $('#txtBusca').autocomplete('close');
          }

          $scope.remove = function(idx, itm) {
            $scope.limiteAlcancado = false;
            $scope.tags.splice(idx, 1);
            input.attr('disabled', false);

            if(itm.Principal == true)
              $scope.selecionado = null;

            if ($scope.removed != undefined)
              return $scope.removed(itm);
          };

          input.bind('keypress', function (event) {
            if (event.keyCode == 13) {
              $scope.$apply(function () {
                $scope.add({Nome: $scope.newValue});
                $scope.newValue = "";
              });
            }
            $element.find('input').focus();
          });

          input.bind('focus', function(event) {
            $element.find('input').autocomplete("search");
          });
        }
      };
    });
})();

(function() {

  angular.module('app.directive')
    .directive('breadcrumb', ['$interpolate', '$state', 'appSettings', function($interpolate, $state, appSettings) {
      return {
        restrict: 'E',
        templateUrl: 'view/common/breadcrumb.html',
        scope: {
          displaynameProperty: '@',
          abstractProxyProperty: '@?'
        },
        link: function(scope) {
          scope.breadcrumbs = [];
          if ($state.$current.name !== '') {
            updateBreadcrumbsArray();
          }
          scope.$on('$stateChangeSuccess', function() {
            updateBreadcrumbsArray();
          });

          /**
           * Start with the current state and traverse up the path to build the
           * array of breadcrumbs that can be used in an ng-repeat in the template.
           */
          function updateBreadcrumbsArray() {
            var workingState;
            var displayName;
            var breadcrumbs = [];
            var currentState = $state.$current;

            var authData = appSettings.getUserStore();


            while (currentState && currentState.name !== '') {
              workingState = getWorkingState(currentState);
              if (workingState) {
                displayName = getDisplayName(workingState);

                if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
                  breadcrumbs.push({
                    displayName: displayName,
                    route: workingState.name
                  });
                }
              }
              currentState = currentState.parent;
            }
            breadcrumbs.reverse();
            scope.breadcrumbs = breadcrumbs;
            if (breadcrumbs.length > 0)
              scope.title = breadcrumbs[breadcrumbs.length - 1].displayName
            else
              scope.title = "TITULO DA PÁGINA";

            if (authData) {
              scope.estabelecimento = authData.estabelecimento;
              scope.quantidade_estabelecimento = authData.quantidade_estabelecimento;
              scope.usuario = authData.apelido || authData.login;
            }

          }

          /**
           * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
           * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
           * set it to `false` which means this breadcrumb level will be skipped entirely.
           * @param currentState
           * @returns {*}
           */
          function getWorkingState(currentState) {
            var proxyStateName;
            var workingState = currentState;
            if (currentState.abstract === true) {
              if (typeof scope.abstractProxyProperty !== 'undefined') {
                proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
                if (proxyStateName) {
                  workingState = $state.get(proxyStateName);
                } else {
                  workingState = false;
                }
              } else {
                workingState = false;
              }
            }
            return workingState;
          }

          /**
           * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
           * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
           * properties on the state config object, by using the usual {{ }} syntax.
           * @param currentState
           * @returns {*}
           */
          function getDisplayName(currentState) {
            var interpolationContext;
            var propertyReference;
            var displayName;

            if (!scope.displaynameProperty) {
              // if the displayname-property attribute was not specified, default to the state's name
              return currentState.name;
            }
            propertyReference = getObjectValue(scope.displaynameProperty, currentState);

            if (propertyReference === false) {
              return false;
            } else if (typeof propertyReference === 'undefined') {
              return currentState.name;
            } else {
              // use the $interpolate service to handle any bindings in the propertyReference string.
              interpolationContext = (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : currentState;
              displayName = $interpolate(propertyReference)(interpolationContext);
              return displayName;
            }
          }

          /**
           * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
           * value found at that path.
           *
           * @param objectPath
           * @param context
           * @returns {*}
           */
          function getObjectValue(objectPath, context) {
            var i;
            var propertyArray = objectPath.split('.');
            var propertyReference = context;

            for (i = 0; i < propertyArray.length; i++) {
              if (angular.isDefined(propertyReference[propertyArray[i]])) {
                propertyReference = propertyReference[propertyArray[i]];
              } else {
                // if the specified property was not found, default to the state's name
                return undefined;
              }
            }
            return propertyReference;
          }

          /**
           * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
           * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
           * @param state
           * @param breadcrumbs
           * @returns {boolean}
           */
          function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
            var i;
            var alreadyUsed = false;
            for (i = 0; i < breadcrumbs.length; i++) {
              if (breadcrumbs[i].route === state.name) {
                alreadyUsed = true;
              }
            }
            return alreadyUsed;
          }
        }
      };
    }]);
})();

(function () {
  'use strict';

  angular
    .module('ticket.controller', [
        	'ticket.controller.authentication',
        	'ticket.controller.site',
        	'ticket.controller.conteudo',
        	'ticket.controller.estabelecimento',
          'ticket.controller.planta',
          'ticket.controller.fluxocaixa',
          'ticket.controller.reports'
    	]);
})();

(function () {
  /**
 * INSPINIA - Responsive Admin Theme
 * 2.5
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeigh > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if(navbarHeigh < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

})();
(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');

// moment.js locale configuration
// locale : brazilian portuguese (pt-br)
// author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

    (function (factory) {
      if (typeof define === 'function' && define.amd) {
        define(['moment'], factory); // AMD
      } else if (typeof exports === 'object') {
        module.exports = factory(require('../moment')); // Node
      } else {
        factory(window.moment); // Browser global
      }
    }(function (moment) {
      return moment.defineLocale('pt-br', {
        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays : 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
        weekdaysShort : 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin : 'dom_2ª_3ª_4ª_5ª_6ª_sáb'.split('_'),
        longDateFormat : {
          LT : 'HH:mm',
          L : 'DD/MM/YYYY',
          LL : 'D [de] MMMM [de] YYYY',
          LLL : 'D [de] MMMM [de] YYYY [às] LT',
          LLLL : 'dddd, D [de] MMMM [de] YYYY [às] LT'
        },
        calendar : {
          sameDay: '[Hoje às] LT',
          nextDay: '[Amanhã às] LT',
          nextWeek: 'dddd [às] LT',
          lastDay: '[Ontem às] LT',
          lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
              '[Último] dddd [às] LT' : // Saturday + Sunday
              '[Última] dddd [às] LT'; // Monday - Friday
          },
          sameElse: 'L'
        },
        relativeTime : {
          future : 'em %s',
          past : '%s atrás',
          s : 'segundos',
          m : 'um minuto',
          mm : '%d minutos',
          h : 'uma hora',
          hh : '%d horas',
          d : 'um dia',
          dd : '%d dias',
          M : 'um mês',
          MM : '%d meses',
          y : 'um ano',
          yy : '%d anos'
        },
        ordinal : '%dº'
      });
    }));

    //angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 1000);

    /* Brazilian initialisation for the jQuery UI date picker plugin. */
    /* Written by Leonildo Costa Silva (leocsilva@gmail.com). */
    jQuery(function($){
      $.datepicker.regional['pt-BR'] = {
        closeText: 'Fechar',
        prevText: '&#x3c;Anterior',
        nextText: 'Pr&oacute;ximo&#x3e;',
        currentText: 'Hoje',
        monthNames: ['Janeiro','Fevereiro','Mar&ccedil;o','Abril','Maio','Junho',
          'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
        monthNamesShort: ['Jan','Fev','Mar','Abr','Mai','Jun',
          'Jul','Ago','Set','Out','Nov','Dez'],
        dayNames: ['Domingo','Segunda-feira','Ter&ccedil;a-feira','Quarta-feira','Quinta-feira','Sexta-feira','Sabado'],
        dayNamesShort: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        dayNamesMin: ['Dom','Seg','Ter','Qua','Qui','Sex','Sab'],
        weekHeader: 'Sm',
        dateFormat: 'dd/mm/yy',
        firstDay: 0,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''};
      $.datepicker.setDefaults($.datepicker.regional['pt-BR']);
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider, menuProvider) {

    $stateProvider
      .state('404', {
        url: '/404',
        views: {
          'root': {
            templateUrl: 'view/common/404.tmpl.html',
            controller: 'ErrorPageController',
            controllerAs: 'vm'
          }
        }
      })

    .state('401', {
      url: '/401',
      views: {
        'root': {
          templateUrl: 'view/common/401.tmpl.html',
          controller: 'ErrorPageController',
          controllerAs: 'vm'
        }
      }
    })

    .state('500', {
      url: '/500',
      views: {
        'root': {
          templateUrl: 'view/common/500.tmpl.html',
          controller: 'ErrorPageController',
          controllerAs: 'vm'
        }
      }
    });


    // set default routes when no path specified
    $urlRouterProvider.when('', '/login');
    $urlRouterProvider.when('/', '/login');

    // always goto 404 if route not found
    $urlRouterProvider.otherwise('/404');



  }

})();
(function() {
    angular
        .module('ticket')
        .controller('ErrorPageController', ErrorPageController);

    /* @ngInject */
    function ErrorPageController($state) {
        var vm = this;

        vm.goHome = goHome;

        
        function goHome() {
            $state.go('auth.login');
        }
    }
})();

(function () {
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .factory("navigation", ["common", function (common) {
        var res = { items: [], menuLeft: { add: function (itm) { res.push(itm); } } };

        return res;
    }])

    .directive('sideNavigation', ["$timeout", function ($timeout) { 
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function () {
                    $timeout(function () {
                        element.metisMenu();
                    });

                  // Enable initial fixed sidebar
                  // var sidebar = element.parent();
                  // sidebar.slimScroll({
                  //   height: '100%',
                  //   railOpacity: 0.9,
                  // });

                });

            }
        };
    }])
    .directive('minimalizaSidebar', ["$timeout", function ($timeout) { 
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    }])
    .directive('fallbackSrc', function () {
      var fallbackSrc = {
        link: function postLink(scope, iElement, iAttrs) {
          iElement.bind('error', function() {
            angular.element(this).attr("src", iAttrs.fallbackSrc);
          });
        }
       }
       return fallbackSrc;
    });

})();


(function(){
	angular.module("app",[
        'app.directive'
    ]);
})();
 (function() {
    'use strict';
 angular.module('app')
.factory('dateInterceptor', function () {
        var regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.(\d{1,})(Z|([\-+])(\d{2}):(\d{2}))?)?)?)?$/;

        function matchDate(dateString) {
            if (dateString.length === 27) {
                return dateString.match(regexIso8601);
            }
            return false;
        };

        function convertDateStringsToDates(object) {
            // ensure that we're processing an object
            if (typeof object !== "object") {
                return object;
            }

            for (var key in object) {
                if (!object.hasOwnProperty(key)) {
                    continue;
                }
                var value = object[key];

                // check for string properties with a date format
                if (typeof value === "string" && matchDate(value)) {
                    var date = new Date(value); // create the date from the date string
                    object[key] = date; // we're mutating the response directly
                } else if (typeof value === "object") {
                    convertDateStringsToDates(value); // recurse into object
                }
            }
            return null;
        }

        var interceptor = {
            'response': function (response) {
                if (response.data) {
                    convertDateStringsToDates(response.data);
                }
                return response;
            }
        };
        return interceptor;
    })
})();
(function () {
  angular.module("ticket")
    .factory("common", ["$rootScope", "$state", "$stateParams", "$q", "$http", "appSettings", "$log", "$timeout", "toaster", "$uibModal", "ticket.service.controleacesso.login", function ($rootScope, $state, $stateParams, $q, $http, appSettings, $log, $timeout, toaster, $uibModal, loginSvc) {

      var AlertType = {
        INFO: "info",
        ERRO: "error",
        ALERTA: "warning",
        SUCESSO: "success",
        AGUARDE: "wait"
      };
      var utils = {
        AlertType: AlertType,
        Messages: {
          post: {
            tit: "Alteração de informações",
            msg: "Atualização realizada com sucesso!",
            type: AlertType.SUCESSO
          },
          put: {
            tit: "Inclusão de informações",
            msg: "Cadastro realizado com sucesso!",
            type: AlertType.SUCESSO
          },
          status: {
            tit: "Alteração de status",
            msg: "Atualização de status realizado com sucesso!",
            type: AlertType.SUCESSO
          },
          del: {
            tit: "Exclusão de informações",
            msg: "Exclusão realizada com sucesso!",
            type: AlertType.SUCESSO
          },
          putPhoto: {
            tit: "Envio de foto",
            msg: "A foto foi enviada com sucesso!",
            type: AlertType.SUCESSO
          },
          errorQuery: {
            tit: "Resultado da Pesquisa:",
            msg: "Nenhum registro encontrado!",
            type: AlertType.INFO
          }
        },
        Confirm: function (tit, msg) {
          return $uibModal.open({
            animation: false,
            templateUrl: "view/common/confirm.html",
            controller: function ($uibModalInstance, itm) {
              var vm = this;
              vm.itm = itm;
              vm.no = function () {
                $uibModalInstance.dismiss('cancel');
              }
              vm.yes = function () {
                $uibModalInstance.close(vm.item);
              }
            },
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
              itm: function () {
                return {
                  tit: tit,
                  msg: msg
                };
              }
            }
          })
            .result;
        },
        SendAlert: function (data) {
          toaster.pop(data.type, data.tit, data.msg);
        },
        ShowError: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.ERRO
          });
        },
        ShowInfo: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.INFO
          });
        },
        ShowWarning: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.ALERTA
          });
        },
        ShowSuccess: function (tit, msg) {
          utils.SendAlert({
            tit: tit,
            msg: msg,
            type: AlertType.SUCESSO
          });
        }
      };

      var common = {
        controller: {
          basic: function (obj) {
            var vm = {};
            vm.utils = utils;

            obj.__proto__ = vm;

            return obj;
          },
          master: function (obj, svc, $scope) {
            var vm = {};
            vm.utils = utils;


            var _queried = $rootScope.$on('queried', function (evt, items) {
              vm.items = items;
            });

            $scope.$on('$destroy', _queried);

            var _canceled = $rootScope.$on('canceled', function () {
              if (vm.items && vm.items.length > 0) {
                for (var i = 0; i < vm.items.length; i++)
                  vm.items[i].updated = false;

                $state.go('^.grid', {
                  items: vm.items
                });
              } else {
                $state.go('^.grid');
              }

            });

            $scope.$on('$destroy', _canceled);

            var _saved = $rootScope.$on('saved', function (evt, pk) {

              if (vm.items && vm.items.length > 0) {
                //VERIFICA SE A PK QUE RETORNOU DA EDIÇÃO EXISTE NA GRID
                var rows = vm.items.filter(function (itm) {
                  itm.updated = false;
                  for (var i in pk) {
                    if (itm[i] != pk[i])
                      return false;
                  }

                  return true;
                });

                //BUSCA O REGISTRO DA GRID ATUALIZADO NO SERVIDOR
                svc.getOne(pk)
                  .then(function (res) {

                    //POSICIONA O REGISTRO ATUALIZADO NA GRID. SE FOR INCLUSÃO, IRÁ PARA A PRIMEIRA POSIÇÃO

                    var index = (rows.length > 0) ? vm.items.indexOf(rows[0]) : -1;

                    res[0].updated = true;

                    if (index == -1) {
                      vm.items.splice(0, 0, res[0]);
                    } else {
                      vm.items.splice(index, 1, res[0]);
                    }

                    $state.go('^.grid', {
                      items: vm.items
                    });

                  });
              } else {
                svc.getOne(pk)
                  .then(function (res) {
                    $state.go('^.grid', {
                      items: res
                    });
                  });
              }


            });

            $scope.$on('$destroy', _saved);

            obj.__proto__ = vm;

            return obj;

          },
          grid: function (obj, svc) {
            var vm = {};
            vm.utils = utils;
            vm.Filter = {};
            vm.debounce = 0;
            vm.searching = false;
            vm.complete = false;
            vm.items = [];
            var pageSize = 20;
            vm.isPost = true;

            //PESQUISA DA GRID
            vm.search = function (inScroll) {

              if (vm.searching) return;

              vm.searching = true;

              if (!inScroll || vm.isPost) {
                vm.isPost = false;
                vm.page = 0;
                vm.complete = false;
                vm.items = [];
              }
              svc.getAll({
                Config: {
                  Skip: vm.page,
                  Top: pageSize
                },
                Filter: vm.Filter
              })
                .then(function (v) {
                  $rootScope.$emit('queried', v);

                  vm.items = vm.items.concat(v);

                  if (v.length < pageSize)
                    vm.complete = true;

                  if (v.length > 0) {
                    vm.page += 1;
                  }


                  if (obj.loaded)
                    obj.loaded();
                })
                .finally(function () {
                  vm.searching = false;
                });
            }


            //INCLUSÃO
            vm.add = function () {
              $state.go('^.form');
            }

            //EDIÇÃO
            vm.edit = function (pk) {

              $state.go('^.form', pk);
            }

            //STATUS ON/OFF
            vm.toggle = function (itm) {
              svc.toggle(itm).then(function (v) {
                itm.Status = v;
              });
            }

            //EXCLUSÃO
            vm.del = function (itm, svc2, callback) {
                utils.Confirm("Exclusão de registro", "Deseja excluir esse registro?").then(function () {
                  if (svc2) {
                    svc2.del(itm).then(function (v) {
                      vm.items.splice(vm.items.indexOf(itm), 1);
                      utils.ShowSuccess("Exclusão de registro.", "Esse registro foi excluído com sucesso!");
                    });
                  }
                  else {
                    svc.del(itm).then(function (v) {
                      vm.items.splice(vm.items.indexOf(itm), 1);
                      utils.ShowSuccess("Exclusão de registro.", "Esse registro foi excluído com sucesso!");
                    });
                  }
  
                  if (callback) {
                    callback();
                  }
              });
            }


            if ($stateParams.items) {
              vm.items = angular.fromJson(angular.toJson($stateParams.items));
            }

            if ($stateParams.filter) {
              vm.Filter = angular.fromJson($stateParams.filter);
              vm.search();
            }


            obj.__proto__ = vm;

            return obj;

          },
          form: function (obj, svc) {
            var vm = {
              utils: utils
            };


            pk = angular.fromJson($stateParams);

            var hasProp = false;
            if (pk != null) {
              for (var _p in pk) {
                if (pk[_p] != "" && pk[_p] != null) {
                  hasProp = true;
                  break;
                }
              }
            }

            if (!hasProp) {
              vm.action = "INCLUSÃO";
              vm.item = {};
            } else {
              vm.action = "EDIÇÃO";
              vm.loading = true;
              svc.get(pk)
                .then(function (res) {
                  vm.item = res;
                  if (obj.loaded)
                    obj.loaded();
                }, function (err) {
                  vm.cancel();
                })
                .finally(function () {
                  vm.loading = false;
                });
            }


            vm.cancel = function () {
              $rootScope.$emit('canceled');
              $state.go('^.grid')
            };

            vm.save = function () {
              vm.loading = true;
              if (!hasProp) {
                svc.post(vm.item)
                  .then(function (v) {
                    utils.ShowSuccess("Inclusão de registro", "Operação realizada com sucesso!");
                    $rootScope.$emit('saved', v);
                    $state.go('^.grid');
                  })
                  .finally(function () {
                    vm.loading = false;
                  });
              } else {
                svc.put(vm.item)
                  .then(function (v) {
                    utils.ShowSuccess("Atualização de registro", "Operação realizada com sucesso!");
                    $rootScope.$emit('saved', pk);
                    $state.go('^.grid');
                  })
                  .finally(function () {
                    vm.loading = false;
                  });
              }
            }

            obj.__proto__ = vm;

            return obj;
          },
          instantiate: function (obj) {
            var res = {
              utils: utils
            };

            obj.__proto__ = res;

            return obj;
          }
        },
        service: {

          basic: function (obj, url) {
            var logLevel = {
              ERROR: 1,
              WARNING: 2,
              DEBUG: 4,
              INFO: 8,
              LOG: 16
            };

            function log(msg, level) {
              if (level == logLevel.ERROR && (appSettings.debugLevel & logLevel.ERROR > 0)) {
                $log.error(msg);
              }
              if (level == logLevel.WARNING && (appSettings.debugLevel & logLevel.WARNING > 0)) {
                $log.warn(msg);
              }
              if (level == logLevel.DEBUG && (appSettings.debugLevel & logLevel.DEBUG > 0)) {
                $log.debug(msg);
              }
              if (level == logLevel.INFO && (appSettings.debugLevel & logLevel.INFO > 0)) {
                $log.info(msg);
              }
              if (level == logLevel.LOG && (appSettings.debugLevel & logLevel.LOG > 0)) {
                $log.log(msg);
              }
            }


            function result_success(result) {
              return result.data;
            }

            function req(service, data, config) {

              function fail(err) {

                var msg = "";

                switch (err.status) {
                  case -1:
                    msg = "Falha ao acessar o servidor. Verifique sua internet.";
                    break;
                  case 401:
                    msg = "Serviço não autorizado. Verifique se você tem permissão para acessar esse recurso.";
                    break;
                  case 404:
                    msg = "Serviço não localizado. Talvez ele esteja apenas indisponível.";
                    break;
                  default:
                    msg = "Falha na chamada do serviço.";
                    break;
                }

                if (err.status != 401) {

                  msg = (err.data && err.data.Message) ? err.data.Message : msg;
                  msg = (err.data && err.data.error_description) ? err.data.error_description : msg;
                  msg = (err.data && err.data.ExceptionMessage) ? err.data.ExceptionMessage : msg;

                  log(err.config.method + ": " + err.config.url, logLevel.INFO);
                  if( err.data && err.data.ExceptionType == 'Barn.Util.BarnWarning' )
                    utils.ShowWarning("Alerta sobre a operação", msg);
                  else
                    utils.ShowError("Erro no servidor", msg);

                  return $q.reject(err);
                } else {
                  var usr = appSettings.getUserStore();
                  if (usr) {
                    return loginSvc.RefreshToken(usr.id_estabelecimento).then(function (v) {
                        return req(service, data, config);
                      },
                      function (err) {
                        return $uibModal.open({
                          backdrop: 'static',
                          keyboard: false,
                          animation: true,
                          //templateUrl: 'view/ingresso/ingresso/template/regra.tmpl.html',
                          template: '' +
                          '<div class="middle-box text-center loginscreen  animated fadeInDown"><div>' +
                          '<p>Identifique-se para continuar.</p>' +
                          '<form class="m-t" role="form" novalidate name="frm">' +
                          '<ng-field label="Email" name="email" ng-disabled="true" model="vm.user.email" type="text" required="true"></ng-field>' +
                          '<ng-field label="Senha" name="pwd" model="vm.user.password" type="password" required="true"></ng-field>' +
                          '<button type="submit" class="btn btn-primary block full-width m-b" ng-click="vm.loginClick()"  ng-disabled="vm.loading || frm.$invalid">' +
                          '<i class="fa " ng-disabled="vm.loading" ng-class="{\'fa-sing-in\': !vm.loading,  \'fa-spinner fa-pulse\': vm.loading}" ></i> Login' +
                          '</button>' +
                          '</form>' +
                          '</div>' +
                          '</div>',
                          controller: function ($uibModalInstance) {
                            var vm = this;
                            loginSvc.Logout(true);

                            vm.user = {
                              email: usr.login
                            }

                            vm.loginClick = function () {
                              vm.loading = true;
                              loginSvc.Logon(vm.user).then(function (v) {
                                  $uibModalInstance.close();
                                  //(v.estabelecimento == null ) ?  $state.go('auth.establishment') : $state.go('site.home');
                                },
                                function (e) {
                                  var msg = "Usuário/Senha incorretos. Verifique as informações e tente novamente.";
                                  if (e.status == -1) {
                                    msg = "Falha ao acessar o serviço. Verifique sua conexão com a internet."
                                  } else if (e.data && e.data.error == "no_establishment") {
                                    msg = e.data.error_description;
                                  }

                                  toaster.pop("error", "Identificação no sistema", msg);

                                })
                                .finally(function (e) {
                                  vm.loading = false;
                                });

                            }
                          },
                          controllerAs: 'vm',
                          size: 'sm',
                          resolve: {}
                        }).result.then(function () {
                          return req(service, data, config)
                        });
                      })


                  }
                }

              }

              config = config || {};
              config.supressError = config.supressError || false;

              if(!config.headers){
                config.headers = {};
              }
              config.headers.timestamp = moment( new Date()).format();

              if (config.supressError) {
                return $http.post(appSettings.url + url + service, data, config).then(result_success);
              } else {
                return $http.post(appSettings.url + url + service, data, config).then(result_success, fail);
              }
            }


            var res = {
              utils: utils,
              request: req,
              log: log
            }


            obj.__proto__ = res;

            return obj;

          },
          instantiate: function (obj, url) {

            obj = obj || {};

            obj.cachedData = [];

            function listCached(filter) {
              return $q(function (resolve, reject) {
                $timeout(function () {
                  resolve(
                    (
                      (obj.cachedData.length == 0) ?
                        obj.list({}).then(function (r) {
                          obj.cachedData = r;
                          return ((filter) ? obj.cachedData.filter(filter) : obj.cachedData);
                        }) :
                        ((filter) ? obj.cachedData.filter(filter) : obj.cachedData)
                    )
                  );

                }, 0, true)
              });

            }


            var res = {

              get: function (pk) {
                return this.request("get", pk)
              },
              getOne: function (pk) {
                return this.request("getone", pk);
              },
              getAll: function (filter) {
                return this.request("getall", filter);
              },
              put: function (mdl) {
                return this.request("put", mdl);
              },
              post: function (mdl) {
                return this.request("post", mdl);
              },
              del: function (pk) {
                return this.request("del", pk);
              },
              toggle: function (mdl) {
                return this.request("toggle", mdl);
              },
              list: function (filter) {
                return this.request("list", filter);
              },
              listCached: listCached
            }


            obj.__proto__ = common.service.basic(res, url);


            return obj;
          }
        }
      };

      return common;


    }]);
})();

(function () {
  "use strict";

  var storeAuthName = "oAuthTICKET_1.0"; //MUDANDO ESSA VERSÃƒO, TODAS AS CONEXÃ•ES EM CACHE NO CLIENTE SERÃƒO REINICIADAS

  angular
    .module("app")
    .provider("appSettings", [
      function () {
        var languages = [];
        var settings = {
          url: "https://api.prd3.divertix.com.br/api/",
          appId: "TICKET.GERENCIADOR",
          appKey: "ea54b3dc-e31f-4921-8d1d-4b03b0f9fc8f",
          auth: "https://api.prd3.divertix.com.br/token",
          ga: "UA-97864533-4" /*'UA-97864533-3*/,
          versao: "1.1.3",
          pageSize: 30,
          debugLevel: 15, //DEBUG LEVEL: 1. ERRO, 2. WARNING, 4. DEBUG, 8. INFO
          expire: 5, //5 minutos
        };

        this.addLanguage = addLanguage;
        this.getUserStore = getUserStore;
        this.setUserStore = setUserStore;
        this.clearUserStore = clearUserStore;

        var _lastRequest = null;

        function getLastRequest() {
          return _lastRequest;
        }

        function updateLastRequest() {
          _lastRequest = new Date();
        }

        function getUserStore() {
          var $window = angular.injector(["ng"]).get("$window");
          var u = $window.sessionStorage.getItem(storeAuthName);
          return u != "" && u != null ? angular.fromJson(u) : null;
        }

        function setUserStore(v) {
          var $window = angular.injector(["ng"]).get("$window");
          return $window.sessionStorage.setItem(
            storeAuthName,
            angular.toJson(v)
          );
        }

        function clearUserStore() {
          var $window = angular.injector(["ng"]).get("$window");
          $window.sessionStorage.removeItem(storeAuthName);
        }

        function addLanguage(newLanguage) {
          languages.push(newLanguage);
        }

        // Service
        this.$get = function () {
          return {
            url: settings.url,
            appId: settings.appId,
            appKey: settings.appKey,
            auth: settings.auth,
            pageSize: settings.pageSize,
            debugLevel: settings.debugLevel,
            languages: languages,
            getUserStore: getUserStore,
            setUserStore: setUserStore,
            clearUserStore: clearUserStore,
            getLastRequest: getLastRequest,
            updateLastRequest: updateLastRequest,
            expire: settings.expire,
            ga: settings.ga,
            versao: settings.versao,
          };
        };
      },
    ])

    .provider("rolesProvider", [
      "appSettingsProvider",
      function (appSettings) {
        this.$get = [
          "$http",
          function ($http) {
            return {
              IsInRole: function (IdTela) {
                return $http
                  .post(
                    appSettings.$get().url + "controleacesso/perfil/isinrole",
                    { IdFuncionalidade: IdTela }
                  )
                  .then(function (v) {
                    //console.log(v.data);
                    return v.data;
                  });
              },
            };
          },
        ];
      },
    ])

    .constant("GuidEmpty", "00000000-0000-0000-0000-000000000000")
    .provider("menu", [
      function () {
        var menuLeft = [];
        this.left = {
          add: function (itm) {
            menuLeft.push(itm);
          },
        };
        this.$get = function () {
          return {
            menuLeft: menuLeft,
          };
        };
      },
    ])
    .factory("BearerAuthInterceptor", [
      "$q",
      "$rootScope",
      "appSettings",
      function ($q, $rootScope, appSettings) {
        var authData = appSettings.getUserStore();

        $rootScope.$on("app.logon", function (arg, v) {
          authData = v;
        });
        $rootScope.$on("app.logoff", function (arg, v) {
          authData = null;
        });

        return {
          request: function (config) {
            config.headers = config.headers || {};

            if (authData && authData.access_token)
              config.headers.Authorization = "Bearer " + authData.access_token;

            appSettings.updateLastRequest();

            return $q.when(config);
          },
        };
      },
    ])

    .config([
      "$httpProvider",
      "$provide",
      function ($httpProvider, $provide) {
        $httpProvider.interceptors.push("BearerAuthInterceptor"); //OAuth 2.0
        //$httpProvider.interceptors.push('dateInterceptor');

        $provide.decorator("uibDatepickerPopupDirective", function ($delegate) {
          var directive = $delegate[0];
          var link = directive.link;

          directive.compile = function () {
            return function (scope, element, attrs) {
              link.apply(this, arguments);
              element.mask("99/99/9999");
            };
          };
          return $delegate;
        });
      },
    ])
    .directive("menuLeft", function ($timeout, menu) {
      return {
        restrict: "E",
        templateUrl: "view/common/navigation.html",
        controller: [
          "$scope",
          "$state",
          "$rootScope",
          "$location",
          "appSettings",
          "ticketSettings",
          function (
            $scope,
            $state,
            $rootScope,
            $location,
            appSettings,
            ticketSettings
          ) {
            var vm = this;

            $rootScope.$state = $state;

            var authData = appSettings.getUserStore();
            if (authData) {
              vm.Nome = authData.apelido || authData.login;
              vm.Perfil = authData.perfil;

              if (!JSON.parse(authData.possui_layout.toLowerCase()))
                disableMenu("Layout", "Planta", menu.menuLeft);
              else enableMenu("Layout", "Planta", menu.menuLeft);
              if (!JSON.parse(authData.possui_pavimento.toLowerCase()))
                disableMenu("Zona", "Planta", menu.menuLeft);
              else enableMenu("Zona", "Planta", menu.menuLeft);
              if (!JSON.parse(authData.possui_setor.toLowerCase()))
                disableMenu("Setor", "Planta", menu.menuLeft);
              else enableMenu("Setor", "Planta", menu.menuLeft);

              vm.items = menu.menuLeft;

              vm.appSettings = ticketSettings;
            } else {
              $location.path("/login");
            }
          },
        ],
        controllerAs: "vm",
      };
    })
    .filter("trustUrl", [
      "$sce",
      function ($sce) {
        return function (recordingUrl) {
          return $sce.trustAsResourceUrl(recordingUrl);
        };
      },
    ])
    .run([
      "appSettings",
      "$rootScope",
      "$window",
      "$location",
      "$stateParams",
      "$q",
      function (appSettings, $rootScope, $window, $location, $stateParams, $q) {
        $window.ga("create", appSettings.ga, "auto");

        $rootScope.$on(
          "$stateChangeStart",
          function (event, toState, toStateParams) {
            $rootScope.toState = toState;
            $rootScope.toStateParams = toStateParams;
          }
        );

        $rootScope.$on("$stateChangeSuccess", function (event) {
          $window.ga("send", "pageview", $location.path());
        });
      },
    ]);

  function disableMenu(menuName, stateParentName, items) {
    var childs = getStateChilds(stateParentName, items);

    for (var i = 0; i < childs.length; i++) {
      if (childs[i].name === menuName) childs[i].disabled = true;
    }

    return true;
  }

  function enableMenu(menuName, stateParentName, items) {
    var childs = getStateChilds(stateParentName, items);

    for (var i = 0; i < childs.length; i++) {
      if (childs[i].name === menuName) childs[i].disabled = false;
    }

    return true;
  }

  function getStateChilds(stateName, items) {
    var childs = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].name === stateName) {
        childs = items[i].childs;
      }
    }
    return childs;
  }
})();

angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("view/main/main.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>{{main.helloText}}</h1><small>{{main.descriptionText}} <i class=\"glyphicon glyphicon-pencil\"></i></small></div></div></div></div>");
$templateCache.put("view/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("view/controller/site/home/home.tmpl.html","<div layout=\"row\" flex=\"\" layout-padding=\"\" layout-fill=\"\" layout-align=\"center center\"><div flex=\"40\" flex-lg=\"50\" flex-md=\"70\" flex-xs=\"100\"><md-card><md-toolbar class=\"padding-20\"><div flex=\"\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{::vm.triSettings.logo}}\" alt=\"{{vm.triSettings.name}}\"></div><div layout=\"row\" layout-align=\"center center\"><h1 class=\"md-headline\" translate=\"\">Home</h1></div></md-toolbar><md-content class=\"md-padding\">pagina inicial</md-content></md-card></div></div>");
$templateCache.put("view/controller/site/layouts/index.tmpl.html","<div class=\"full-image-background mb-bg-fb-05\" layout=\"row\" layout-fill=\"\"><div class=\"animate-wrapper\" flex=\"\" layout=\"row\"><div id=\"ui-login\" class=\"login-frame\" ui-view=\"\" flex=\"\" layout=\"column\"></div></div></div>");
$templateCache.put("view/conteudo/programacao/resumoProgramacao/popup/ingresso.resumo.popup.html","<div class=\"modal-header\"><h4>INCLUIR INGRESSO</h4></div><div class=\"modal-body\"><h4>Selecione os ingressos.</h4><form name=\"frm\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching || vm.LimteAlcancado\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i> &nbsp; FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input ng-enter=\"vm.search()\" type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"ibox-content\" ng-if=\"vm.items.length > 0\" style=\"max-height: 300px;overflow-y: auto;\"><div class=\"table-responsive\"><div class=\"infiniteScroll\" style=\"height: 260px; overflow: auto\"><table id=\"tbIngressos\" class=\"table table-striped table-hover\" ng-if=\"vm.items.length > 0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" infinite-scroll-container=\'\".infiniteScroll\"\'><thead><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Nome</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Percentual / Valor</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Valor editavel</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Local de Venda</th></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\" ng-click=\"vm.selected(vm.Tabelaingressos,item)\" ng-class=\"{\'colorir\': item.selected}\"><td class=\"sorting_1\">{{item.Nome}}</td><td class=\"sorting_1\" ng-if=\"item.TipoDesconto == \'F\'\">{{item.ValorRegra | currency :\'R$ \'}}</td><td class=\"sorting_1\" ng-if=\"item.TipoDesconto == \'P\'\">{{item.ValorRegra * 100}} %</td><td class=\"sorting_1\">{{item.DefineValorNaSessao == true ? \'Sim\' : \'Não\'}}</td><td>{{item.VendeRemoto && item.VendeBilheteria ? \'Todos\' : item.VendeRemoto ? \'Site\' : item.VendeBilheteria ? \'Bilheteria\' : \'Nenhum\' }}</td></tr></tbody></table></div></div></div><br><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div><br><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.items.length == 0 && !vm.LimteAlcancado && vm.click\"><strong>Nenhum ingresso encontrado.</strong></div><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.LimteAlcancado\"><strong>Só é permitido a inclusão de 30 tipos de ingressos por setor.</strong></div></form><div ng-if=\"vm.ingressosSelecionados.length > 0\"><span ng-if=\"vm.ingressosSelecionados.length == 1\" style=\"font-weight: 600\">{{vm.ingressosSelecionados.length}} ingresso selecionado</span> <span ng-if=\"vm.ingressosSelecionados.length > 1\" style=\"font-weight: 600\">{{vm.ingressosSelecionados.length}} ingressos selecionados</span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.ingressosSelecionados)\" ng-disabled=\"!vm.btnPopupIngresso || vm.LimteAlcancado\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/authentication/_content.html","<div id=\"wrapper\" class=\"top-navigation\"><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div class=\"wrapper wrapper-content\"><div ui-view=\"\"></div><div ng-include=\"\'view/common/footer.html\'\"></div></div></div></div>");
$templateCache.put("view/authentication/index.html","<div ui-view=\"\"></div><div ng-include=\"\'view/common/footer.html\'\"></div>");
$templateCache.put("view/common/401.tmpl.html","<h3>Página de teste</h3>");
$templateCache.put("view/common/404.tmpl.html","<h1>erro 404</h1>");
$templateCache.put("view/common/500.tmpl.html","<h1>erro 500</h1>");
$templateCache.put("view/common/breadcrumb.html","<div class=\"row\"><nav class=\"navbar bg-azul\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"></div><ul class=\"nav navbar-top-links navbar-left\"><li><h2 class=\"title\">{{title}}</h2></li></ul><ul class=\"nav navbar-top-links navbar-right\"><li class=\"breadcrumb-nav-item\"><h4 class=\"text-white\">{{usuario}}</h4><h5 class=\"text-white\">{{estabelecimento}}</h5></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><img src=\"../img/icons/more_vert.png\" style=\"width: 25px; height: 25px;\"><div class=\"md-ripple-container\"></div></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li ng-if=\"quantidade_estabelecimento > 1\"><a href=\"/#/establishment\">Mudar de estabelecimento</a></li><li class=\"m-t\"><a href=\"#\">Sair</a></li></ul></li></ul></nav></div>");
$templateCache.put("view/common/confirm-cancel.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{vm.itm.tit}}</h3></div><div class=\"modal-body\"><p>{{vm.itm.msg}}</p><div class=\"alert alert-warning alert-dismissible\" role=\"alert\"><strong>Para fazer a edição das sessões que não possuem vendas é necessário excluir os bloqueios!</strong></div></div><div class=\"modal-footer m-l-md\"><button class=\"btn btn-w-m btn-success pull-left\" type=\"button\" ng-click=\"vm.cancel();\">Cancelar</button> <button class=\"btn btn-w-m btn-success pull-left\" type=\"button\" ng-click=\"vm.yes();\">Sim</button> <button class=\"btn btn-outline btn-link pull-right m-r-md\" type=\"button\" ng-click=\"vm.no();\">Não</button></div>");
$templateCache.put("view/common/confirm.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{vm.itm.tit}}</h3></div><div class=\"modal-body\"><p>{{vm.itm.msg}}</p></div><div class=\"modal-footer\"><button class=\"btn btn-outline btn-link pull-right\" type=\"button\" ng-click=\"vm.no();\">Não</button> <button class=\"btn btn-w-m btn-success pull-right\" type=\"button\" ng-click=\"vm.yes();\">Sim</button></div>");
$templateCache.put("view/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'views/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'views/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'views/common/footer.html\'\"></div></div><div ng-include=\"\'views/common/right_sidebar.html\'\"></div></div>");
$templateCache.put("view/common/content_top_navigation.html","<div id=\"wrapper\" class=\"top-navigation\"><div ng-include=\"\'views/common/top_navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ui-view=\"\"></div><div ng-include=\"\'views/common/footer.html\'\"></div></div></div>");
$templateCache.put("view/common/footer.html","<div class=\"footer fixed\"><div class=\"pull-right\">Versão <strong>{{main.versao}}</strong></div><div><strong>Copyright</strong> Divertix &copy; 2017</div></div>");
$templateCache.put("view/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("view/common/ibox_tools_full_screen.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a ng-click=\"fullscreen()\"><i class=\"fa fa-expand\"></i></a> <a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"dropdown-user\" uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("view/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"></li><li ng-repeat=\"itm in vm.items\" ng-class=\"{divider: itm.type == \'divider\', active: $state.includes(itm.state)}\"><a ng-if=\"itm.type != \'divider\'\" href=\"index.html\"><i class=\"{{itm.icon}}\"></i> <span class=\"nav-label\">{{itm.name}}</span> <span class=\"fa arrow\"></span></a><ul ng-if=\"itm.childs\" class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(itm.state)}\"><li ng-repeat=\"itm2 in itm.childs\" ng-if=\"!itm2.disabled\" ui-sref-active=\"active\"><a ui-sref=\"{{itm2.state}}\">{{ itm2.name }}</a></li></ul></li></ul></div></nav>");
$templateCache.put("view/common/navigation_full_height.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\" full-scroll=\"\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><img alt=\"image\" class=\"img-circle\" src=\"img/profile_small.jpg\"> <a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">David Williams</strong></span> <span class=\"text-muted text-xs block\">Art Director <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\"><li><a ui-sref=\"profile\">Profile</a></li><li><a ui-sref=\"contacts\">Contacts</a></li><li><a ui-sref=\"inbox\">Mailbox</a></li><li class=\"divider\"></li><li><a href=\"../login.html\">Logout</a></li></ul></div><div class=\"logo-element\">IN+</div></li><li ng-class=\"{active: $state.includes(\'dashboards\')}\"><a href=\"index.html\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\">{{ \'DASHBOARD\' | translate }}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'dashboards\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_1\">{{ \'DASHBOARD\' | translate }} v.1</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_2\">{{ \'DASHBOARD\' | translate }} v.2</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_3\">{{ \'DASHBOARD\' | translate }} v.3</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_4_1\">{{ \'DASHBOARD\' | translate }} v.4</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"layouts\"><i class=\"fa fa-diamond\"></i> <span class=\"nav-label\">{{ \'LAYOUTS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'charts\')}\"><a href=\"\"><i class=\"fa fa-bar-chart-o\"></i> <span class=\"nav-label\">{{ \'GRAPHS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'charts\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"charts.flot_chart\">Flot Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.rickshaw_chart\">Rickshaw Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.chartjs_chart\">Chart.js</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.chartist_chart\">Chartist</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.peity_chart\">Peity Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.sparkline_chart\">Sparkline Charts</a></li></ul></li><li ng-class=\"{active: $state.includes(\'mailbox\')}\"><a ui-sref=\"inbox\"><i class=\"fa fa-envelope\"></i> <span class=\"nav-label\">{{ \'MAILBOX\' | translate }}</span><span class=\"label label-warning pull-right\">16/24</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'mailbox\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.inbox\">Inbox</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_view\">Email view</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_compose\">Compose email</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_template\">Email template</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"metrics\"><i class=\"fa fa-pie-chart\"></i> <span class=\"nav-label\">{{ \'METRICS\' | translate }}</span> <span class=\"label label-primary pull-right\">NEW</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"widgets\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">{{ \'WIDGETS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'forms\')}\"><a href=\"\"><i class=\"fa fa-edit\"></i> <span class=\"nav-label\">{{ \'FORMS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'forms\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"forms.basic_form\">Basic form</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.advanced_plugins\">Advanced Plugins</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.wizard.step_one\">Wizard</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.file_upload\">File Upload</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.text_editor\">Text Editor</a></li></ul></li><li ng-class=\"{active: $state.includes(\'app\')}\"><a href=\"\"><i class=\"fa fa-desktop\"></i> <span class=\"nav-label\">{{ \'APPVIEWS\' | translate }}</span> <span class=\"pull-right label label-primary\">SPECIAL</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'app\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"app.contacts\">Contacts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.profile\">Profile</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.projects\">Projects</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.project_detail\">Project detail</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.teams_board\">Teams board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.social_feed\">Social feed</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.clients\">Clients</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.file_manager\">File manager</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.calendar\">Calendar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.issue_tracker\">Issue tracker</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.blog\">Blog</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.article\">Article</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.faq\">FAQ</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.timeline\">Timeline</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pin_board\">Pin board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.invoice\">Invoice</a></li></ul></li><li ng-class=\"{active: $state.includes(\'pages\')}\"><a href=\"\"><i class=\"fa fa-files-o\"></i> <span class=\"nav-label\">{{ \'OTHERPAGES\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'pages\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"pages.search_results\">Search results</a></li><li><a ui-sref=\"lockscreen\">Lockscreen</a></li><li><a ui-sref=\"errorOne\">404 Page</a></li><li><a ui-sref=\"errorTwo\">500 Page</a></li><li><a ui-sref=\"login\">Login</a></li><li><a ui-sref=\"login_two_columns\">Login v.2</a></li><li><a ui-sref=\"forgot_password\">Forgot password</a></li><li><a ui-sref=\"register\">Register</a></li><li ui-sref-active=\"active\"><a ui-sref=\"pages.empy_page\">Empty page</a></li></ul></li><li ng-class=\"{active: $state.includes(\'miscellaneous\')}\"><a href=\"\"><i class=\"fa fa-globe\"></i> <span class=\"nav-label\">{{ \'MISCELLANEOUS\' | translate }}</span> <span class=\"label label-info pull-right\">NEW</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'miscellaneous\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.notify\">Notification</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.nestable_list\">Nestable list</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.agile_board\">Agile board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.timeline_2\">Timeline v.2</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.diff\">Diff</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.sweet_alert\">Sweet alert</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.idle_timer\">Idle timer</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.spinners\">Spinners</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.live_favicon\">Live favicon</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.google_maps\">Google maps</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.code_editor\">Code editor</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.forum_view\">Forum view</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.validation\">Validation</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.modal_window\">Modal window</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.chat_view\">Chat view</a></li></ul></li><li ng-class=\"{active: $state.includes(\'ui\')}\"><a href=\"\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">{{ \'UIELEMENTS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'ui\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"ui.typography\">Typography</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.icons\">Icons</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.draggable\">Draggable Panels</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.buttons\">Buttons</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.video\">Video</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.tabs_panels\">Panels</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.tabs\">Tabs</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.notifications_tooltips\">Notifications & Tooltips</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.badges_labels\">Badges, Labels, Progress</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"grid_options\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">{{ \'GRIDOPTIONS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'tables\')}\"><a href=\"\"><i class=\"fa fa-table\"></i> <span class=\"nav-label\">{{ \'TABLES\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'tables\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"tables.static_table\">Static Tables</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.data_tables\">Data Tables</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.foo_table\">Foo Table</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.nggrid\">NG Grid</a></li></ul></li><li ng-class=\"{active: $state.includes(\'commerce\')}\"><a href=\"#\"><i class=\"fa fa-shopping-cart\"></i> <span class=\"nav-label\">{{ \'COMMERCE\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'commerce\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"commerce.products_grid\">Products list (front)</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.product_list\">Product list (admin)</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.product\">Product edit</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.orders\">Orders</a></li></ul></li><li ng-class=\"{active: $state.includes(\'gallery\')}\"><a href=\"\"><i class=\"fa fa-picture-o\"></i> <span class=\"nav-label\">{{ \'GALLERY\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'gallery\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"gallery.basic_gallery\">Lightbox Gallery</a></li><li ui-sref-active=\"active\"><a ui-sref=\"gallery.bootstrap_carousel\">Bootstrap Carusela</a></li></ul></li><li><a href=\"\"><i class=\"fa fa-sitemap\"></i> <span class=\"nav-label\">{{ \'MENULEVELS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\"><li><a href=\"\">Third Level <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li><a href=\"\">Third Level Item</a></li><li><a href=\"\">Third Level Item</a></li><li><a href=\"\">Third Level Item</a></li></ul></li><li><a href=\"\">Second Level Item</a></li><li><a href=\"\">Second Level Item</a></li><li><a href=\"\">Second Level Item</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"css_animations\"><i class=\"fa fa-magic\"></i> <span class=\"nav-label\">{{ \'ANIMATIONS\' | translate }}</span><span class=\"label label-info pull-right\">62</span></a></li><li class=\"landing_link\"><a ui-sref=\"landing\"><i class=\"fa fa-star\"></i> <span class=\"nav-label\">{{ \'LANDING\' | translate }}</span> <span class=\"label label-warning pull-right\">NEW</span></a></li></ul></div></nav>");
$templateCache.put("view/common/navigation_off_canvas.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\" full-scroll=\"\"><span close-off-canvas=\"\"></span><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><img alt=\"image\" class=\"img-circle\" src=\"img/profile_small.jpg\"> <a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">David Williams</strong></span> <span class=\"text-muted text-xs block\">Art Director <b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\"><li><a ui-sref=\"profile\">Profile</a></li><li><a ui-sref=\"contacts\">Contacts</a></li><li><a ui-sref=\"inbox\">Mailbox</a></li><li class=\"divider\"></li><li><a href=\"../login.html\">Logout</a></li></ul></div><div class=\"logo-element\">IN+</div></li><li ng-class=\"{active: $state.includes(\'dashboards\')}\"><a href=\"index.html\"><i class=\"fa fa-th-large\"></i> <span class=\"nav-label\">{{ \'DASHBOARD\' | translate }}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'dashboards\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_1\">{{ \'DASHBOARD\' | translate }} v.1</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_2\">{{ \'DASHBOARD\' | translate }} v.2</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_3\">{{ \'DASHBOARD\' | translate }} v.3</a></li><li ui-sref-active=\"active\"><a ui-sref=\"dashboards.dashboard_4_1\">{{ \'DASHBOARD\' | translate }} v.4</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"layouts\"><i class=\"fa fa-diamond\"></i> <span class=\"nav-label\">{{ \'LAYOUTS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'charts\')}\"><a href=\"\"><i class=\"fa fa-bar-chart-o\"></i> <span class=\"nav-label\">{{ \'GRAPHS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'charts\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"charts.flot_chart\">Flot Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.rickshaw_chart\">Rickshaw Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.chartjs_chart\">Chart.js</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.chartist_chart\">Chartist</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.peity_chart\">Peity Charts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"charts.sparkline_chart\">Sparkline Charts</a></li></ul></li><li ng-class=\"{active: $state.includes(\'mailbox\')}\"><a ui-sref=\"inbox\"><i class=\"fa fa-envelope\"></i> <span class=\"nav-label\">{{ \'MAILBOX\' | translate }}</span><span class=\"label label-warning pull-right\">16/24</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'mailbox\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.inbox\">Inbox</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_view\">Email view</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_compose\">Compose email</a></li><li ui-sref-active=\"active\"><a ui-sref=\"mailbox.email_template\">Email template</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"metrics\"><i class=\"fa fa-pie-chart\"></i> <span class=\"nav-label\">{{ \'METRICS\' | translate }}</span> <span class=\"label label-primary pull-right\">NEW</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"widgets\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">{{ \'WIDGETS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'forms\')}\"><a href=\"\"><i class=\"fa fa-edit\"></i> <span class=\"nav-label\">{{ \'FORMS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'forms\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"forms.basic_form\">Basic form</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.advanced_plugins\">Advanced Plugins</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.wizard.step_one\">Wizard</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.file_upload\">File Upload</a></li><li ui-sref-active=\"active\"><a ui-sref=\"forms.text_editor\">Text Editor</a></li></ul></li><li ng-class=\"{active: $state.includes(\'app\')}\"><a href=\"\"><i class=\"fa fa-desktop\"></i> <span class=\"nav-label\">{{ \'APPVIEWS\' | translate }}</span> <span class=\"pull-right label label-primary\">SPECIAL</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'app\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"app.contacts\">Contacts</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.profile\">Profile</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.projects\">Projects</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.project_detail\">Project detail</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.teams_board\">Teams board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.social_feed\">Social feed</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.clients\">Clients</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.file_manager\">File manager</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.calendar\">Calendar</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.issue_tracker\">Issue tracker</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.blog\">Blog</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.article\">Article</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.faq\">FAQ</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.timeline\">Timeline</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.pin_board\">Pin board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.invoice\">Invoice</a></li></ul></li><li ng-class=\"{active: $state.includes(\'pages\')}\"><a href=\"\"><i class=\"fa fa-files-o\"></i> <span class=\"nav-label\">{{ \'OTHERPAGES\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'pages\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"pages.search_results\">Search results</a></li><li><a ui-sref=\"lockscreen\">Lockscreen</a></li><li><a ui-sref=\"errorOne\">404 Page</a></li><li><a ui-sref=\"errorTwo\">500 Page</a></li><li><a ui-sref=\"login\">Login</a></li><li><a ui-sref=\"login_two_columns\">Login v.2</a></li><li><a ui-sref=\"forgot_password\">Forgot password</a></li><li><a ui-sref=\"register\">Register</a></li><li ui-sref-active=\"active\"><a ui-sref=\"pages.empy_page\">Empty page</a></li></ul></li><li ng-class=\"{active: $state.includes(\'miscellaneous\')}\"><a href=\"\"><i class=\"fa fa-globe\"></i> <span class=\"nav-label\">{{ \'MISCELLANEOUS\' | translate }}</span> <span class=\"label label-info pull-right\">NEW</span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'miscellaneous\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.notify\">Notification</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.nestable_list\">Nestable list</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.agile_board\">Agile board</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.timeline_2\">Timeline v.2</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.diff\">Diff</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.sweet_alert\">Sweet alert</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.idle_timer\">Idle timer</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.spinners\">Spinners</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.live_favicon\">Live favicon</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.google_maps\">Google maps</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.code_editor\">Code editor</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.forum_view\">Forum view</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.validation\">Validation</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.modal_window\">Modal window</a></li><li ui-sref-active=\"active\"><a ui-sref=\"miscellaneous.chat_view\">Chat view</a></li></ul></li><li ng-class=\"{active: $state.includes(\'ui\')}\"><a href=\"\"><i class=\"fa fa-flask\"></i> <span class=\"nav-label\">{{ \'UIELEMENTS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'ui\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"ui.typography\">Typography</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.icons\">Icons</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.draggable\">Draggable Panels</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.buttons\">Buttons</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.video\">Video</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.tabs_panels\">Panels</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.tabs\">Tabs</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.notifications_tooltips\">Notifications & Tooltips</a></li><li ui-sref-active=\"active\"><a ui-sref=\"ui.badges_labels\">Badges, Labels, Progress</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"grid_options\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">{{ \'GRIDOPTIONS\' | translate }}</span></a></li><li ng-class=\"{active: $state.includes(\'tables\')}\"><a href=\"\"><i class=\"fa fa-table\"></i> <span class=\"nav-label\">{{ \'TABLES\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'tables\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"tables.static_table\">Static Tables</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.data_tables\">Data Tables</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.foo_table\">Foo Table</a></li><li ui-sref-active=\"active\"><a ui-sref=\"tables.nggrid\">NG Grid</a></li></ul></li><li ng-class=\"{active: $state.includes(\'commerce\')}\"><a href=\"#\"><i class=\"fa fa-shopping-cart\"></i> <span class=\"nav-label\">{{ \'COMMERCE\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'commerce\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"commerce.products_grid\">Products list (front)</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.product_list\">Product list (admin)</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.product\">Product edit</a></li><li ui-sref-active=\"active\"><a ui-sref=\"commerce.orders\">Orders</a></li></ul></li><li ng-class=\"{active: $state.includes(\'gallery\')}\"><a href=\"\"><i class=\"fa fa-picture-o\"></i> <span class=\"nav-label\">{{ \'GALLERY\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" ng-class=\"{in: $state.includes(\'gallery\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"gallery.basic_gallery\">Lightbox Gallery</a></li><li ui-sref-active=\"active\"><a ui-sref=\"gallery.bootstrap_carousel\">Bootstrap Carusela</a></li></ul></li><li><a href=\"\"><i class=\"fa fa-sitemap\"></i> <span class=\"nav-label\">{{ \'MENULEVELS\' | translate }}</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\"><li><a href=\"\">Third Level <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li><a href=\"\">Third Level Item</a></li><li><a href=\"\">Third Level Item</a></li><li><a href=\"\">Third Level Item</a></li></ul></li><li><a href=\"\">Second Level Item</a></li><li><a href=\"\">Second Level Item</a></li><li><a href=\"\">Second Level Item</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"css_animations\"><i class=\"fa fa-magic\"></i> <span class=\"nav-label\">{{ \'ANIMATIONS\' | translate }}</span><span class=\"label label-info pull-right\">62</span></a></li><li class=\"landing_link\"><a ui-sref=\"landing\"><i class=\"fa fa-star\"></i> <span class=\"nav-label\">{{ \'LANDING\' | translate }}</span> <span class=\"label label-warning pull-right\">NEW</span></a></li></ul></div></nav>");
$templateCache.put("view/common/notify.html","<div class=\"cg-notify-message inspinia-notify\" ng-class=\"$classes\"><div class=\"p-lg\"><div ng-show=\"!$messageTemplate\">{{$message}}</div><div ng-show=\"$messageTemplate\" class=\"cg-notify-message-template\"></div><button type=\"button\" class=\"cg-notify-close\" ng-click=\"$close()\"><span aria-hidden=\"true\">&times;</span> <span class=\"cg-notify-sr-only\">Close</span></button></div></div>");
$templateCache.put("view/common/right_sidebar.html","<div id=\"right-sidebar\" ng-show=\"rightSidebar\" class=\"sidebar-open\"><div class=\"sidebar-container\" full-scroll=\"\"><ul class=\"nav nav-tabs navs-3\"><li ng-class=\"{active: tab1}\"><a ng-click=\"tab1 = true; tab2 = false; tab3 = false\" ng-init=\"tab1 = true\">Notes</a></li><li ng-class=\"{active: tab2}\"><a ng-click=\"tab2 = true; tab1 = false; tab3 = false\">Projects</a></li><li ng-class=\"{active: tab3}\"><a ng-click=\"tab3 = true; tab1 = false; tab2 = false\"><i class=\"fa fa-gear\"></i></a></li></ul><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{active: tab1}\"><div class=\"sidebar-title\"><h3><i class=\"fa fa-comments-o\"></i> Latest Notes</h3><small><i class=\"fa fa-tim\"></i> You have 10 new message.</small></div><div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a1.jpg\"><div class=\"m-t-xs\"><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=\"media-body\">There are many variations of passages of Lorem Ipsum available.<br><small class=\"text-muted\">Today 4:21 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a2.jpg\"></div><div class=\"media-body\">The point of using Lorem Ipsum is that it has a more-or-less normal.<br><small class=\"text-muted\">Yesterday 2:45 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a3.jpg\"><div class=\"m-t-xs\"><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=\"media-body\">Mevolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).<br><small class=\"text-muted\">Yesterday 1:10 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a4.jpg\"></div><div class=\"media-body\">Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the<br><small class=\"text-muted\">Monday 8:37 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a8.jpg\"></div><div class=\"media-body\">All the Lorem Ipsum generators on the Internet tend to repeat.<br><small class=\"text-muted\">Today 4:21 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a7.jpg\"></div><div class=\"media-body\">Renaissance. The first line of Lorem Ipsum, \"Lorem ipsum dolor sit amet..\", comes from a line in section 1.10.32.<br><small class=\"text-muted\">Yesterday 2:45 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a3.jpg\"><div class=\"m-t-xs\"><i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i> <i class=\"fa fa-star text-warning\"></i></div></div><div class=\"media-body\">The standard chunk of Lorem Ipsum used since the 1500s is reproduced below.<br><small class=\"text-muted\">Yesterday 1:10 pm</small></div></a></div><div class=\"sidebar-message\"><a href=\"#\"><div class=\"pull-left text-center\"><img alt=\"image\" class=\"img-circle message-avatar\" src=\"img/a4.jpg\"></div><div class=\"media-body\">Uncover many web sites still in their infancy. Various versions have.<br><small class=\"text-muted\">Monday 8:37 pm</small></div></a></div></div></div><div class=\"tab-pane\" ng-class=\"{active: tab2}\"><div class=\"sidebar-title\"><h3><i class=\"fa fa-cube\"></i> Latest projects</h3><small><i class=\"fa fa-tim\"></i> You have 14 projects. 10 not completed.</small></div><ul class=\"sidebar-list\"><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Business valuation</h4>It is a long established fact that a reader will be distracted.<div class=\"small\">Completion with: 22%</div><div class=\"progress progress-mini\"><div style=\"width: 22%;\" class=\"progress-bar progress-bar-warning\"></div></div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Contract with Company</h4>Many desktop publishing packages and web page editors.<div class=\"small\">Completion with: 48%</div><div class=\"progress progress-mini\"><div style=\"width: 48%;\" class=\"progress-bar\"></div></div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Meeting</h4>By the readable content of a page when looking at its layout.<div class=\"small\">Completion with: 14%</div><div class=\"progress progress-mini\"><div style=\"width: 14%;\" class=\"progress-bar progress-bar-info\"></div></div></a></li><li><a href=\"#\"><span class=\"label label-primary pull-right\">NEW</span><h4>The generated</h4>There are many variations of passages of Lorem Ipsum available.<div class=\"small\">Completion with: 22%</div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Business valuation</h4>It is a long established fact that a reader will be distracted.<div class=\"small\">Completion with: 22%</div><div class=\"progress progress-mini\"><div style=\"width: 22%;\" class=\"progress-bar progress-bar-warning\"></div></div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Contract with Company</h4>Many desktop publishing packages and web page editors.<div class=\"small\">Completion with: 48%</div><div class=\"progress progress-mini\"><div style=\"width: 48%;\" class=\"progress-bar\"></div></div></a></li><li><a href=\"#\"><div class=\"small pull-right m-t-xs\">9 hours ago</div><h4>Meeting</h4>By the readable content of a page when looking at its layout.<div class=\"small\">Completion with: 14%</div><div class=\"progress progress-mini\"><div style=\"width: 14%;\" class=\"progress-bar progress-bar-info\"></div></div></a></li><li><a href=\"#\"><span class=\"label label-primary pull-right\">NEW</span><h4>The generated</h4>There are many variations of passages of Lorem Ipsum available.<div class=\"small\">Completion with: 22%</div><div class=\"small text-muted m-t-xs\">Project end: 4:00 pm - 12.06.2014</div></a></li></ul></div><div class=\"tab-pane\" ng-class=\"{active: tab3}\"><div class=\"sidebar-title\"><h3><i class=\"fa fa-gears\"></i> Settings</h3><small><i class=\"fa fa-tim\"></i> You have 14 projects. 10 not completed.</small></div><div class=\"setings-item\"><span>Show notifications</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example\"> <label class=\"onoffswitch-label\" for=\"example\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Disable Chat</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" checked=\"\" class=\"onoffswitch-checkbox\" id=\"example2\"> <label class=\"onoffswitch-label\" for=\"example2\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Enable history</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example3\"> <label class=\"onoffswitch-label\" for=\"example3\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Show charts</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example4\"> <label class=\"onoffswitch-label\" for=\"example4\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Offline users</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" checked=\"\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example5\"> <label class=\"onoffswitch-label\" for=\"example5\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Global search</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" checked=\"\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example6\"> <label class=\"onoffswitch-label\" for=\"example6\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"setings-item\"><span>Update everyday</span><div class=\"switch\"><div class=\"onoffswitch\"><input type=\"checkbox\" name=\"collapsemenu\" class=\"onoffswitch-checkbox\" id=\"example7\"> <label class=\"onoffswitch-label\" for=\"example7\"><span class=\"onoffswitch-inner\"></span> <span class=\"onoffswitch-switch\"></span></label></div></div></div><div class=\"sidebar-content\"><h4>Settings</h4><div class=\"small\">I belive that. Lorem Ipsum is simply dummy text of the printing and typesetting industry. And typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s. Over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</div></div></div></div></div></div>");
$templateCache.put("view/common/top_navigation.html","<div class=\"row border-bottom white-bg\"><nav class=\"navbar navbar-static-top\" role=\"navigation\"><div class=\"navbar-header\"><button aria-controls=\"navbar\" aria-expanded=\"false\" data-target=\"#navbar\" data-toggle=\"collapse\" class=\"navbar-toggle collapsed\" type=\"button\"><i class=\"fa fa-reorder\"></i></button> <a href=\"#\" class=\"navbar-brand\">Inspinia</a></div><div class=\"navbar-collapse collapse\" id=\"navbar\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ui-sref=\"layouts\" href=\"#\">Back to main Layout page</a></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">Menu item <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li></ul></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">Menu item <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li></ul></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">Menu item <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li></ul></li><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\">Menu item <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\"><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li><li><a href=\"#\">Menu item</a></li></ul></li></ul><ul class=\"nav navbar-top-links navbar-right\"><li><a href=\"login.html\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></div></nav></div>");
$templateCache.put("view/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"views/search_results.html\"><div class=\"form-group\"><input type=\"text\" placeholder=\"{{ \'SEARCH\' | translate }}\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\">Language</a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\" ng-controller=\"translateCtrl\"><li><a ng-click=\"changeLanguage(\'en\')\">English</a></li><li><a ng-click=\"changeLanguage(\'es\')\">Spanish</a></li></ul></li><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope\"></i> <span class=\"label label-warning\">16</span></a><ul class=\"dropdown-messages\" uib-dropdown-menu=\"\"><li><div class=\"dropdown-messages-box\"><a ui-sref=\"profile\" class=\"pull-left\"><img alt=\"image\" class=\"img-circle\" src=\"img/a7.jpg\"></a><div><small class=\"pull-right\">46h ago</small> <strong>Mike Loreipsum</strong> started following <strong>Monica Smith</strong>.<br><small class=\"text-muted\">3 days ago at 7:58 pm - 10.06.2014</small></div></div></li><li class=\"divider\"></li><li><div class=\"dropdown-messages-box\"><a ui-sref=\"profile\" class=\"pull-left\"><img alt=\"image\" class=\"img-circle\" src=\"img/a4.jpg\"></a><div><small class=\"pull-right text-navy\">5h ago</small> <strong>Chris Johnatan Overtunk</strong> started following <strong>Monica Smith</strong>.<br><small class=\"text-muted\">Yesterday 1:21 pm - 11.06.2014</small></div></div></li><li class=\"divider\"></li><li><div class=\"dropdown-messages-box\"><a ui-sref=\"profile\" class=\"pull-left\"><img alt=\"image\" class=\"img-circle\" src=\"img/profile.jpg\"></a><div><small class=\"pull-right\">23h ago</small> <strong>Monica Smith</strong> love <strong>Kim Smith</strong>.<br><small class=\"text-muted\">2 days ago at 2:30 am - 11.06.2014</small></div></div></li><li class=\"divider\"></li><li><div class=\"text-center link-block\"><a ui-sref=\"mailbox.inbox\"><i class=\"fa fa-envelope\"></i> <strong>Read All Messages</strong></a></div></li></ul></li><li uib-dropdown=\"\"><a class=\"count-info\" href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell\"></i> <span class=\"label label-primary\">8</span></a><ul class=\"dropdown-alerts\" uib-dropdown-menu=\"\"><li><a ui-sref=\"inbox\"><div><i class=\"fa fa-envelope fa-fw\"></i> You have 16 messages <span class=\"pull-right text-muted small\">4 minutes ago</span></div></a></li><li class=\"divider\"></li><li><a ui-sref=\"profile\"><div><i class=\"fa fa-twitter fa-fw\"></i> 3 New Followers <span class=\"pull-right text-muted small\">12 minutes ago</span></div></a></li><li class=\"divider\"></li><li><a ui-sref=\"grid_options\"><div><i class=\"fa fa-upload fa-fw\"></i> Server Rebooted <span class=\"pull-right text-muted small\">4 minutes ago</span></div></a></li><li class=\"divider\"></li><li><div class=\"text-center link-block\"><a ui-sref=\"miscellaneous.notify\"><strong>See All Alerts</strong> <i class=\"fa fa-angle-right\"></i></a></div></li></ul></li><li><a ui-sref=\"login\"><i class=\"fa fa-sign-out\"></i> Log out</a></li><li><a ng-click=\"$root.rightSidebar = !$root.rightSidebar\"><i class=\"fa fa-tasks\"></i></a></li></ul></nav></div>");
$templateCache.put("view/site/_content.html","<div id=\"wrapper\"><menu-left></menu-left><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><breadcrumb displayname-property=\"data.displayName\" abstract-proxy-property=\"data.proxy\"></breadcrumb><div ui-view=\"\"></div><div ng-include=\"\'view/common/footer.html\'\"></div></div><div ng-include=\"\'view/common/right_sidebar.html\'\"></div></div>");
$templateCache.put("view/authentication/establishment/index.html","<div class=\"ibox float-e-margins animated fadeInDown\"><div class=\"ibox-title\"><h5>Selecione o seu estabelecimento</h5><div class=\"ibox-tools\"><span class=\"label label-info-light pull-right\">{{vm.estabelecimentos.length}} Estabelecimentos</span></div></div><div class=\"ibox-content\"><div><div class=\"list-group\"><a class=\"list-group-item\" ng-repeat=\"item in vm.estabelecimentos\" ng-click=\"vm.selecionar(item)\" ng-if=\"!vm.loading\"><h4 class=\"list-group-item-heading\">{{item.NomeEstabelecimento}}</h4><p class=\"list-group-item-text\">{{item.NomeEmpresa}}</p></a> <span class=\"list-group-item\" ng-if=\"vm.loading\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i> <span class=\"sr-only\">Carregando...</span></span></div></div></div></div>");
$templateCache.put("view/authentication/forgot/forgot.html","<div class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content\"><h2 class=\"font-bold\">Esqueci minha senha</h2><p>Digite o código que aparece na imagem e entre com o seu e-mail</p><form class=\"m-t\" role=\"form\" name=\"frm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"widget-head-color-box navy-bg p-lg text-center\"><div ng-if=\"!vm.ImgCaptcha\"><i class=\"fa fa-4x\" ng-class=\"{\'fa-spinner fa-pulse\':!vm.loadingError, \'fa-chain-broken\': vm.loadingError}\"></i></div><img ng-src=\"{{vm.ImgCaptcha}}\" class=\"img-responsive\" ng-if=\"vm.ImgCaptcha\"></div><div class=\"widget-text-box\"><a class=\"btn btn-sm btn-white btn-block\" ng-click=\"vm.renderCaptcha()\" ng-disabled=\"vm.loadingCaptcha\"><i class=\"fa fa-refresh\" ng-class=\"{\'fa-spin\': vm.loadingCaptcha}\"></i> Não consigo ler a imagem</a></div></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Código\" name=\"codigo\" model=\"vm.user.Captcha\" type=\"text\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Email\" name=\"email\" model=\"vm.user.Email\" type=\"email\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary block full-width m-b\" ng-click=\"vm.resetClick()\" ng-disabled=\"vm.reseting || !frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa-sign-in\':!vm.reseting, \'fa-spinner fa-pulse\': vm.reseting}\"></i> Enviar minha senha</button></div></div></form></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Example Company</div><div class=\"col-md-6 text-right\"><small>© 2014-2015</small></div></div>");
$templateCache.put("view/authentication/forgot/reset.html","<div class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content\"><h2 class=\"font-bold\">{{vm.pageTitle}}</h2><p ng-if=\"vm.showFields\">Informe sua nova senha e redigite-a para confirmar a alteração.</p><form class=\"m-t\" role=\"form\" name=\"frm\" ng-if=\"vm.showFields\"><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Senha\" name=\"senha\" model=\"vm.user.Password\" type=\"password\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field label=\"Confirme sua senha\" name=\"confirma\" model=\"vm.user.Confirma\" type=\"password\" required=\"true\" validate-async=\"vm.ComparaSenha\" validate-async-error=\"Os campos são diferentes\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-primary block full-width m-b\" ng-click=\"vm.Change()\" ng-disabled=\"vm.loading || !frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa-sign-in\':!vm.loading, \'fa-spinner fa-pulse\': vm.loading}\"></i> Confirmar</button></div></div></form></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Example Company</div><div class=\"col-md-6 text-right\"><small>© 2014-2015</small></div></div>");
$templateCache.put("view/authentication/login/login.html","<div class=\"login-bg\"></div><div class=\"content\"><div class=\"text-center loginscreen animated rubberBand m-b-xl\"><img class=\"logo-name\" src=\"../img/logo.png\"></div><div class=\"container span7 text-center col-md-6 col-md-offset-3 col-lg-offset-3\"><div class=\"col\"><div class=\"login-box text-center loginscreen animated bounceInUp\"><div class=\"col-xs-12 col-sm-12 col-md-12 m-t\"><h3 class=\"title-text\"><span translate=\"\">Bem vindo ao</span> Divertix</h3><h4 class=\"title-text\">Identifique-se para continuar</h4><form class=\"m-t\" role=\"form\" novalidate=\"\" name=\"frm\"><div class=\"row\"><div class=\"col-xs-4\"><label for=\"email\">Email <span class=\"text-danger\">*</span></label></div></div><div class=\"row m-b\"><div class=\"col-md-12\"><input type=\"email\" class=\"text-input-md\" name=\"email\" id=\"email\" ng-model=\"vm.user.email\" ng-required=\"true\"></div></div><div class=\"row\"><div class=\"col-xs-4\"><label for=\"password\">Senha <span class=\"text-danger\">*</span></label></div></div><div class=\"row m-b-md\"><div class=\"col-md-12\"><input type=\"password\" class=\"text-input-md\" name=\"password\" id=\"password\" ng-model=\"vm.user.password\" ng-required=\"true\"></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 m-b-md\"><a href=\"#/forgot\" class=\"forgotpass-text\">Esqueci minha senha</a></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><button type=\"submit\" class=\"btn-login\" ng-click=\"vm.loginClick()\" ng-disabled=\"vm.loading || frm.$invalid\">Entrar</button></div></form></div></div></div></div></div>");
$templateCache.put("view/authentication/profile/profile.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Profile</div>{{vm.user }}<div class=\"panel-body\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Nome\" label=\"Apelido\" model=\"vm.item.Apelido\" type=\"text\" maxlength=\"40\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Login\" label=\"Email\" model=\"vm.item.Login\" type=\"email\" maxlength=\"120\" required=\"\" ng-disabled=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"DataNascimento\" label=\"Data Nascimento\" model=\"vm.item.DataNascimento\" type=\"date\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"Telefone\" label=\"Telefone\" model=\"vm.item.Telefone\" type=\"text\" mask=\"(99)99999-999?9\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Ramal\" label=\"Ramal\" model=\"vm.item.Ramal\" type=\"text\" mask=\"?9?9?9?9?9?9\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Perfil\" label=\"Perfil\" model=\"vm.item.Perfil\" type=\"text\" ng-disabled=\"true\"></ng-field></div></div></form></div><div class=\"panel-footer pull-right\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel();\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\">Salvar</button></div></div>");
$templateCache.put("view/conteudo/atracao/form.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Edição</div><div class=\"panel-body\"><p>Preencha os dados do formulário</p><form name=\"frm\"><div class=\"row\"><div class=\"col-md-12\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\"></ng-field></div></div></form></div><div class=\"panel-footer pull-right\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel();\" \"=\"\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> Salvar</button></div></div>");
$templateCache.put("view/conteudo/atracao/form_wizard.html","<style>\n    .wizard > .content {\n        background: white !important;\n    }\n</style><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"steps clearfix\"><ul><li ui-sref-active=\"current\"><button ui-sref=\".ficha_tecnica\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"vm.loading\"><span>1</span> Ficha Técnica</button></li><li ui-sref-active=\"current\"><button ui-sref=\".participantes\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"AtracaoForm.$invalid || vm.participantesload || !vm.ValidaGenero || vm.loading\"><span>2</span> Participantes <i class=\"fa pull-right\" ng-class=\"{\'\' : !vm.participantesload, \'fa-spinner fa-pulse\' : vm.participantesload}\"></i></button></li><li ui-sref-active=\"current\"><button ui-sref=\".sinopse\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"AtracaoForm.$invalid || !vm.ValidaGenero || vm.loading\"><span>3</span> Sinopse</button></li><li ui-sref-active=\"current\"><button ui-sref=\".midia\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"AtracaoForm.$invalid || !vm.ValidaGenero\"><span>4</span> Mídia</button></li></ul></div><div class=\"hr-line-dashed\" style=\"margin-bottom:10px;\"></div><div class=\"wizard\"><div class=\"content\"><form name=\"AtracaoForm\" class=\"p-lg\"><div id=\"form-views\" ui-view=\"\"></div></form></div></div><div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/atracao/grid.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right m-b-lg\" ng-click=\"vm.novaAtracao()\">NOVA ATRAÇÃO</button><form name=\"frm\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-8\"><div class=\"input-group\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"col-md-2\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button></div><div class=\"col-md-2\"><div class=\"pull-right m-t-sm\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.Filter.Status\" ng-true-value=\"1\" ng-false-value=\"2\" style=\"text-align: right\"><strong class=\"m-l-sm\">&nbsp;EXIBIR ATIVOS</strong></div></div></div></div><br><div class=\"ibox-content\" ng-if=\"vm.CountAtracao == 0\"><div class=\"alinhar-centro\"><div class=\"col-md-8 m-t-md\"><p class=\"text-center\"><i class=\"fa fa-commenting\" aria-hidden=\"true\" style=\"font-size:3em;\"></i></p><p class=\"text-center\">Você ainda não possui atrações a serem exibidas.<br>Que tal criar ou associar novas atrações agora?</p><p class=\"text-center\"><button class=\"btn btn-link\" ng-click=\"vm.novaAtracao()\">NOVA ATRAÇÃO</button></p></div></div></div><div class=\"ibox-content\" ng-if=\"vm.NotResult && vm.CountAtracao > 0\"><div class=\"alinhar-centro\"><div class=\"col-md-8 m-t-md\"><p class=\"text-center\"><i class=\"fa fa-commenting\" aria-hidden=\"true\" style=\"font-size:3em;\"></i></p><p class=\"text-center\">Ops! Sua pesquisa não encontrou resultados.<br>Que tal pesquisar em atrações inativas ou criar uma nova atração?</p><p class=\"text-center\"><button class=\"btn btn-link\" ng-click=\"vm.novaAtracao()\">NOVA ATRAÇÃO</button> <button class=\"btn btn-link\" ng-click=\"vm.search(); vm.Filter.Status = 2\">PESQUISAR EM INATIVOS</button></p></div></div></div><div class=\"ibox-content\" ng-if=\"vm.items && vm.items.length > 0\"><div class=\"table-responsive constrained\"><table class=\"table table-hover table-striped\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\"><thead><tr><th width=\"300\">Atração</th><th>Diretores</th><th>Autores</th><th>Ano</th><th>Tipo</th><th>Data de criação</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.items\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeAtracao}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.Diretores}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.Autores}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.AnoLancamento}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeTipoAtracao}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.DataCriacao | date: \'dd/MM/yyyy\' : \'UTC\'}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.editarAtracao(itm);\"><i class=\"fa fa-edit\"></i> Editar atração</a> <a role=\"button\" ng-click=\"vm.editarInformacoesExclusivas(itm);\"><i class=\"fa fa-edit\"></i> Editar informações exclusivas</a> <a role=\"button\" ng-click=\"vm.customToggle(itm);\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar atração\' : \'Habilitar atração\'}}</a> <a role=\"button\" ng-if=\"!itm.ExistiuSessao\" ng-click=\"vm.desassociar(itm);\"><i class=\"fa fa-toggle-off\"></i> Desassociar atração</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/conteudo/atracao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/atracao/informacoesexclusivas.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"NomeIngresso\" label=\"Nome ingresso\" model=\"vm.item.NomeImpressao\" type=\"text\" required=\"true\" maxlength=\"60\"></ng-field></div><div class=\"col-md-4\"><ng-field name=\"DataEstreia\" label=\"Data da estréia\" model=\"vm.item.DataEstreia\" type=\"date\"></ng-field></div><div class=\"col-md-2\"><br><br><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.Status\" ng-true-value=\"1\" ng-false-value=\"2\" class=\"m-t-md\"><strong class=\"m-l-md\">&nbsp;STATUS ATIVO</strong></div></div><div class=\"row\"><div class=\"col-md-12\"><ng-field name=\"DescricaoAuxiliar\" label=\"Descrição auxiliar\" model=\"vm.item.DescricaoAuxiliar\" type=\"text\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"NotasCompra\" label=\"Notas antes compra\" model=\"vm.item.NotasCompra\" type=\"textarea\" rows=\"3\" maxlength=\"500\"></ng-field></div><div class=\"col-md-6\"><ng-field name=\"NotasImpressao\" label=\"Notas impressas\" model=\"vm.item.NotasImpressao\" type=\"textarea\" rows=\"3\" maxlength=\"100\"></ng-field></div></div><br></form><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\">SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel();\">CANCELAR</button></p><br></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/atracao/pre_cadastro.html","<style>\n  h3 {\n    text-transform: uppercase;\n  }\n\n  .table {\n    border-bottom: 0px !important;\n  }\n\n  .table th,\n  .table td {\n    border: 1px !important;\n  }\n\n  .fixed-table-container {\n    border: 0px !important;\n  }\n\n  table tr {\n    height: 5px !important;\n  }\n\n  .associado {\n    background-color: #ebebeb !important;\n  }\n\n.panel-min-height {\n  min-height: 120px;\n}\n\ndiv.panel.panel-default.ng-scope  p {\n  margin: 0;\n}\n\n.card {\n  height: 230px;\n  margin-bottom: 40px;\n}\n\n.responsive {\n  max-width: 90px;\n  border-radius: 4px;\n}\n</style><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"panel panel-default panel-min-height\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12 m-b-md\"><div class=\"col-md-1 m-t-sm\"><img src=\"../img/icons/ico-star-atracao.png\"></div><div class=\"col-md-11\"><h4>Veja se a atração já existe na divertix.com.br</h4><h5>Use os filtros abaixo para facilitar sua busca</h5></div></div></div><div class=\"row\" ng-if=\"vm.tiposAtracao.length > 1\"><div class=\"col-md-12\"><label class=\"radio-inline\" ng-repeat=\"item in vm.tiposAtracao\"><input icheck=\"\" type=\"radio\" name=\"optradio\" ng-model=\"vm.Filter.TipoAtracao\" ng-change=\"vm.NomeCriacao(item.IdTipoAtracao)\" value=\"{{item.IdTipoAtracao}}\"> <label>{{item.NomeTipoAtracao}}</label></label></div></div><br><div class=\"row\"><div class=\"col-sm-8 col-md-8 m-b-md\"><div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\"><div class=\"glyphicon glyphicon-search\"></div></span> <input type=\"text\" class=\"form-control\" placeholder=\"Pesquisar\" ng-model=\"vm.Filter.Nome\" aria-describedby=\"basic-addon1\"></div></div><div class=\"col-md-4\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa-spinner fa-pulse fa-fw\' : vm.searching}\"></i> VERIFICAR NA DIVERTIX</button></div></div></div></div></div><div class=\"row\" ng-if=\"vm.items.length >= 0\"><div class=\"col-md-6\"><div class=\"contact-box\" style=\"background-color:#F3F3F4; border:none\"><div ng-if=\"vm.items.length == 0\">Nenhuma atração encontrada</div><div ng-if=\"vm.items.length == 1\">1 atração escontrada</div><div ng-if=\"vm.items.length > 1\">{{vm.items.length}} atrações escontradas</div></div></div><div class=\"col-md-6\"><div class=\"panel panel-default\"><div class=\"panel-body bg-success\"><span class=\"glyphicon glyphicon-plus-sign pull-left\" style=\"font-size:40px\"></span> <button type=\"button\" ng-click=\"vm.NovaAtracao()\" class=\"btn btn-success pull-right\">CRIAR {{ vm.TipoAtracao.NomeExibicao}}</button></div></div></div></div><div class=\"row\"><div class=\"col\"><div class=\"col-lg-4 col-md-6 card\" ng-repeat=\"itm in vm.items\"><div class=\"panel panel-default\" ng-class=\"itm.Associada ? \'associado\': \'\'\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-10 col-sm-10 col-xs-7\"><div class=\"row\"><div class=\"col-md-12\"><h3>{{itm.NomeAtracao}}</h3></div><div class=\"panel panel-default\" ng-class=\"itm.Associada ? \'associado\': \'\'\" style=\"border:none\" ng-if=\"itm.IdTipoAtracao == 2 || itm.IdTipoAtracao == 3\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\" style=\"\">Produtor</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Produtor}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Autor</div><div class=\"col-md-10\"><p read-more=\"\" limit=\"10\" content=\"{{itm.Autores}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Atores</div><div class=\"col-md-10\"><p read-more=\"\" limit=\"10\" content=\"{{itm.Elenco}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Ano</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Ano}}\"></p></div></div></div></div><div class=\"panel panel-default\" ng-class=\"itm.Associada ? \'associado\': \'\'\" style=\"border:none\" ng-if=\"itm.IdTipoAtracao == 1\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\" style=\"\">Produtor</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Produtor}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Autor</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Autores}}\"></p></div></div><div class=\"row\"><div class=\"col-md-2\">Atores</div><div class=\"col-md-10\"><p read-more=\"\" content=\"{{itm.Elenco}}\"></p></div></div></div></div></div></div><div class=\"col-md-2 col-sm-2 col-xs-5\"><img ng-if=\"itm.FotoCapa != null\" class=\"responsive pull-right\" ng-src=\"{{itm.FotoCapa}}\" fallback-src=\"../img/foto-capa-no-image.png\"> <img ng-if=\"itm.FotoCapa == null\" class=\"responsive pull-right\" src=\"../img/foto-capa-no-image.png\"></div></div></div><div class=\"panel-footer\" style=\"border:none;min-height:50px;background:white\" ng-class=\"itm.Associada ? \'associado\': \'\'\"><div class=\"row top\"><div class=\"col-md-6\"><div class=\"pull-left\" style=\"color:#337ab7\" ng-if=\"itm.Associada == true\">JÁ ASSOCIADA</div><div class=\"pull-left\" ng-if=\"itm.Associada == false\"><a ng-click=\"vm.associarDesassociar(itm)\"><strong>ASSOCIAR</strong></a></div></div><div class=\"col-md-6\"><div ng-if=\"itm.Associada\"><a class=\"pull-right btn\" ng-class=\"{ \'btn-primary btn-outline btn-sm\': itm.Status == 2, \'btn-danger btn-outline btn-sm\': itm.Status == 1 }\" ng-click=\"vm.customToggle(itm)\">{{(itm.Status == 1)? \'Inativar\' : \'Ativar\'}}</a>&nbsp;</div></div></div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/genero/form.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Edição</div><div class=\"panel-body\"><p>Preencha os dados do formulário</p><form name=\"frm\"><div class=\"row\"><div class=\"col-md-12\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\"></ng-field></div></div></form></div><div class=\"panel-footer pull-right\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel();\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading}\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading}\"></i> Salvar</button></div></div>");
$templateCache.put("view/conteudo/genero/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content animated fadeInUp\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Listagem de gêneros</h5><div class=\"ibox-tools\"><a class=\"btn btn-primary btn-xs\" ng-click=\"vm.add();\"><i class=\"fa fa-plus\"></i> Criar novo gênero</a></div></div><div class=\"ibox-content\"><div class=\"row m-b-sm m-t-sm\"><div class=\"col-md-12\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Pesquisar\" class=\"input-sm form-control\" ng-model=\"vm.Filter.Nome\" ng-model-options=\"{ debounce: { \'default\': vm.debounce } }\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i></button></span></div></div></div><div class=\"project-list\"><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.items && vm.items.length == 0\"><strong>Nenhum registro encontrado</strong> Verifique os filtros informados ou se você possui acesso a essas informações.</div><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" class=\"table table-hover\" ng-if=\"vm.items && vm.items.length > 0\"><thead><tr><th>Nome</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.Nome}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(itm);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(itm);\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-click=\"vm.toggle(itm);\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar\' : \'Habilitar\'}}</a></li></ul></span></td></tr><tr class=\"gradeA odd showIfLast ng-scope\" ng-show=\"vm.searching\"><td colspan=\"9\" class=\"ng-binding\">Carregando dados...<svg-loading></svg-loading></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/genero/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/programacao/form.html","<style>\n    .wizard > .content {\n        background: white !important;\n    }\n     .step_visited{\n       background-color: #94bed8;\n       color: white;\n     }\n</style><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-content wizard\"><div class=\"steps clearfix\"><ul><li ui-sref-active=\"current\"><button ui-sref=\".identificacao\" ng-click=\"vm.Identificacao()\" style=\"width:90%!important;text-align:left\" class=\"btn-default text-bold\" ng-disabled=\"!vm.ValidaAtracao || !vm.ValidaSala || !vm.ValidaLayout\" ng-class=\"{\'step_visited\': vm.clickIdentificacao, \'\': !vm.clickIdentificacao}\"><span>1</span> Identificação</button></li><li ui-sref-active=\"current\"><button ui-sref=\".data-horario\" ng-click=\"vm.DataHora()\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"(vm.tabelaDataHorario == 0) && !vm.ValidaAtracao || !vm.ValidaSala || !vm.ValidaLayout\" ng-class=\"{\'step_visited\': vm.clickDataHora, \'\': !vm.clickDataHora}\"><span>2</span> Data e horário</button></li><li ui-sref-active=\"current\"><button ui-sref=\".valores-ingresso\" ng-click=\"vm.ValorIngresso()\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"SessaoForm.$invalid || !vm.ValidaAtracao || !vm.ValidaSala || !vm.ValidaLayout || vm.tabelaDataHorario == 0\" ng-class=\"{\'step_visited\': vm.clickValorIngresso, \'\': !vm.clickValorIngresso}\"><span>3</span> Valores de Ingresso</button></li><li ui-sref-active=\"current\"><button ui-sref=\".detalhes\" ng-click=\"vm.Detalhes()\" style=\"width:90%!important;text-align:left\" class=\"btn-default\" ng-disabled=\"SessaoForm.$invalid || !vm.ValidaAtracao || !vm.ValidaSala || !vm.ValidaLayout || vm.tabelaDataHorario == 0 || !vm.HasIngresso || vm.HasIngresso == null || vm.LotesInvalido != null || vm.QtdIngressosLotesMaior\" ng-class=\"{\'step_visited\': vm.clickDetalhes, \'\': !vm.clickDetalhes}\"><span>4</span> Detalhes</button></li></ul></div><div class=\"hr-line-dashed\" style=\"margin-bottom:10px;\"></div><div class=\"wizard\"><div class=\"content\"><form name=\"SessaoForm\" class=\"p-lg\"><div id=\"form-views\" ui-view=\"\"></div></form></div></div><div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/programacao/grid.html","<style>\n  .btn-success-custom {\n    background-color: #27AE60;\n    border-color: #27AE60;\n    color: #FFFFFF;\n  }\n\n  .btn-success-custom:hover {\n    color: #fff;\n    background-color: #29a05d;\n    border-color: #29a05d;\n  }\n\n  .btn-success-custom:focus\n  {\n    color: #fff;\n    background-color: #29a05d;\n    border-color: #29a05d;\n  }\n\n  .btn-success-custom:visited\n  {\n    color: #fff;\n    background-color: #29a05d;\n    border-color: #29a05d;\n  }\n\n  .btn-success-custom:active{\n    color: #fff;\n    background-color: #29a05d;\n    border-color: #29a05d;\n  }\n\n\n  .filtro{\n    padding-right: 8px;\n    vertical-align:36%;\n  }\n\n  .icone{\n    padding: 5px\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.add();\" ng-disabled=\"vm.loadBordero\">NOVA PROGRAMAÇÃO</button><br><br><br><form name=\"frm\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col col-xs-4 col-sm-4 col-md-4 col-lg-2\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"Data Início\" model=\"vm.Filter.DataPeriodoInicio\" type=\"date\"></ng-field></div><div class=\"col col-xs-4 col-sm-4 col-md-4 col-lg-2\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"Data Fim\" model=\"vm.Filter.DataPeriodoFim\" type=\"date\"></ng-field></div><div class=\"col col-xs-4 col-sm-4 col-md-4 col-lg-3\"><ng-field name=\"Nome\" label=\"Atrações\" model=\"vm.Filter.IdAtracao\" type=\"select\" options=\"vm.atracoes\" value-field=\"IdAtracao\"></ng-field></div></div><div class=\"row\"><div class=\"col col-xs-4 col-sm-4 col-md-4 col-lg-2\"><input ng-enter=\"vm.search()\" ng-change=\"vm.changeNaoLiberada()\" icheck=\"\" type=\"checkbox\" ng-model=\"vm.Filter.VendaLiberada\"> <strong class=\"m-l-sm\">NÃO LIBERADAS</strong></div><div class=\"col col-xs-4 col-sm-4 col-md-4 col-lg-2\" \"=\"\"><input ng-enter=\"vm.search()\" ng-change=\"vm.changeEncerrada()\" icheck=\"\" type=\"checkbox\" ng-model=\"vm.Filter.Encerrada\"> <strong class=\"m-l-sm\">ENCERRADA</strong></div><div class=\"col\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right m-r-md\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching || vm.loadBordero\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button></div></div><br><div class=\"ibox-content\"><div class=\"row m-b-xs\"><div class=\"col-sm-12\"><button type=\"button\" id=\"btv\" style=\"text-align: inherit;\" class=\"btn btn-xs pull-right m-r-sm btn-success-custom\" data-dismiss=\"modal\" ng-click=\"vm.LiberarOnlineBilheteria();\" ng-disabled=\"vm.loadBordero\"><i class=\"material-icons icone\" style=\"font-size: 22px\">done_all</i> <span class=\"filtro\">Liberar Online e Bilheteria</span></button> <button type=\"button\" style=\"text-align: inherit;\" class=\"btn btn-xs pull-right m-r-sm btn-info\" data-dismiss=\"modal\" ng-click=\"vm.LiberarOnline();\" ng-disabled=\"vm.loadBordero\"><i class=\"material-icons icone\" style=\"font-size: 22px; color:white\">done</i> <span class=\"filtro\" style=\"color: white;\">Liberar Somente Online</span></button> <button type=\"button\" style=\"text-align: inherit;\" class=\"btn btn-xs btn-warning pull-right m-r-sm\" data-dismiss=\"modal\" ng-click=\"vm.LiberarBilheteria();\" ng-disabled=\"vm.loadBordero\"><i class=\"material-icons icone\" style=\"font-size: 22px\">done</i> <span class=\"filtro\">Liberar Somente Bilheteria</span></button> <button type=\"button\" style=\"text-align: inherit;\" class=\"btn btn-xs btn-danger pull-right m-r-sm\" data-dismiss=\"modal\" ng-click=\"vm.SuspenderVenda();\" ng-disabled=\"vm.loadBordero\"><i class=\"material-icons icone\" style=\"font-size: 22px\">highlight_off</i> <span class=\"filtro\">Suspender Vendas</span></button></div></div><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para buscar programações\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" role=\"grid\" data-sorting=\"true\"><thead><tr role=\"row\"><th class=\"sorting\" rowspan=\"2\" colspan=\"1\" style=\"width: 10px;\"><input type=\"checkbox\" ng-change=\"vm.selectAll();\" icheck=\"\" ng-model=\"vm.SelectAll\"></th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\" ts-criteria=\"DataHoraInicio\">Dia/Mês</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"DataHoraInicio\">Horário</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\" ts-criteria=\"NomeAtracao|lowercase\">Atração</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"NomeSala|lowercase\">Sala</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 250px;\" ts-criteria=\"VendaLiberada\">Status da Sessão</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"center\"><input ng-click=\"vm.SetSelected(itm)\" type=\"checkbox\" icheck=\"\" ng-model=\"itm.Selected\" ng-disabled=\"itm.PossuiBordero || itm.Status == 2\"></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.DataHoraInicio | date : \'dd/MM\'}}{{\' (\' + itm.DiaSemana + \')\'}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.DataHoraInicio | momentParseZone : date : \'HH:mm\'}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeAtracao}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeSala}}</span></td><td class=\"project-title\" style=\"font-weight:600\"><span style=\"color:red\" ng-if=\"!itm.PossuiBordero && itm.Status == 1 && !itm.VendaLiberada\">Não Liberada</span> <span style=\"color:green\" ng-if=\"!itm.PossuiBordero && itm.Status == 1 && itm.VendaLiberada && itm.VendaBilheteria && itm.VendeRemoto\">Liberada Online e Bilheteria</span> <span style=\"color:darkorange\" ng-if=\"!itm.PossuiBordero && itm.Status == 1 && itm.VendaLiberada && itm.VendaBilheteria && !itm.VendeRemoto\">Liberada Somente Bilheteria</span> <span style=\"color:#61baf4\" ng-if=\"!itm.PossuiBordero && itm.Status == 1 && itm.VendaLiberada && !itm.VendaBilheteria && itm.VendeRemoto\">Liberada Somente Online</span> <span style=\"color:darkgray\" ng-if=\"itm.PossuiBordero\">Encerrada</span> <span style=\"color:darkgray\" ng-if=\"!itm.PossuiBordero && itm.Status != 1\">Desabilitada</span></td><td class=\"project-actions\"><div ng-if=\"$index + 1 == vm.items.length || $index + 2 == vm.items.length\" class=\"dropup\"><a role=\"button\" data-toggle=\"dropdown\"><i class=\"fa fa-wrench\"></i></a><ul class=\"dropdown-menu pull-right\"><li><a role=\"button\" ng-show=\"!vm.loadBordero\" ng-click=\"vm.resumoProgramacao(itm);\"><i class=\"fa fa-file-text\"></i> Resumo da Programação</a> <a role=\"button\" ng-show=\"vm.loadBordero\" style=\"color: lightgrey;\"><i class=\"fa fa-file-text\" style=\"color: lightgrey;\"></i> Resumo da Programação</a> <a role=\"button\" ng-show=\"!itm.ExistiuVenda && !vm.loadBordero\" ng-click=\"vm.editarProgramacao(itm);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-show=\"itm.ExistiuVenda || vm.loadBordero\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar</a> <a role=\"button\" ng-show=\"!itm.ExistiuVenda && !vm.loadBordero\" ng-click=\"vm.del(itm);\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-show=\"itm.ExistiuVenda || vm.loadBordero\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Excluir</a> <a role=\"button\" ng-show=\"!itm.ExistiuVenda && !vm.loadBordero\" ng-click=\"vm.toggle(itm);\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar\' : \'Habilitar\'}}</a> <a role=\"button\" ng-show=\"itm.ExistiuVenda || vm.loadBordero\" style=\"color: lightgrey;\"><i style=\"color: lightgrey;\" class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar\' : \'Habilitar\'}}</a> <a role=\"button\" ng-show=\"!itm.PossuiBordero && !vm.loadBordero && itm.VendaLiberada\" ng-click=\"vm.GerarBordero(itm)\"><i class=\"fa fa-clipboard\"></i> Gerar Borderô</a> <a role=\"button\" ng-show=\"itm.PossuiBordero || vm.loadBordero || !itm.VendaLiberada\" style=\"color: lightgrey;\"><i class=\"fa fa-clipboard\" style=\"color: lightgrey;\"></i> Gerar Borderô</a></li></ul></div><span ng-if=\"$index + 2 < vm.items.length\" uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-disabled=\"vm.loadBordero\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\"><li><a role=\"button\" ng-show=\"!vm.loadBordero\" ng-click=\"vm.resumoProgramacao(itm);\"><i class=\"fa fa-file-text\"></i> Resumo da Programação</a> <a role=\"button\" ng-show=\"vm.loadBordero\" style=\"color: lightgrey;\"><i class=\"fa fa-file-text\" style=\"color: lightgrey;\"></i> Resumo da Programação</a> <a role=\"button\" ng-show=\"!itm.ExistiuVenda && !vm.loadBordero\" ng-click=\"vm.editarProgramacao(itm);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-show=\"itm.ExistiuVenda || vm.loadBordero\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar</a> <a role=\"button\" ng-show=\"!itm.ExistiuVenda && !vm.loadBordero\" ng-click=\"vm.del(itm);\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-show=\"itm.ExistiuVenda || vm.loadBordero\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Excluir</a> <a role=\"button\" ng-show=\"!itm.ExistiuVenda && !vm.loadBordero\" ng-click=\"vm.toggle(itm);\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar\' : \'Habilitar\'}}</a> <a role=\"button\" ng-show=\"itm.ExistiuVenda || vm.loadBordero\" style=\"color: lightgrey;\"><i style=\"color: lightgrey;\" class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar\' : \'Habilitar\'}}</a> <a role=\"button\" ng-show=\"!itm.PossuiBordero && !vm.loadBordero && itm.VendaLiberada\" ng-click=\"vm.GerarBordero(itm)\"><i class=\"fa fa-clipboard\"></i> Gerar Borderô</a> <a role=\"button\" ng-show=\"itm.PossuiBordero || vm.loadBordero || !itm.VendaLiberada\" style=\"color: lightgrey;\"><i class=\"fa fa-clipboard\" style=\"color: lightgrey;\"></i> Gerar Borderô</a></li></ul></span> <span ng-if=\"itm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-2x fa-fw\' : itm.searching}\"></i></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/conteudo/programacao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/conteudo/tabelaprecopadrao/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-7\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\" tooltip=\"Nome que será apresentado para montar as sessões.\"></ng-field></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-3\"><ng-field name=\"ValorBase\" label=\"Valor base\" model=\"vm.item.ValorBase\" type=\"money\" required=\"true\" maxlength=\"11\" tooltip=\"Valor usado para gerar o cálculo do valor Ingresso.\"></ng-field></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-2\"><br><br><div class=\"pull-right\"><label><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.Status\"> INATIVO</label></div></div></div><br><a href=\"#\"><a class=\"btn btn-xs btn-w-m btn-success pull-right\" ng-click=\"vm.open()\">INCLUIR INGRESSO</a></a><br><br><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 710px;\">Nome</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Tipo do desconto</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Valor da regra</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Valor do Ingresso</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"tr in vm.Table | filter: vm.myfilter\"><td class=\"sorting_1\">{{tr.Nome}}</td><td class=\"sorting_1\">{{tr.TipoDesconto == \'P\' ? \'Percentual\' : \'Fixo\'}}</td><td class=\"sorting_1\" ng-if=\"tr.TipoDesconto == \'F\'\">{{tr.ValorRegra | currency :\'R$ \'}}</td><td class=\"sorting_1\" ng-if=\"tr.TipoDesconto == \'P\'\">{{tr.ValorRegra * 100}} %</td><td class=\"center\">{{tr.Valor | currency :\'R$ \'}}</td><td class=\"center\"><div class=\"ibox-tools\"><a role=\"button\" ng-click=\"vm.ExcluirItem(tr);\"><i class=\"fa fa-trash\"></i></a></div></td></tr></tbody></table></div><br><div class=\"row\"><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Save();\" ng-disabled=\"(!frm.$valid) || (vm.Table.length == 0) || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.OpenGrid();\">CANCELAR</button></p><br></div></div></div></div></div></form></div></div>");
$templateCache.put("view/conteudo/tabelaprecopadrao/grid.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><a href=\"#\"><a class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.add();\">NOVA TABELA DE PREÇO</a></a><br><br><br><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search();\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Nome\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.searching || vm.complete\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 710px;\">Nome</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Valor base</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Status</th><th class=\"sorting center\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 30px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"sorting_1\">{{item.Nome}}</td><td class=\"sorting_1\">{{item.ValorBase | currency:\"R$ \"}}</td><td class=\"center\">{{item.Status == 1 ? \'Ativo\' : \'Inativo\'}}</td><td class=\"center\" width=\"30\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/tabelaprecopadrao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/dadosbancarios/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><ng-field name=\"alias\" label=\"Alias\" model=\"vm.item.Alias\" type=\"text\" required=\"true\" maxlength=\"25\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><ng-field name=\"razaosocial\" label=\"Razão social\" model=\"vm.item.RazaoSocial\" type=\"text\" maxlength=\"100\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><ng-field name=\"cnpj\" label=\"Cnpj\" model=\"vm.item.Cnpj\" type=\"text\" required=\"true\" maxlength=\"14\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-6\"><ng-field name=\"inscricaomunicipal\" label=\"Incrição Municipal\" model=\"vm.item.InscricaoMunicipal\" type=\"text\" maxlength=\"15\"></ng-field></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><ng-field name=\"banco\" label=\"Banco\" model=\"vm.item.IdBanco\" type=\"select\" required=\"true\" options=\"vm.bancoList\" value-field=\"IdBanco\" text-field=\"Nome\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><ng-field name=\"agencia\" label=\"Agencia\" model=\"vm.item.Agencia\" type=\"text\" required=\"true\" maxlength=\"20\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-3\"><ng-field name=\"conta\" label=\"Conta\" model=\"vm.item.Conta\" type=\"text\" required=\"true\" maxlength=\"20\"></ng-field></div></div><div class=\"row\"><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"(!frm.$valid) || (vm.Table.length == 0) || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel();\">CANCELAR</button></p></div></div></div></div></div></form></div></div>");
$templateCache.put("view/estabelecimento/dadosbancarios/grid.html","<div id=\"wrapper\" class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content animated fadeInUp\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success pull-right\">ADICIONAR DADOS BANCÁRIOS</button><br><br><br><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 150px;\">Nome</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Empresa</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Razão social</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 100px;\">Banco</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 100px;\">Agência/Conta</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"sorting_1\">{{item.Alias}}</td><td>{{item.Empresa}}</td><td>{{item.RazaoSocial}}</td><td>{{item.Banco}}</td><td>{{item.Agencia}} / {{item.Conta}}</td><td class=\"center\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr><tr class=\"gradeA odd showIfLast ng-scope\" ng-show=\"vm.searching\"><td colspan=\"9\" class=\"ng-binding\">Carregando dados...<svg-loading></svg-loading></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/dadosbancarios/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/estabelecimentoconfiguracao/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\" novalidate=\"\"><div class=\"row\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"inline\"><ng-field name=\"EncerramentoVendaMinutoAposInicioSessao\" label=\"Encerramento de vendas\" model=\"vm.item.EncerramentoVendaMinutoAposInicioSessao\" type=\"number\" maxlength=\"3\" tooltip=\"Encerramento de vendas\"></ng-field></div></div><div class=\"col-md-2\"><br><br><span>minutos após início da sessão</span></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"inline\"><ng-field name=\"EncerramentoVendaMinutoAntesRemoto\" label=\"Encerramento de vendas remotas\" model=\"vm.item.EncerramentoVendaMinutoAntesRemoto\" type=\"number\" maxlength=\"3\" tooltip=\"Encerramento de vendas remotas\"></ng-field></div></div><div class=\"col-md-2\"><br><br><span>minutos antes do início da sessão</span></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"inline\"><ng-field name=\"CancelaReservaMinutoAntes\" label=\"Cancelamento de reservas podem ser efetuadas até\" model=\"vm.item.CancelaReservaMinutoAntes\" type=\"number\" maxlength=\"3\"></ng-field></div></div><div class=\"col-md-2\"><br><br><span>minutos antes início da sessão</span></div><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"inline\"><ng-field name=\"HoraAberturaMinutoAntes\" label=\"Horário de abertura dos portões antes do evento\" model=\"vm.item.HoraAberturaMinutoAntes\" type=\"number\" maxlength=\"3\" tooltip=\"Horário de abertura dos portões antes do evento\"></ng-field></div></div><div class=\"col-md-2\"><br><br><span>minutos antes do início da sessão</span></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-6 col-md-6\"><ng-field name=\"NotasCompra\" label=\"Notas antes da compra\" model=\"vm.item.NotasCompra\" type=\"textarea\" rows=\"3\" maxlength=\"500\" tooltip=\"O que será exibido como alerta para o usuário\"></ng-field></div><div class=\"col-sm-6 col-md-6\"><ng-field name=\"NotasImpressao\" label=\"Notas Impressas\" model=\"vm.item.NotasImpressao\" type=\"textarea\" rows=\"3\" maxlength=\"100\"></ng-field></div></div><div class=\"row\"><div class=\"col-sm-6 col-md-6\"><ng-field name=\"InformacoesSobreLocal\" label=\"Informações Sobre o Local\" model=\"vm.item.InformacoesSobreLocal\" type=\"textarea\" rows=\"3\" maxlength=\"500\"></ng-field></div></div></form><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Salvar();\" ng-disabled=\"vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.Cancelar();\">CANCELAR</button></p><br></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/estabelecimentoconfiguracao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/estacao/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div ng-if=\"vm.item.IdEstabelecimentoEstacao==null\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><ng-field name=\"codigo\" label=\"Código de ativação\" model=\"vm.item.CodigoAtivacao\" type=\"text\" required=\"true\" maxlength=\"10\"></ng-field></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><ng-field name=\"codigo\" label=\"Nome Estação\" model=\"vm.item.NomeEstacao\" type=\"text\" required=\"true\" maxlength=\"10\"></ng-field></div></div><div ng-if=\"vm.item.IdEstabelecimentoEstacao!=null\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-4\"><ng-field name=\"codigo\" label=\"Nome da estação\" model=\"vm.item.NomeEstacao\" type=\"text\" required=\"true\" maxlength=\"10\"></ng-field></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-4\"><ng-field name=\"TipoImpressoa\" label=\"Tipo impressao\" model=\"vm.item.ImpressoraIngresso\" options=\"vm.lstTiposImpressao\" type=\"select\" value-field=\"value\" required=\"true\"></ng-field></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-4\"><ng-field name=\"TipoImpressora\" label=\"Tipo impressora\" model=\"vm.item.ImpressoraModelo\" options=\"vm.lstTiposImpressora\" type=\"select\" value-field=\"value\"></ng-field></div></div></div><div class=\"row\"><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"(!frm.$valid) || (vm.Table.length == 0) || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel();\">CANCELAR</button></p></div></div></div></div></div></form></div></div>");
$templateCache.put("view/estabelecimento/estacao/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">NOVA ESTAÇÃO PDV</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Descricao\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar as estações\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" role=\"grid\"><thead><tr role=\"row\"><th style=\"width: 310px;\">Código Instalação</th><th style=\"width: 210px;\">Nome estação</th><th style=\"width: 210px;\">Impressora Ingresso</th><th style=\"width: 200px;\">Impressora Modelo</th><th style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"sorting_1\">{{item.RegistroEstacao}}</td><td class=\"sorting_1\">{{item.NomeEstacao}}</td><td ng-switch=\"item.ImpressoraIngresso\"><text ng-switch-when=\"U\">USB</text><text ng-switch-when=\"T\">Térmica(Contingência)</text><text ng-switch-when=\"P\">Paralela</text><text ng-switch-when=\"S\">Serial</text></td>text<td class=\"sorting_1\">{{item.ImpressoraModelo}}</td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/estacao/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/estrutura/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\" novalidate=\"\"><div class=\"row\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"inline\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.PossuiLayout\" class=\"i-checks\" ng-true-value=\"true\" ng-false-value=\"false\"> <strong class=\"m-l-md\">Possui Layout</strong></label></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"inline\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.PossuiSetor\"> <strong class=\"m-l-md\">Possui Setor</strong></label></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"inline\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.PossuiZona\"> <strong class=\"m-l-md\">Possui Zona</strong></label></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-4 col-md-4 col-lg-4\"><div class=\"inline\"><label><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.FluxoAtracao\" class=\"i-checks\" ng-true-value=\"\'R\'\" ng-false-value=\"\'C\'\"> <strong class=\"m-l-md\">Fluxo de venda resumido</strong></label></div></div></div></form><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Salvar();\" ng-disabled=\"vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading}\"></i> SALVAR</button></p><br></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/estrutura/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/formapagamentotaxa/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12 col-lg-12\"><ng-field label=\"Forma de pagamento\" required=\"true\" type=\"select\" model=\"vm.item.IdFormaPagamento\" options=\"vm.formaPagamentoList\" value-field=\"IdFormaPagamento\" text-field=\"NomeFormaPagamento\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><ng-field label=\"Data Inicio\" required=\"true\" min-date=\"vm.minDate\" type=\"date\" model=\"vm.item.DataInicio\"></ng-field></div><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-4\"><ng-field name=\"TaxaVista\" label=\"Taxa à vista\" model=\"vm.item.TaxaVista\" type=\"number|3\" required=\"true\"></ng-field></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-4\"><ng-field name=\"TaxaParcelada\" type=\"number|3\" label=\"Taxa Parcelada\" model=\"vm.item.TaxaParcelada\" required=\"true\"></ng-field></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"(!frm.$valid) || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel();\">CANCELAR</button></p><br></div></div></form></div></div>");
$templateCache.put("view/estabelecimento/formapagamentotaxa/grid.html","<div id=\"wrapper\" class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content animated fadeInUp\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success pull-right\">ADICIONAR</button><br><br><br><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 100px;\">Forma de pagamento</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 100px;\">Taxa à vista</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 110px;\">Taxa parcelada</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Data Inicio</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\"><td class=\"project-title\"><span>{{itm.FormaPagamento}}</span></td><td class=\"project-title\"><span>{{itm.TaxaVista}}</span></td><td class=\"project-title\"><span>{{itm.TaxaParcelada}}</span></td><td class=\"project-title\"><span>{{itm.DataInicio | date : \'dd/MM/yyyy\'}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a ng-show=\"itm.PodeEditar\" role=\"button\" ng-click=\"vm.edit(itm);\"><i class=\"fa fa-edit\"></i> Editar</a> <a ng-show=\"!itm.PodeEditar\" style=\"color: lightgrey;\" role=\"button\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar</a> <a ng-show=\"itm.PodeEditar\" role=\"button\" ng-click=\"vm.del(itm);\"><i class=\"fa fa-trash\"></i> Excluir</a> <a ng-show=\"!itm.PodeEditar\" style=\"color: lightgrey;\" role=\"button\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/formapagamentotaxa/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/ingresso/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div><div class=\"col-md-3\"><br><br><div class=\"input-group\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.VendeRemoto\" class=\"i-checks\"> <strong class=\"m-l-md\">&nbsp;&nbsp;VENDE NO DIVERTIX.COM.BR</strong></div></div><div class=\"col-md-3\"><br><br><div class=\"input-group\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.VendeBilheteria\" class=\"i-checks\" ng-true-value=\"true\" ng-false-value=\"false\"> <strong class=\"m-l-md\">&nbsp;&nbsp;VENDE NA BILHETERIA</strong></div></div></div><div class=\"hr-line-dashed\"></div><label>Regra de Validação</label><div class=\"form-group bg-regra\" ng-if=\"vm.RegraSelecionada == null\"><div class=\"input-group m-b\">&nbsp; &nbsp;<i class=\"fa fa-search\" aria-hidden=\"true\"></i> <button class=\"btn btn-link\" data-toggle=\"modal\" data-target=\".bd-example-modal-lg\" ng-click=\"vm.open()\">SELECIONAR REGRA</button> <span class=\"help-block m-l-sm\">É obrigatório escolher uma regra</span></div></div><div ng-if=\"vm.RegraSelecionada != null\"><br><div class=\"row\"><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><label>Nome</label></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-5\"><label>Descrição da regra</label></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-2\"><label>Exige documento</label></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-2\"><label>Tipo de Desconto</label></div></div><div class=\"form-group bg-regra space\"><div class=\"row\"><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\">{{vm.RegraSelecionada.Nome}}</div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-5\">{{vm.RegraSelecionada.Descricao}}</div>{{vm.CorExigeDoc}}<div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-2\"><span style=\"{{vm.RegraSelecionada.ValidaDocumento ? \'color:green\' : \'color:red\'}}\">{{vm.RegraSelecionada.ValidaDocumento ? \'SIM\' : \'NÃO\'}}</span></div><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-1\"><span style=\"{{vm.RegraSelecionada.TipoDesconto == \'P\' ? \'color:mediumblue\' : \'color:#FF7F50\'}}\">{{vm.RegraSelecionada.TipoDesconto == \'P\' ? \'PERCENTUAL\' : \'FIXO\'}}</span></div><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><button class=\"btn btn-link\" ng-click=\"vm.open(vm.RegraSelecionada)\"><i class=\"fa fa-wrench pull-right\" aria-hidden=\"true\"></i></button></div></div></div></div><div class=\"row\"><div class=\"col-sm-4 col-md-3 col-lg-4\"><ng-field name=\"ValorRegra\" label=\"Valor do desconto\" type=\"text\" ng-if=\"!vm.RegraSelecionada\" uib-popover=\"Escolha uma regra\" popover-trigger=\"mouseenter\" popover-placement=\"top-left\" ng-disabled=\"true\"></ng-field><ng-field name=\"ValorRegra\" label=\"Valor do desconto Percentual\" model=\"vm.item.ValorRegra\" ng-disabled=\"vm.descDisabled\" type=\"percentual|2\" maxlength=\"8\" ng-if=\"vm.RegraSelecionada.TipoDesconto == \'P\'\" required=\"true\"></ng-field><ng-field name=\"ValorRegra\" label=\"Valor do desconto Fixo\" model=\"vm.item.ValorRegra\" type=\"money\" ng-disabled=\"vm.descDisabled\" ng-if=\"vm.RegraSelecionada.TipoDesconto == \'F\' && vm.RegraSelecionada.IdRegraIngresso != 8\" required=\"true\"></ng-field><ng-field name=\"ValorRegra\" label=\"Valor do preço fixo\" model=\"vm.item.ValorRegra\" type=\"money\" ng-disabled=\"vm.descDisabled\" ng-if=\"vm.RegraSelecionada.IdRegraIngresso == 8\" required=\"true\"></ng-field></div><div class=\"col-sm-3 col-md-2\"><label><br></label><div class=\"input-group\"><button type=\"button\" class=\"btn btn-w-m btn-success\" disabled=\"\">SIMULAR VALOR</button></div></div><div class=\"col-sm-5 col-md-6 pull-right\" ng-if=\"vm.RegraSelecionada.ValidaDocumento && !vm.searchValidaIngresso\"><ng-field name=\"IdTipoValidacaoDocumento\" model=\"vm.item.IdTipoValidacaoDocumento\" label=\"Documento\" type=\"select\" options=\"vm.tipovalidacaodocumento\" value-field=\"IdTipoValidacaoDocumento\" required=\"true\"></ng-field></div><div class=\"col-sm-5 col-md-6 pull-right\" ng-if=\"vm.searchValidaIngresso\"><br><br><i class=\"fa\" ng-class=\"{\'fa-spinner fa-pulse\' : vm.searchValidaIngresso}\"></i> Carregando...</div></div><div class=\"row\"><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.msgRegraIngresso\"><strong>{{vm.msgRegraIngresso}}</strong></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-4 col-md-4\"><ng-field name=\"Mensagem\" label=\"Tipo Informativo Ingresso\" model=\"vm.item.IdTipoInformativoIngresso\" type=\"select\" required=\"true\" options=\"vm.lstTipoInformativo\" value-field=\"IdTipoInformativoIngresso\"></ng-field></div><div class=\"col-sm-4 col-md-4\" ng-if=\"vm.item.IdTipoInformativoIngresso == 0 || vm.item.IdTipoInformativoIngresso == undefined\"><ng-field name=\"Mensagem\" label=\"Mensagem Site\" model=\"vm.item.Mensagem\" type=\"text\" maxlength=\"200\"></ng-field></div><div class=\"col-sm-4 col-md-4\" ng-if=\"vm.item.IdTipoInformativoIngresso >= 1\"><ng-field name=\"Mensagem\" label=\"Mensagem Site\" model=\"vm.item.Mensagem\" type=\"text\" required=\"true\" maxlength=\"200\"></ng-field></div><div class=\"col-sm-4 col-md-4\"><ng-field name=\"MensagemAbreviada\" label=\"Mensagem PDV\" model=\"vm.item.MensagemAbreviada\" type=\"text\" maxlength=\"15\"></ng-field></div></div><br></form><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save(vm.RegraSelecionada);\" ng-disabled=\"!frm.$valid || vm.RegraSelecionada == null || vm.searchValidaIngresso || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.OpenGrid()\">CANCELAR</button></p><br></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/ingresso/grid.html","<div id=\"wrapper\" class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content animated fadeInUp\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success pull-right\">NOVO INGRESSO</button><br><br><br><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.searching || vm.complete\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Nome</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Valor Desconto</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 520px;\">Regras</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 520px;\">Vende</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Exige Documento</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Status</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"sorting_1\">{{item.Nome}}</td><td ng-if=\"item.TipoDesconto == \'P\'\">{{item.ValorRegra * 100}}%</td><td ng-if=\"item.TipoDesconto == \'F\'\">{{item.ValorRegra | currency: \'R$ \'}}</td><td>{{item.Regra}}</td><td>{{item.VendeRemoto && item.VendeBilheteria ? \'Todos\' : item.VendeRemoto ? \'Site\' : item.VendeBilheteria ? \'Bilheteria\' : \'Nenhum\' }}</td><td class=\"center\">{{item.ValidaDocumento ? \'SIM\' : \'NÃO\'}}</td><td class=\"center\">{{item.Status == 1 ? \'Ativo\' : \'Inativo\'}}</td><td class=\"center\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a ng-show=\"!item.ModeradoSite\" role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a ng-show=\"item.ModeradoSite\" role=\"button\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar</a> <a ng-show=\"!item.ModeradoSite\" role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a> <a ng-show=\"item.ModeradoSite\" role=\"button\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/ingresso/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/tipo-bloqueio/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-10\"><ng-field name=\"rotulo\" label=\"Rótulo\" model=\"vm.item.Rotulo\" type=\"text\" required=\"true\" maxlength=\"2\"></ng-field></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-2\"><br><br><div class=\"pull-right\"><label><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.Status\"> <strong class=\"m-l-md\">ATIVO</strong></label></div></div></div><ng-field label=\"Descrição\" type=\"textarea\" model=\"vm.item.Descricao\" rows=\"10\" maxlength=\"100\"></ng-field><div class=\"form-group form-group-sm\"><h4 class=\"text-bold text-left ng-binding\">Cor</h4><ngjs-color-picker selected-color=\"vm.CorSel\" custom-colors=\"vm.colors\" options=\"vm.options\"></ngjs-color-picker><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"(!frm.$valid) || (vm.Table.length == 0) || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel();\">CANCELAR</button></p><br></div></div></div></div></div></form></div></div>");
$templateCache.put("view/estabelecimento/tipo-bloqueio/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">NOVO TIPO DE BLOQUEIO</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os tipos de bloqueio\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Rotulo|lowercase\" class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Rótulo</th><th ts-criteria=\"Descricao|lowercase\" class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Descricao</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\" ts-repeat=\"\"><td class=\"sorting_1\">{{item.Rotulo}}</td><td class=\"sorting_1\">{{item.Descricao}}</td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/tipo-bloqueio/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/usuario/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Nome\" label=\"Apelido\" model=\"vm.item.Apelido\" type=\"text\" maxlength=\"40\" required=\"true\" minlength=\"3\"></ng-field></div><div class=\"col-md-6\" ng-if=\"vm.item.Id == null\"><ng-field name=\"Login\" label=\"Email\" model=\"vm.item.Login\" type=\"text\" maxlength=\"120\" required=\"true\" ng-disabled=\"vm.item.Id != null\" validate-async=\"vm.checkLogin\"></ng-field></div><div class=\"col-md-6\" ng-if=\"vm.item.Id != null\"><h4 class=\"text-bold text-left ng-binding\">Email</h4><input class=\"form-group-sm form-control\" style=\"width: 100%; height: 29px;\" type=\"text\" value=\"{{vm.item.Login}}\" ng-disabled=\"true\"><br></div></div><div class=\"row\"><div class=\"col-md-2\"><ng-field name=\"DataNascimento\" label=\"Data de Nascimento\" maxlength=\"8\" model=\"vm.item.DataNascimento\" type=\"date\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Telefone\" label=\"Telefone\" maxlength=\"15\" model=\"vm.item.Telefone\" type=\"phone\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Ramal\" label=\"Ramal\" model=\"vm.item.Ramal\" type=\"number\" maxlength=\"6\"></ng-field></div><div class=\"col-md-6\"><ng-field name=\"IdPerfil\" label=\"Perfil\" model=\"vm.item.IdPerfil\" type=\"select\" options=\"vm.lstPerfil\" value-field=\"IdPerfil\" required=\"true\" validate-submit=\"frm.$submitted\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group form-group-sm\"><h3 class=\"text-bold text-left ng-binding\">Estabelecimentos</h3><div class=\"bg-info\" style=\"padding: 1em;\">{{vm.exibirEstabelecimentos(vm.item)}}</div></div></div></div><div class=\"form-group\"><p><button ng-disabled=\"frm.$invalid || vm.loading\" type=\"submit\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"frm.$valid ? vm.save() : frm.$setSubmitted();\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fx\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel();\">CANCELAR</button></p><br></div></form></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/usuario/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.add()\">NOVO USUÁRIO</button><br><br><br><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Login\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os usuários\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"Login|lowercase\">Login</th><th ts-criteria=\"Apelido|lowercase\">Apelido</th><th ts-criteria=\"NomePerfil|lowercase\">Perfil</th><th>Estabelecimentos</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.Login}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.Apelido}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomePerfil}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\" data-toggle=\"tooltip\" title=\"{{itm.Estabelecimentos}}\">{{itm.QtdEstabelecimentos == 1 ? itm.Estabelecimentos : itm.QtdEstabelecimentos.toString() + \" Estabelecimentos\"}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(itm);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(itm);\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-click=\"vm.reenviarEmail(itm);\"><i class=\"fa fa-edit\"></i> Reenviar email</a> <a role=\"button\" ng-click=\"vm.toggle(itm);\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar\' : \'Habilitar\'}}</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/estabelecimento/usuario/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/estabelecimento/usuario/profile.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Profile</div>{{vm.user }}<div class=\"panel-body\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Nome\" label=\"Apelido\" model=\"vm.item.Apelido\" type=\"text\" maxlength=\"40\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Login\" label=\"Email\" model=\"vm.item.Login\" type=\"email\" maxlength=\"120\" required=\"\" ng-disabled=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"DataNascimento\" label=\"Data Nascimento\" model=\"vm.item.DataNascimento\" type=\"date\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"Telefone\" label=\"Telefone\" model=\"vm.item.Telefone\" type=\"text\" mask=\"(99)99999-999?9\"></ng-field></div><div class=\"col-md-2\"><ng-field name=\"Ramal\" label=\"Ramal\" model=\"vm.item.Ramal\" type=\"text\" mask=\"?9?9?9?9?9?9\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Perfil\" label=\"Perfil\" model=\"vm.item.Perfil\" type=\"text\" ng-disabled=\"true\"></ng-field></div></div></form></div><div class=\"panel-footer pull-right\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel();\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\">Salvar</button></div></div>");
$templateCache.put("view/fluxo-caixa/estabelecimentofechamentodia/form-relatorio.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe class=\"iframe-responsivo\" ng-style=\"vm.style\" ng-src=\"{{vm.pdfUrl}}\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row\"><div class=\"col pull-right\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a style=\"margin-right: 20px;\" ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/fluxo-caixa/estabelecimentofechamentodia/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox float-e-margins\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"row\"><div class=\"col-lg-6\"><button ng-disabled=\"vm.loading\" ng-class=\"dia.selecionado == true ? \'btn-warning\' :\'btn-success\'\" class=\"btn btn-lg m-r-md\" ng-repeat=\"dia in vm.diasAbertos | orderBy : \'DataContabil\'\" ng-click=\"vm.SelecionaDia(dia)\"><i class=\"fa fa-calendar\"></i>&nbsp; <span ng-if=\"!dia.flagHoje\">{{dia.DataContabil | date: \'dd/MM/yyyy\' : \'UTC\'}}</span> <span ng-if=\"dia.flagHoje\">HOJE</span> <i class=\"fa fa-check fa-fw\" ng-if=\"dia.selecionado\"></i> <i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : dia.loading}\"></i></button></div></div></div><div class=\"font-bold alert alert-warning alert-dismissable\" ng-if=\"vm.hasMenor\" ng-hide=\"vm.closed\" ng-click=\"(vm.closed = true)\"><button aria-hidden=\"true\" data-dismiss=\"alert\" class=\"close\" type=\"button\">×</button> É obrigatório fechar o dia anterior.</div><div class=\"font-bold alert alert-warning alert-dismissable\" ng-if=\"vm.hasCaixaAberto && vm.diaSelected\" ng-hide=\"vm.closed\" ng-click=\"(vm.closed = true)\"><button aria-hidden=\"true\" data-dismiss=\"alert\" class=\"close\" type=\"button\">×</button> Para fechar o dia é necessário fechar todos os caixas.</div><div class=\"font-bold alert alert-warning alert-dismissable\" ng-if=\"vm.hasBorderoAberto && !vm.hasMenor && !vm.hasCaixaAberto && vm.diaSelected\" ng-hide=\"vm.closed\" ng-click=\"(vm.closed = true)\"><button aria-hidden=\"true\" data-dismiss=\"alert\" class=\"close\" type=\"button\">×</button> Para fechar o dia é necessário gerar os Borderôs.</div><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Caixas</h5></div><div class=\"ibox-content\" ng-if=\"!vm.loadingCaixa\"><div class=\"feed-activity-list\"><div ng-if=\"vm.caixas.length == 0\"><ul class=\"todo-list m-t\"><li><small class=\"m-r-xs\">Não foram abertos nenhum caixa</small></li></ul></div><div class=\"feed-element\" ng-repeat=\"item in vm.caixas | orderBy : \'-DataHoraAbertura\'\"><div class=\"media-body\"><small class=\"text-muted pull-right\">Aberto em {{item.DataHoraAbertura | date : \'dd/MM/yyyy HH:mm\'}}</small> <strong>{{item.NomeEstacao}}</strong><br><small class=\"badge m-t-lg\" ng-class=\"item.StatusCaixa == \'Aberto\' ? \'badge-primary\' :\'badge-danger\'\">{{item.StatusCaixa}}</small><br><small class=\"text-muted pull-right\" ng-show=\"item.StatusCaixa == \'Fechado\'\">Fechado em {{item.DataHoraFechamento | date : \'dd/MM/yyyy HH:mm\'}}</small> <small class=\"text-muted pull-right\" ng-show=\"item.StatusCaixa == \'Aberto\'\">{{item.Apelido}}</small></div></div></div></div><div class=\"ibox-content\" ng-if=\"vm.loadingCaixa\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div></div></div><div class=\"col-lg-6\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Borderôs</h5></div><div class=\"ibox-content\" ng-if=\"!vm.loadingBordero\"><ul class=\"todo-list m-t\"><li ng-repeat=\"itm in vm.borderos | orderBy : \'StatusBordero\'\" class=\"m-b-xs text-danger\"><small class=\"m-r-xs\">{{itm.Nome}} - Dia {{itm.DataHoraInicio | date : \'dd/MM\'}} ÀS {{itm.DataHoraInicio | date : \'HH:mm\'}}</small> <small class=\"badge\" ng-class=\"itm.StatusBordero == \'Aberto\' ? \'badge-primary\' :\'badge-danger\'\">{{itm.StatusBordero}}</small></li><li ng-if=\"vm.borderos.length == 0\"><small class=\"m-r-xs\">Nenhum borderô para o dia</small></li></ul></div><div class=\"ibox-content\" ng-if=\"vm.loadingBordero\"><div class=\"spiner-example\"><div class=\"sk-spinner sk-spinner-wave\"><div class=\"sk-rect1\"></div><div class=\"sk-rect2\"></div><div class=\"sk-rect3\"></div><div class=\"sk-rect4\"></div><div class=\"sk-rect5\"></div></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.FecharDia();\" ng-disabled=\"vm.hasCaixaAberto || vm.hasBorderoAberto || vm.hasMenor || !vm.diaSelected || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.loading}\"></i> FECHAR DIA SELECIONADO</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.openGrid()\">CANCELAR</button></p></div></div></div></div></div>");
$templateCache.put("view/fluxo-caixa/estabelecimentofechamentodia/grid.html","<div id=\"wrapper\" class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success pull-right\">NOVO FECHAMENTO</button><br><br><br><form name=\"frm\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><h3>Período</h3></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-2\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataPeriodoInicio\" type=\"date\"></ng-field></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-2\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataPeriodoFim\" type=\"date\"></ng-field></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-2 pull-right\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching || vm.loadBordero\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button></div></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para exibir mais informações\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" role=\"grid\" data-sorting=\"true\"><thead><tr role=\"row\"><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 100px;\" ts-criteria=\"DataContabil\" ts-default=\"descending\">Data Contábil</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"DataHoraFechamento\">Data Fechamento</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"DataHoraFechamento\">Qtd. Ingr. Vendidos</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"DataHoraFechamento\">Qtd. Ing. Devolvidos</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"DataHoraFechamento\">Qtd. Ing. Remididos</th></tr></thead><tbody><tr class=\"gradeA odd\" ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{itm.DataContabil | date : \'dd/MM/yyyy\'}}</span></td><td class=\"project-title\"><span>{{itm.DataHoraFechamentoDia | date : \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{itm.QtdIngressoVendidos}}</span></td><td class=\"project-title\"><span>{{itm.QtdIngressoDevolvidos}}</span></td><td class=\"project-title\"><span>{{itm.QtdIngressoReemitidos}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-if=\"!itm.searching\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.resumoFechamentoDia(itm)\"><i class=\"fa fa-clipboard\"></i> Resumo Fechamento Dia</a></li></ul></span> <span ng-if=\"itm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-2x fa-fw\' : itm.searching}\"></i></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/fluxo-caixa/estabelecimentofechamentodia/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/fluxo-caixa/fechamentocaixa/form-relatorio.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe class=\"iframe-responsivo\" ng-style=\"vm.style\" ng-src=\"{{vm.pdfUrl}}\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row\"><div class=\"col pull-right\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a style=\"margin-right: 20px;\" ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/fluxo-caixa/fechamentocaixa/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"ibox-title\"><h5>Fechamento de caixa</h5><span class=\"label label-warning\">{{vm.items.length}} Estações</span><div class=\"ibox-tools pull-right\" ng-if=\"!vm.LiberadoFechamento\"></div></div><br><div class=\"row\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.searching || vm.complete\" infinite-scroll-immediate-check=\"true\" infinite-scroll-distance=\"0\"><form name=\"frm\"><div class=\"col-lg-6\" role=\"grid\" ng-repeat=\"item in vm.items | orderBy :\'-DataHoraAbertura\'\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"feed-activity-list\"><div class=\"feed-element\" style=\"height: 109px;\"><div class=\"media-body\" style=\"height: 105px;\"><div class=\"pull-right\"><small class=\"text-muted pull-right\">Aberto em {{item.DataHoraAbertura | date : \'dd/MM/yyyy HH:mm:ss\'}}</small></div><strong class=\"m-b-5\">{{item.NomeEstacao}}</strong><br><br><small class=\"badge m-t-5\" ng-class=\"item.StatusCaixa == \'Aberto\' ? \'badge-danger\' :\'badge-primary\'\" style=\"margin-top: 45px;\">{{item.StatusCaixa}}</small><div class=\"pull-right\"><small class=\"text-muted pull-right\" ng-show=\"item.StatusCaixa == \'Fechado\'\" style=\"margin-top: 50px;\">Fechado em {{item.DataHoraFechamento | date : \'dd/MM/yyyy HH:mm:ss\'}}</small> <small class=\"text-muted pull-right\" ng-show=\"item.StatusCaixa == \'Aberto\'\">{{item.Apelido}}</small><div class=\"pull-right\" style=\"margin-top: 30px;\"><button type=\"button\" ng-click=\"vm.fecharCaixa(item)\" ng-hide=\"item.StatusCaixa == \'Fechado\'\" class=\"btn btn-success\" ng-disabled=\"item.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : item.loading}\"></i> Fechar Caixa</button></div></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></form></div></div>");
$templateCache.put("view/fluxo-caixa/fechamentocaixa/grid.html","<div id=\"wrapper\" class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><h3>Período</h3></div><div class=\"col-xs-3 col-sm-4 col-md-3 col-lg-2\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataPeriodoInicio\" type=\"date\"></ng-field></div><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-2\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"\" model=\"vm.Filter.DataPeriodoFim\" type=\"date\"></ng-field></div></div><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching || vm.loadBordero\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" ng-model=\"vm.Filter.Texto\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para exibir mais informações\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" role=\"grid\" data-sorting=\"true\"><thead><tr role=\"row\"><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\" ts-criteria=\"DataContabil\" ts-default=\"descending\">Data Contábil</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 200px;\" ts-criteria=\"NomeEstacao|lowercase\">Nome Estação</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"NomeEstacao|lowercase\">Bilheteiro</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\" ts-criteria=\"DataHoraFechamento\">Data Fechamento</th><th class=\"sorting\" rowspan=\"1\" colspan=\"1\" style=\"width: 100px;\" ts-criteria=\"StatusCaixa\">Status</th><th class=\"sorting\" rowspan=\"1\" style=\"width: 30px;\" colspan=\"1\"></th></tr></thead><tbody><tr class=\"gradeA odd\" ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{itm.DataContabil | date : \'dd/MM/yyyy\'}}</span></td><td class=\"project-title\"><span>{{itm.NomeEstacao}}</span></td><td class=\"project-title\"><span>{{itm.Apelido}}</span></td><td class=\"project-title\"><span>{{itm.DataHoraFechamento | date : \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span class=\"badge m-t-5\" ng-class=\"itm.StatusCaixa == \'Aberto\' ? \'badge-primary\' : \'badge-danger\'\">{{itm.StatusCaixa}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-if=\"!itm.searching\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a ng-if=\"itm.StatusCaixa != \'Aberto\'\" role=\"button\" ng-click=\"vm.resumoFechamento(itm)\"><i class=\"fa fa-clipboard\"></i> Resumo Fechamento</a> <a ng-if=\"itm.StatusCaixa == \'Aberto\'\" role=\"button\" style=\"color: lightgrey;\"><i class=\"fa fa-clipboard\" style=\"color: lightgrey;\"></i> Resumo Fechamento</a> <a ng-if=\"itm.StatusCaixa == \'Aberto\'\" role=\"button\" ng-click=\"vm.fecharCaixa(itm)\"><i class=\"fa fa-bar-chart\"></i> Fechar o Caixa</a></li></ul></span> <span ng-if=\"itm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-2x fa-fw\' : itm.searching}\"></i></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/fluxo-caixa/fechamentocaixa/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/mapa/editor/form.html","<div class=\"panel panel-info\"><div class=\"panel-heading\">Edição</div><div class=\"panel-body\"><p>Preencha os dados do formulário</p><form name=\"frm\"><div class=\"row\"><div class=\"col-md-12\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\"></ng-field></div></div></form></div><div class=\"panel-footer pull-right\"><button class=\"btn btn-warning\" type=\"button\" ng-click=\"vm.cancel();\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\">Cancelar</button> <button class=\"btn btn-primary\" type=\"button\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> Salvar</button></div></div>");
$templateCache.put("view/mapa/editor/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content animated fadeInUp\"><div class=\"ibox\"><div class=\"ibox-title\"><h5>Listagem de gêneros</h5><div class=\"ibox-tools\"><a class=\"btn btn-primary btn-xs\" ng-click=\"vm.add();\"><i class=\"fa fa-plus\"></i> Criar novo gênero</a></div></div><div class=\"ibox-content\"><div class=\"row m-b-sm m-t-sm\"><div class=\"col-md-12\"><div class=\"input-group\"><input type=\"text\" placeholder=\"Pesquisar\" class=\"input-sm form-control\" ng-model=\"vm.Filter.Nome\" ng-model-options=\"{ debounce: { \'default\': vm.debounce } }\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i></button></span></div></div></div><div class=\"project-list\"><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.items && vm.items.length == 0\"><strong>Nenhum registro encontrado</strong> Verifique os filtros informados ou se você possui acesso a essas informações.</div><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" class=\"table table-hover\" ng-if=\"vm.items && vm.items.length > 0\"><thead><tr><th>Nome</th><th class=\"text-right\">Ações</th></tr></thead><tbody><tr ng-repeat=\"itm in vm.items\" ng-class=\"{\'success\' : itm.updated}\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.Nome}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(itm);\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(itm);\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-click=\"vm.toggle(itm);\"><i class=\"fa\" ng-class=\"{\'fa-toggle-on\': itm.Status == 1, \'fa-toggle-off\': itm.Status != 1}\"></i> {{(itm.Status == 1)?\'Desabilitar\' : \'Habilitar\'}}</a></li></ul></span></td></tr><tr class=\"gradeA odd showIfLast ng-scope\" ng-show=\"vm.searching\"><td colspan=\"9\" class=\"ng-binding\">Carregando dados...<svg-loading></svg-loading></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("view/mapa/editor/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/planta/bloqueio-permanente/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12 col-lg-6\"><ng-field label=\"Sala\" required=\"true\" type=\"select\" model=\"vm.item.IdSala\" options=\"vm.listSalas\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-12 col-lg-6\" ng-if=\"vm.PossuiLayout == \'True\'\"><ng-field label=\"Layout\" required=\"true\" type=\"select\" model=\"vm.item.IdLayout\" options=\"vm.listLayouts\" ng-disabled=\"!vm.item.IdSala\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-12 col-lg-6\" ng-if=\"vm.PossuiSetor == \'True\'\"><ng-field label=\"Setor\" required=\"true\" type=\"select\" model=\"vm.item.IdSetor\" options=\"vm.listSetor\" ng-disabled=\"!vm.item.IdLayout\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div><div class=\"col-md-12 col-lg-6\"><ng-field label=\"Tipo de bloqueio\" required=\"true\" type=\"select\" options=\"vm.listTiposBloqueio\" model=\"vm.item.IdTipoBloqueioAssentoEstabelecimento\" value-field=\"Id\" text-field=\"Rotulo\"></ng-field></div></div><div class=\"row\"><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-4\"><ng-field name=\"\" label=\"Data de início\" model=\"vm.item.DataInicio\" min-date=\"vm.minDate\" type=\"date\" required=\"true\"></ng-field></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-2\"><ng-field name=\"\" type=\"time\" label=\"horário de início\" model=\"vm.item.HoraInicio\" required=\"true\"></ng-field></div><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-4\"><ng-field name=\"\" label=\"Data de fim\" type=\"date\" model=\"vm.item.DataFim\" min-date=\"vm.minDate\" required=\"true\"></ng-field></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-2\"><ng-field name=\"\" type=\"time\" label=\"horário de fim\" model=\"vm.item.HoraFim\" required=\"true\"></ng-field></div></div><form><ng-field label=\"Observação\" type=\"textarea\" model=\"vm.item.Observacao\" rows=\"5\"></ng-field></form><div class=\"row\"><div class=\"coluna m-baixo-8\" style=\"height: 500px\"><div class=\"col-md-12\"><div class=\"col-md-3\"></div><div class=\"col-md-12\"><p class=\"svg-container\" id=\"svgcontent\" ng-if=\"!vm.loadingSvg\"><ng-svg content=\"vm.mapaSvg\" loaded=\"vm.svgloaded\"></ng-svg></p><p ng-if=\"vm.loadingSvg\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\" ng-if=\"vm.loadingSvg\"></i></p></div><div class=\"col-md-3\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"(!frm.$valid) || (vm.Table.length == 0) || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel();\">CANCELAR</button></p><br></div></div></div></div></div></form></div></div>");
$templateCache.put("view/planta/bloqueio-permanente/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">NOVO BLOQUEIO DE ASSENTO</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os bloqueios\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr role=\"row\"><th ts-criteria=\"Setor|lowercase\" class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Setor</th><th ts-criteria=\"Assento|lowercase\" class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Assento</th><th ts-criteria=\"Rotulo|lowercase\" class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Rótulo</th><th ts-criteria=\"Observacao|lowercase\" class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Observação</th><th ts-criteria=\"DataInicio|lowercase\" class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Data Início</th><th ts-criteria=\"DataFim|lowercase\" class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Data Término</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\" ts-repeat=\"\"><td class=\"project-title\"><span>{{item.Setor}}</span></td><td class=\"project-title\"><span>{{item.Assento}}</span></td><td class=\"project-title\"><span>{{item.Rotulo}}</span></td><td class=\"project-title\"><span>{{item.Observacao}}</span></td><td class=\"project-title\"><span>{{item.DataInicio | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-title\"><span>{{item.DataFim | date: \'dd/MM/yyyy HH:mm\'}}</span></td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.del(item);\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div>");
$templateCache.put("view/planta/bloqueio-permanente/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/planta/layout/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-12 col-md-12\"><ng-field name=\"Nome\" label=\"Nome do Layout\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-12\"><ng-field label=\"Sala\" required=\"true\" type=\"select\" model=\"vm.item.IdSala\" options=\"vm.salaList\" value-field=\"Id\" text-field=\"Nome\"></ng-field></div></div></form></div></div><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></p></div></div>");
$templateCache.put("view/planta/layout/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR LAYOUT</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os layouts\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\"><thead><tr role=\"row\"><th ts-criteria=\"Nome|lowercase\">Layout</th><th ts-criteria=\"NomeSala|lowercase\">Sala</th><th class=\"text-right\" width=\"50px\">Ações</th></tr></thead><tbody><tr ng-repeat=\"layout in vm.layouts\" ts-repeat=\"\"><td class=\"project-title\">{{layout.Nome}}</td><td class=\"project-title\">{{layout.NomeSala}}</td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(layout);\" ng-show=\"layout.PodeEditar\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-show=\"!layout.PodeEditar\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.delete(layout);\" ng-show=\"layout.PodeExcluir\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-click=\"\" ng-show=\"!layout.PodeExcluir\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div></div>");
$templateCache.put("view/planta/layout/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/planta/pavimento/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"IdLayout\" ng-if=\"vm.userSettings.possui_layout | lowercase\" model=\"vm.item.IdLayout\" label=\"Layout\" type=\"select\" tooltip=\"Layout pavimeto\" value-field=\"Id\" text-field=\"Nome\" options=\"vm.layoutList\" required=\"true\"></ng-field></div><div class=\"col-md-6\"><ng-field name=\"Ordem\" label=\"Ordem\" model=\"vm.item.Ordem\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field name=\"ArquivoPlanta\" model=\"vm.item.ArquivoPlanta\" label=\"Arquivo Planta\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div></div></form><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.openGrid()\">CANCELAR</button></p><br></div></div></div></div></div></div>");
$templateCache.put("view/planta/pavimento/grid.html","<div id=\"wrapper\" class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content animated fadeInUp\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success pull-right\">ADICIONAR ZONA</button><br><br><br><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div class=\"table-responsive\"><div><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar as zonas\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\"><thead><tr role=\"row\"><th ts-criteria=\"Nome|lowercase\">Zona</th><th ts-criteria=\"Layout|lowercase\">Layout</th><th ts-criteria=\"NomeSala|lowercase\">Sala</th><th class=\"text-right\" width=\"50px\">Ações</th></tr></thead><tbody><tr ng-repeat=\"pavimento in vm.pavimentos\" ts-repeat=\"\"><td class=\"project-title\">{{pavimento.Nome}}</td><td class=\"project-title\">{{pavimento.Layout}}</td><td class=\"project-title\">{{pavimento.NomeSala}}</td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(pavimento);\" ng-show=\"pavimento.PodeEditar\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-show=\"!pavimento.PodeEditar\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.delete(pavimento);\" ng-show=\"pavimento.PodeExcluir\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-show=\"!pavimento.PodeExcluir\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("view/planta/pavimento/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/planta/sala/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-12\"><ng-field name=\"Nome\" label=\"Nome\" model=\"vm.item.Nome\" type=\"text\" required=\"true\" maxlength=\"50\"></ng-field></div></div></form><div class=\"row\"><div class=\"col-lg-12\"><button type=\"button\" class=\"btn btn-w-m btn-xs btn-success pull-right\" ng-click=\"vm.openPopUp();\">ADICIONAR DOCUMENTO</button></div></div><table class=\"table table-striped table-bordered table-hover\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Documento</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Valor/Descrição</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 310px;\">Vencimento</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.Table| filter: vm.myfilter\"><td class=\"sorting_1\">{{item.Nome}}</td><td class=\"sorting_1\">{{item.Valor}}</td><td class=\"sorting_1\">{{item.Vencimento | date}}</td><td class=\"center\"><div class=\"ibox-tools\"><a role=\"button\" ng-click=\"vm.ExcluirItem(item);\"><i class=\"fa fa-trash\"></i></a></div></td></tr></tbody></table><form><ng-field label=\"Observações\" type=\"textarea\" model=\"vm.item.Observacao\" rows=\"10\" maxlength=\"5000\"></ng-field></form></div></div><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button class=\"btn btn-outline pull-right\" type=\"button\" ng-click=\"vm.cancel();\">CANCELAR</button></p></div></div>");
$templateCache.put("view/planta/sala/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR SALA</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar as salas\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\"><thead><tr role=\"row\"><th ts-criteria=\"Nome|lowercase\">Sala</th><th class=\"text-right\" width=\"50px\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\" ts-repeat=\"\"><td class=\"sorting_1\">{{item.Nome}}</td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(item);\" ng-show=\"item.PodeEditar\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-show=\"!item.PodeEditar\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.del(item);\" ng-show=\"item.PodeExcluir\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-show=\"!item.PodeExcluir\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div></div>");
$templateCache.put("view/planta/sala/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/planta/setor/form.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><form name=\"frm\"><div class=\"row\"><div class=\"col-xs-6 col-md-6\"><ng-field label=\"Nome do Setor\" model=\"vm.item.Nome\" required=\"true\" maxlength=\"50\"></ng-field></div><div class=\"col-xs-6 col-md-6\"><ng-field name=\"IdLayout\" label=\"Layout\" ng-if=\"vm.userSettings.possui_layout | lowercase\" required=\"true\" type=\"select\" model=\"vm.item.IdLayout\" options=\"vm.layoutList\" value-field=\"Id\"></ng-field></div></div><div class=\"row\"><div class=\"col-xs-6 col-md-6\"><ng-field ng-if=\"vm.userSettings.possui_pavimento | lowercase\" label=\"Zona\" type=\"select\" value-field=\"Id\" model=\"vm.item.IdZona\" ng-disabled=\"vm.ZonaDisable\" text-field=\"Nome\" options=\"vm.zonalist\"></ng-field></div><div class=\"col-xs-6 col-md-6\"><ng-field label=\"Mapa de Assentos\" required=\"true\" type=\"select\" model=\"vm.item.IdMapa\" value-field=\"Id\" text-field=\"Nome\" options=\"vm.mapaAssentoList\" ng-if=\"vm.item.LugarMarcado\"></ng-field><ng-field label=\"Quantidade de lugares livres\" model=\"vm.item.QuantidadeLugares\" required=\"true\" ng-if=\"vm.item.LugarMarcado == false\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-6 m-b\"><h4>Tipo de mapa</h4><input type=\"radio\" icheck=\"\" ng-model=\"vm.item.LugarMarcado\" name=\"lugarmarcado\" ng-value=\"true\" required=\"\" ng-click=\"vm.LugarLivre()\"> Lugar Reservado &nbsp; <input type=\"radio\" icheck=\"\" ng-model=\"vm.item.LugarMarcado\" name=\"lugarmarcado\" ng-value=\"false\"> Lugar Livre</div><div class=\"col-md-6 m-b\"><h4>Vende Remoto</h4><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.item.VendeRemoto\"> Vende Remoto</div></div><div class=\"row\"><div class=\"col-md-6\"><ng-field label=\"Informações de Acesso ao Setor\" model=\"vm.item.InformacaoAcesso\" maxlength=\"200\" required=\"true\" type=\"textarea\"></ng-field></div><div class=\"col-md-6\"><ng-field label=\"Mensagem do Ingresso\" model=\"vm.item.MsgIngresso\" maxlength=\"200\" required=\"true\" type=\"textarea\"></ng-field></div></div></form></div></div></div><div class=\"form-group\"><p><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.save();\" ng-disabled=\"!frm.$valid || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.cancel()\">CANCELAR</button></p></div></div>");
$templateCache.put("view/planta/setor/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><button ng-click=\"vm.add()\" type=\"button\" class=\"btn btn-w-m btn-success m-b-md pull-right\">ADICIONAR SETOR</button><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><br><div class=\"ibox-content\"><div><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os setores\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\"><thead><tr role=\"row\"><th ts-criteria=\"Nome|lowercase\">Setor</th><th ts-criteria=\"NomeZona|lowercase\">Zona</th><th ts-criteria=\"NomeLayout|lowercase\">Layout</th><th ts-criteria=\"NomeSala|lowercase\">Sala</th><th class=\"text-right\" width=\"50px\">Ações</th></tr></thead><tbody><tr ng-repeat=\"setor in vm.setores\" ts-repeat=\"\"><td class=\"project-title\">{{setor.Nome}}</td><td class=\"project-title\">{{setor.NomeZona}}</td><td class=\"project-title\">{{setor.NomeLayout}}</td><td class=\"project-title\">{{setor.NomeSala}}</td><td class=\"project-actions\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.edit(setor);\" ng-show=\"setor.PodeEditar\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-show=\"!setor.PodeEditar\" style=\"color: lightgrey;\"><i class=\"fa fa-edit\" style=\"color: lightgrey;\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.delete(setor);\" ng-show=\"setor.PodeExcluir\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-show=\"!setor.PodeExcluir\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\" style=\"color: lightgrey;\"></i> Excluir</a></li></ul></span></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></div></div></div></div>");
$templateCache.put("view/planta/setor/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/bordero/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe ng-src=\"{{vm.pdfUrl}}\" ng-style=\"vm.style\" ng-show=\"!vm.loading\"></iframe></div><div class=\"col m-t pull-right\"><div class=\"col-md-12\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" ng-disabled=\"vm.loading\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/bordero/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"Data\" model=\"vm.Filter.Data\" type=\"date\"></ng-field></div></div><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"col\"><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Filtrar pelo nome da atração\" aria-controls=\"DataTables_Table_0\"></div></div></div><br><div class=\"ibox-content\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" role=\"grid\" data-sorting=\"true\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Atração</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Data</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"2\" colspan=\"0\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date : \'dd/MM/yyyy HH:mm\' }}</span></td><td class=\"project-actions\"><a role=\"button\" ng-click=\"vm.exibir(item);\" ng-if=\"item.HasBordero\"><i class=\"fa fa-clipboard\"></i> Visualizar</a> <a role=\"button\" ng-click=\"vm.edit(item);\" ng-if=\"!item.HasBordero\"><i class=\"fa fa-clipboard\"></i> Gerar</a></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></form></div></div></div>");
$templateCache.put("view/reports/bordero/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/financeiro/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe ng-src=\"{{vm.pdfUrl}}\" ng-style=\"vm.style\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row m-t pull-right\"><div class=\"col-md-12\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/financeiro/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><ng-field name=\"DataInicio\" label=\"Data\" model=\"vm.Filter.DataInicio\" type=\"date\" required=\"true\"></ng-field></div><div class=\"col-lg-2\"><ng-field name=\"DataFim\" label=\"Data\" model=\"vm.Filter.DataFim\" type=\"date\" required=\"true\"></ng-field></div><div class=\"col-lg-6\"><ng-field label=\"Atração\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.lstAtracao\" value-field=\"IdAtracao\" text-field=\"Nome\"></ng-field></div><div class=\"col-lg-2\" style=\"margin-top: 25px;\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-left col-offset-m1\" ng-disabled=\"vm.gerar || frm.$invalid\" ng-click=\"vm.Gerar()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.gerar}\"></i> Gerar</button></div></div></div><br><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.searching}\"></i>Atualizar</button><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os relatórios\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"DataHoraSolicitacao\">Data</th><th ts-criteria=\"TempoExecucao\">Tempo Execução</th><th ts-criteria=\"ApelidoUsuario\">Usuário</th><th>Parâmetros</th><th style=\"text-align: center;\">Ações</th></tr></thead><tbody><tr ng-repeat=\"report in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span>{{report.DataHoraSolicitacao | momentCompleteDate }}</span></td><td class=\"project-title\"><span ng-style=\"\">{{ report.TempoExecucao }}</span></td><td class=\"project-title\"><span>{{report.ApelidoUsuario}}</span></td><td class=\"project-title\"><span>{{report.Parametros}}</span></td><td class=\"project-actions\" style=\"text-align: center;\"><span class=\"project-title\" ng-if=\"report.IdStatusRelatorio !== 2\">{{report.DescricaoStatusRelatorio}}</span> <a class=\"project-actions\" role=\"button\" ng-if=\"report.IdStatusRelatorio == 2\" ng-click=\"vm.exibir(report)\"><i class=\"fa fa-clipboard\"></i> Visualizar</a> <a ng-if=\"report.IdStatusRelatorio !== 1\" style=\"margin-left: 15px;\" role=\"button\" ng-click=\"vm.delete(report);\"><i title=\"Excluir\" class=\"fa fa-trash\"></i></a></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></form></div></div></div><div></div>");
$templateCache.put("view/reports/financeiro/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/futuras/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe ng-src=\"{{vm.pdfUrl}}\" ng-style=\"vm.style\" \"=\"\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row m-t pull-right\"><div class=\"col-md-12\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/futuras/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><ng-field name=\"DataFim\" label=\"Data\" model=\"vm.Filter.Data\" type=\"date\" required=\"true\"></ng-field></div><div class=\"col-lg-6\"><ng-field label=\"Atração\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.lstAtracao\" value-field=\"IdAtracao\" text-field=\"Nome\" ng-disabled=\"vm.disabled\"></ng-field></div><div class=\"col-lg-2\" style=\"margin-top: 25px;\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-disabled=\"vm.gerar || frm.$invalid\" ng-click=\"vm.Gerar()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.gerar}\"></i> Gerar</button></div></div></div></form></div></div></div>");
$templateCache.put("view/reports/futuras/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/futuras-dia/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe ng-src=\"{{vm.pdfUrl}}\" ng-style=\"vm.style\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row m-t pull-right\"><div class=\"col-md-12\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/futuras-dia/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-3\"><ng-field name=\"DataInicio\" label=\"Data\" model=\"vm.Filter.Data\" type=\"date\" required=\"true\"></ng-field></div><div class=\"col-md-5\"><ng-field label=\"Atração\" type=\"select\" model=\"vm.Filter.IdAtracao\" options=\"vm.lstAtracao\" value-field=\"IdAtracao\" text-field=\"Nome\" ng-disabled=\"vm.disabled\"></ng-field></div><div class=\"col-md-1 m-t-lg\" ng-if=\"vm.loading\"><i class=\"fa fa-spinner fa-pulse fa-fw\"></i></div><div class=\"col-lg-2\" style=\"margin-top: 25px;\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-left col-offset-m1\" ng-disabled=\"vm.gerar || frm.$invalid\" ng-click=\"vm.Gerar()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.gerar}\"></i> Gerar</button></div></div><div class=\"row\"><div class=\"col-md-6 m-b\"><input type=\"radio\" icheck=\"\" ng-model=\"vm.Filter.DoDia\" name=\"futuras\" ng-value=\"true\" required=\"\"> Somente no dia &nbsp; <input type=\"radio\" icheck=\"\" ng-model=\"vm.Filter.DoDia\" name=\"futuras\" ng-value=\"false\"> Somente na semana</div></div><br><div class=\"ibox-content\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-pulse fa-fw\' : vm.searching}\"></i>Atualizar</button><div class=\"table-responsive constrained\" ts-wrapper=\"\" ts-no-data-text=\"Utilize o filtro para filtrar os relatórios\"><table class=\"table table-hover table-striped\" data-sorting=\"true\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><thead><tr><th ts-criteria=\"DataHoraSolicitacao\">Data Solicitação</th><th ts-criteria=\"TempoExecucao\">Tempo Execução</th><th ts-criteria=\"ApelidoUsuario\">Usuário</th><th>Parâmetros</th><th style=\"text-align: center;\">Ações</th></tr></thead><tbody><tr ng-repeat=\"report in vm.items\" ng-class=\"{\'success\' : itm.updated}\" ts-repeat=\"\"><td class=\"project-title\"><span ng-style=\"\">{{report.DataHoraSolicitacao | momentCompleteDate }}</span></td><td class=\"project-title\"><span ng-style=\"\">{{ report.TempoExecucao }}</span></td><td class=\"project-title\"><span ng-style=\"\">{{report.ApelidoUsuario}}</span></td><td class=\"project-title\"><span ng-style=\"\">{{report.Parametros}}</span></td><td class=\"project-actions\" style=\"text-align: center;\"><span class=\"project-title\" ng-if=\"report.IdStatusRelatorio !== 2\">{{report.DescricaoStatusRelatorio}}</span> <a class=\"project-actions\" role=\"button\" ng-if=\"report.IdStatusRelatorio == 2\" ng-click=\"vm.exibir(report)\"><i class=\"fa fa-clipboard\"></i> Visualizar</a> <a ng-if=\"report.IdStatusRelatorio !== 1\" style=\"margin-left: 15px;\" role=\"button\" ng-click=\"vm.delete(report);\"><i title=\"Excluir\" class=\"fa fa-trash\"></i></a></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></div></div></form></div></div></div>");
$templateCache.put("view/reports/futuras-dia/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/reports/previa/form.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><form name=\"frm\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><i class=\"fa\" style=\"margin: 0 auto\" ng-class=\"{\'fa fa-spinner fa-pulse fa-3x fa-fw\' : vm.loading}\"></i><iframe class=\"iframe-responsivo\" ng-style=\"vm.style\" ng-src=\"{{vm.pdfUrl}}\" ng-show=\"!vm.loading\"></iframe></div><div class=\"row\"><div class=\"col pull-right\"><button class=\"btn btn-default btn-md\" ng-click=\"vm.voltar()\">Voltar</button> <a style=\"margin-right: 20px;\" ng-disabled=\"vm.loading\" class=\"btn btn-success btn-md\" href=\"{{vm.pdfUrl}}\" download=\"\">Download</a></div></div></div></div></div></div></form></div></div>");
$templateCache.put("view/reports/previa/grid.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"frm\" class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-2\"><ng-field name=\"Nome\" ng-enter=\"vm.search()\" label=\"Data\" model=\"vm.Filter.Data\" type=\"date\"></ng-field></div></div><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-disabled=\"vm.searching\" ng-click=\"vm.search()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.searching}\"></i> FILTRAR</button><div class=\"col\"><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-enter=\"vm.search()\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Filtrar pelo nome da atração\" aria-controls=\"DataTables_Table_0\"></div></div></div><br><div class=\"ibox-content\"><table infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" class=\"table table-striped table-hover\" role=\"grid\" data-sorting=\"true\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Atração</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 310px;\">Data</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"2\" colspan=\"0\" style=\"width: 5px;\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.items\"><td class=\"project-title\"><span>{{item.Atracao}}</span></td><td class=\"project-title\"><span>{{item.DataHoraInicio | date : \'dd/MM/yyyy HH:mm\' }}</span></td><td class=\"project-actions\"><a role=\"button\" ng-click=\"vm.edit(item);\"><i class=\"fa fa-clipboard\"></i> Visualizar</a></td></tr></tbody></table><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div></div></form></div></div></div>");
$templateCache.put("view/reports/previa/index.html","<div ui-view=\"\"></div>");
$templateCache.put("view/site/home/index.html","<div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\">pagina inicial</div></div></div>");
$templateCache.put("view/conteudo/atracao/template/crop_tmpl.html","<style>\n    .cropArea {\n        background: #E4E4E4;\n        overflow: hidden;\n        width: 100% !important;\n        height: 300px;\n    }\n</style><div class=\"modal-header\"><h3 class=\"modal-title\">Cortar Imagem</h3></div><div class=\"modal-body\"><div class=\"cropArea medium\"><img-crop image=\"vm.imageDataURI\" result-image=\"vm.resImageDataURI\" area-type=\"{{vm.tipoImagem}}\" result-image-size=\"vm.resultImageSize\" aspect-ratio=\"vm.ratio\" result-array-image=\"vm.resArrImagens\" chargement=\"\'Carregando...\'\"></img-crop></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm();\" ng-disabled=\"vm.loadingCrop\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loadingCrop}\"></i> CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.Cancel();\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/atracao/template/ficha_tecnica_tmpl.html","<style>\n  .wizard > .content {\n    background: white !important;\n    background-color: red;\n  }\n\n\n</style><form><div ng-form=\"fichaTecnicaForm\"><div class=\"row\"><div class=\"row\"><div class=\"col-lg-6\"><ng-field name=\"Nome\" model=\"vm.Atracao.FichaTecnica.Nome\" label=\"Nome\" required=\"true\" ng-disabled=\"!vm.PodeEditar\" tooltip=\"Nome que será exibido nos pontos de venda.\" maxlength=\"150\"></ng-field></div><div class=\"col-lg-6\"><ng-field name=\"NomeOriginal\" model=\"vm.Atracao.FichaTecnica.NomeOriginal\" label=\"Nome Original\" ng-disabled=\"!vm.PodeEditar\" tooltip=\"Nome original da atração para controle interno.\" maxlength=\"150\"></ng-field></div></div><div class=\"row\"><div class=\"col-lg-12\"><ng-field name=\"UrlOficial\" model=\"vm.Atracao.FichaTecnica.UrlOficial\" label=\"URL Oficial\" maxlength=\"150\" tooltip=\"Site da peça.\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"PaisOrigem\" model=\"vm.Atracao.FichaTecnica.PaisOrigem\" label=\"País de Origem\" maxlength=\"100\" tooltip=\"País onde a peça originalmente foi lançada e exibida pela primeira vez.\"></ng-field></div><div class=\"col-md-4\"><ng-field name=\"IdiomaOficial\" model=\"vm.Atracao.FichaTecnica.IdiomaOriginal\" label=\"Idioma original\" maxlength=\"50\" tooltip=\"Idioma de criação.\"></ng-field></div><div class=\"col-md-4\"><ng-field type=\"number\" name=\"AnoLancamento\" model=\"vm.Atracao.FichaTecnica.AnoLancamento\" label=\"Ano de lançamento\" maxlength=\"4\" tooltip=\"Ano que a peça fora lançada e registrada para fins de exibição.\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-4\"><ng-field name=\"DataEstreia\" model=\"vm.Atracao.FichaTecnica.DataEstreia\" label=\"Data da primeira estréia\" type=\"date\" tooltip=\"Quando a peça irá ao ar.\"></ng-field></div><div class=\"col-md-4\"><ng-field name=\"Duracao\" model=\"vm.Atracao.FichaTecnica.Duracao\" type=\"number\" label=\"Duração\" required=\"true\" maxlength=\"3\" tooltip=\"Duração em mintos.\"></ng-field></div><div class=\"col-md-4\"><ng-field name=\"IdClassificacao\" model=\"vm.Atracao.FichaTecnica.IdClassificacao\" label=\"Classificação\" type=\"select\" tooltip=\"Informação relevante para saber quais pessoas em quais faixas etárias poderão assistir determinadas peças.\" value-field=\"Id\" text-field=\"Nome\" options=\"vm.classificacoes\" required=\"true\"></ng-field></div></div><div class=\"row\"><div class=\"col-md-12\"><h3>Inadequação</h3><div ng-if=\"!vm.loadInadequacoes\"><chips tags=\"vm.Inadequacoes\" has-image=\"false\" allow-new-item=\"false\" items=\"vm.inadequacoesSearch\"></chips></div><div ng-if=\"vm.loadInadequacoes\"><label>Carregando...</label><i class=\"fa pull-left\" ng-class=\"{\'\' : !vm.loadInadequacoes, \'fa-spinner fa-pulse\' : vm.loadInadequacoes}\"></i></div></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\"><h3>Gêneros</h3><div ng-if=\"!vm.loadGeneros\"><chips tags=\"vm.Generos\" has-image=\"false\" allow-new-item=\"false\" items=\"vm.generosSearch\" selecionado=\"vm.GeneroPrincipal\" has-check=\"true\"></chips><span class=\"help-block\" ng-show=\"!vm.ValidaGenero\" aria-hidden=\"false\">Preenchimento obrigatório</span></div><div ng-if=\"vm.loadGeneros\"><label>Carregando...</label><i class=\"fa pull-left\" ng-class=\"{\'\' : !vm.loadGeneros, \'fa-spinner fa-pulse\' : vm.loadGeneros}\"></i></div></div></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><button ui-sref=\"conteudo.atracao.wizard.participantes\" class=\"btn btn-success pull-right\" ng-disabled=\"AtracaoForm.$invalid || vm.participantesload || !vm.ValidaGenero\">PRÓXIMO</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.Cancelar();\">CANCELAR</button></div></div></div></div></form>");
$templateCache.put("view/conteudo/atracao/template/midia_tmpl.html","<style>\n    .img-vazio {\n    width: 100%;\n    height: 240px;\n    background-color: #ebebeb !important;\n    border: 5px dashed #DDD;\n    border-radius: 3px;\n  }\n\n  .banner {\n    position: relative;\n    max-width: 740px;\n    max-height: 380px;\n  }\n\n  .capa {\n    position: relative;\n    max-width: 260px;\n    max-height: 380px;\n  }\n\n  .galeria {\n    position: relative;\n    max-width: 360px;\n    max-height: 240px;\n  }\n\n  .banner img, .capa img, .thumb-galeria {\n    width: 100%;\n    height: auto;\n  }\n\n  .banner h3, .capa h3, .img-vazio h3 {\n    position: absolute;\n    top: 55%;\n    left: 0;\n    padding: 0 10px;\n    width: 100%;\n    text-align: center;\n  }\n\n  .img-ok {\n    width: 100%;\n    background-color: #ebebeb !important;\n    /*border: 1px solid #d7d7d7;*/\n    border-radius: 3px;\n  }\n\n  .tratar_video {\n    width: 100%;\n    min-height: 250px;\n    background-color: indigo !important;\n    border-radius: 3px;\n    color: white;\n  }\n\n  .img-vazio-peq {\n    min-height: 200px;\n  }\n\n  .centro {\n    width: 100px;\n    height: 100px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -50px;\n    margin-left: -50px;\n  }\n\n  li {\n    display: inline-block;\n  }\n\n  .cropArea {\n    background: #E4E4E4;\n    overflow: hidden;\n    width: 600px;\n    height: 350px;\n  }\n\n  .alinhar-centro {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .btn-crop-center {\n    position: absolute;\n    top: calc(50% - 45px);\n    left: calc(50% - 25px);\n    margin: 0;\n  }\n\n  .btn-circle.btn-lg {\n    padding: 10px;\n  }\n\n  .btn-file {\n    position: relative;\n    overflow: hidden;\n  }\n\n  .btn-file input[type=file] {\n    position: absolute;\n    top: 0;\n    right: 0;\n    min-width: 100%;\n    min-height: 100%;\n    font-size: 100px;\n    text-align: right;\n    filter: alpha(opacity=0);\n    opacity: 0;\n    outline: none;\n    background: white;\n    cursor: inherit;\n    display: block;\n  }\n\n  .drop-box {\n    background: #F8F8F8;\n    border: 5px dashed #DDD;\n    /*width: 820px;*/\n    height: 200px;\n    text-align: center;\n    padding-top: 25px;\n    margin: 10px;\n  }\n\n  .dragover {\n    border: 5px dashed #03273D;\n  }\n\n  .progress-bar {\n    background-color: #3f51b5;\n  }\n\n  .notificacao-tratamento {\n    margin-top: 15%;\n    background-color: #086AA6;\n    color: #fff;\n    padding: 0.9em;\n    border-radius: 5px;\n    width: 350px;\n  }\n  .notificacao-tratamento:hover {\n    background-color: #1c84c6;\n  }\n  .teste{\n    background: #71bded;\n    border: none;\n  }\n</style><div class=\"container-fluid\"><form name=\"midiaForm\"><div class=\"row\"><div class=\"col-sm-12 col-md-12 col-lg-9\"><div class=\"banner\"><h4>Foto destaque (Mínimo 740x380)</h4><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileDestaque\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column alinhar-centro banner\" ng-class=\"{\'img-ok\' : vm.Atracao.Midia.FotoDestaque != null, \'img-vazio\' : vm.Atracao.Midia.FotoDestaque == null}\"><div ng-if=\"!vm.Atracao.Midia.FotoDestaque\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoDestaque, \'fa fa-spinner fa-pulse\': vm.spinFotoDestaque}\"></i></button><h3>Clique ou arraste a foto para fazer upload</h3><div ngf-no-file-drop=\"\">Arrastar não suportado pelo browser</div></div><div ng-if=\"vm.Atracao.Midia.FotoDestaque\"><img ng-src=\"{{vm.Atracao.Midia.FotoDestaque.Uri}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button class=\"btn btn-link btn-lg\" ng-disabled=\"!vm.Atracao.Midia.FotoDestaque\" ng-click=\"vm.DeleteFotoDestaque(vm.Atracao.Midia.FotoDestaque)\"><i class=\"fa fa-trash\"></i></button> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.uploadDestaque($files)\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\" style=\"margin: 0; padding: 8px 0;\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será destaque da atração\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div><div class=\"col-sm-12 col-md-12 col-lg-3\"><div class=\"capa\"><h4>Foto de capa (Mínimo 370x550)</h4><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileCapa\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" layout-align=\"center center\" class=\"layout-align-center-center layout-column capa alinhar-centro\" ng-class=\"{\'img-ok\' : vm.Atracao.Midia.FotoCapa != null, \'img-vazio\' : vm.Atracao.Midia.FotoCapa == null}\"><div ng-if=\"!vm.Atracao.Midia.FotoCapa\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoCapa, \'fa fa-spinner fa-pulse\': vm.spinFotoCapa}\"></i></button><h3>Clique ou arraste a foto para fazer upload</h3></div><div ng-if=\"vm.Atracao.Midia.FotoCapa\"><img ng-src=\"{{vm.Atracao.Midia.FotoCapa.Uri}}\"></div></div><div class=\"list-group list-group-horizontal pull-right\"><button class=\"btn btn-link btn-lg\" ng-disabled=\"!vm.Atracao.Midia.FotoCapa\" ng-click=\"vm.DeleteFotoCapa(vm.Atracao.Midia.FotoCapa)\"><i class=\"fa fa-trash\"></i></button> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.uploadCapa($files)\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <a class=\"btn btn-link btn-lg\" style=\"margin: 0; padding: 8px 0;\"><span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Foto que será exibida na capa de seus espetáculos\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></a></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><h4 class=\"m-l-md\">Fotos para galeria na página da atração (Mínimo 960x640)</h4><div class=\"col-md-3\" ng-if=\"vm.Atracao.Midia.FotoGaleria != nulL\" ng-repeat=\"item in vm.Atracao.Midia.FotoGaleria\"><div class=\"layout-align-center-center layout-column img-ok\" layout-align=\"center center\" ng-disabled=\"item.error\"><span><img ng-src=\"{{item.Thumb.Uri}}\" class=\"thumb-galeria\"></span></div><div class=\"list-group list-group-horizontal pull-left\"><button class=\"btn btn-link btn-lg\" ng-click=\"vm.DeleteFotoGaleria($index, item)\" ng-disabled=\"vm.loading\"><i class=\"fa fa-trash\"></i></button> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-select=\"vm.updateGaleria($files, $index,item)\" ngf-multiple=\"false\" accept=\"image/*\"><i class=\"fa fa-pencil\"></i></button> <span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Fotos que serão exibidas no corrossel de imagens.\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></div></div><div class=\"col-md-3\"><div ng-disabled=\"vm.loading\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileGaleria\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"image/*\" class=\"layout-align-center-center layout-column img-vazio alinhar-centro\" layout-align=\"center center\"><button class=\"btn btn-success btn-circle btn-lg btn-crop-center\" aria-label=\"upload\" ng-disabled=\"vm.loading\"><i ng-class=\"{\'fa fa-cloud-upload idle\' : !vm.spinFotoGaleria, \'fa fa-spinner fa-pulse\': vm.spinFotoGaleria}\"></i></button><h3>Clique ou arraste a foto para fazer upload.</h3></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-md-8 col-lg-7\" ng-if=\"vm.videoProgress == null\"><p></p><h4>Vídeo destaque</h4><p></p><div><div ng-disabled=\"vm.loading\" class=\"drop-box alinhar-centro\" ng-if=\"vm.Atracao.Midia.Video == null\" ngf-drop=\"\" ngf-select=\"\" ng-model=\"vm.FileVideo\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" accept=\"video/*\" ngf-validate=\"{size: {max: \'400000MB\', min: \'1B\'}, height: {max: 12000}, width: {max: 12000}, duration: {max: \'200m\'}}\"><h3>Arraste o vídeo ou clique para enviar</h3></div><div ngf-no-file-drop=\"\">Arrastar e soltar não suportado pelo browser</div><p ng-show=\"vm.result\">Vídeo enviado com sucesso.</p><div class=\"pull-left\" ng-if=\"vm.Atracao.Midia.Video != null\"><div class=\"list-group list-group-horizontal pull-right\"><label for=\"\">Excluir Vídeo</label> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ng-click=\"vm.DeleteVideo(vm.Atracao.Midia.Video)\"><i class=\"fa fa-trash\"></i></button> <label for=\"\">Editar Vídeo</label> <button ng-disabled=\"vm.loading\" class=\"btn btn-link btn-lg\" ngf-allow-dir=\"true\" ngf-select=\"vm.UpdateVideo($files)\" ngf-multiple=\"false\" ngf-pattern=\"video/*,application/pdf\" accept=\"video/*\" ngf-validate=\"{size: {max: \'400000MB\', min: \'1B\'}, height: {max: 12000}, width: {max: 12000}, duration: {max: \'200m\'}}\"><i class=\"fa fa-pencil\"></i></button> <span class=\"btn btn-link\" popover-placement=\"auto top\" uib-popover=\"Trailler da atração.\" popover-trigger=\"mouseenter\"><i class=\"fa fa-question-circle\" style=\"font-size:1.3em;\"></i></span></div></div><div class=\"progress\" ng-show=\"vm.progress >= 0\" style=\"width:{{vm.progress}}%\" ng-bind=\"vm.progress + \'%\'\"></div></div></div><div class=\"col-md-8 col-lg-7\" ng-if=\"vm.videoProgress != null\" style=\"margin-top:42px;\"><div class=\"progress\" ng-if=\"vm.videoProgress != null\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{vm.videoProgress}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{vm.videoProgress}}%;\">{{vm.videoProgress}} %</div></div></div><div class=\"col-md-4 col-lg-5 alinhar-centro\"><div class=\"notificacao-tratamento\"><h3>O vídeo será tratado pela divertix.com.br</h3><p>Em breve disponibilizaremos o link de compartilhamento através do YouTube.</p></div></div></div><br></form><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.atracao.wizard.sinopse\" class=\"btn btn-default pull-right offset3\">ANTERIOR</a></div><div class=\"inline\"><button type=\"button\" ng-click=\"vm.Save()\" class=\"btn btn-success pull-right\" ng-disabled=\"AtracaoForm.$invalid || vm.participantesload || vm.loading || vm.videoProgress != null\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button></div></div></div></div></div>");
$templateCache.put("view/conteudo/atracao/template/participantes_tmpl.html","<form name=\"participantesForm\"><fieldset><div class=\"row m-t-md\" ng-if=\"vm.TipoVisao == 2\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Autoria</h4><chips tags=\"vm.Autoria\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.autoriaSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\" ng-if=\"vm.TipoVisao == 2\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Elenco</h4><chips tags=\"vm.Elenco\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.elencoSearch\" enter-new=\"true\"></chips></div></div><div ng-if=\"vm.TipoVisao == 2\"><div class=\"row\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Direção</h4><chips tags=\"vm.Direcao\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.direcaoSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Direção Musical</h4><chips tags=\"vm.DirecaoMusical\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.direcaoMusicalSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Elenco Musical</h4><chips tags=\"vm.ElencoMusical\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.elencoMusicalSearch\" enter-new=\"true\"></chips></div></div></div><div ng-if=\"vm.TipoVisao == 1 || vm.TipoVisao == 3\"><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Músico</h4><chips tags=\"vm.Musico\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.musicoSearch\" enter-new=\"true\"></chips></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Banda</h4><chips tags=\"vm.Banda\" value-field=\"IdBanda\" icon-field=\"FotoPerfil\" items=\"vm.searchBanda\" enter-new=\"true\"></chips></div></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.atracao.wizard.ficha_tecnica\" class=\"btn btn-default pull-right offset3\">ANTERIOR</a></div><div class=\"inline\"><a ui-sref=\"conteudo.atracao.wizard.sinopse\" class=\"btn btn-success pull-right\">PRÓXIMO</a></div></div></div></div></fieldset></form>");
$templateCache.put("view/conteudo/atracao/template/sinopse_tmpl.html","<style>\n    textarea {\n    resize: none;\n}\n</style><fieldset><div class=\"row\"><div class=\"form-group\"><text-angular ta-toolbar=\"[ [\'h1\', \'h2\', \'h3\', \'h4\', \'h5\', \'h6\', \'p\'],[\'bold\', \'italics\', \'underline\', \'strikeThrough\', \'ul\', \'ol\', \'redo\', \'undo\', \'clear\'], [\'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'indent\', \'outdent\']]\" ng-model=\"vm.Atracao.Sinopse.Texto\" name=\"your-textAngular-instance-name\" ta-maxlength=\"2000\"></text-angular></div></div><div class=\"row m-t-md\"><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.atracao.wizard.participantes\" class=\"btn btn-default pull-right offset3\" ng-disabled=\"vm.itensCount < 7\">ANTERIOR</a></div><div class=\"inline\"><a ui-sref=\"conteudo.atracao.wizard.midia\" class=\"btn btn-success pull-right\">PRÓXIMO</a></div></div></div></div></fieldset>");
$templateCache.put("view/conteudo/programacao/popup/calendario.popup.html","<style>\n    .picker-day.picker-selected {\n        background-color: #3F51B5 !important;\n        color: #fff;\n    }\n    .picker-day:not(.picker-off):not(.picker-empty):hover {\n        background-color: #3F51B5 !important;\n        color: #fff;\n        cursor: pointer;\n    }\n\n    /*.picker-day.selected.picker-off{*/\n      /*background-color: #a94442;*/\n      /*color: #fff;*/\n      /*cursor: default;*/\n    /*}*/\n</style><div class=\"modal-header\"><h4>ESCOLHA AS DATAS</h4></div><div class=\"modal-body\"><form name=\"frm\"><div><multiple-date-picker ng-model=\"vm.DataHora\" disable-days-before=\"vm.today\" highlight-days=\"vm.highlightDays\"></multiple-date-picker></div></form><br><br><div class=\"alert alert-danger alert-dismissible p-r-md\" role=\"alert\" ng-if=\"vm.DatasExistentes.length > 0\"><strong>Já existe(m) sessão(ões) com a(s) data(s) abaixo:</strong><br><br><div ng-repeat=\"itm in vm.DatasExistentes\">{{itm}}</div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.DataHora)\" ng-disabled=\"vm.DataHora.length == 0\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/programacao/popup/dadosincompletos.popup.html","<div class=\"modal-header\"><h4>Dados incompletos!</h4></div><div class=\"modal-body\"><h4>Alguns dados necessários não foram preenchidos, revise a programação.</h4></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.goBack()\">OK</button></div>");
$templateCache.put("view/conteudo/programacao/popup/datahora.popup.html","<div class=\"modal-header\"><h4>INCLUIR DATA</h4></div><div class=\"modal-body\"><form name=\"frmPopData\"><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><ng-field name=\"DataSessao\" width=\"20px\" model=\"vm.DataHora.DataSessao\" label=\"Data da Sessão\" type=\"date\" min-date=\"vm.minDate\" tooltip=\"Quando a peça irá ao ar.\" required=\"true\"></ng-field></div><div class=\"col-xs-6 col-sm-6 col-md-6\" style=\"margin-top:30px;\"><div class=\"input-group\"><input icheck=\"\" ng-model=\"vm.DataHora.EventoDiaInteiro\" type=\"checkbox\"> &nbsp; &nbsp; <strong>EVENTO COM DURAÇÃO DE UM DIA</strong></div></div></div><br><div class=\"row\"><div class=\"col-xs-6 col-sm-6 col-md-6\" ng-if=\"!vm.DataHora.EventoDiaInteiro\"><ng-field name=\"HoraSessao\" model=\"vm.DataHora.HoraSessao\" type=\"time\" label=\"Hora de Início\" required=\"{{vm.DataHora.EventoDiaInteiro}}\" tooltip=\"Hora de Início.\"></ng-field></div><div class=\"col-xs-6 col-sm-6 col-md-6\" ng-if=\"vm.DataHora.EventoDiaInteiro\"><ng-field name=\"HoraSessaoFake\" model=\"\" type=\"time\" label=\"Hora de Início\" tooltip=\"Hora de Início.\" ng-disabled=\"vm.DataHora.EventoDiaInteiro\"></ng-field></div><div class=\"col-xs-6 col-sm-6 col-md-6\" ng-if=\"!vm.DataHora.EventoDiaInteiro\"><ng-field name=\"AberturaPortao\" model=\"vm.DataHora.AberturaPortao\" label=\"Hora de abertura dos portões\" type=\"time\" tooltip=\"Hora de abertura dos portões.\"></ng-field><label>Tempo em minutos para abertura da sessão: {{vm.Abertura}}</label><br></div><div class=\"col-xs-6 col-sm-6 col-md-6\" ng-if=\"vm.DataHora.EventoDiaInteiro\"><ng-field name=\"AberturaPortao\" model=\"vm.DataHora.AberturaPortao\" label=\"Hora de abertura dos portões\" type=\"time\" tooltip=\"Hora de abertura dos portões.\" required=\"true\"></ng-field><br></div></div></div><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-if=\"vm.DataInvalida\"><strong>A data da sessão não pode ser menor que a data atual.</strong></div><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-if=\"vm.HasSessao\"><strong>Já existe uma sessão para essa data e hora.</strong></div><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-if=\"vm.HoraAberturaMaior\"><strong>Hora de abertura dos portões não pode ser maior que o hora de início da Sessão.</strong></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.DataHora)\" ng-disabled=\"vm.DataHora.DataSessao == null || (vm.DataHora.HoraSessao == null && vm.DataHora.EventoDiaInteiro == false) || vm.SearchSessao || frmPopData.$invalid || vm.SearchConfiguracao\"><i class=\"fa\" ng-class=\"{\'fa-spinner fa-pulse\' : vm.SearchSessao, \'fa-spinner fa-pulse\' : vm.SearchConfiguracao}\"></i> CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel(vm.DataHora)\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/programacao/popup/ingresso.popup.html","<div class=\"modal-header\"><h4>INCLUIR INGRESSO</h4></div><div class=\"modal-body\"><h4>Selecione os ingressos.</h4><form name=\"frm\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching || vm.LimteAlcancado\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i> &nbsp; FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input ng-enter=\"vm.search()\" type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"ibox-content\" ng-if=\"vm.items.length > 0\" style=\"max-height: 300px;overflow-y: auto;\"><div class=\"table-responsive\"><div class=\"infiniteScroll\" style=\"height: 260px; overflow: auto\"><table id=\"tbIngressos\" class=\"table table-striped table-hover\" ng-if=\"vm.items.length > 0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\" infinite-scroll=\"vm.search(true)\" infinite-scroll-disabled=\"vm.complete || vm.searching\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\" infinite-scroll-container=\'\".infiniteScroll\"\'><thead><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Nome</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Percentual / Valor</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Valor editavel</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Local de Venda</th></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.Tabelaingressos\" ng-click=\"vm.selected(vm.Tabelaingressos,item)\" ng-class=\"{\'colorir\': item.selected}\"><td class=\"sorting_1\">{{item.Nome}}</td><td class=\"sorting_1\" ng-if=\"item.TipoDesconto == \'F\'\">{{item.ValorRegra | currency :\'R$ \'}}</td><td class=\"sorting_1\" ng-if=\"item.TipoDesconto == \'P\'\">{{item.ValorRegra * 100}} %</td><td class=\"sorting_1\">{{item.DefineValorNaSessao == true ? \'Sim\' : \'Não\'}}</td><td>{{item.VendeRemoto && item.VendeBilheteria ? \'Todos\' : item.VendeRemoto ? \'Site\' : item.VendeBilheteria ? \'Bilheteria\' : \'Nenhum\' }}</td></tr></tbody></table></div></div></div><br><div class=\"row\"><div class=\"col-md-6 col-md-offset-5\" ng-show=\"vm.searching\"><i class=\"fa fa-spinner fa-pulse fa-1x fa-fw\"></i> Carregando...</div></div><br><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.items.length == 0 && !vm.LimteAlcancado && vm.click\"><strong>Nenhum ingresso encontrado.</strong></div><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.LimteAlcancado\"><strong>Só é permitido a inclusão de 30 tipos de ingressos por setor.</strong></div></form><div ng-if=\"vm.ingressosSelecionados.length > 0\"><span ng-if=\"vm.ingressosSelecionados.length == 1\" style=\"font-weight: 600\">{{vm.ingressosSelecionados.length}} ingresso selecionado</span> <span ng-if=\"vm.ingressosSelecionados.length > 1\" style=\"font-weight: 600\">{{vm.ingressosSelecionados.length}} ingressos selecionados</span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.ingressosSelecionados)\" ng-disabled=\"!vm.btnPopupIngresso || vm.LimteAlcancado\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/programacao/popup/programacoes.popup.html","<div class=\"modal-header\"><h4>ESCOLHA UMA SESSÃO</h4></div><div class=\"modal-body\"><h4>Selecione a sessão que deseja copiar.</h4><form name=\"frm\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i> &nbsp; FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Texto\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"ibox-content\" style=\"max-height: 300px;overflow-y: auto;\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\">Dia</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 300px;\">Atração</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\">Horário</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\">Sala</th></tr></thead><tbody><tr class=\"gradeA odd\" ng-repeat=\"itm in vm.items\" ng-click=\"vm.selected = $index; vm.Item = itm\" ng-class=\"{\'colorir\': vm.selected == $index}\"><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.DataHoraInicio | date : \'dd\'}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeAtracao}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.DataHoraInicio | date : \'HH:mm\'}}</span></td><td class=\"project-title\"><span ng-style=\"{\'text-decoration\':((itm.Status != 1) ? \'line-through\' : \'\')}\">{{itm.NomeSala}}</span></td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.Item)\" ng-disabled=\"vm.Item == null\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/programacao/popup/tabelapreco.popup.html","<div class=\"modal-header\"><h4>TABELA DE PREÇOS</h4></div><div class=\"modal-body\"><h4>Selecione a tabela de preços para importar os ingressos.</h4><form name=\"frm\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i> &nbsp; FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"ibox-content\" style=\"max-height: 300px;overflow-y: auto;\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.TabelaPrecos\" ng-click=\"vm.selected = $index; vm.Item = item\" ng-class=\"{\'colorir\': vm.selected == $index}\"><td class=\"sorting_1\">{{item.Nome}}</td></tr></tbody></table></div></div><br><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.setor.tipoIngresso.length > 0\"><strong>Ao importar uma nova tabela de preços, os ingressos já incluídos serão excluídos.</strong></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.Item)\" ng-disabled=\"vm.Item == null\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/conteudo/programacao/resumoProgramacao/resumo.html","<style>\n\n  .md-contact-suggestion img {\n    margin-top: 1px !important;\n  }\n\n  .md-contact-suggestion img {\n    margin-top: -30px !important;\n  }\n\n  .md-contact-suggestion {\n    width: 50px;\n  }\n\n  .md-chips .md-chip {\n    padding-left: 5px;\n  }\n  .circled {\n    display: inline-block;\n    width: 1.4em;\n    height: 1.4em;\n    padding-top: 0.1em;\n    border: 0.1em solid;\n    border-radius: 100%;\n    box-sizing: border-box;\n    text-align: center;\n  }\n  .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n    width: 400px !important;\n  }\n\n\n\n  .status{\n    border-radius: 4px;\n    padding: 2px;\n    color: white;\n    text-align: center;\n    max-width: 200px;\n  }\n\n\n  /*.panel-body{*/\n    /*padding: 0px;*/\n  /*}*/\n\n  .uib-tab.ng-scope.ng-isolate-scope.active {\n    color: #000 !important;\n    background-color: #e7eaec !important;\n    text-decoration: none;\n  }\n\n  uib-tab-heading .inline.ng-binding {\n    color: black !important;\n  }\n\n  .nav > li.active {\n    border-left: none;\n    background: none;\n  }\n\n  /*.panel-body {*/\n    /*background-color: #e7eaec;*/\n  /*}*/\n\n  .border {\n    border: 1px solid red;\n    border-radius: 3px !important;\n  }\n\n  .text-muted {\n    color: #333333;\n  }\n\n  .btn-info.disabled {\n    background-color: #ccc;\n  }\n\n  .btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled]:active, .btn-info.active[disabled], fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {\n    background-color: #ccc;\n  !important;\n  }\n\n  .addLote {\n    background-color: white !important;\n    boder: none !important;\n  }\n\n  .addLote a:hover {\n    background-color: #a7b1c2 !important;\n    border: solid 1px #ccc;\n  }\n\n  .uib-tab.ng-scope.ng-isolate-scope {\n    background-color: white !important;\n    boder: none !important;\n  }\n\n  .lugaresRestantes {\n    position: absolute;\n    width: 200px;\n    top: 7px;\n    margin-left: 10px;\n  }\n\n</style><div class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h3>Informações da Atração</h3><div class=\"hr-line-dashed\"></div></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Atração</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Sala</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Status da Venda</label></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.NomeAtracao}}</div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.NomeSala}}</div><div class=\"col-xs-4 col-sm-4 col-md-4\"><div class=\"status\" style=\"background-color:red\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status == 1 && !vm.item.VendaLiberada\">Não Liberada</div><div class=\"status\" style=\"background-color:green\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status == 1 && vm.item.VendaLiberada && vm.item.VendaBilheteria && vm.item.VendeRemoto\">Liberada Online e Bilheteria</div><div class=\"status\" style=\"background-color:darkorange\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status == 1 && vm.item.VendaLiberada && vm.item.VendaBilheteria && !vm.item.VendeRemoto\">Liberada Somente Bilheteria</div><div class=\"status\" style=\"background-color:#61baf4\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status == 1 && vm.item.VendaLiberada && !vm.item.VendaBilheteria && vm.item.VendeRemoto\">Liberada Somente Online</div><div class=\"status\" style=\"background-color:slategrey\" ng-if=\"vm.item.PossuiBordero\">Encerrada</div><div class=\"status\" style=\"background-color:silver\" ng-if=\"!vm.item.PossuiBordero && vm.item.Status != 1\">Desabilitada</div><br></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Data</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Layout</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Abertura dos Portões</label></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.DataHoraInicio | date : \'dd/MM/yyyy\' + \' (\' + vm.item.DiaSemana + \')\'}}</div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.NomeLayout}}</div><div ng-maxlength=\"2\" class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.HoraAbertura}}<br><br></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Horario</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Evento com duração de um dia</label></div></div><div class=\"row\"><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.DataHoraInicio | momentParseZone | date : \'HH:mm\'}}<br></div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.DuracaoDiaInteiro == false ? \'Não\' : \'Sim\'}}<br><br></div></div></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><h3>Produção</h3><div class=\"hr-line-dashed\"></div></div></div><section><form action=\"\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><chips max=\"1\" has-image=\"false\" allow-new-item=\"false\" tags=\"vm.Producao\" value-field=\"IdProducao\" icon-field=\"FotoPerfil\" items=\"vm.querySearchProducao\" enter-new=\"false\"></chips></div></div></div></form></section></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><h3>Valores do Ingresso</h3><div class=\"hr-line-dashed\"></div></div></div><section><form name=\"frmValorIngresso\"><div class=\"tabs-container\"><uib-tabset><uib-tab active=\"lote.active\" ng-repeat=\"lote in vm.lotes | orderBy : \'Lote\'\" ng-hide=\"lote.deleted\"><uib-tab-heading><span class=\"inline\" ng-if=\"vm.PossuiLote\">Lote {{(lote.IndexLote)}}</span> <span class=\"inline\" ng-if=\"!vm.PossuiLote\" style=\"color:black;\">Ingressos</span> &nbsp;&nbsp;&nbsp;&nbsp;</uib-tab-heading><div class=\"panel-body\"><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"lote.LoteEncerrado\"><strong>Lote encerrado.</strong></div><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"!lote.LoteEncerrado && lote.ExistiuVenda\"><strong>Esse lote já possui venda.</strong></div><div class=\"checkbox\" ng-if=\"vm.setores.length > 1 || lote.setores.length > 1\"><label><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.oneAtATime\"> Abra somente um de cada vez</label></div><div id=\"accordion\" role=\"tablist\" aria-multiselectable=\"false\"><uib-accordion close-others=\"vm.oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"setor in lote.setores track by $index\" is-open=\"vm.accordionArray[$index]\" is-disabled=\"vm.setores.length == 1\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-6\"><div><i class=\"pull-left glyphicon\" ng-class=\"vm.accordionArray[$index] ? \'glyphicon-chevron-down\':\'glyphicon-chevron-right\'\" ng-if=\"vm.setores.length > 1\"></i>&nbsp; {{setor.Nome}} {{setor.NomeZona != null ? \"(\" + setor.NomeZona + \")\" : \'\'}}</div></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn btn-xs btn-w-m btn-success pull-right\" ng-disabled=\"lote.LoteEncerrado\" ng-click=\"vm.addTipoIngresso(lote, setor,$event, $index)\">INCLUIR INGRESSO</button></div></div></uib-accordion-heading><div class=\"table-responsive margin-table\"><div class=\"col-xs-12 no-padding\"><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"setor.IngNeg\"><strong>O valor dos ingressos devem ser superiores a 0 (Zero).</strong></div><label>Valor Base</label><div class=\"input-group\"><input type=\"text\" maxlength=\"11\" ui-money-mask=\"\" class=\"form-control no-padding\" ng-model=\"setor.ValorBase\" required=\"\" ng-change=\"vm.ChangeValueIngresso(setor)\" ng-class=\"{\'border\' : setor.ValorBase == null, \'\' : setor.ValorBase != null}\" ng-disabled=\"true\"></div><span class=\"help-block\" ng-show=\"setor.ValorBase == null\" aria-hidden=\"false\">Preenchimento obrigatório</span><br></div><table class=\"table table-striped table-hover\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 710px;\">Tipo de Ingresso</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 150px;\">Local de Venda</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Tipo de Desconto</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Qtd. Máxima</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 120px;\">Valor da regra</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Valor</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 10px;\"></th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"ti in setor.tipoIngresso | filter: vm.myfilter | orderBy : \'OrdemIngresso\'\" style=\"{{ti.excluido == true ? \'display:none\' : \'\'}}\"><td class=\"sorting_1\">{{ti.Nome}}</td><td>{{ti.VendeRemoto && ti.VendeBilheteria ? \'Todos\' : ti.VendeRemoto ? \'Site\' : ti.VendeBilheteria ? \'Bilheteria\' : \'Nenhum\' }}</td><td class=\"sorting_1\">{{ti.TipoDesconto == \'P\' ? \'Percentual\' : \'Fixo\'}}</td><td class=\"sorting_1\" ng-if=\"!ti.ExibeQtd\">{{ti.QuantidadeIngressos}}</td><td class=\"sorting_1\" ng-if=\"ti.ExibeQtd\"><input type=\"text\" id=\"qtdIngressos\" name=\"qtdIngressos\" ng-model=\"ti.QuantidadeIngressos\" style=\"width:100px;\" ui-hide-group-sep=\"\" ui-number-mask=\"0\" ng-disabled=\"ti.IdSessaoSetorLotePrecoIngresso\"></td><td class=\"sorting_1\" ng-if=\"ti.TipoDesconto == \'F\'\">{{ti.ValorRegra | currency:\"R$\"}}</td><td class=\"sorting_1\" ng-if=\"ti.TipoDesconto == \'P\'\">{{ti.ValorRegra * 100}} %</td><td class=\"center\" ng-if=\"!ti.DefineValorNaSessao\">{{ ti.Valor | currency:\"R$\"}}</td><td class=\"center\" ng-if=\"ti.DefineValorNaSessao\"><input type=\"text\" ng-model=\"ti.Valor\" style=\"width:100px;\" ui-money-mask=\"\" required=\"\" ng-disabled=\"ti.IdSessaoSetorLotePrecoIngresso\"></td><td><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-if=\"!itm.searching\" ng-disabled=\"vm.loadBordero\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-if=\"!ti.IdSessaoSetorLotePrecoIngresso\" ng-click=\"vm.incluirQuantidade(ti);\"><i class=\"fa fa-trash\"></i> Incluir Qtd Máxima</a> <a role=\"button\" ng-if=\"ti.IdSessaoSetorLotePrecoIngresso\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\"></i> Incluir Qtd Máxima</a> <a role=\"button\" ng-if=\"ti.ExibeQtd && !ti.IdSessaoSetorLotePrecoIngresso\" ng-click=\"vm.excluirQuantidade(ti);\"><i class=\"fa fa-trash\"></i> Cancelar Qtd Máxima</a> <a role=\"button\" ng-if=\"ti.ExibeQtd && ti.IdSessaoSetorLotePrecoIngresso\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\"></i> Cancelar Qtd Máxima</a> <a role=\"button\" ng-if=\"!lote.LoteEncerrado\" ng-click=\"vm.delIngresso(ti,setor);\"><i class=\"fa fa-trash\"></i> Excluir</a> <a role=\"button\" ng-if=\"lote.LoteEncerrado\" style=\"color: lightgrey;\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></uib-accordion></div></div></uib-tab><uib-tab index=\"NewTab\" ng-click=\"vm.addLote(true,false)\" class=\"addLote\" ng-if=\"vm.PossuiLote && vm.lugaresRestantes > 0\"><uib-tab-heading><div class=\"row\"><div class=\"col-md-4\"><a><i class=\"fa fa-plus-circle\"></i></a></div></div></uib-tab-heading></uib-tab></uib-tabset></div></form></section></div></div><div class=\"ibox float-e-margins\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12\"><h3>Detalhes</h3><div class=\"hr-line-dashed\"></div></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5\"><label>Tipos de Entrega</label></div><div class=\"col-xs-3 col-sm-3 col-md-3\"><label>Artista(s) Convidado(s)</label></div><div class=\"col-xs-4 col-sm-4 col-md-4\"><label>Encerramento de venda após sessão</label></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5\"><span ng-repeat=\"item in vm.item.ListaTipoEntrega.$values\">{{$last ? item.Nome : item.Nome + \'/\'}}</span></div><div ng-if=\"vm.item.ListaConvidado.$values.length > 0\" class=\"col-xs-3 col-sm-3 col-md-3\"><span ng-repeat=\"item in vm.item.ListaConvidado.$values\">{{$last ? item.NomeArtistico : item.NomeArtistico + \',\'}}</span></div><div ng-if=\"vm.item.ListaConvidado.$values.length == 0\" class=\"col-xs-3 col-sm-3 col-md-3\">Nenhum</div><div class=\"col-xs-4 col-sm-4 col-md-4\">{{vm.item.EncerraVendaAposSessao}} min após início da sessão<br><br></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5\"><label>Encerramento de vendas remotas</label></div><div class=\"col-xs-5 col-sm-5 col-md-5\"><label>Cancelamento de reservas</label></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5 col-md-5\">{{vm.item.EncerraVendaRemota}} min</div><div class=\"col-xs-5 col-sm-5 col-md-5\">{{vm.item.CancelamentoReserva}} min antes do início da sessão<br><br></div><div class=\"row pull-right\"><div class=\"inline m-r-md\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\" ng-click=\"vm.back();\">VOLTAR</button></div><div class=\"inline\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" style=\"margin-right: 20px;\" ng-disabled=\"vm.loading || !vm.ok || !vm.HasIngresso || vm.HasIngresso == null\" ng-click=\"vm.save()\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/programacao/template/data-horario.tmpl.html","<div id=\"wrapper\" class=\"wrapper wrapper-content animated fadeInDown\"><div class=\"ibox-content\"><div class=\"ibox float-e-margins\"><div class=\"row\"><div class=\"col-lg-12\"><button type=\"button\" class=\"btn btn-xs btn-w-m btn-success pull-right\" ng-click=\"vm.addDataHora()\" ng-disabled=\"vm.Sessao.ExistiuVenda\">INCLUIR DATA</button></div></div><br><div class=\"row\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><table class=\"table table-striped table-hover\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 120px;\">Data</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 120px;\">Hora da Sessão</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 200px;\">Evento com duração de um dia</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 180px;\">Abertura dos Portões</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 60px;\" ng-hide=\"vm.Sessao.ExistiuVenda\">Ações</th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"itm in vm.tabelaDataHorario | orderBy:[\'+DataSessao\', \'+HoraSessao\']\"><td class=\"sorting_1\">{{itm.DataSessao | date: \'dd/MM/yyyy\'}}</td><td>{{itm.HoraSessao == null ? \'-\' : itm.HoraSessao}}</td><td class=\"center\">{{itm.EventoDiaInteiro ? \'Sim\' : \'Não\'}}</td><td class=\"center\">{{itm.AberturaPortao == null || itm.AberturaPortao == \"\" ? \'-\' : itm.AberturaPortao | date : \"HH:mm\"}}</td><td class=\"project-actions\" ng-hide=\"itm.ExistiuVenda\"><span uib-dropdown=\"\" on-toggle=\"toggled(open)\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.copiarDataHora(itm);\"><i class=\"fa fa-copy\"></i> Copiar</a> <a role=\"button\" ng-click=\"vm.editarDataHora(itm);\" ng-if=\"!itm.ExistiuVenda\"><i class=\"fa fa-edit\"></i> Editar</a> <a role=\"button\" ng-click=\"vm.excluirDataHora(itm);\" ng-if=\"!itm.ExistiuVenda\"><i class=\"fa fa-trash\"></i> Excluir</a></li></ul></span></td></tr></tbody></table></div></div></div><br><br><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.programacao.form.identificacao\" class=\"btn btn-default pull-right offset3\">ANTERIOR</a></div><div class=\"inline\"><button ui-sref=\"conteudo.programacao.form.valores-ingresso\" class=\"btn btn-success pull-right\" ng-disabled=\"vm.tabelaDataHorario == 0\" ng-click=\"vm.ValorIngresso()\">PRÓXIMO</button></div></div></div></div></div></div>");
$templateCache.put("view/conteudo/programacao/template/detalhes.tmpl.html","<style>\n  .md-contact-suggestion img {\n    margin-top: 1px !important;\n  }\n\n  .md-contact-suggestion img {\n    margin-top: -30px !important;\n  }\n\n  .md-contact-suggestion {\n    width: 50px;\n  }\n\n  .md-chips .md-chip {\n    padding-left: 5px;\n  }\n  .circled {\n    display: inline-block;\n    width: 1.4em;\n    height: 1.4em;\n    padding-top: 0.1em;\n    border: 0.1em solid;\n    border-radius: 100%;\n    box-sizing: border-box;\n    text-align: center;\n  }\n  .md-virtual-repeat-container.md-autocomplete-suggestions-container {\n    width: 400px !important;\n  }\n</style><div class=\"panel panel-default\"><div class=\"panel-body\"><h4>Informações sobre a sessão</h4><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-xs-3 col-sm-4 col-md-3 m-b-md\" ng-repeat=\"itm in vm.TipoSessoEmpresa\"><input icheck=\"\" type=\"checkbox\" value=\"{{itm.Nome}}\" ng-model=\"itm.selected\" ng-disabled=\"vm.Sessao.ExistiuVenda\"> {{itm.Nome}}</div></div></div><hr></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h3>Tipos de Entrega</h3><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-xs-3 col-sm-4 col-md-3 m-b-md\" ng-repeat=\"itm in vm.TipoEntrega\"><input icheck=\"\" type=\"checkbox\" value=\"{{itm.Nome}}\" ng-model=\"itm.selected\" ng-disabled=\"vm.Sessao.ExistiuVenda\"> {{itm.Nome}}</div></div></div></div></div><hr><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Artista(s) convidado(s)</h4><chips tags=\"vm.ArtistaConvidado\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.querySearchArtista\" enter-new=\"true\"></chips></div></div></div><hr><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Músico(s) convidado(s)</h4><chips tags=\"vm.MusicoConvidado\" value-field=\"IdArtista\" icon-field=\"FotoPerfil\" items=\"vm.querySearchMusico\" enter-new=\"true\"></chips></div></div></div><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"col-md-12\" style=\"padding-left:0; padding-right:0\"><h4>Produção</h4><chips max=\"1\" has-image=\"false\" allow-new-item=\"false\" tags=\"vm.Producao\" value-field=\"IdProducao\" icon-field=\"FotoPerfil\" items=\"vm.querySearchProducao\" enter-new=\"false\"></chips></div></div></div><hr><div class=\"panel panel-default\"><div class=\"panel-body\"><form><div class=\"row\"><div class=\"col-xs-6 col-sm-6 col-md-6\"><ng-field name=\"DataEncerraVendaAposSessao\" model=\"vm.Sessao.ModelDataEncerraVendaAposSessao\" type=\"number\" ng-disabled=\"vm.Sessao.ExistiuVenda\" label=\"Encerramento de vendas após sessão\" maxlength=\"3\" tooltip=\"Encerramento de vendas\"></ng-field><span>minutos após início da sessão</span></div><div class=\"col-xs-6 col-sm-6 col-md-6 m-b-lg\"><ng-field name=\"CancelaReservaMinutoAntes\" model=\"vm.Sessao.ModelCancelaReservaMinutoAntes\" type=\"number\" ng-disabled=\"vm.Sessao.ExistiuVenda\" label=\"Cancelamento de reservas podem ser efetuadas até\" maxlength=\"3\" tooltip=\"Cancelamento de reservas.\"></ng-field><span>minutos antes do início da sessão</span></div></div><div class=\"row\"><div class=\"col-xs-6 col-sm-6 col-md-6\"></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"input-group\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.Sessao.ModelEncerraVendaAutomatica\" ng-change=\"vm.ClearDataEncerraVenda()\" ng-disabled=\"vm.Sessao.ExistiuVenda\"> &nbsp; &nbsp; <strong class=\"m-l-md\">ENCERRA VENDAS REMOTAS AUTOMATICAMENTE</strong><br></div></div></div><div class=\"row\"><br><br><div class=\"col-xs-6 col-sm-6 col-md-6\" ng-if=\"!vm.HasTipoEntrega\"><div class=\"alert alert-danger alert-dismissible p-r-md\" role=\"alert\"><strong>Escolha uma forma de entrega.</strong></div></div><div class=\"col-xs-offset-5 col-sm-offset-6 col-md-offset-6 col-xs-6 col-sm-6 col-md-6\"><div class=\"panel panel-default\" ng-if=\"!vm.Sessao.ModelEncerraVendaAutomatica\"><div class=\"panel-body\"><ng-field name=\"DataEncerraVendaRemotoAntesSessao\" model=\"vm.Sessao.ModelDataEncerraVendaRemotoAntesSessao\" required=\"true\" type=\"number\" label=\"Encerramento de vendas remotas\" maxlength=\"4\" tooltip=\"Encerramento de vendas remotas.\" ng-disabled=\"vm.Sessao.ExistiuVenda\"></ng-field><span>minutos antes do início da sessão</span></div></div></div></div></form></div></div><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.programacao.form.valores-ingresso\" class=\"btn btn-default pull-right offset3\">ANTERIOR</a></div><div class=\"inline\"><button type=\"button\" ng-click=\"vm.Save()\" class=\"btn btn-success pull-right\" ng-disabled=\"SessaoForm.$invalid || vm.loading\"><i class=\"fa\" ng-class=\"{\'fa fa-spinner fa-spin\' : vm.loading}\"></i> SALVAR</button></div></div></div>");
$templateCache.put("view/conteudo/programacao/template/identificacao.tmpl.html","<section><button type=\"button\" ng-click=\"vm.copiarSessao()\" class=\"btn btn-xs btn-outline btn-success pull-right\" data-toggle=\"modal\" data-target=\".bd-modal-lg\" style=\"color:white\">COPIAR SESSÃO</button><form><br><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><h3>Atração</h3><chips max=\"1\" tags=\"vm.selectedItem\" has-image=\"false\" allow-new-item=\"false\" disabled=\"vm.Sessao.ExistiuVenda\" selected-item-change=\"vm.selectedItemChange\" items=\"vm.searchAtracao\" value-field=\"IdAtracao\" removed=\"vm.deleteAtracao\"></chips><span class=\"help-block\" ng-show=\"!vm.ValidaAtracao\" aria-hidden=\"false\">Preenchimento obrigatório</span></div><div class=\"row\" ng-show=\"exibeTipoAtracao && vm.ListaTipoAtracao.length > 1\"><div class=\"col-xs-3 col-sm-4 col-md-2\" ng-repeat=\"itm in vm.ListaTipoAtracao\"><input name=\"TipoAtracao\" ng-disabled=\"true\" type=\"radio\" ng-change=\"vm.ChangeTipoAtracao()\" icheck=\"\" ng-model=\"vm.item.IdTipoAtracao\" ng-value=\"itm.IdTipoAtracao\">&nbsp;&nbsp;{{itm.NomeTipoAtracao}}<br></div></div></div></div><br><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><h3>Sala</h3><chips max=\"1\" tags=\"vm.selectedItemSala\" has-image=\"false\" allow-new-item=\"false\" disabled=\"vm.Sessao.ExistiuVenda\" selected-item-change=\"vm.selectedItemChangeSala\" items=\"vm.querySearchSala\" removed=\"vm.deleteSala\"></chips><span class=\"help-block\" ng-show=\"!vm.ValidaSala\" aria-hidden=\"false\">Preenchimento obrigatório</span></div></div></div><br><div class=\"row\" ng-if=\"vm.possuiLayout != \'False\'\"><div class=\"col-md-12\"><div class=\"form-group\"><h4>Layout</h4><chips max=\"1\" tags=\"vm.selectedItemLayout\" has-image=\"false\" allow-new-item=\"false\" selected-item-change=\"vm.selectedItemChangeLayout\" items=\"vm.querySearchLayout\" removed=\"vm.deleteLayout\"></chips><span class=\"help-block\" ng-show=\"!vm.ValidaLayout\" aria-hidden=\"false\">Preenchimento obrigatório</span></div></div></div><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"vm.Sessao.ExistiuVenda\"><strong>Sessão já possui venda. Não é possivel alterar essas informações.</strong></div><div class=\"col-md-12\"><div class=\"row pull-right\"><button ui-sref=\"conteudo.programacao.form.data-horario\" class=\"btn btn-success pull-right\" ng-disabled=\"!vm.ValidaAtracao || !vm.ValidaSala || !vm.ValidaLayout\" ng-click=\"vm.DataHora()\">PRÓXIMO</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" ng-click=\"vm.Cancelar();\">CANCELAR</button></div></div></form><br><br></section>");
$templateCache.put("view/conteudo/programacao/template/valores-ingresso.tmpl.html","<style>\n  .uib-tab.ng-scope.ng-isolate-scope.active {\n    color: #000 !important;\n    background-color: #e7eaec !important;\n    text-decoration: none;\n  }\n\n  uib-tab-heading .inline.ng-binding {\n    color: black !important;\n  }\n\n  .nav > li.active {\n    border-left: none;\n    background: none;\n  }\n\n  .panel-body {\n    background-color: #e7eaec;\n  }\n\n  .border {\n    border: 1px solid red;\n    border-radius: 3px !important;\n  }\n\n  .text-muted {\n    color: #333333;\n  }\n\n  .btn-info.disabled {\n    background-color: #ccc;\n  }\n\n  .btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled]:active, .btn-info.active[disabled], fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {\n    background-color: #ccc;\n  !important;\n  }\n\n  .addLote {\n    background-color: white !important;\n    boder: none !important;\n  }\n\n  .addLote a:hover {\n    background-color: #a7b1c2 !important;\n    border: solid 1px #ccc;\n  }\n\n  .uib-tab.ng-scope.ng-isolate-scope {\n    background-color: white !important;\n    boder: none !important;\n  }\n\n  .lugaresRestantes {\n    position: absolute;\n    width: 200px;\n    top: 7px;\n    margin-left: 10px;\n  }\n\n</style><section><frm name=\"frmValorIngresso\"><div class=\"row\" ng-if=\"vm.PossuiLote\"><div class=\"col-md-12\"><div class=\"col-xs-4 col-sm-4 col-md-4\"><ng-field name=\"IdTipoFinalizacao\" model=\"vm.Sessao.IdTipoLote\" label=\"Regra de Finalização de Lote\" ng-disabled=\"vm.Sessao.ExistiuVenda\" type=\"select\" value-field=\"IdTipoFinalizacao\" text-field=\"Nome\" options=\"vm.TipoLotes\" required=\"true\"></ng-field></div><div class=\"col-xs-4 col-sm-4 col-md-4 m-t-xl text-success\" role=\"alert\"><strong>{{ vm.QtdIngressoSetores }} Lugares disponíveis.</strong></div></div></div><div class=\"tabs-container\"><uib-tabset><uib-tab active=\"lote.active\" ng-repeat=\"lote in vm.lotes | orderBy : \'Lote\'\" ng-hide=\"lote.deleted\"><uib-tab-heading><span class=\"inline\" ng-if=\"vm.PossuiLote\">Lote {{(lote.IndexLote)}}</span> <span class=\"inline\" ng-if=\"!vm.PossuiLote\" style=\"color:black;\">Ingressos</span> &nbsp;&nbsp;&nbsp;&nbsp; <span class=\"inline\"><a ng-click=\"vm.delLote(lote, $index)\" ng-hide=\"vm.lotes.length == 1 || lote.ExistiuVenda || lote.LoteEncerrado\"><i ng-class=\"{\'fa fa-times-circle\' : !lote.spinDelLote, \'fa fa-spinner fa-pulse\' : lote.spinDelLote }\" style=\"color:#ccc\"></i></a></span></uib-tab-heading><div class=\"panel-body\"><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"lote.LoteEncerrado\"><strong>Lote encerrado.</strong></div><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"!lote.LoteEncerrado && lote.ExistiuVenda\"><strong>Esse lote já possui venda.</strong></div><div class=\"row\" id=\"PanelConfiguracaoLote\" ng-if=\"vm.PossuiLote\"><div class=\"col-md-12\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label>Configurações de Lote {{lote.IndexLote}}</label></div><div class=\"panel-body\"><div class=\"col-xs-6 col-sm-6 col-md-6\" ng-if=\"vm.Sessao.IdTipoLote == 1\"><h4>Quantidade de Ingressos</h4><div class=\"input-group col-md-6\"><input ng-blur=\"vm.ValidaLote(lote.QtdIngresso)\" style=\"height:30px\" ng-model=\"lote.QtdIngresso\" ui-hide-group-sep=\"\" ui-number-mask=\"0\" type=\"text\" required=\"\" ng-change=\"vm.calcIngressos(lote.QtdIngresso, \'{{lote.QtdIngresso}}\')\" maxlength=\"{{vm.QtdIngressoSetores.toString().length}}\" max=\"{{vm.QtdIngressoSetores}}\" class=\"form-control\" ng-class=\"{\'border\' : lote.QtdIngresso == null, \'\' : lote.QtdIngresso != null}\"> <span class=\"input-group-addon\"><i class=\"fa fa-question-circle\" aria-hidden=\"true\" popover-placement=\"auto top\" uib-popover=\"Quantidade que será disponibilizada à venda para esse lote\" popover-trigger=\"mouseenter\"></i></span><div class=\"lugaresRestantes\">(Faltam {{vm.lugaresRestantes}} lugares)</div></div></div><div class=\"col-xs-4 col-sm-4 col-md-4\" ng-if=\"vm.Sessao.IdTipoLote == 2\"><h4>Data de encerramento do lote</h4><div class=\"input-group\"><input ng-blur=\"vm.ValidaLote(lote.HoraEncerramentoLote)\" type=\"text\" class=\"form-control\" style=\"height:30px\" ng-model=\"lote.DataEncerramentoLote\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"pop\" required=\"\" ng-class=\"{\'border\' : lote.DataEncerramentoLote == null, \'\' : lote.DataEncerramentoLote != null}\" show-weeks=\"false\" show-button-bar=\"false\" min-date=\"vm.minDate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"pop = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-4 col-sm-4 col-md-4\" ng-if=\"vm.Sessao.IdTipoLote == 2\"><h4>Hora de encerramento do lote</h4><div class=\"input-group col-md-6\"><input ng-blur=\"vm.ValidaLote(lote.HoraEncerramentoLote)\" style=\"height:30px\" ng-model=\"lote.HoraEncerramentoLote\" ui-time-mask=\"short\" type=\"text\" required=\"\" maxlength=\"100\" class=\"form-control\" ng-class=\"{\'border\' : lote.HoraEncerramentoLote == null, \'\' : lote.HoraEncerramentoLote != null}\"> <span class=\"input-group-addon\"><i class=\"fa fa-question-circle\" aria-hidden=\"true\" popover-placement=\"auto top\" uib-popover=\"Hora encerramento\" popover-trigger=\"mouseenter\"></i></span></div></div><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-show=\"lote.DataEncerramentoLote < (moment().add(-1, \'day\'))\"><strong>A data da sessão não pode ser menor que a data atual.</strong></div></div></div></div></div><div ng-if=\"vm.PossuiLote\"><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-if=\"vm.LotesInvalido != null\"><strong>{{vm.LotesInvalido}}</strong></div><div class=\"alert alert-danger alert-dismissible\" role=\"alert\" ng-if=\"vm.QtdIngressosLotesMaior\"><strong>O somatório dos ingressos para os lotes ultrapassa a quantidade permitidade para a SALA.</strong></div></div><div class=\"checkbox\" ng-if=\"vm.setores.length > 1 || lote.setores.length > 1\"><label><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.oneAtATime\"> Abra somente um de cada vez</label></div><div id=\"accordion\" role=\"tablist\" aria-multiselectable=\"false\"><uib-accordion close-others=\"vm.oneAtATime\"><div uib-accordion-group=\"\" class=\"panel-default\" ng-repeat=\"setor in lote.setores track by $index\" is-open=\"vm.accordionArray[$index]\" is-disabled=\"vm.setores.length == 1\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-6\"><div><i class=\"pull-left glyphicon\" ng-class=\"vm.accordionArray[$index] ? \'glyphicon-chevron-down\':\'glyphicon-chevron-right\'\" ng-if=\"vm.setores.length > 1\"></i>&nbsp; {{setor.Nome}} {{setor.NomeZona != null ? \"(\" + setor.NomeZona + \")\" : \'\'}}</div></div><div class=\"col-sm-6\"><button type=\"button\" class=\"btn btn-xs btn-w-m btn-success pull-right\" ng-disabled=\"lote.LoteEncerrado || lote.ExistiuVenda\" ng-click=\"vm.addTipoIngresso(lote, setor,$event, $index)\">INCLUIR INGRESSO</button> <button type=\"button\" class=\"btn-xs btn btn-outline btn-info pull-right m-r-sm\" ng-disabled=\"lote.LoteEncerrado || lote.ExistiuVenda\" ng-click=\"vm.addTabelaPreco(lote, setor,$event, $index)\"><i class=\"fa\" ng-class=\"{\'fa-spinner fa-pulse\' : setor.searching}\"></i> &nbsp; IMPORTAR TABELA DE PREÇO</button></div></div></uib-accordion-heading><div class=\"table-responsive margin-table\"><div class=\"col-xs-12 no-padding\"><div class=\"alert alert-warning alert-dismissible m-t-md m-b-md\" role=\"alert\" ng-if=\"setor.IngNeg\"><strong>O valor dos ingressos devem ser superiores a 0 (Zero).</strong></div><label>Valor Base</label><div class=\"input-group\"><input type=\"text\" maxlength=\"11\" ng-disabled=\"lote.LoteEncerrado || lote.ExistiuVenda\" ui-money-mask=\"\" class=\"form-control no-padding\" ng-model=\"setor.ValorBase\" required=\"\" ng-change=\"vm.ChangeValueIngresso(setor)\" ng-class=\"{\'border\' : setor.ValorBase == null, \'\' : setor.ValorBase != null}\"></div><span class=\"help-block\" ng-show=\"setor.ValorBase == null\" aria-hidden=\"false\">Preenchimento obrigatório</span><br></div><table class=\"table table-striped table-hover\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 710px;\">Tipo de Ingresso</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 150px;\">Local de Venda</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Tipo de Desconto</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Qtd. Máxima</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 120px;\">Valor da regra</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 80px;\">Valor</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" ng-hide=\"lote.LoteEncerrado || lote.ExistiuVenda\" style=\"width: 5px;\"></th></tr></thead><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"ti in setor.tipoIngresso | filter: vm.myfilter | orderBy : [\'OrdemIngresso\', \'-Valor\', \'Nome\']\" style=\"{{ti.excluido == true ? \'display:none\' : \'\'}}\"><td class=\"sorting_1\">{{ti.Nome}}</td><td>{{ti.VendeRemoto && ti.VendeBilheteria ? \'Todos\' : ti.VendeRemoto ? \'Site\' : ti.VendeBilheteria ? \'Bilheteria\' : \'Nenhum\' }}</td><td class=\"sorting_1\">{{ti.TipoDesconto == \'P\' ? \'Percentual\' : \'Fixo\'}}</td><td class=\"sorting_1\" ng-if=\"!ti.ExibeQtd\">{{ti.QuantidadeIngressos}}</td><td class=\"sorting_1\" ng-if=\"ti.ExibeQtd\"><input type=\"text\" id=\"qtdIngressos\" name=\"qtdIngressos\" ng-model=\"ti.QuantidadeIngressos\" style=\"width:100px;\" ui-hide-group-sep=\"\" ui-number-mask=\"0\"></td><td class=\"sorting_1\" ng-if=\"ti.TipoDesconto == \'F\'\">{{ti.ValorRegra | currency:\"R$\"}}</td><td class=\"sorting_1\" ng-if=\"ti.TipoDesconto == \'P\'\">{{ti.ValorRegra * 100}} %</td><td class=\"center\" ng-if=\"!ti.DefineValorNaSessao\">{{ ti.Valor | currency:\"R$\"}}</td><td class=\"center\" ng-if=\"ti.DefineValorNaSessao\"><input type=\"text\" ng-model=\"ti.Valor\" style=\"width:100px;\" ui-money-mask=\"\" required=\"\"></td><td><span uib-dropdown=\"\" on-toggle=\"toggled(open)\" ng-if=\"!itm.searching\" ng-disabled=\"vm.loadBordero\"><a role=\"button\" uib-dropdown-toggle=\"\"><i class=\"fa fa-wrench\"></i></a><ul class=\"pull-right\" uib-dropdown-menu=\"\" aria-labelledby=\"simple-dropdown\"><li><a role=\"button\" ng-click=\"vm.delIngresso(ti,setor);\"><i class=\"fa fa-trash\"></i>Excluir</a> <a role=\"button\" ng-if=\"!ti.ExibeQtd\" ng-click=\"vm.incluirQuantidade(ti);\"><i class=\"fa fa-trash\"></i>Incluir Qtd Máxima</a> <a role=\"button\" ng-if=\"ti.ExibeQtd\" ng-click=\"vm.excluirQuantidade(ti);\"><i class=\"fa fa-trash\"></i>Cancelar Qtd Máxima</a></li></ul></span></td></tr></tbody></table></div></div></uib-accordion></div></div></uib-tab><uib-tab index=\"NewTab\" ng-click=\"vm.addLote(true,false)\" class=\"addLote\" ng-if=\"vm.PossuiLote && vm.lugaresRestantes > 0\"><uib-tab-heading><div class=\"row\"><div class=\"col-md-4\"><a><i class=\"fa fa-plus-circle\"></i></a></div></div></uib-tab-heading></uib-tab></uib-tabset></div></frm><br><br><div class=\"col-md-12\"><div class=\"row pull-right\"><div class=\"inline m-r-md\"><a ui-sref=\"conteudo.programacao.form.data-horario\" class=\"btn btn-default pull-right offset3\">ANTERIOR</a></div><div class=\"inline\"><button ui-sref=\"conteudo.programacao.form.detalhes\" class=\"btn btn-success pull-right\" ng-disabled=\"SessaoForm.$invalid || !vm.HasIngresso || vm.HasIngresso == null || vm.LotesInvalido != null || vm.QtdIngressosLotesMaior\" ng-click=\"vm.Detalhes()\">PRÓXIMO</button></div></div></div><br><br></section>");
$templateCache.put("view/conteudo/tabelaprecopadrao/template/ingresso.tmpl.html","<div class=\"modal-header\"><h4>INCLUIR INGRESSOS</h4></div><div class=\"modal-body\"><h4>Selecione os ingressos.</h4><form name=\"frm\"><div class=\"ibox-content\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m1\"><i class=\"fa\" ng-class=\"{\'fa-search\' : !vm.searching, \'fa-spinner fa-pulse\' : vm.searching}\"></i> &nbsp; FILTRAR</button><div class=\"input-group col-xs-7 col-sm-8 col-md-9 col-lg-10\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div></div><div class=\"ibox-content\" ng-if=\"vm.items.length > 0\" style=\"max-height: 300px;overflow-y: auto;\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><tbody><tr class=\"gradeA odd\" role=\"row\" ng-repeat=\"item in vm.TabelaIngressos\" ng-click=\"vm.selected(vm.items,item)\" ng-class=\"{\'colorir\': item.selected}\"><td class=\"sorting_1\">{{item.Nome}}</td></tr></tbody></table></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.items | filter: vm.myfilter)\" ng-disabled=\"!vm.btnPopupIngresso\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/estabelecimento/ingresso/template/regra.tmpl.html","<div class=\"modal-header\"><h4>SELECIONAR REGRA</h4></div><div class=\"modal-body\"><button type=\"button\" ng-click=\"vm.search()\" ng-disabled=\"vm.searching\" class=\"btn btn-w-m btn-success pull-right col-offset-m9\">FILTRAR</button><div class=\"input-group col-md-9\"><div class=\"input-group-addon\"><i class=\"fa fa-search\"></i></div><input type=\"search\" ng-model=\"vm.Filter.Nome\" class=\"form-control\" placeholder=\"Digite para filtrar os resultados\" aria-controls=\"DataTables_Table_0\"></div><br><br><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example dataTable\" id=\"DataTables_Table_0\" aria-describedby=\"DataTables_Table_0_info\" role=\"grid\"><thead><tr role=\"row\"><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" aria-sort=\"ascending\" aria-label=\"Rendering engine: activate to sort column descending\" style=\"width: 289px;\">Nome</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 480px;\">Regras</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 150px;\">Exige Documento</th><th class=\"sorting\" tabindex=\"0\" aria-controls=\"DataTables_Table_0\" rowspan=\"1\" colspan=\"1\" style=\"width: 160px;\">Tipo de Desconto</th></tr></thead><tbody><tr class=\"gradeA even\" role=\"row\" ng-repeat=\"item in vm.items\" ng-click=\"vm.selected = $index; vm.Item = item; vm.Index = $index\" ng-class=\"{\'colorir\': vm.selected == $index}\"><td class=\"sorting_1\">{{item.Nome}}</td><td>{{item.Descricao}}</td><td class=\"center\">{{item.ValidaDocumento ? \'SIM\' : \'NÃO\'}}</td><td class=\"center\">{{item.TipoDesconto == \'P\' ? \'Percentual\' : \'Fixo\'}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.Item, vm.Index)\" ng-disabled=\"vm.Item == null\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/fluxo-caixa/fechamentocaixa/popup/fechamentocaixa.popup.html","<div class=\"modal-header\"><h4>FECHAR CAIXA</h4></div><div class=\"modal-body\"><form name=\"frmPopMotivo\"><div class=\"modal-body\"><div class=\"row\"><label class=\"col-md-4 col-form-label\">Data Contábil: {{vm.caixa.DataContabil | date : \'dd/MM/yyyy\'}}</label> <label class=\"col-md-4 col-form-label\">Estação: {{vm.caixa.NomeEstacao}}</label> <label class=\"col-md-4 col-form-label\">Bilheteiro: {{vm.caixa.Apelido}}</label></div><div class=\"row\"><div class=\"col-md-12\"><ng-field name=\"vm.Motivo\" model=\"vm.Motivo\" label=\"Motivo\" type=\"textarea\" rows=\"4\" required=\"true\" maxlength=\"200\"></ng-field></div></div><br></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.Motivo)\" ng-disabled=\"frmPopMotivo.$invalid\"><i class=\"fa\" ng-class=\"{\'fa-spinner fa-pulse\' : vm.SearchSessao}\">CONFIRMAR</i></button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/planta/layout/template/popup.html","<div class=\"modal-header\"><h4>ADICIONAR DOCUMENTO</h4></div><div class=\"modal-body\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-6\"><ng-field label=\"Documento de Vistoria\" model=\"vm.item.Id\" type=\"select\" options=\"vm.items\" required=\"true\"></ng-field></div><div class=\"col-md-6\"><ng-field label=\"Vencimento\" required=\"true\" type=\"date\"></ng-field></div></div><ng-field label=\"Valor/Descrição\" required=\"true\" type=\"text\"></ng-field></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.items , vm.item.Id)\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/planta/pavimento/template/popup.html","<div class=\"modal-header\"><h4>ADICIONAR DOCUMENTO</h4></div><div class=\"modal-body\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-6\"><ng-field label=\"Documento de Vistoria\" model=\"vm.item.Id\" type=\"select\" options=\"vm.items\" required=\"true\"></ng-field></div><div class=\"col-md-6\"><ng-field label=\"Vencimento\" required=\"true\" type=\"date\"></ng-field></div></div><ng-field label=\"Valor/Descrição\" required=\"true\" type=\"text\"></ng-field></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.items , vm.item.Id)\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/planta/sala/template/popup.html","<div class=\"modal-header\"><h4>ADICIONAR DOCUMENTO</h4></div><div class=\"modal-body\"><form name=\"frmDocumento\"><div class=\"row\"><div class=\"col-md-6\"><ng-field label=\"Documento\" model=\"vm.item.Id\" type=\"select\" options=\"vm.tipodocumentoSala\" value-field=\"Id\" text-field=\"Nome\" required=\"true\"></ng-field></div><div class=\"col-md-6\"><ng-field label=\"Vencimento\" model=\"vm.item.Vencimento\" required=\"true\" type=\"date\"></ng-field></div></div><ng-field label=\"Valor/Descrição\" model=\"vm.item.Valor\" required=\"true\" type=\"text\"></ng-field><div class=\"alert alert-warning alert-dismissible\" role=\"alert\" ng-if=\"vm.TableAdd.length > 0 && vm.tipodocumentoSala.length == 0\"><strong>Todos os documentos já foram incluídos.</strong></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.item, vm.tipodocumentoSala)\" ng-disabled=\"!frmDocumento.$valid\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");
$templateCache.put("view/planta/setor/template/popup.html","<div class=\"modal-header\"><h4>ADICIONAR DOCUMENTO</h4></div><div class=\"modal-body\"><form name=\"frm\"><div class=\"row\"><div class=\"col-md-6\"><ng-field label=\"Documento de Vistoria\" model=\"vm.item.Id\" type=\"select\" options=\"vm.items\" required=\"true\"></ng-field></div><div class=\"col-md-6\"><ng-field label=\"Vencimento\" required=\"true\" type=\"date\"></ng-field></div></div><ng-field label=\"Valor/Descrição\" required=\"true\" type=\"text\"></ng-field></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-w-m btn-success pull-right\" ng-click=\"vm.Confirm(vm.items , vm.item.Id)\">CONFIRMAR</button> <button type=\"button\" class=\"btn btn-outline btn-link pull-right\" data-dismiss=\"modal\" ng-click=\"vm.Cancel()\">CANCELAR</button></div>");}]);